(function () {
	'use strict';

	var dependencies = [
		'ngRoute',
		'ui.router',
		'ui.router.state.events',
		'ngAria',
		'ngResource',
		'LocalStorageModule',
		'ngStorage',
		'ngCookies',
		'ngCacheBuster',
		'angular-loading-bar',
		'pascalprecht.translate',
		'ngFileUpload',
		'ngIntlTelInput',
		'720kb.socialshare',
		'angucomplete-alt',
		'ngTable',
		'ngMap',
		'timer',
		'ngTouch',
		'seo',
        'SignalR'
	];

	var modules = [
		'eltazkara.handler',
		'eltazkara.config',
		'eltazkara.topBar',
		'eltazkara.footer',
		'eltazkara.social',
		'eltazkara.auth',
		'eltazkara.utils',
		'eltazkara.interceptor'
	];

	angular
		.module('eltazkaraApp', dependencies.concat(modules))
		.run(elTazkaraStarter)
		.factory('UserData', UserData);

	elTazkaraStarter.$inject = [
		'$http',
		'$rootScope',
		'$location',
		'$timeout',
		'$window',
		'UserData',
		'stateHandler',
        // 'hubFactory'
	];

	// starter
	function elTazkaraStarter(
		$http,
		$rootScope,
		$location,
		$timeout,
		$window,
		UserData,
		stateHandler
	) {
		stateHandler.initialize();
		$http.defaults.headers.common.Accept = '*/*';
		$rootScope.accountText = UserData.getKey('UserName', 'Login');
		$rootScope.backendURL = window.location.href.replace(window.location.hash, '');

		var forceSSL = function () {
			if ($location.protocol() !== 'https' && $window.location.href.indexOf("localhost") == -1) {
				$window.location.href = $location
					.absUrl()
					.replace('http', 'https');
			}
		};

		forceSSL();

		/**
		 * loading function to be called to start/end loading
		 * @param { onOff }
		 */
		$rootScope.startLoading = function (onOff, apply) {
			if (onOff) {
				$rootScope.isLoading = true;

				$timeout(function () {
					$rootScope.bodyLoading = true;
				}, 1000);
			} else {
				$rootScope.isLoading = false;
				$rootScope.bodyLoading = false;
			}

			if (apply)
				$rootScope.$apply();
		};

		/**
		 * to call a toast alert
		 *
		 * @param { message } message to show up
		 * in toast
		 */
		$rootScope.showToast = function (message) {
			$mdToast.show(
				$mdToast
					.simple()
					.textContent(message)
					.position('bottom left')
					.hideDelay(1000)
			);
		};
	}

	function UserData($window) {
		return {
			set: function (userData, homeLocation, companyLocation) {
				for (var property in userData) {
					if (userData[property] == null ||
						userData[property] === 'undefined'
					) {
						$window.localStorage[property] = '';
						continue;
					}

					$window.localStorage[property] = userData[property];
				}

				if (homeLocation) {
					for (var property in homeLocation) {
						$window.localStorage['Home' + property] = homeLocation[property];
					}
				}

				if (companyLocation) {
					for (var property in companyLocation) {
						$window.localStorage['Company' + property] = companyLocation[property];
					}
				}

				$window.localStorage['IsVerified'] = false;
				$window.localStorage['VerifictaionSkipped'] = false;
				$window.localStorage['LogoutText'] = 'Logout';
				$window.localStorage['VerificationHeading'] = 'Thank you for registering';
			},
			getUser: function () {
				var user = {
					UserId: $window.localStorage['UserId'],
					Name: $window.localStorage['Name'],
					Email: $window.localStorage['Email'],
					MobileNumber: $window.localStorage['MobileNumber'],
					Image: $window.localStorage['Image'],
					Gender: $window.localStorage['Gender'],
					CompanyName: $window.localStorage['CompanyName'],
					CompanyPhone: $window.localStorage['CompanyPhone'],
					IsVerified: $window.localStorage['IsVerified'],
					IsBlocked: $window.localStorage['IsBlocked'],
					VerificationCode: $window.localStorage['VerificationCode'],
					Token: $window.localStorage['Token'],
					Birthdate: $window.localStorage['Birthdate'],
					CreatedOn: $window.localStorage['CreatedOn']
				};

				return user;
			},
			getHomeLocation: function () {
				var location = {
					LocationId: $window.localStorage['HomeLocationId'],
					LocationTypeId: $window.localStorage['HomeLocationTypeId'],
					CountryId: $window.localStorage['HomeCountryId'],
					CityId: $window.localStorage['HomeCityId'],
					Address: $window.localStorage['HomeAddress'],
					PostalCode: $window.localStorage['HomePostalCode']
				};

				return location;
			},
			getCompanyLocation: function () {
				var location = {
					LocationId: $window.localStorage['CompanyLocationId'],
					LocationTypeId: $window.localStorage['CompanyLocationTypeId'],
					CountryId: $window.localStorage['CompanyCountryId'],
					CityId: $window.localStorage['CompanyCityId'],
					Address: $window.localStorage['CompanyAddress'],
					PostalCode: $window.localStorage['CompanyPostalCode']
				};

				return location;
			},
			setKey: function (key, val) {
				$window.localStorage[key] = val;
			},
			getKey: function (key, defaultValue) {
				return $window.localStorage[key] || defaultValue;
			},
			getBackendURL: function () {
				return window.location.href.replace(window.location.hash, '');
			},
			isVerified: function () {
				return $window.localStorage['IsVerified'];
			},
			isVerificationSkipped: function () {
				return !$window.localStorage['VerifictaionSkipped'];
			},
			CLEAR: function () {
				$window.localStorage.clear();
			}
		};
	}

})();
;
(function () {
  'use strict';

  angular
      .module('eltazkaraApp')
      .constant('VERSION', "1.0.0")
      .constant('DEBUG_INFO_ENABLED', false)
      .constant('FB_APP_ID', "460375385657393")
      .constant('BACKEND_URL', "https://tixawybackend.azurewebsites.net/api/")
      .constant('APP_URL', "https://tixawy.com/")
      .constant('PHANTOM_URL', "https://tixawy.com:8888/")
      .config(["BACKEND_URL", function (BACKEND_URL) {
        window.backendUrl = BACKEND_URL;
        window.events = BACKEND_URL + "events";
        window.venues = BACKEND_URL + "venues";
        window.search = BACKEND_URL + "Home/Search?Key=";
        window.performences = BACKEND_URL + "performences";
        window.performers = BACKEND_URL + "performers";
        window.locations = BACKEND_URL + "locations";
      }]);
})();
;
(function () {
    "use strict";

    angular
        .module("eltazkaraApp")
        .config(stateConfig)
        .run(function ($rootScope, $transitions) {
            $transitions.onStart({}, function (transition) {
                $rootScope.noContent = false;
            });
        });

    stateConfig.$inject = [
        "$stateProvider",
        "$urlRouterProvider",
        "$locationProvider",
    ];

    function stateConfig(
        $stateProvider,
        $urlRouterProvider,
        $locationProvider
    ) {
        $stateProvider
            .state("app", {
                abstract: true,
                views: {
                    "topBar@": {
                        templateUrl: "layouts/topBar/topBar.html",
                        controller: "TopBarController",
                        controllerAs: "vm",
                    },
                    "footer@": {
                        templateUrl: "layouts/footer/footer.html",
                        controller: "FooterController",
                        controllerAs: "footerC",
                    },
                },
                resolve: {
                    authorize: [
                        "Auth",
                        function (Auth) {
                            return Auth.authorize();
                        },
                    ],
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("global");
                        },
                    ],
                },
            })
            .state("404", {
                parent: "app",
                url: "/404",
                views: {
                    "content@": {
                        templateUrl: "components/users/404.html",
                        controller: "NotFoundController",
                        controllerAs: "vm",
                    },
                },
            });

        $urlRouterProvider.when("", "home").when("/", "home").otherwise("404");
    }
})();
;
(function () {
    'use strict';

    angular
        .module('eltazkaraApp')
        .controller('SearchController', SearchController);

    SearchController.$inject = [
      '$rootScope',
      'NgTableParams',
      'SearchData',
      '$window',
      '$localStorage'
    ];
    function SearchController($rootScope, NgTableParams, SearchData, $window, $localStorage) {
        var vm = this;
        vm.hasperformers = false;
        vm.hasEvents = false;
        vm.hasvenues = false;

        $rootScope.initSearchPage = function () {
            var searchDataFromServer = SearchData.getData();
            if (searchDataFromServer) {
                $localStorage.searchContent = searchDataFromServer;
            }
            else {
                searchDataFromServer = $localStorage.searchContent;
            }
            var data = [];
            var performers = [];
            var venues = [];
            for (var item = 0; item < searchDataFromServer.length; item++) {
                if (searchDataFromServer[item].type == 'Performance') {
                    var event = {
                        id: searchDataFromServer[item].id,
                        fullDate: searchDataFromServer[item].day + searchDataFromServer[item].month + searchDataFromServer[item].year,
                        StartDate: searchDataFromServer[item].StartDate,
                        day: searchDataFromServer[item].day,
                        dayName: searchDataFromServer[item].dayName,
                        month: searchDataFromServer[item].month,
                        year: searchDataFromServer[item].year,
                        time: searchDataFromServer[item].time,
                        eventName: searchDataFromServer[item].eventName,
                        eventId: searchDataFromServer[item].eventId,
                        performence: searchDataFromServer[item].title,
                        venue: searchDataFromServer[item].venueName,
                        venueId: searchDataFromServer[item].venueId,
                        avTickets: searchDataFromServer[item].avTickets,
                        IsBuyBlocked: searchDataFromServer[item].IsBuyBlocked,
                        IsSellBlocked: searchDataFromServer[item].IsSellBlocked

                    }
                    data.push(event);

                }
                else if (searchDataFromServer[item].type == 'Performer') {
                    var performer = { id: searchDataFromServer[item].id, name: searchDataFromServer[item].title };
                    performers.push(performer);
                }
                else if (searchDataFromServer[item].type == 'Venue') {
                    var venue = { id: searchDataFromServer[item].id, name: searchDataFromServer[item].title };
                    venues.push(venue);
                }
            }
            if (data.length > 0) vm.hasEvents = true;
            if (performers.length > 0) vm.hasperformers = true;
            if (venues.length > 0) vm.hasvenues = true;
            vm.eventsConfig = createUsingFullOptions(data);
            vm.performersConfig = createUsingFullOptions(performers);
            vm.venuesConfig = createUsingFullOptions(venues);

            function createUsingFullOptions(dataSource) {
                var initialParams = {
                    count: 10 // initial page size
                };
                var initialSettings = {
                    // page size buttons (right set of buttons in demo)
                    counts: [],
                    // determines the pager buttons (left set of buttons in demo)
                    paginationMaxBlocks: 13,
                    paginationMinBlocks: 2,
                    dataset: dataSource
                };
                return new NgTableParams(initialParams, initialSettings);
            }
        }

        $rootScope.initSearchPage();
        vm.sell_redirection = function (event) {
            if ($rootScope.User && $rootScope.User.Email) {
                location.href = "#/performance/" + event.id + "/sell";
            }
            else {
                vm.toggleLoginPanel();
            }

        }
        vm.toggleLoginPanel = function () {
            $window.scrollTo(0, 0);
            $rootScope.loginPanelActive = !$rootScope.loginPanelActive;
            document.getElementById("userLoginEmail").value = "";
            document.getElementById("userLoginPassword").value = "";
            document.getElementById("userLoginRemember").checked = false;
            $rootScope.userLoginError = false;
            vm.User = {};
            vm.errors = {};
        };

    }
})();
;
(function () {
  'use strict';

  angular
      .module('eltazkaraApp')
      .config(stateConfig);

  stateConfig.$inject = ['$stateProvider'];

  function stateConfig($stateProvider) {
    $stateProvider.state('search', {
      parent: 'app',
      url: '/search',
      views: {
        'content@': {
            templateUrl: 'components/search/search.html',
          controller: 'SearchController',
          controllerAs: 'vm'
        }
      },
      resolve: {
        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
          $translatePartialLoader.addPart('global');
        }]
      }
    });
  }
})()
;
(function () {
  "use strict";

  angular.module("eltazkaraApp").controller("HomeController", HomeController);
  HomeController.$inject = ["$scope", "$rootScope", "Home", "$window", "User"];

  function HomeController($scope, $rootScope, Home, $window, User) {
    var vm = this;
    vm.featuredEvents = [];
    vm.CategoriesEvents = [];
    vm.PopularVenue = {};
    vm.VenuePerformances = [];
    vm.TrendingToday = [];
    vm.PopularPerformers = [];
    vm.clientWidth = $rootScope.clientWidth;

    vm.initCarousel = function () {
      vm.carouselInitializing = true;

      setTimeout(function () {
        if (vm.carouselInitialized) {
          $(".featuredEventsCarouselFeaturedUnits").slick("unslick");
          $(".featuredEventsCarouselNavUnits").slick("unslick");
        }

        $(".featuredEventsCarouselFeaturedUnits").slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          asNavFor: ".featuredEventsCarouselNavUnits",
          autoplay: true,
          autoplaySpeed: 5000,
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                autoplay: false,
              },
            },
          ],
        });

        $(".featuredEventsCarouselNavUnits").slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          asNavFor: ".featuredEventsCarouselFeaturedUnits",
          dots: false,
          centerMode: false,
          focusOnSelect: true,
          responsive: [
            {
              breakpoint: 1000,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: false,
              },
            },
            {
              breakpoint: 860,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: false,
              },
            },
          ],
        });

        vm.carouselInitialized = true;

        $scope.$apply(function () {
          vm.carouselInitializing = false;
        });

        vm.clientWidth = $rootScope.clientWidth;
      });
    };

    vm.getFeaturedEvents = function () {
      Home.getFeaturedEvents({}).$promise.then(
        function (data) {
          if (data && data.length > 0) {
            vm.featuredEvents = data;
          } else {
            vm.NoFeatured = true;
          }
        },
        function (error) {}
      );
    };

    vm.getFeaturedCategoriesEvents = function () {
      Home.getFeaturedCategoriesEvents({}).$promise.then(
        function (data) {
          if (data && data.length > 0) {
            vm.CategoriesEvents = data;
          }
        },
        function (error) {}
      );
    };

    vm.getPopularVenue = function () {
      Home.getPopularVenue({}).$promise.then(
        function (data) {
          if (data && data.Venue && data.VenuePerformances) {
            vm.PopularVenue = data.Venue;

            for (var i = 0; i < data.VenuePerformances.length; i++) {
              vm.VenuePerformances.push(data.VenuePerformances[i]);
            }
          }
        },
        function (error) {}
      );
    };

    vm.getTrendingToday = function () {
      Home.getTrendingToday({}).$promise.then(
        function (data) {
          if (data && data.length > 0) {
            vm.TrendingToday = data;
          } else {
            vm.NoTrending = true;
          }
        },
        function (error) {}
      );
    };

    vm.getPopularPerformers = function () {
      Home.getPopularPerformers({}).$promise.then(
        function (data) {
          if (data && data.length > 0) {
            vm.PopularPerformers = data;
          }
        },
        function (error) {}
      );
    };

    vm.getFeaturedEvents();
    vm.getFeaturedCategoriesEvents();
    vm.getTrendingToday();
    vm.getPopularVenue();
    vm.getPopularPerformers();

    vm.trySell = function (route, id) {
      var _route = route || "performance";

      if ($rootScope.User && $rootScope.User.Email) {
        User.IsUserBlockedOrDeleted({
          UserId: $rootScope.User.UserId,
        }).$promise.then(
          function (data) {
            if (data.status == "true") {
              location.href = "#/" + _route + "/" + id;
            } else {
              location.href = "#/";
              $rootScope.PopUpTitle = "Blocked User";

              $rootScope.PopUpDescription =
                "You don't have access please contact with Admin";

              $rootScope.showPopup = true;
            }
          },
          function (error) {}
        );
      } else {
        vm.toggleLoginPanel();
      }
    };

    vm.toggleLoginPanel = function () {
      $window.scrollTo(0, 0);
      $rootScope.loginPanelActive = !$rootScope.loginPanelActive;
      document.getElementById("userLoginEmail").value = "";
      document.getElementById("userLoginPassword").value = "";
      document.getElementById("userLoginRemember").checked = false;
      $rootScope.userLoginError = false;
      vm.User = {};
      vm.errors = {};
    };

    $rootScope.$on("app:loginPanelToggled", function () {
      if (!$rootScope.loginPanelActive) {
        vm.initCarousel();
      }
    });
  }
})();
;
(function () {
  'use strict';

  angular
      .module('eltazkaraApp')
      .config(stateConfig);

  stateConfig.$inject = ['$stateProvider'];

  function stateConfig($stateProvider) {
    $stateProvider.state('home', {
      parent: 'app',
      url: '/home',
      views: {
        'content@': {
          templateUrl: 'components/home/home.html',
          controller: 'HomeController',
          controllerAs: 'vm'
        }
      },
      resolve: {
        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
          $translatePartialLoader.addPart('global');
        }]
      }
    });
  }
})();
;
(function () {
    'use strict';

    angular
        .module('eltazkaraApp')
        .factory('Home', Home);

    Home.$inject = ['$resource'];

    function Home($resource) {
        var service = $resource(window.backendUrl + '/Home', {}, {
            'getFeaturedEvents': {
                method: 'GET', isArray: true,
                url: window.backendUrl + "Home/GetFeaturedEvents"
            },
            'getFeaturedCategoriesEvents': {
                method: 'GET', isArray: true,
                url: window.backendUrl + "Home/GetCategroiesEvents"
            },
            'getTrendingToday': {
                method: 'GET', isArray: true,
                url: window.backendUrl + "Home/GetTrendingToday"
            },
            'getPopularVenue': {
                method: 'GET', isArray: false,
                url: window.backendUrl + "Home/GetPopularVenue"
            },
            'getPopularPerformers': {
                method: 'GET', isArray: true,
                url: window.backendUrl + "Home/GetPopularPerformers"
            }
        });

        return service;
    }
})();
;
//(function () {
'use strict';
angular
    .module('eltazkaraApp')
    .controller('UsersController', UsersController)
    .factory('ConfirmCodeService', ConfirmCodeService)
    .service('ProfileService', ProfileService)
    .service('MyDataService', ['$http', function ($http) {
        this.getCountries = function () {
            return $http({
                url: window.backendUrl + "Locations/GetCountries",
                method: 'GET',
                crossDomain: true,
                withCredentials: false,
                headers: { 'content-type': 'application/json' }
            });
        };
    }])
    .service('ResendCodeService', ['$http', function ($http) {
        this.getCode = function (data) {
            return $http({
                url: window.backendUrl + "Users/ResendCode",
                method: 'POST',
                data: JSON.stringify(data),
                crossDomain: true,
                withCredentials: false,
                headers: { 'content-type': 'application/json' }
            });
        };
    }])
    .service('UpdateMobileService', UpdateMobileService)
    //.directive("mobileClaim", mobileClaim);
UsersController.$inject = [
    '$rootScope',
    '$scope',
    '$location',
    '$http',
    '$q',
    'MyDataService',
    'ProfileService',
    'ConfirmCodeService',
    'ResendCodeService',
    'UpdateMobileService',
    'UserData'
];
function UsersController($rootScope, $scope, $location, $http, $q, MyDataService, ProfileService, ConfirmCodeService, ResendCodeService, UpdateMobileService, UserData) {
    $rootScope.logoutText = UserData.getKey("LogoutText", "");
    $rootScope.mobileNumber = UserData.getKey("MobileNumber", "error");
    $rootScope.idee = UserData.getKey("UserId", "error");
    $rootScope.loginPanelActive = false;
    var vm = this;
    vm.toggleLoginPanel = function () {
        $rootScope.loginPanelActive = !$rootScope.loginPanelActive;
    }
    vm.regex = {
        Email: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9]+$/,
        Mobile: /^(01[0-2])\d{8}$/
    }
    vm.days = [''];
    for (var i = 1; i <= 31; i++) {
        vm.days.push(i);
    }
    vm.months = {
        0: ['', '', ''],
        1: ['January', '1', '31'],
        2: ['February', '2', '29'],
        3: ['March', '3', '31'],
        4: ['April', '4', '30'],
        5: ['May', '5', '31'],
        6: ['June', '6', '30'],
        7: ['July', '7', '31'],
        8: ['August', '8', '31'],
        9: ['September', '9', '30'],
        10: ['October', '10', '31'],
        11: ['November', '11', '30'],
        12: ['December', '12', '31']
    };
    vm.years = [''];
    vm.now = new Date();
    for (var i = '1916'; i <= parseInt(vm.now.getFullYear()); i++) {
        vm.years.push(i);
    }
    vm.changeDate = function(date) {
        if (date.day > 28) {
            date.day--;
            return date;
        } else if (date.month > 11) {
            date.day = 31;
            date.month--;
            return date;
        }
    };
    vm.checkDate = function (date) {
        //if (!date.day || date.month === null || date.month === undefined || !date.year) return false;
        //var d = new Date(Date.UTC(date.year, date.month, date.day));
        //if (d && (d.getMonth() === date.month && d.getDate() === Number(date.day))) {
        //    return d;
        //}
        //return vm.checkDate(vm.changeDate(date));
        //if (date.day > date.month[1]) {
        //    date.day = date.month[1];
        //}
    };
    vm.updateDays = function () {
        var days = [];
        while (dayRange[0] <= dayRange[1]) {
            days.push(dayRange[0]++);
        }
        return days;
    };
    vm.updateMonths = function () {
        var lst = [],
            mLen = vm.months.length;

        for (var i = 0; i < mLen; i++) {
            lst.push({
                value: i,
                name: vm.months[i]
            });
        }
        return lst;
    };
    vm.getCurrDay = function () {
        var birthdate = Date(Date.parse(UserData.getKey("Birthdate", ""), "Ymd"));
    }
    vm.getCurrDay();
    vm.saveText = "Save";
    vm.verificationText = "Verify";
    vm.resendText = "Resend Code";
    vm.skipText = "Skip"
    vm.updateText = "";
    vm.changeText = "Update";
    vm.mobileUpdateText = "";
    vm.mobileRejectToggle = false;
    vm.submitted = false;
    vm.errors = {};
    vm.locations = null;
    MyDataService.getCountries().then(function (resp) {
        vm.Countries = resp.data;
    });
    vm.getCities = function () {
        if (vm.HomeLocation.CountryId !== "" && vm.HomeLocation.CountryId > -1) {
            return vm.Countries[vm.HomeLocation.CountryId-1].CountryCities;
        }
    }
    vm.getCompanyCities = function () {
        if (vm.CompanyLocation.CountryId !== "" && vm.CompanyLocation.CountryId > -1) {
            return vm.Countries[vm.CompanyLocation.CountryId-1].CountryCities;
        }
    }
    vm.User = UserData.getUser();
    vm.Locations = [];
    vm.HomeLocation = UserData.getHomeLocation();
    vm.CompanyLocation = UserData.getCompanyLocation();
    var homeLocationUndefiendCount = 0;
    var companyLocationUndefiendCount = 0;


    //Save Data
    vm.SaveData = function () {
        if (vm.saveText == 'Save') {
            if (!vm.validate()) return;
            if (vm.User.Day && vm.User.Month && vm.User.Year) {
                vm.User.Birthdate = vm.User.Day + '-' + vm.User.Month + '-' + vm.User.Year;
            }
            var currData = UserData.getUser();
            for (var property in vm.User) {
                currData[property] = vm.User[property];
            }
            var obj = {};
            obj.User = currData;
            for (var key in vm.HomeLocation) {
                if (key === "LocationId" || key === "LocationTypeId") continue;
                if (typeof (vm.HomeLocation[key]) === 'undefined') {
                    homeLocationUndefiendCount++;
                }
            }
            for (var key in vm.CompanyLocation) {
                if (key === "LocationId" || key === "LocationTypeId") continue;
                if (typeof (vm.CompanyLocation[key]) === 'undefined') {
                    companyLocationUndefiendCount++;
                }
            }
            if (homeLocationUndefiendCount === 0) {
                vm.HomeLocation.LocationTypeId = "1";
                vm.Locations.push(vm.HomeLocation);
            }
            if (companyLocationUndefiendCount === 0) {
                vm.CompanyLocation.LocationTypeId = "2";
                vm.Locations.push(vm.CompanyLocation);
            }
            var locations = [];
            for (var i = 0; i < vm.Locations.length; i++) {
                //if (Object.keys(vm.Locations[i]).length === 1) continue;
                locations.push(vm.Locations[i]);
            }
            obj.Locations = locations;
            vm.saveText = 'Please Wait...';
            ProfileService.SaveFormData(obj).then(function (d) {
                if (d.Msg === 'updated') {
                    //UserData.set(d.User);
                    UserData.set(d.User, d.HomeLocation, d.CompanyLocation);
                    //    for (var location in d.Locations) {
                    //        if (location.LocationTypeId === '1') {
                    //            UserData.setKey("HomeLocationTypeId", location);
                    //        }
                    //        else {
                    //            UserData.setKey("CompanyLocation", location);
                    //        }
                    //    }
                    //}
                    vm.updateText = "Changes are saved."
                }
                else {
                    vm.updateText = "No such user."
                }
                vm.saveText = "Save";
            });
        }
    }
    //if (!($("#ucompany").val() === '')) {
    //}
    //else {
    //    errors = 0;
    //}
    //errors += errors;
    //if (errors > 0) {
    //    $scope.$apply(function () {
    //        vm.regValid = false;
    //    })
    //}
    //else {
    //    //$scope.$apply(function () {
    //        vm.regValid = true;
    //    //})
    //}
    vm.ConfirmCode = function (code) {
        if (vm.verificationText === 'Verify') {
            if ($("#uverificationcode").val() === "") {
                vm.errors.InvalidVerificationCode = "Code cannot be empty.";
                return false;
            }
            else {
                vm.errors.InvalidVerificationCode = "";
            }
            var data = {};
            data.VerificationCode = code;
            data.UserId = UserData.getKey("UserId", "error");
            vm.verificationText = "Please Wait..."
            ConfirmCodeService.ConfirmCode(data).then(function (d) {
                if (d.Msg === 'Verified') {
                    vm.errors.InvalidVerificationCode = ""
                    UserData.set(d.User);
                    $location.path("/home");
                }
                else if (d.Msg === 'Invalid') {
                    vm.errors.InvalidVerificationCode = "Invalid verification code."
                }
                else {
                    vm.errors.InvalidVerificationCode = "No such user."
                }
                vm.verificationText = "Verify";
            });
        }
    };
    vm.ResendCode = function () {
        if (vm.resendText === 'Resend Code') {
            vm.resendText = 'Please wait...';
            var data = {};
            var userId = UserData.getKey("UserId", "-1");
            data.UserId = userId;
            ResendCodeService.getCode(data).then(function (res) {
                if (res.data.Msg === 'resent') {
                    UserData.setKey("UserCode", res.data.ResentCode);
                    vm.errors.InvalidVerificationCode = "Code has been resent.";
                }
                vm.resendText = 'Resend Code';
            })
            //.error(function () {
            //    vm.resendText === 'Resend Code';
            //});
        };
    };
    vm.skipVerification = function () {
        if (vm.skipText === 'Skip') {
            UserData.setKey("VerificationSkipped", true);
            $location.path('/home');
        }
    }
    vm.updateMobile = function() {
        $location.path('/users/verify/update');
    }
    vm.saveMobile = function (number) {
        if (vm.changeText === 'Update') {
            if ($("#newmobilenumber").val() === "") {
                vm.errors.InvalidMobileNumber = "Number cannot be empty.";
                return false;
            }
            else {
                vm.errors.InvalidMobileNumber = "";
            }
            if (vm.checkErrors()) {
                var obj = {};
                var id = UserData.getKey("UserId", "");
                var newMobile = number;
                obj.UserId = id;
                obj.NewMobile = newMobile;
                UpdateMobileService.updateMobile(obj).then(function (res) {
                    if (res.Msg === "changed") {
                        UserData.setKey("MobileNumber", res.NewMobileNumber);
                        $rootScope.mobileNumber = res.NewMobileNumber;
                        vm.toggleMobileReject();
                    }
                    vm.changeText = 'Update';
                })
            }
        }
    }
    vm.checkErrors = function() {
        var errors = 0;
        for (var key in vm.errors) {
            if (vm.errors[key] !== "") {
                errors++;
            }
        }
        if (errors > 0) {
            return false;
        }
        else {
            return true;
        }
    }
    vm.toggleMobileReject = function() {
        vm.mobileRejectToggle = !vm.mobileRejectToggle;
        vm.errors = {};
    }
    vm.validate = function () {
        var missing = 0;
        if ($("#fullname").val() === '') {
            missing++;
            vm.errors.FullName = "Full name is required.";
        }
        if ($("#mobilenumber").val() === '') {
            missing++;
            vm.errors.MobileNumber = "Mobile number is required.";
        }
        if ($("#email").val() === '') {
            missing++;
            vm.errors = "Email address is required.";
        }
        if ($("#password").val() === '') {
            missing++;
            vm.errors.Password = "Password is required.";
        }
        if (($("#day").val() !== '' || $("#month").val() !== '' || $("#year").val() !== '')) {
            if ($(this).siblings("select").val() === '') {
                missing++;
                vm.errors.BirthDate = "Full birthdate is required.";
            }
        }
        else {
            vm.errors.BirthDate = "";
        }
        if ($("#homecity").val() === '' && $("#homecountry").val() !== '') {
            missing++;
            vm.errors.HomeCity = "City is required.";
        }

        if ($("#company").val() === '') {
            vm.errors.CompanyCity = vm.errors.CompanyAddress = vm.errors.CompanyPostalCode = "";
            $("#companyphone, #companycountry, #companycity, #companyaddress, #companypostalcode").val("");
        }
        if (missing > 0) {
            return false;
        }
        else {
            var errors = 0;
            for (var key in vm.errors) {
                if (vm.errors[key] !== "") {
                    errors++;
                }
            }
            if (errors > 0) {
                return false;
            }
            else {
                return true;
            }
        }
    }
    $(document).ready(function () {
        var errors = 0;
        if ($("#company").val() === '') {
            $("#companyphone, \n\
                        #companycountry, \n\
                        #companycity, \n\
                        #companyaddress, \n\
                        #companypostalcode").attr('disabled', 'disabled');
        }
        else {
            $("#companyphone, \n\
                        #companycountry, \n\
                        #companycity, \n\
                        #companyaddress, \n\
                        #companypostalcode").attr('disabled', 'disabled').removeAttr('disabled');
        }
        $("#fullname").on("keyup change", function (e) {
            if (e.which === 9) return;
            $scope.$apply(function () {
                if ($("#fullname").val() === '') {
                    errors++;
                    vm.errors.FullName = "Full name is required.";
                }
                else if (!($("#fullname").val().match(/\s/g))) {
                    errors++;
                    vm.errors.FullName = "At least two words.";
                }
                else {
                    vm.errors.FullName = "";
                }
            });
        });
        $("#mobilenumber").on("keyup change", function (e) {
            if (e.which === 9) return;
            $scope.$apply(function () {
                if ($("#mobilenumber").val() === '') {
                    errors++;
                    vm.errors.MobileNumber = "Mobile number is required.";
                }
                else if (!($("#mobilenumber").val().match(/^(01[0-2])\d{8}$/))) {
                    errors++;
                    vm.errors.MobileNumber = "Invalid mobile number.";
                }
                else {
                    vm.errors.MobileNumber = "";
                }
            });
        });
        $("#email").on("keyup change", function (e) {
            if (e.which === 9) return;
            $scope.$apply(function () {
                if ($("#email").val() === '') {
                    errors++;
                    vm.errors.Email = "Email address is required.";
                }
                else if (!($("#email").val().match(/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9]+$/))) {
                    errors++;
                    vm.errors.Email = "Invalid email address.";
                }
                else {
                    vm.errors.Email = "";
                }
            });
        });
        $("#password").on("keyup change", function (e) {
            if (e.which === 9) return;
            $scope.$apply(function () {
                if ($("#password").val() === $("#confirmpassword").val()) {
                    vm.errors.ConfirmPassword = "";
                }
                else {
                    errors++;
                    vm.errors.ConfirmPassword = "Passwords do not match.";
                }
                if ($("#password").val() === '') {
                    errors++;
                    vm.errors.Password = "Password is required.";
                }
                else if ($("#password").val().length < 6) {
                    errors++;
                    vm.errors.Password = "Password is too short";
                }
                else if ($("#password").val().length > 32) {
                    errors++;
                    vm.errors.Password = "Password is too long";
                }
                else {
                    vm.errors.Password = "";
                }
            });
        });
        $("#confirmpassword").on("keyup change", function (e) {
            if (e.which === 9) return;
            $scope.$apply(function () {
                if (!($("#confirmpassword").val() === $("#password").val())) {
                    errors++;
                    vm.errors.ConfirmPassword = "Passwords do not match.";
                }
                else {
                    vm.errors.ConfirmPassword = "";
                }
            });
        });
        $("#day, #month, #year").on("change", function () {
            var full = true;
            $(".birthdate").each(function () {
                if ($(this).val() === '') {
                    full = false;
                }
            });
            if ($(this).val() === '' || !full) {
                errors++;
                vm.errors.BirthDate = "Full birthdate is required.";
            }
            else {
                vm.errors.BirthDate = "";
            }
            if ($("#day").val() === '' && $("#month").val() === '' && $("#year").val() === '') {
                vm.errors.BirthDate = "";
            }
        })
        $("#male, #female").on("change", function (e) {
            if (e.which === 9) return;
            $scope.$apply(function () {
                vm.errors.Gender = "";
            });
        });
        $("#homecountry").on("change", function (e) {
            if (e.which === 9) return;
            $scope.$apply(function () {
                if ($("#homecountry").val() === '') {
                    errors++;
                    vm.errors.HomeCity = "";
                }
                else {
                    if ($("#homecity").val() === '') {
                        vm.errors.HomeCity = "City is required.";
                    }
                    else {
                        vm.errors.HomeCity = "";
                    }
                }
            });
        });
        $("#homecity").on("change", function (e) {
            if (e.which === 9) return;
            $scope.$apply(function () {
                if ($("#homecity").val() === '' && $("#homecountry").val() !== '') {
                    errors++;
                    vm.errors.HomeCity = "City is required.";
                }
                else {
                    vm.errors.HomeCity = "";
                }
            });
        });
        $("#homeaddress").on("keyup change", function (e) {
            if (e.which === 9) return;
            $scope.$apply(function () {
                if ($("#homeaddress").val() === '') {
                    errors++;
                    vm.errors.HomeAddress = "Address is required.";
                }
                else {
                    vm.errors.HomeAddress = "";
                }
            });
        });

        $("#homepostalcode").on("keyup change", function (e) {
            if (e.which === 9) return;
            $scope.$apply(function () {
                if ($("#homepostalcode").val() === '') {
                    errors++;
                    vm.errors.HomePostalCode = "Postal code is required.";
                }
                else {
                    vm.errors.HomePostalCode = "";
                }
            });
        });

        $("#company").on("keyup change", function (e) {
            if ($(this).val() === '') {
                $("#companyphone, \n\
                        #companycountry, \n\
                        #companycity, \n\
                        #companyaddress, \n\
                        #companypostalcode").attr('disabled', 'disabled');
            }
            else {
                $("#companyphone, \n\
                        #companycountry, \n\
                        #companycity, \n\
                        #companyaddress, \n\
                        #companypostalcode").removeAttr('disabled');
                $("#companyphone").on("keyup change", function (e) {
                    if (e.which === 9) return;
                    if ($("#companyphone").val() === '') {
                        $scope.$apply(function () {
                            errors++;
                            vm.errors.CompanyPhone = "Company phone number is required.";
                        })
                    }
                    else if (!($("#companyphone").val().match(/^(01[0-2])\d{8}$/))) {
                        $scope.$apply(function () {
                            errors++;
                            vm.errors.CompanyPhone = "Invalid company phone number.";
                        })
                    }
                    else {
                        $scope.$apply(function () {
                            vm.errors.CompanyPhone = "";
                        })
                    }
                });
                $("#companycountry").on("change", function (e) {
                    if (e.which === 9) return;
                    if ($(this).val() === '') {
                        $scope.$apply(function () {
                            errors++;
                            vm.errors.CompanyCity = "";
                        })
                    }
                    else {
                        if ($("#companycity").val() === '') {
                            $scope.$apply(function () {
                                vm.errors.CompanyCity = "Company city is required.";
                            })
                        }
                        else {
                            $scope.$apply(function () {
                                vm.errors.CompanyCity = "";
                            })
                        }
                    }
                });
                $("#companycity").on("change", function (e) {
                    if (e.which === 9) return;
                    if ($("#companycity").val() === '') {
                        $scope.$apply(function () {
                            errors++;
                            vm.errors.CompanyCity = "Company city is required.";
                        })
                    }
                    else if ($("#companycity").val() === '' && $("#companycountry").val() !== '') {
                        $scope.$apply(function () {
                            errors++;
                            vm.errors.CompanyCity = "Company city is required.";
                        })
                    }
                    else {
                        $scope.$apply(function () {
                            vm.errors.CompanyCity = "";
                        })
                    }
                });
                $("#companyaddress").on("keyup change", function (e) {
                    if (e.which === 9) return;
                    if ($("ucompanyaddress").val() === '') {
                        $scope.$apply(function () {
                            errors++;
                            vm.errors.CompanyAddress = "Company address is required.";
                        })
                    }
                    else {
                        $scope.$apply(function () {
                            vm.errors.CompanyAddress = "";
                        })
                    }
                });
                $("#companypostalcode").on("keyup change", function (e) {
                    if (e.which === 9) return;
                    if ($("#companypostalcode").val() === '') {
                        $scope.$apply(function () {
                            errors++;
                            vm.errors.CompanyPostalCode = "Company postal code is required.";
                        })
                    }
                    else {
                        $scope.$apply(function () {
                            vm.errors.CompanyPostalCode = "";
                        })
                    }
                });
            }
        })
        //=======================================================================================
        //Change Mobile Page
        //=======================================================================================
        $("#newmobilenumber").on("keyup change", function (e) {
            if (e.which === 9) return;
            if ($(this).val() === "") {
                $scope.$apply(function () {
                    errors++;
                    vm.errors.InvalidMobileNumber = "Number cannot be empty.";
                })
            }
            else if (!($("#newmobilenumber").val().match(vm.regex.Mobile))) {
                $scope.$apply(function () {
                    errors++;
                    vm.errors.InvalidMobileNumber = "Invalid mobile number.";
                })
            }
            else {
                $scope.$apply(function () {
                    errors++;
                    vm.errors.InvalidMobileNumber = "";
                })
            }
        })
        $("#uverificationcode").on("keyup change", function (e) {
            if (e.which === 9) return;
        })
        $("#image").on("change", function (e) {
            var fileName = e.target.files[0].name;
            vm.User.Image = fileName;
        })
    });
};
function ProfileService($http, $q) {
    var fac = {};
    fac.SaveFormData = function (data) {
        var defer = $q.defer();
        $http({
            url: window.backendUrl + "Users/Update",
            method: 'POST',
            data: JSON.stringify(data),
            crossDomain: true,
            withCredentials: false,
            headers: { 'content-type': 'application/json' }
        }).success(function (d) {
            defer.resolve(d);
        }).error(function (e) {
            console.log('Error', e);
            defer.reject(e);
        });
        return defer.promise;
    }
    return fac;
}
function ConfirmCodeService($http, $q) {
    var o = {};
    o.ConfirmCode = function (data) {
        var defer = $q.defer();
        $http({
            url: window.backendUrl + "Users/Verify",
            method: 'POST',
            data: JSON.stringify(data),
            crossDomain: true,
            withCredentials: false,
            headers: { 'content-type': 'application/json' }
        }).success(function (d) {
            defer.resolve(d);
        }).error(function (e) {
            console.log('Error', e);
            defer.reject(e);
        });
        return defer.promise;
    }
    return o;
}
function UpdateMobileService($http, $q) {
    var o = {};
    o.updateMobile = function (data) {
        var defer = $q.defer();
        $http({
            url: window.backendUrl + "Users/UpdateMobile",
            method: 'POST',
            data: JSON.stringify(data),
            crossDomain: true,
            withCredentials: false,
            headers: { 'content-type': 'application/json' }
        }).success(function (d) {
            defer.resolve(d);
        }).error(function (e) {
            console.log('Error', e);
            defer.reject(e);
        });
        return defer.promise;
    }
    return o;
}
;
(function () {
    'use strict';

    angular
        .module('eltazkaraApp')
        .controller('VerifyController', VerifyController);

    UsersController.$inject = [
        '$rootScope',
        '$state',
        'User',
        'stateService',
        'userInfo',
        'RequestsService',
        '$cookies'
    ];

    function VerifyController(
        $rootScope,
        $state,
        User,
        stateService,
        userInfo,
        RequestsService,
        $cookies
    ) {
        var vm = this;
        vm.firstSent = false;
        vm.secondSent = false;
        vm.disableButton = false;
        vm.wehreToRedirect = '#/users/account';
        vm.verificationCheck = false;

		vm.regex = {
			mobile: /^(20|0){0,1}1[0-2,5]{1}[0-9]{8}$/
		};

        if ($rootScope.User)
            vm.id = $rootScope.User.UserId;
        else
            $state.go('home');

        vm.checkVerification = function () {
            User.checkVerification({ UserId: vm.id }).$promise.then(function (data) {
                vm.verificationCheck = true;
            });
        };

        if ($cookies.get('SmsSent') == 'true') {
            vm.showEmailPopUp = true;
            vm.resendVerificationCodeText = 'Resend Code';
            vm.firstSent = true;
            vm.secondSent = false;
            $cookies.remove('SmsSent');
            $cookies.put('SmsSent', 'false');
        } else {
            vm.firstSent = false;
            vm.secondSent = true;
            vm.resendVerificationCodeText = 'Send Code';
        }

        vm.wehreToRedirect = userInfo.getData();
        vm.checkVerification();
        vm.mobileNumber, vm.verificationCode;
        vm.verificationCodeSubmitted = false;
        vm.incorrectVerificationCode = false;
        vm.verificationCodeResent = false;
        vm.verifyText = 'Verify';
        vm.resendVerificationCodeText = 'Send Code';
        vm.skipVerificationText = 'Skip';
        vm.changeMobileNumberText = 'Change';
        var redirector = stateService.getPrev();

        vm.getMobileNumber = function () {
            vm.mobileNumber = 'Please wait...';

            User.getMobileNumber({ UserId: vm.id }).$promise.then(function (data) {
                if (data.User)
                    vm.mobileNumber = data.User.MobileNumber;
            });
        };

        vm.getMobileNumber();

        vm.rejectMobileNumber = function () {
            vm.mobileNumberCopy = angular.copy(vm.mobileNumber);
            vm.toggleMobileRejection();
        };

        vm.cancelRejection = function () {
            vm.mobileNumber = vm.mobileNumberCopy;
            vm.toggleMobileRejection();
        };

        vm.verify = function (codeThere) {
            vm.verificationCodeSubmitted = true;
            
            if (codeThere) {
                vm.verifyText = 'Please wait...';
                User.verifyMobileNumber({
                    UserId: vm.id,
                    VerificationCode: vm.verificationCode
                }).$promise.then(function (data) {
                    if (data.Msg === 'Verified') {
                        var redirection = redirector === 'account' ? 'account' : 'home';
                        vm.verificationCode = null;
                        vm.message = '';

                        if (vm.wehreToRedirect != '') {
                            userInfo.setWhereToRedirectAfterVerify('#/users/account');
                            $cookies.put('refresh', 'true');
                            location.href = vm.wehreToRedirect;
                        } else
                            $state.go(redirection);
                    } else {
                        vm.incorrectVerificationCode = true;
                        vm.message = 'Invalid code';
                    }

                    vm.verifyText = 'Verify';
                });
            }
            else
                vm.message = 'Code is required';
        };
        
        //Redirect back to account settings if came from it, home page otherwise
        vm.skipVerification = function () {
            if (vm.skipVerificationText === 'Skip') {
                var redirection = redirector === 'account' ? 'account' : 'home';
                vm.verificationCode = null;
                vm.message = '';
                $state.go(redirection);
            }
        };

        vm.resendVerificationCode = function () {
            if (vm.disableButton != true) {
                userInfo.SendSMSVerifiy({}).$promise.then(function (data) {
                    vm.resendVerificationCodeText = 'Please wait...';
                    vm.disableButton = false;

                    if (data.status && data.status == 'success') {
                        vm.verificationCodeResent = true;
                        vm.resendVerificationCodeText = 'Resend Code';
                    } 
                    else
                        vm.SendErrorRequest(data.status);
                });

            }
            vm.disableButton = true;
        };

        vm.SendErrorRequest = function (messageError) {
            RequestsService.AddRequest({
                Subject: 'SMS Credit is Over',
                RequestTypeId: { id: 6 },
                Name: $rootScope.User.Name,
                Mobile: $rootScope.User.MobileNumber,
                Email: '',
                ToFinance: true,
                Body: messageError
            }).$promise.then(function (data) { }).catch(function (error) {
                console.log(error)
            }).finally(function () {
                vm.resendVerificationCodeText = 'Resend Code';
                $rootScope.PopUpTitle = 'Mobile Verification Error';
                $rootScope.PopUpDescription = 'We are not able to send you a verification code, please try again later.';
                $rootScope.PopError = true;
            });
        };

        vm.change = function (numberValid) {
            vm.newNumberSubmitted = true;
            vm.mobileUsed = false;

            if (numberValid) {
                vm.changeMobileNumberText = 'Please wait...';

                User.UpdateMobileAndSendSMS({ NewMobile: vm.mobileNumber }).$promise.then(function (data) {
                    if (data.status) {
                        $rootScope.PopUpTitle = 'Update Error';
                        $rootScope.PopUpDescription = data.status;
                        $rootScope.PopError = true;
                    }

                    if (data.Break_Msg)
                        vm.mobileUsed = true;

                    if (data.Msg === 'changed')
                        vm.toggleMobileRejection();

                    vm.changeMobileNumberText = 'Change';
                });
            }
            else
                vm.message = 'Code is required';
        };

        vm.toggleMobileRejection = function () {
            vm.mobileRejectionToggle = !vm.mobileRejectionToggle;
            vm.message = '';
        };
    }
})();
;
(function() {
	'use strict';
    
	angular
		.module('eltazkaraApp')
		.controller('ProfileController', ProfileController);

	ProfileController.$inject = [
		'$rootScope',
		'userInfo',
		'$state',
		'$timeout',
		'fieldsService'
	];

	function ProfileController(
		$rootScope,
		userInfo,
		$state,
		$timeout,
		fieldsService
	) {
		var vm = this;
		if ($rootScope.User) vm.id = $rootScope.User.UserId;
		else $state.go('home');
		vm.submitProfileText = vm.submitLocationText = vm.submitCompanyText ='Update';
		vm.profileSubmitted = vm.locationSubmitted = vm.companySubmitted = false;
		vm.profileSent = vm.locationSent = vm.companySent = false;
        vm.profileInfoDetails = {};
		vm.genders = [['none', 'Not set'], [true, 'Male'], [false, 'Female']];

		vm.getProfileInfo = function() {
			userInfo.getProfileInfoDetails({ UserId: vm.id }).$promise.then(function(data) {
                if (data.User) {
                    vm.setProfileInfoModel(data.User);
                    vm.updateDays(vm.profileInfoDetails.Month);
                }
            });
		};

		vm.getProfileInfo();

        vm.saveProfileInfo = function(profileInfoValid) {
			vm.profileSubmitted = true;

			if (profileInfoValid) {
				vm.submitProfileText = 'Please wait...';
				vm.profileSent = true;

				vm.profileInfoDetails.NameCopy = vm.profileInfoDetails.GenderCopy = vm.profileInfoDetails.DayCopy 
                    = vm.profileInfoDetails.MonthCopy = vm.profileInfoDetails.YearCopy = null;

				vm.profileInfoDetails.Gender =vm.profileInfoDetails.Gender === 'none'
                    ? null
                    : vm.profileInfoDetails.Gender;

				vm.profileInfoDetails.UserId = vm.id;
				vm.profileInfoDetails.Birthdate = vm.profileInfoDetails.Year === 'YYYY'
                    ? null
                    : (vm.profileInfoDetails.Birthdate =
                            vm.profileInfoDetails.Year +
                            '-' +
                            vm.profileInfoDetails.Month +
                            '-' +
                            vm.profileInfoDetails.Day);
                            
				userInfo.saveProfileInfoDetails({ profileInfoDetails: vm.profileInfoDetails }).$promise.then(function(data) {
                    if (data.User) {
                        vm.setProfileInfoModel(data.User);
                        vm.submitProfileText = 'Update';
                        vm.profileSubmitted = false;
                        $rootScope.User.Name = data.User.Name.split(' ')[0];
                        vm.toggler('profileInfo');
                    }

                    vm.profileSent = false;
                });
			}
		};

		vm.setProfileInfoModel = function(data) {
			vm.profileInfoDetails.Name = data.Name;
			vm.profileInfoDetails.NameCopy = angular.copy(vm.profileInfoDetails.Name);
			vm.profileInfoDetails.Gender = data.Gender;
			vm.profileInfoDetails.GenderCopy = angular.copy(vm.profileInfoDetails.Gender);

			switch (vm.profileInfoDetails.Gender) {
				case true:
					vm.GenderLiteral = 'Male';
					break;
				case false:
					vm.GenderLiteral = 'Female';
					break;
				case 'none':
					vm.GenderLiteral = 'Not set';
			}

			vm.profileInfoDetails.Day = data.Day ? data.Day : 'DD';
			vm.profileInfoDetails.DayCopy = angular.copy(vm.profileInfoDetails.Day);
			vm.profileInfoDetails.Month = data.Month ? data.Month : 'MM';
			vm.profileInfoDetails.MonthCopy = angular.copy(vm.profileInfoDetails.Month);
			vm.profileInfoDetails.Year = data.Year ? data.Year : 'YYYY';
			vm.profileInfoDetails.YearCopy = angular.copy(vm.profileInfoDetails.Year);

			vm.profileInfoDetails.Birthdate = data.Year
				? vm.combineDate(vm.profileInfoDetails.Day, vm.profileInfoDetails.Month, vm.profileInfoDetails.Year)
				: null;
		};

		vm.checkValidity = function(e) {
			if (e.which === 50) 
                e.preventDefault();
		};

        vm.combineDate = function(d, m, y) {
			var day = d < 10 ? '0' + d : d;
			var month = m < 10 ? '0' + m : m;
			var year = y;
			return day + '/' + month + '/' + year;
		};

        vm.countries = [];
		vm.homeCities = [];
		vm.companyCities = [];
		vm.homeCountriesLoading = vm.companyCountriesLoading = vm.homeCitiesLoading = vm.compnayCitiesLoading = false;
		vm.homeCityLoading, vm.companyCityLoading;

        vm.getHomeCountries = function() {
			vm.homeCountriesLoading = true;
			vm.homeLocationCountryLiteral = vm.homeLocationCityLiteral = 'Please wait...';
			vm.homeCountries = [];

			vm.homeCountries.push({
				CountryId: 0,
				CountryName: 'Please wait...'
			});

			userInfo.getAllCountries().$promise.then(function(data) {
				vm.homeCountriesLoading = false;

				if (data) {
					vm.homeCountries = [];
					vm.homeCountries = data;

					vm.homeCountries.unshift({
						CountryId: 0,
						CountryName: 'None'
					});

					if (vm.homeLocationInfoDetails.CountryId == 0)
						vm.homeLocationCountryLiteral = 'Not set';
					else {
						for (var i = 0; i < vm.homeCountries.length; i++) {
							if (vm.homeCountries[i].CountryId == vm.homeLocationInfoDetails.CountryId) {
								vm.homeLocationCountryLiteral = vm.homeCountries[i].CountryName;
								break;
							}
						}
					}

					vm.getHomeCountryCities(false);
				}
			});
		};

        vm.getCompanyCountries = function() {
			vm.companyCountriesLoading = true;
			vm.companyLocationCountryLiteral = vm.companyLocationCityLiteral = 'Please wait...';
			vm.companyCountries = [];

			vm.companyCountries.push({
				CountryId: 0,
				CountryName: 'Please wait...'
			});

			userInfo.getCompanyCountries().$promise.then(function(data) {
				vm.companyCountriesLoading = false;

				if (data) {
					vm.companyCountries = [];
					vm.companyCountries = data;

					vm.companyCountries.unshift({
						CountryId: 0,
						CountryName: 'None'
					});

					if (vm.companyLocationInfoDetails.CountryId == 0)
						vm.companyLocationCountryLiteral = 'Not set';
					else {
						for (var i = 0; i < vm.companyCountries.length; i++) {
							if (vm.companyCountries[i].CountryId == vm.companyLocationInfoDetails.CountryId) {
								vm.companyLocationCountryLiteral = vm.companyCountries[i].CountryName;
								break;
							}
						}
					}

					vm.getCompanyCountryCities(false);
				}
			});
		};

        vm.getHomeCountryCities = function(changed) {
			vm.homeCitiesLoading = true;
			vm.homeCityLoading = false;

			if (vm.homeLocationInfoDetails.CityId > 0 && !vm.locationInfo) {
				vm.homeLocationCityLiteral = 'Please wait...';
				vm.homeCityLoading = true;
			}

			vm.homeCities = [];

			if (changed) {
				if (vm.homeLocationInfoDetails.CountryId <= 0) {
					vm.homeLocationInfoDetails.CityId = null;
					vm.homeLocationInfoDetails.Address = null;
					vm.homeLocationInfoDetails.PostalCode = null;
				} else {
					vm.homeCities.push({
						CityId: 0,
						CityName: 'Please wait...'
					});

					vm.homeLocationInfoDetails.CityId = vm.homeCities[0].CityId;
				}
			}

			userInfo.getCountryCities({ CountryId: vm.homeLocationInfoDetails.CountryId }).$promise.then(function(data) {
                vm.homeCitiesLoading = false;

                if (data.CountryCities) {
                    vm.homeCities = data.CountryCities;

                    if (changed)
                        vm.homeLocationInfoDetails.CityId = vm.homeCities[0].CityId;
                    else {
                        for (var i = 0; i < vm.homeCities.length; i++) {
                            if (vm.homeCities[i].CityId == vm.homeLocationInfoDetails.CityId)
                                vm.homeLocationCityLiteral = vm.homeCities[i].CityName;
                        }
                    }

                    vm.homeCityLoading = false;
                }
            });
		};

        vm.getCompanyCountryCities = function(changed) {
			vm.compnayCitiesLoading = true;
			vm.companyCityLoading = false;

			if (vm.companyLocationInfoDetails.CityId > 0) {
				vm.companyLocationCityLiteral = 'Please wait...';
				vm.companyCityLoading = true;
			}

			vm.companyCities = [];

			if (changed) {
				if (vm.companyLocationInfoDetails.CountryId <= 0) {
					vm.companyLocationInfoDetails.CityId = null;
					vm.companyLocationInfoDetails.Address = null;
					vm.companyLocationInfoDetails.PostalCode = null;
					vm.companyInfoDetails.CompanyName = null;
				} else {
					vm.companyCities.push({
						CityId: 0,
						CityName: 'Please wait...'
					});

					vm.companyLocationInfoDetails.CityId = vm.companyCities[0].CityId;
				}
			}

			userInfo.getCountryCities({ CountryId: vm.companyLocationInfoDetails.CountryId }).$promise.then(function(data) {
                vm.compnayCitiesLoading = false;

                if (data.CountryCities) {
                    vm.companyCities = data.CountryCities;

                    if (changed)
                        vm.companyLocationInfoDetails.CityId = vm.companyCities[0].CityId;
                    else {
                        for (var i = 0; i < vm.companyCities.length; i++) {
                            if (vm.companyCities[i].CityId == vm.companyLocationInfoDetails.CityId) {
                                vm.companyLocationCityLiteral = vm.companyCities[i].CityName;
                            }
                        }
                    }

                    vm.companyCityLoading = false;
                }
            });
		};

		vm.homeLocationInfoDetails = {
			LocationTypeId: 1,
			CountryId: 0,
			CityId: 0
		};

        vm.getHomeLocation = function() {
			userInfo.getLocation({
                UserId: vm.id,
                LocationTypeId: vm.homeLocationInfoDetails.LocationTypeId
            }).$promise.then(function(data) {
                if (data.Location) {
                    vm.setHomeLocationInfoModel(data.Location);
                    vm.toggler('locationInfo');
                }
            });
		};

		vm.getHomeLocation();

		vm.saveHomeLocation = function(homeLocationInfoValid) {
			vm.locationSubmitted = true;

			if (homeLocationInfoValid) {
				vm.submitLocationText = 'Please wait...';
				vm.locationSent = true;
				userInfo.saveLocation({
                    UserId: vm.id,
                    locationInfoDetails: vm.homeLocationInfoDetails
                }).$promise.then(function(data) {
                    if (data.Location) {
                        vm.setHomeLocationInfoModel(data.Location);
                        vm.locationSubmitted = false;
                        vm.submitLocationText = 'Update';
                        vm.toggler('locationInfo');
                    }

                    vm.locationSent = false;
                });
			}
		};

		vm.setHomeLocationInfoModel = function(data) {
			$timeout(function() {
				vm.homeLocationInfoDetails.LocationId = data.LocationId;
				vm.homeLocationInfoDetails.CountryId = data.CountryId > 0 ? data.CountryId : 0;
				vm.homeLocationInfoDetails.CountryIdCopy = angular.copy(vm.homeLocationInfoDetails.CountryId);
				vm.homeLocationInfoDetails.CityId = data.CityId > 0 ? data.CityId : 0;
				vm.homeLocationInfoDetails.CityIdCopy = angular.copy(vm.homeLocationInfoDetails.CityId);

				vm.homeLocationCityLiteral = vm.homeLocationInfoDetails.CityId > 0
                    ? vm.homeLocationCityLiteral
                    : null;

				vm.homeLocationInfoDetails.Address = data.Address;
				vm.homeLocationInfoDetails.AddressCopy = angular.copy(vm.homeLocationInfoDetails.Address);
				vm.homeLocationInfoDetails.PostalCode = data.PostalCode;
				vm.homeLocationInfoDetails.PostalCodeCopy = angular.copy(vm.homeLocationInfoDetails.PostalCode);
			});

			vm.getHomeCountries();
		};

        vm.companyInfoDetails = {};

		vm.companyLocationInfoDetails = {
			LocationTypeId: 2,
			CountryId: 0,
			CityId: 0
		};
		
        vm.getCompanyInfo = function() {
			userInfo.getCompanyInfoDetails({ UserId: vm.id }).$promise.then(function(data) {
                if (data.User)
                    vm.setCompanyInfoModel(data.User);
            });
		};

		vm.getCompanyInfo();
		
        vm.getCompanyLocation = function() {
			userInfo
				.getLocation({
					UserId: vm.id,
					LocationTypeId: vm.companyLocationInfoDetails.LocationTypeId
				})
				.$promise.then(function(data) {
					if (data.Location) {
						vm.setCompanyLocationInfoModel(data.Location);
						vm.toggler('locationInfo');
					}
				});
		};

		vm.getCompanyLocation();

		vm.saveCompanyInfo = function(companyInfoValid) {
			vm.companySubmitted = true;

			if (companyInfoValid) {
				vm.submitCompanyText = 'Please wait...';
				vm.companySent = true;
				vm.companyInfoDetails.UserId = vm.id;

				userInfo.saveCompanyInfoDetails({ companyInfoDetails: vm.companyInfoDetails }).$promise.then(function(data) {
                    if (data.User) {
                        vm.setCompanyInfoModel(data.User);
                        vm.submitCompanyText = 'Update';
                        vm.companyInfo = false;
                    }
                });

				userInfo.saveLocation({
                    UserId: vm.id,
                    locationInfoDetails: vm.companyLocationInfoDetails
                }).$promise.then(function(data) {
                    if (data.Location) {
                        vm.setCompanyLocationInfoModel(data.Location);
                        vm.submitCompanyText = 'Update';
                        vm.companySubmitted = false;
                        vm.companyInfo = false;
                    }

                    vm.companySent = false;
                });
			}
		};

		vm.setCompanyInfoModel = function(data) {
			vm.companyInfoDetails.CompanyName = data.CompanyName;
			vm.companyInfoDetails.CompanyNameCopy = angular.copy(vm.companyInfoDetails.CompanyName);
			vm.companyInfoDetails.CompanyPhone = data.CompanyPhone;
			vm.companyInfoDetails.CompanyPhoneCopy = angular.copy(vm.companyInfoDetails.CompanyPhone);
		};

		vm.setCompanyLocationInfoModel = function(data) {
			$timeout(function() {
				vm.companyLocationInfoDetails.LocationId = data.LocationId;
				vm.companyLocationInfoDetails.CountryId = data.CountryId > 0 ? data.CountryId : 0;
				vm.companyLocationInfoDetails.CountryIdCopy = angular.copy(vm.companyLocationInfoDetails.CountryId);
				vm.companyLocationInfoDetails.CityId = data.CityId > 0 ? data.CityId : 0;
				vm.companyLocationInfoDetails.CityIdCopy = angular.copy(vm.companyLocationInfoDetails.CityId);

				vm.companyLocationCityLiteral = vm.companyLocationInfoDetails.CityId > 0
                    ? vm.companyLocationCityLiteral
                    : null;

				vm.companyLocationInfoDetails.Address = data.Address;
				vm.companyLocationInfoDetails.AddressCopy = angular.copy(vm.companyLocationInfoDetails.Address);
				vm.companyLocationInfoDetails.PostalCode = data.PostalCode;
				vm.companyLocationInfoDetails.PostalCodeCopy = angular.copy(vm.companyLocationInfoDetails.PostalCode);
			});

			vm.getCompanyCountries();
		};

		vm.toggler = function(varName) {
			if (!vm[varName]) {
				vm[varName] = false;
			}

			vm[varName] = !vm[varName];
		};

		vm.regex = {
			name: /\s/g, //A basic name regex (ignored for now)
			mobile: /^(20|0){0,1}1[0-2,5]{1}[0-9]{8}$/
		};

		vm.checkFullBirthdate = function(ctrl) {
			var notFull =
				vm.profileInfoDetails.Day === 'DD' ||
				vm.profileInfoDetails.Month === 'MM' ||
				vm.profileInfoDetails.Year === 'YYYY';

			var clear =
				vm.profileInfoDetails.Day === 'DD' &&
				vm.profileInfoDetails.Month === 'MM' &&
				vm.profileInfoDetails.Year === 'YYYY';

			var dateValid = clear || !notFull;
			ctrl.$setValidity('notFull', dateValid);
		};

		vm.months = {
			0: ['MM', 'MM', '31'],
			1: ['Jan', 1, '31'],
			2: ['Feb', 2, '29'],
			3: ['Mar', 3, '31'],
			4: ['Apr', 4, '30'],
			5: ['May', 5, '31'],
			6: ['Jun', 6, '30'],
			7: ['Jul', 7, '31'],
			8: ['Aug', 8, '31'],
			9: ['Sep', 9, '30'],
			10: ['Oct', 10, '31'],
			11: ['Nov', 11, '30'],
			12: ['Dec', 12, '31']
		};

		vm.days = [];
		vm.years = [];
		var now = new Date();
		vm.thisYear = parseInt(now.getFullYear());
		vm.firstValidYear = vm.thisYear - 100;
		vm.lastValidYear = vm.thisYear - 13;

		for (var i = vm.lastValidYear; i >= vm.firstValidYear; i--) {
			vm.years.push(i);
		}

		vm.years.unshift('YYYY');

		vm.updateDays = function (month) {
			vm.days = ['DD'];

			if (isNaN(month)) {
				for (var i = 1; i < 32; i++) {
					vm.days.push(i);
				}

				vm.profileInfoDetails.Day = vm.days[0];
				return;
			}

			var days = parseInt(vm.months[month][2]);

			for (var i = 1; i <= days; i++) {
				vm.days.push(i);
			}
		};

		vm.resetProfileFields = function() {
			fieldsService.reset([[vm.profileInfoDetails, []]], vm.profileInfo);
		};

		vm.resetHomeLocationFields = function() {
			fieldsService.reset(
				[[vm.homeLocationInfoDetails, []]],
				vm.locationInfo
			);
		};
        
		vm.resetCompanyFields = function() {
			fieldsService.reset(
				[
					[vm.companyInfoDetails, []],
					[vm.companyLocationInfoDetails, []]
				],
				vm.companyInfo
			);
		};
	}
})();
;
(function() {
	'use strict';

	angular
		.module('eltazkaraApp')
		.controller('AccountController', AccountController);

	AccountController.$inject = [
		'$scope',
		'$rootScope',
		'$state',
		'$timeout',
		'userInfo',
		'fieldsService',
		'RequestsService',
		'FilesService'
	];

	function AccountController(
		$scope,
		$rootScope,
		$state,
		$timeout,
		userInfo,
		fieldsService,
		RequestsService,
		FilesService
	) {
		var vm = this;
		vm.nationalIdFileBase64 = null;

		$scope.$watch('vm.myFile', function() {
			if (typeof vm.myFile === 'undefined') return;
			var reader = new FileReader();

			reader.onload = function() {
				var binary = '';
				var arrayBuffer = this.result;
				var bytes = new Uint8Array(arrayBuffer);

				for (var i = 0; i < bytes.length; i++)
					binary += String.fromCharCode(bytes[i]);

				vm.nationalIdFileBase64 = btoa(binary);
			}

			reader.readAsArrayBuffer(vm.myFile);
		});

		vm.regex = {
			email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
			mobile: /^(20|0){0,1}1[0-2,5]{1}[0-9]{8}$/,
			password: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\w~@#$%^&*+=`|{}:;!.?\"()\[\]-]+$/
		};

		vm.toggler = function(varName) {
			if (!vm[varName]) {
				vm[varName] = false;
			}

			vm[varName] = !vm[varName];
		};

		if ($rootScope.redirecSetting == true) {
			$rootScope.redirecSetting = false;
			window.location.reload(true);
		}

		vm.showFileUploadedPopup = vm.showInProgressPopup = vm.showFileErrorPopup = false;
		vm.filePopupTitle = vm.filePopupBody = '';
		vm.NationalId = { link: null };

		if ($rootScope.User) vm.id = $rootScope.User.UserId;
		else $state.go('home');

		vm.submitEmailText = vm.submitMobileText = vm.submitNewPasswordText = 'Update';
		vm.emailSubmitted = vm.mobileSubmitted = vm.passwordSubmitted = false;
		vm.emailSent = vm.mobileSent = vm.passwordSent = false;
		vm.emailUsed = vm.mobileUsed = vm.incorrectPassword = vm.duplicatePassword = false;
		vm.passwordReset;
		vm.MailIsSent = userInfo.getMailSent();
		/**-----------------------------------------------------------------------------------------------------------------------------------
        HS:Account Info
        -----------------------------------------------------------------------------------------------------------------------------------**/
		/*HS:Email
        ---------*/
		vm.accountInfoEmail = {};
		//HS:Get
		vm.getEmail = function() {
			userInfo
				.getEmail({
					UserId: vm.id
				})
				.$promise.then(function(data) {
					if (data.User) {
						vm.setaccountInfoEmailModel(data.User);
					}
				});
		};

		vm.getEmail();
		//HS:Set
		vm.saveEmail = function(emailValid) {
			vm.emailUsed = false;
			vm.emailSubmitted = true;
			if (emailValid) {
				vm.submitEmailText = 'Please wait...';
				vm.emailSent = true;
				var emailObj = {
					UserId: vm.id,
					Email: vm.accountInfoEmail.Address
				};
				userInfo
					.saveEmail({
						obj: emailObj
					})
					.$promise.then(function(data) {
						if (data.Break_Msg) {
							vm.emailUsed = true;
							vm.submitEmailText = 'Update';
							vm.emailSent = false;
						} else if (data.User) {
							vm.setaccountInfoEmailModel(data.User);
							vm.toggler('emailAddressToggle');
							vm.emailSubmitted = false;
							userInfo.setMailSent(true);
							vm.submitEmailText = 'Update';
							vm.emailSent = false;
							window.location.href =
								'#/users/emailVerifiy/SendVerificationEmail';
						}
						// vm.submitEmailText = "Update";
						//vm.emailSent = false;
					});
			}
		};

		//HS:Update scope
		vm.setaccountInfoEmailModel = function(data) {
			//HS:Must create copies of initial unedited values from server
			$rootScope.User.IsEmailVerified = data.IsEmailVerified;
			$rootScope.User.IsPhoneVerified = data.IsPhoneVerified;
			$rootScope.User.Email = data.Email;
			vm.accountInfoEmail.Address = data.Email;
			vm.NationalId.link = data.NationalId;
			vm.accountInfoEmail.AddressCopy = angular.copy(
				vm.accountInfoEmail.Address
			);
		};
		/*HS:Mobile
        ---------*/
		vm.accountInfoMobile = {};
		//HS:Get
		vm.getMobile = function() {
			userInfo
				.getMobile({
					UserId: vm.id
				})
				.$promise.then(function(data) {
					if (data.User) {
						vm.setaccountInfoMobileModel(data.User);
					}
				});
		};
		vm.getMobile();

		vm.GoVerifiyMobile = function() {
			vm.SendErrorRequestDescription =
				'We are not able to send you a verification code, please try again later.';
			vm.SendErrorRequestBoolean = true;
			userInfo.SendSMSVerifiy({}).$promise.then(function(data) {
				if (data.status && data.status == 'success') {
					$state.go('verify');
				} else {
					vm.SendErrorRequest(data.errors[0].message);
				}
			});
		};

		vm.SendErrorRequest = function(messageError) {
			RequestsService.AddRequest({
				Subject: 'SMS Credit is Over',
				RequestTypeId: { id: 6 },
				Name: $rootScope.User.Name,
				Mobile: $rootScope.User.MobileNumber,
				Email: $rootScope.User.Email,
				Body: messageError
			}).$promise.then(
				function(data) {
					if (data) {
						$rootScope.PopUpTitle = 'Mobile Verification Error';
						$rootScope.PopUpDescription =
							'We are not able to send you a verification code, please try again later.';
						$rootScope.PopError = true;
					}
				},
				function(error) {
					$rootScope.PopUpTitle = 'Mobile Verification Error';
					$rootScope.PopUpDescription =
						'We are not able to send you a verification code, please try again later.';
					$rootScope.PopError = true;
				}
			);
		};

		//HS:Set
		vm.saveMobile = function(mobileValid, form) {
			vm.mobileUsed = false;
			vm.mobileSubmitted = true;
			if (mobileValid) {
				vm.submitMobileText = 'Please wait...';
				var mobileObj = {
					UserId: vm.id,
					MobileNumber: vm.accountInfoMobile.Number
				};
				userInfo
					.saveMobile({
						obj: mobileObj
					})
					.$promise.then(function(data) {
						if (data.Break_Msg) {
							vm.mobileUsed = true;
						} else if (data.User) {
							vm.setaccountInfoMobileModel(data.User);
							vm.toggler('mobileNumberToggle');
							vm.mobileSubmitted = false;
							$state.go('verify');
						}
						vm.submitMobileText = 'Update';
						vm.emailSent = false;
					});
			}
		};
		//HS:Update scope
		vm.setaccountInfoMobileModel = function(data) {
			//HS:Must create copies of initial unedited values from server
			$rootScope.User.IsEmailVerified = data.IsEmailVerified;
			$rootScope.User.IsPhoneVerified = data.IsPhoneVerified;
			$rootScope.User.MobileNumber = data.MobileNumber;
			vm.accountInfoMobile.Number = data.MobileNumber;
			vm.accountInfoMobile.NumberCopy = angular.copy(
				vm.accountInfoMobile.Number
			);
		};
		/*HS:Password
        -----------*/
		vm.accountInfoPasswords = {};
		//HS:Must create copies of null values
		vm.accountInfoPasswords.currentCopy = vm.accountInfoPasswords.newCopy = vm.accountInfoPasswords.confirmCopy = null;

		vm.passwordReset = false;
		$scope.$watch('vm.passwordReset', function() {
			vm.passwordText = vm.passwordReset
				? 'Password has been reset'
				: 'Edit to change';
		});
		//HS:Compare & update/reject
		vm.savePassword = function(passwordForm) {
			vm.passwordSubmitted = true;
			vm.passwordSent = false;
			if (passwordForm.$valid) {
				vm.passwordSent = true;
				var passwordObj = {
					UserId: vm.id,
					Password: vm.accountInfoPasswords.new,
					currentPassword: vm.accountInfoPasswords.current
				};
				userInfo
					.savePassword({
						obj: passwordObj
					})
					.$promise.then(function(data) {
						if (data.Msg) {
							vm.incorrectPassword = true;
							passwordForm.$setPristine();
						}
						if (data.Break_Msg) {
							vm.duplicatePassword = true;
							passwordForm.$setPristine();
						}
						if (data.User) {
							vm.passwordReset = true;
							vm.accountInfoPasswords.current = vm.accountInfoPasswords.new = vm.accountInfoPasswords.confirm = null;
							$timeout(function() {
								vm.passwordReset = vm.passwordSubmitted = false;
							}, 2000);
							vm.toggler('passwordToggle');
						}
						vm.passwordSent = false;
					});
			}
		};

		vm.uploadFiles = function() {
			if (vm.myFile != null && vm.nationalIdFileBase64 !== null) {
				var file = vm.myFile;

				if (file.size > 50000000) {
					vm.fileError = 'Image must be at most 50 MB in size.';
					vm.showFileErrorPopup = true;
					return;
				}

				vm.showInProgressPopup = true;
				
				var params = {
					FileName: file.name,
					FileContents: vm.nationalIdFileBase64
				};

				FilesService.uploadToBlobStorage(params).$promise.then(
					function (data) {  vm.updateNId(data.url) },
					function (err) {
						console.log(err);
						vm.fileError = 'Something went wrong.';
						vm.showInProgressPopup = false;
						vm.showFileErrorPopup = true;
					});
			} else {
				vm.fileError = 'Please select an image to upload.';
				vm.showFileErrorPopup = true;
			}
		};

		vm.dismissFileUploadedPopup = function() {
			vm.showFileUploadedPopup = false;
		};

		vm.updateNId = function(fileLink) {
			userInfo
				.uploadId({
					NIdLink: fileLink
				})
				.$promise.then(
					function(data) {
						if (data) {
							vm.filePopupTitle = 'File Uploaded';
							vm.filePopupBody = 'File uploaded successfuly.';
							vm.fileUploaded = true;
							vm.showInProgressPopup = false;
							vm.showFileUploadedPopup = true;
							vm.NationalId.link = data.nationalIdLink + '?r=' + Math.random();
							vm.resetNationalId();
						}
					},
					function(error) {
						console.log(error)
						vm.filePopupTitle = 'Failed';
						vm.filePopupBody = 'Failed to upload file!';
						vm.fileUploaded = false;
						vm.showInProgressPopup = false;
						vm.showFileUploadedPopup = true;
						vm.resetNationalId();
					}
				);
		};

		/**---------------------------------------------------------------------------------------------------------------------------------*/
		//HS:Reset fields functions
		vm.resetEmailField = function() {
			fieldsService.reset(
				[[vm.accountInfoEmail, []]],
				vm.emailAddressToggle
			);
			vm.mobileSubmitted = vm.emailUsed = false;
		};

		vm.resetMobileField = function() {
			fieldsService.reset(
				[[vm.accountInfoMobile, []]],
				vm.mobileNumberToggle
			);
			vm.mobileSubmitted = vm.mobileUsed = false;
		};

		vm.resetPasswordFields = function() {
			fieldsService.reset(
				[[vm.accountInfoPasswords, []]],
				vm.passwordToggle
			);
			vm.passwordSubmitted = vm.incorrectPassword = vm.duplicatePassword = false;
		};

		vm.resetNationalId = function() {
			vm.myFile = null;
			vm.nationalIdToggle = false;
		}
	}

})();
;
(function () {
    'use strict';

    angular
        .module('eltazkaraApp')
        .controller('BoughtTicketsController', BoughtTicketsController);

    BoughtTicketsController.$inject = [
      '$http',
      '$state',
      '$rootScope',
      '$stateParams',
      'NgTableParams',
      'User'
    ];


    function BoughtTicketsController($http, $state, $rootScope, $stateParams, NgTableParams, User) {
        var vm = this;
        vm.showPoper = false;
        vm.Receipt;

        if($rootScope.User)
            vm.id = $rootScope.User.UserId;
        else
            $state.go("home");

        vm.dataLength_pinding = 0;
        vm.dataLength_Active = 0;
        vm.dataLength_History = 0;
        vm.dataLength_Refund = 0;
        vm.PageIndex = 1;
        vm.CountPerPage_Pending = 5;
        vm.CountPerPage_Active = 5;
        vm.CountPerPage_History = 5;
        vm.CountPerPage_Refunded = 5;
        vm.disablePending = false;
        vm.disableActive = false;
        vm.disableHistory = false;
        vm.disableRefunded = false;
        vm.BOUGHT_TICKETS_HISTORY = [];    //all bought tickets
        vm.ACTIVE_BOUGHT_TICKETS = [];     //date of event still available
        vm.PENDING_BOUGHT_TICKETS = [];    //if respond == 3 =>pending
        vm.REFUNDED_BOUGHT_TICKETS = [];    //if refunded == 4 =>refunded
        vm.hasPendingTickets = false;
        vm.hasActiveTickets = false;
        vm.hasHistoryTickets = false;
        vm.hasRefundedTickets = false;
        vm.ticketsLoading = false;

        vm.boughtTickets = function () {
            vm.ticketsLoading = true;
            User.GetBoughtTickets({ "Id": vm.id })
                .$promise.then(function (data) {
                    vm.ticketsLoading = false;
                    if (data) {
                        if (data.PendingTickets.length > 0) vm.hasPendingTickets = true;
                        if (data.ActiveTickets.length > 0) vm.hasActiveTickets = true;
                        if (data.HistoryTickets.length > 0) vm.hasHistoryTickets = true;
                        if (data.RefundedTickets.length > 0) vm.hasRefundedTickets = true;

                        for (var i = 0; i < data.PendingTickets.length; i++) {
                            var tempItem = {
                                "bought": data.PendingTickets[i].BoughtTikets,
                                "PricePerTicket": data.PendingTickets[i].PricePerTicket,
                                "OrderTotal": data.PendingTickets[i].OrderTotal,
                                "Loans": data.PendingTickets[i].Loans,
                                "row": data.PendingTickets[i].Row,
                                "section":data.PendingTickets[i].Section,
                                "block": data.PendingTickets[i].Block,
                                "Type": data.PendingTickets[i].Type,
                                "performence": data.PendingTickets[i].Performance,
                                "PerformanceId": data.PendingTickets[i].PerformanceId,
                                "EventId": data.PendingTickets[i].EventId,
                                "fullDate": data.PendingTickets[i].FullDate,
                                "year": data.PendingTickets[i].Year,
                                "day": data.PendingTickets[i].Day,
                                "month": data.PendingTickets[i].Month,
                                "dayName": data.PendingTickets[i].DayName,
                                "time": data.PendingTickets[i].Time,
                                "eventName": data.PendingTickets[i].Event,
                                "Respond": data.PendingTickets[i].PaymentResponse,
                                "CreatedOn": data.PendingTickets[i].CreatedOn,
                                "FullOrderDate": Date.parse(data.PendingTickets[i].FullOrderDate),
                                "OrderRef": data.PendingTickets[i].OrderRef,
                                "Num_Performances_InEvent": data.PendingTickets[i].Num_Performances_InEvent

                            };
                            vm.PENDING_BOUGHT_TICKETS[i] = tempItem;
                            vm.dataLength_pinding = data.PendingTickets.length;
                            vm.customConfigParamsPindingTable = createUsingFullOptionsPindingTable();
                        }
                        for (var i = 0; i < data.ActiveTickets.length; i++) {
                            var tempItem = {
                                "OrderId": data.ActiveTickets[i].OrderId,
                                "bought": data.ActiveTickets[i].BoughtTikets,
                                "OrderTotal": data.ActiveTickets[i].OrderTotal,
                                "PricePerTicket": data.ActiveTickets[i].PricePerTicket,
                                "Loans": data.ActiveTickets[i].Loans,
                                "row": data.ActiveTickets[i].Row,
                                "section": data.ActiveTickets[i].Section,
                                "block": data.ActiveTickets[i].Block,
                                "Type": data.ActiveTickets[i].Type,
                                "performence": data.ActiveTickets[i].Performance,
                                "PerformanceId": data.ActiveTickets[i].PerformanceId,
                                "EventId": data.ActiveTickets[i].EventId,
                                "fullDate": data.ActiveTickets[i].FullDate,
                                "year": data.ActiveTickets[i].Year,
                                "day": data.ActiveTickets[i].Day,
                                "month": data.ActiveTickets[i].Month,
                                "dayName": data.ActiveTickets[i].DayName,
                                "time": data.ActiveTickets[i].Time,
                                "eventName": data.ActiveTickets[i].Event,
                                "Respond": data.ActiveTickets[i].Respond,
                                "CreatedOn": data.ActiveTickets[i].CreatedOn,
                                "FullOrderDate": Date.parse(data.ActiveTickets[i].FullOrderDate),
                                "Num_Performances_InEvent": data.ActiveTickets[i].Num_Performances_InEvent
                            };
                            vm.ACTIVE_BOUGHT_TICKETS[i] = tempItem;
                            vm.dataLength_Active = data.ActiveTickets.length;
                            vm.customConfigParamsActiveTable = createUsingFullOptionsActiveTable();

                        }

                        for (var i = 0; i < data.HistoryTickets.length; i++) {
                            var tempItem = {
                                "OrderId": data.HistoryTickets[i].OrderId,
                                "bought": data.HistoryTickets[i].BoughtTikets,
                                "OrderTotal": data.HistoryTickets[i].OrderTotal,
                                "PricePerTicket": data.HistoryTickets[i].PricePerTicket,
                                "Loans": data.HistoryTickets[i].Loans,
                                "row": data.HistoryTickets[i].Row,
                                "section": data.HistoryTickets[i].Section,
                                "block": data.HistoryTickets[i].Block,
                                "Type": data.HistoryTickets[i].Type,
                                "performence": data.HistoryTickets[i].Performance,
                                "PerformanceId": data.HistoryTickets[i].PerformanceId,
                                "EventId": data.HistoryTickets[i].EventId,
                                "fullDate": data.HistoryTickets[i].FullDate,
                                "year": data.HistoryTickets[i].Year,
                                "day": data.HistoryTickets[i].Day,
                                "month": data.HistoryTickets[i].Month,
                                "dayName": data.HistoryTickets[i].DayName,
                                "time": data.HistoryTickets[i].Time,
                                "eventName": data.HistoryTickets[i].Event,
                                "Respond": data.HistoryTickets[i].Respond,
                                "CreatedOn": data.HistoryTickets[i].CreatedOn,
                                "FullOrderDate": Date.parse(data.HistoryTickets[i].FullOrderDate),
                                "Num_Performances_InEvent": data.HistoryTickets[i].Num_Performances_InEvent
                            };
                            vm.BOUGHT_TICKETS_HISTORY[i] = tempItem;
                            vm.dataLength_History = data.HistoryTickets.length;

                            vm.customConfigParamsHistoryTable = createUsingFullOptionsHistoryTable();
                        }

                        for (var i = 0; i < data.RefundedTickets.length; i++) {
                            var tempItem = {
                                "OrderId": data.RefundedTickets[i].OrderId,
                                "bought": data.RefundedTickets[i].BoughtTikets,
                                "OrderTotal": data.RefundedTickets[i].OrderTotal,
                                "Refunded": data.RefundedTickets[i].Refunded,
                                "PricePerTicket": data.RefundedTickets[i].PricePerTicket,
                                "Loans": data.RefundedTickets[i].Loans,
                                "row": data.RefundedTickets[i].Row,
                                "section": data.RefundedTickets[i].Section,
                                "block": data.RefundedTickets[i].Block,
                                "Type": data.RefundedTickets[i].Type,
                                "performence": data.RefundedTickets[i].Performance,
                                "PerformanceId": data.RefundedTickets[i].PerformanceId,
                                "EventId": data.RefundedTickets[i].EventId,
                                "fullDate": data.RefundedTickets[i].FullDate,
                                "year": data.RefundedTickets[i].Year,
                                "day": data.RefundedTickets[i].Day,
                                "month": data.RefundedTickets[i].Month,
                                "dayName": data.RefundedTickets[i].DayName,
                                "time": data.RefundedTickets[i].Time,
                                "eventName": data.RefundedTickets[i].Event,
                                "Respond": data.RefundedTickets[i].Respond,
                                "CreatedOn": data.RefundedTickets[i].CreatedOn,
                                "FullOrderDate": Date.parse(data.RefundedTickets[i].FullOrderDate),
                                "Num_Performances_InEvent": data.RefundedTickets[i].Num_Performances_InEvent
                            };
                            vm.REFUNDED_BOUGHT_TICKETS[i] = tempItem;
                            vm.dataLength_Refund = data.RefundedTickets.length;
                            vm.customConfigParamsRefundTable = createUsingFullOptionsRefundTable();
                        }
                    }
                }, function (error) {
                    vm.ticketsLoading = false;
                })
        }

        vm.boughtTickets();

        vm.showReceipt = function (Orderid) {
            vm.showPoper = true;
            User.GetReceipt({ "Id": Orderid })
             .$promise.then(function (data) {
                 if (data) {

                     var tempItem = {
                         "PricePerTicket": data.PricePerTicket,
                         "boughtTikets": data.boughtTikets,
                         "ServicesFees": data.ServicesFees,
                         "DeliveryFees": data.DeliveryFees,
                         "Total": data.Total,
                         "GrandTotal": data.GrandTotal,
                         "Fees":data.Fees,
                         "Loans": data.Loans,
                         "Perfomance": data.Perfomance,
                         "Reference":data.Ref
                     };
                     vm.Receipt = tempItem;

                 }
             }, function (error) { })
        }
        vm.proceedToPayment = function (Orderid) {
            location.href = "#/payment_details/" + Orderid;
        }
        vm.loadMorePending = function () {
            if (vm.CountPerPage_Pending < vm.dataLength_pinding) {
                vm.customConfigParamsPindingTable.count(vm.CountPerPage_Pending + 5);
                vm.CountPerPage_Pending += 5;
            }
            else
                vm.disablePending = true;

        }
        vm.loadMoreActive = function () {
            if (vm.CountPerPage_Active < vm.dataLength_Active) {
                vm.customConfigParamsActiveTable.count(vm.CountPerPage_Active + 5);
                vm.CountPerPage_Active += 5;
            }
            else
                vm.disableActive = true;

        }
        vm.loadMoreHistory = function () {
            if (vm.CountPerPage_History < vm.dataLength_History) {
                vm.customConfigParamsHistoryTable.count(vm.CountPerPage_History + 5);
                vm.CountPerPage_History += 5;
            }
            else
                vm.disableHistory = true;
        }
        vm.loadMoreRefunded = function () {
            if (vm.CountPerPage_Refunded < vm.dataLength_Refund) {
                vm.customConfigParamsRefundTable.count(vm.CountPerPage_Refunded + 5);
                vm.CountPerPage_Refunded += 5;
            }
            else {
                vm.disableRefunded = true;
            }
                
        }

        function createUsingFullOptionsPindingTable() {
            var initialParams = {
                count: vm.CountPerPage_Pending, // initial page size
                sorting: { FullOrderDate: "desc" }
            };
            var initialSettings = {
                counts: [],
                dataset: vm.PENDING_BOUGHT_TICKETS
            };
            return new NgTableParams(initialParams, initialSettings);
        }

        function createUsingFullOptionsActiveTable() {
            var initialParams = {
                count: vm.CountPerPage_Active, // initial page size
                sorting: { FullOrderDate: "desc" }
            };
            var initialSettings = {
                counts: [],
                dataset: vm.ACTIVE_BOUGHT_TICKETS
            };
            return new NgTableParams(initialParams, initialSettings);
        }

        function createUsingFullOptionsHistoryTable() {
            var initialParams = {
                count: vm.CountPerPage_History, // initial page size
                sorting: { FullOrderDate: "desc" }
            };
            var initialSettings = {
                counts: [],
                dataset: vm.BOUGHT_TICKETS_HISTORY
            };
            return new NgTableParams(initialParams, initialSettings);
        }

        function createUsingFullOptionsRefundTable() {
            var initialParams = {
                count: vm.CountPerPage_Refunded // initial page size
            };
            var initialSettings = {
                counts: [],
                dataset: vm.REFUNDED_BOUGHT_TICKETS
            };
            return new NgTableParams(initialParams, initialSettings);
        }
    }
})();
;
(function () {
    'use strict';

    angular
    .module('eltazkaraApp')
    .controller('SoldTicketsController', SoldTicketsController);

    SoldTicketsController.$inject = [
    '$rootScope',
    'NgTableParams',
    'User',
    '$state',
    'PaymentService'
    ];

    function SoldTicketsController($rootScope, NgTableParams, User,$state, PaymentService) {
        var vm = this;
        vm.showPoper = false;
        vm.PageIndex = 1;
        vm.CountPerPage_RejectedTickets = 5;
        vm.CountPerPage_SoldTickets = 5;
        vm.CountPerPage_ActiveTickets = 5;
        vm.CountPerPage_PendingTickets = 5;
        vm.CountPerPage_CancelledTickets = 5;

        vm.soldTicketsLoading = false;
        vm.disableRejectedTickets = false;
        vm.disableSoldTickets = false;
        vm.disableActiveTickets = false;
        vm.disablePendingTickets = false;
        vm.disableCancelledTickets = false;

        vm.PendingTickets = [];
        vm.RejectedTickets = [];
        vm.ActiveTickets = [];
        vm.SoldTickets = [];
        vm.CancelledTickets = [];
        vm.FinalActiveTickets = [];
        vm.FinalPendingTickets = [];
        vm.FinalSoldTickets = [];
        vm.FinalRejectedTickets = [];
        vm.FinalCancelledTickets=[];
        vm.ReceiptTickets = [];

        vm.showCancel = false;
        vm.tgtc = 0;

        vm.GetSoldTickets = function () {
            vm.soldTicketsLoading = true;
            User.GetSoldTickets({ "Id": vm.id })
            .$promise.then(function (data) {
                vm.soldTicketsLoading = false;
                if (data) {
                    vm.AllTickets = data;
                    vm.PendingTickets = data.PendingTickets;
                    vm.RejectedTickets = data.RejectedTickets;
                    vm.ActiveTickets = data.ActiveTickets;
                    vm.SoldTickets = data.SoldTickets;
                    vm.CancelledTickets = data.CancelledTickets;

                    vm.AmountDollars = data.TotalSoldTicketPriceDollars;
                    vm.AmountCents = data.TotalSoldTicketPriceCents;
                    vm.PaidDollars = data.PaidMoneyDollars;
                    vm.PaidCents = data.PaidMoneyCents;
                    vm.RemainingDollars = data.RemainingMoneyDollars;
                    vm.RemainingCents = data.RemainingMoneyCents;
                    vm.RefundDollars = data.TotalRefundedMoneyDollars;
                    vm.RefundCents = data.TotalSoldTicketPriceCents;
                    for (var i = 0; i < vm.ActiveTickets.length; i++) {
                        var tempItem = {
                            "TicketGroupId": vm.ActiveTickets[i].TicketGroupId,
                            "Day": vm.ActiveTickets[i].Day,
                            "Month": vm.ActiveTickets[i].Month,
                            "Year": vm.ActiveTickets[i].Year,
                            "Time": vm.ActiveTickets[i].Time,
                            "DayName": vm.ActiveTickets[i].DayName,
                            "RemainingTickets": vm.ActiveTickets[i].RemainingTickets,
                            "NumberOfTickets": vm.ActiveTickets[i].NumberOfTickets,
                            "Section": vm.ActiveTickets[i].Section,
                            "Block": vm.ActiveTickets[i].Block,
                            "Row": vm.ActiveTickets[i].Row,
                            "PerformanceId": vm.ActiveTickets[i].PerformanceId,
                            "PerformanceName": vm.ActiveTickets[i].PerformanceName,
                            "EventId": vm.ActiveTickets[i].EventId,
                            "EventName": vm.ActiveTickets[i].EventName,
                            "StartSeat": vm.ActiveTickets[i].StartSeat,
                            "EndSeat": vm.ActiveTickets[i].EndSeat,
                            "Price": vm.ActiveTickets[i].Price,
                            "FullDate": Date.parse(vm.ActiveTickets[i].FullDate)
                        };
                        vm.FinalActiveTickets.push(tempItem);
                    }
                    for (var i = 0; i < vm.PendingTickets.length; i++) {
                        var tempItem = {
                            "Day": vm.PendingTickets[i].Day,
                            "RequestId":vm.PendingTickets[i].RequestId,
                            "CancelText": vm.PendingTickets[i].CancelText,
                            "Month": vm.PendingTickets[i].Month,
                            "Year": vm.PendingTickets[i].Year,
                            "Time": vm.PendingTickets[i].Time,
                            "DayName": vm.PendingTickets[i].DayName,
                            "RemainingTickets": vm.PendingTickets[i].RemainingTickets,
                            "NumberOfTickets": vm.PendingTickets[i].NumberOfTickets,
                            "Section": vm.PendingTickets[i].Section,
                            "Block": vm.PendingTickets[i].Block,
                            "Row": vm.PendingTickets[i].Row,
                            "PerformanceId": vm.PendingTickets[i].PerformanceId,
                            "PerformanceName": vm.PendingTickets[i].PerformanceName,
                            "EventId": vm.PendingTickets[i].EventId,
                            "EventName": vm.PendingTickets[i].EventName,
                            "StartSeat": vm.PendingTickets[i].StartSeat,
                            "EndSeat": vm.PendingTickets[i].EndSeat,
                            "Price": vm.PendingTickets[i].Price,
                            "FullDate": Date.parse(vm.PendingTickets[i].FullDate)
                        };
                        vm.FinalPendingTickets.push(tempItem);
                    }
                    for (var i = 0; i < vm.SoldTickets.length; i++) {
                        var tempItem = {
                            "Day": vm.SoldTickets[i].Day,
                            "Month": vm.SoldTickets[i].Month,
                            "Year": vm.SoldTickets[i].Year,
                            "Time": vm.SoldTickets[i].Time,
                            "DayName": vm.SoldTickets[i].DayName,
                            "NumberOfTickets": vm.SoldTickets[i].NumberOfTickets,
                            "RemainingTickets": vm.SoldTickets[i].RemainingTickets,
                            "Section": vm.SoldTickets[i].Section,
                            "Block": vm.SoldTickets[i].Block,
                            "StartSeat": vm.SoldTickets[i].StartSeat,
                            "EndSeat": vm.SoldTickets[i].EndSeat,
                            "EndSeatUpdated": vm.SoldTickets[i].EndSeatUpdated,
                            "Row": vm.SoldTickets[i].Row,
                            "PerformanceId": vm.SoldTickets[i].PerformanceId,
                            "PerformanceName": vm.SoldTickets[i].PerformanceName,
                            "EventId": vm.SoldTickets[i].EventId,
                            "EventName": vm.SoldTickets[i].EventName,
                            "TicketsEventId": vm.SoldTickets[i].EventId,
                            "TicketsEventName": vm.SoldTickets[i].EventName,
                            "TicketsStartSeat": vm.SoldTickets[i].StartSeat,
                            "Price": vm.SoldTickets[i].Price,
                            "FullDate": Date.parse(vm.SoldTickets[i].FullDate),
                            "RequestRef": vm.SoldTickets[i].RequestRef
                        };
                        var ticketItem = {
                            "RequestRef": vm.SoldTickets[i].RequestRef,
                            "NumberOfTickets": vm.SoldTickets[i].NumberOfTickets - vm.SoldTickets[i].RemainingTickets,
                        }
                        vm.FinalSoldTickets.push(tempItem);
                        vm.ReceiptTickets.push(ticketItem);
                    }

                    for (var i = 0; i < vm.RejectedTickets.length; i++) {
                        var tempItem = {
                            "Day": vm.RejectedTickets[i].Day,
                            "Month": vm.RejectedTickets[i].Month,
                            "Year": vm.RejectedTickets[i].Year,
                            "Time": vm.RejectedTickets[i].Time,
                            "DayName": vm.RejectedTickets[i].DayName,
                            "NumberOfTickets": vm.RejectedTickets[i].NumberOfTickets,
                            "RemainingTickets": vm.RejectedTickets[i].RemainingTickets,
                            "Section": vm.RejectedTickets[i].Section,
                            "Block": vm.RejectedTickets[i].Block,
                            "Row": vm.RejectedTickets[i].Row,
                            "PerformanceId": vm.RejectedTickets[i].PerformanceId,
                            "PerformanceName": vm.RejectedTickets[i].PerformanceName,
                            "EventId": vm.RejectedTickets[i].EventId,
                            "EventName": vm.RejectedTickets[i].EventName,
                            "StartSeat": vm.RejectedTickets[i].StartSeat,
                            "EndSeat": vm.RejectedTickets[i].EndSeat,
                            "Price": vm.RejectedTickets[i].Price,
                            "FullDate": Date.parse(vm.RejectedTickets[i].FullDate)
                        };
                        vm.FinalRejectedTickets.push(tempItem);
                    }

                    for (var i = 0; i < vm.CancelledTickets.length; i++) {
                        var tempItem = {
                            "Day": vm.CancelledTickets[i].Day,
                            "Month": vm.CancelledTickets[i].Month,
                            "Year": vm.CancelledTickets[i].Year,
                            "Time": vm.CancelledTickets[i].Time,
                            "DayName": vm.CancelledTickets[i].DayName,
                            "NumberOfTickets": vm.CancelledTickets[i].NumberOfTickets,
                            "RemainingTickets": vm.CancelledTickets[i].RemainingTickets,
                            "Section": vm.CancelledTickets[i].Section,
                            "Block": vm.CancelledTickets[i].Block,
                            "Row": vm.CancelledTickets[i].Row,
                            "PerformanceId": vm.CancelledTickets[i].PerformanceId,
                            "PerformanceName": vm.CancelledTickets[i].PerformanceName,
                            "EventId": vm.CancelledTickets[i].EventId,
                            "EventName": vm.CancelledTickets[i].EventName,
                            "StartSeat": vm.CancelledTickets[i].StartSeat,
                            "EndSeat": vm.CancelledTickets[i].EndSeat,
                            "Price": vm.CancelledTickets[i].Price,
                            "FullDate": Date.parse(vm.CancelledTickets[i].FullDate)
                        };
                        vm.FinalCancelledTickets.push(tempItem);
                    }
                    
                    if(vm.FinalRejectedTickets.length == 0 && vm.FinalSoldTickets.length == 0
                        && vm.FinalPendingTickets.length == 0 && vm.FinalActiveTickets.length == 0 
                        && vm.FinalCancelledTickets.length == 0)
                    {
                          $rootScope.User.HaveSoldTicket = false;
                          $state.go('home');
                    }
                    else {
                      $rootScope.User.HaveSoldTicket = true;
                    }
                }
            }, function (error) { vm.soldTicketsLoading = false; });
        };

        vm.GetSoldTickets();
        vm.showReceipt = function (Ticket) {

            vm.subTotal = Ticket.NumberOfTickets * Ticket.Price
            PaymentService.getOrder({ "OrderRef": Ticket.RequestRef })
            .$promise.then(function (data) {
                if (data) {
                    for (var i = 0; i < vm.ReceiptTickets.length; i++) {
                        if (vm.ReceiptTickets[i].RequestRef == Ticket.RequestRef) {
                            vm.ReceiptNumberOfTickets = vm.ReceiptTickets[i].NumberOfTickets;
                            break;
                        }
                    }
                    if (data.message == "4041")
                        location.href = "#/Home";
                    else
                        vm.order = data;
                    vm.showPoper = true;
                }
            }, function (error) { })
        }
        vm.loadMoreRejectedTickets = function () {
            if (vm.CountPerPage_RejectedTickets < vm.RejectedTickets.length) {
                vm.customConfigParamsRejected.count(vm.CountPerPage_RejectedTickets + 5);
                vm.CountPerPage_RejectedTickets += 5;
            }
            else
                vm.disableRejectedTickets = true;
        }

        vm.loadMoreSoldTickets = function () {
            if (vm.CountPerPage_SoldTickets < vm.SoldTickets.length) {
                vm.customConfigParamsSold.count(vm.CountPerPage_SoldTickets + 5);
                vm.CountPerPage_SoldTickets += 5;
            }
            else
                vm.disableSoldTickets = true;

        }

        vm.loadMoreActiveTickets = function () {
            if (vm.CountPerPage_ActiveTickets < vm.ActiveTickets.length) {
                vm.customConfigParamsActive.count(vm.CountPerPage_ActiveTickets + 5);
                vm.CountPerPage_ActiveTickets += 5;
            }
            else
                vm.disableActiveTickets = true;

        }

        vm.loadMorePendingTickets = function () {
            if (vm.CountPerPage_PendingTickets < vm.PendingTickets.length) {
                vm.customConfigParamsPending.count(vm.CountPerPage_PendingTickets + 5);
                vm.CountPerPage_PendingTickets += 5;
            }
            else
                vm.disablePendingTickets = true;
        }

        vm.loadMoreCancelledTickets = function () {
            if (vm.CountPerPage_CancelledTickets < vm.CancelledTickets.length) {
                vm.customConfigParamsCancelled.count(vm.CountPerPage_CancelledTickets + 5);
                vm.CountPerPage_CancelledTickets += 5;
            }
            else
                vm.disableCancelledTickets = true;
        }

        //vm.tableParams = new NgTableParams({}, { dataset: data});
        vm.customConfigParamsActive = createUsingFullOptionsActive();

        function createUsingFullOptionsActive() {
            var initialParams = {
                count: vm.CountPerPage_ActiveTickets, // initial page size
                sorting: { FullDate: "desc" }
            };
            var initialSettings = {
                counts: [],
                dataset: vm.FinalActiveTickets
            };
            return new NgTableParams(initialParams, initialSettings);
        };
        vm.customConfigParamsPending = createUsingFullOptionsPending();

        function createUsingFullOptionsPending() {
            var initialParams = {
                count: vm.CountPerPage_PendingTickets, // initial page size
                sorting: { FullDate: "desc" }
            };
            var initialSettings = {
                counts: [],
                dataset: vm.FinalPendingTickets
            };
            return new NgTableParams(initialParams, initialSettings);
        }
        vm.customConfigParamsSold = createUsingFullOptionsSold();

        function createUsingFullOptionsSold() {
            var initialParams = {
                count: vm.CountPerPage_SoldTickets, // initial page size
                sorting: { FullDate: "desc" }
            };
            var initialSettings = {
                counts: [],
                dataset: vm.FinalSoldTickets
            };
            return new NgTableParams(initialParams, initialSettings);
        }
        vm.customConfigParamsRejected = createUsingFullOptionsRejected();

        function createUsingFullOptionsRejected() {
            var initialParams = {
                count: vm.CountPerPage_RejectedTickets, // initial page size
                sorting: { FullDate: "desc" }
            };
            var initialSettings = {
                counts: [],
                dataset: vm.FinalRejectedTickets
            };
            return new NgTableParams(initialParams, initialSettings);
        }

        vm.customConfigParamsCancelled = createUsingFullOptionsCancelled();

        function createUsingFullOptionsCancelled() {
            var initialParams = {
                count: vm.CountPerPage_CancelledTickets, // initial page size
                sorting: { FullDate: "desc" }
            };
            var initialSettings = {
                counts: [],
                dataset: vm.FinalCancelledTickets
            };
            return new NgTableParams(initialParams, initialSettings);
        }

        vm.CancelSellRequest = function (RequestId) {
            User.CancelSellRequest({ "Id": RequestId })
            .$promise.then(function (data) {
                if (data) {
                  if(vm.FinalRejectedTickets.length != 0 && vm.FinalSoldTickets.length != 0
                      && vm.FinalPendingTickets.length != 0 && vm.FinalActiveTickets.length != 0)
                      {
                        $state.reload();
                      }
                      else {
                        $rootScope.User.HaveSoldTicket = false;
                        $state.go('home');
                      }
                }
            }, function (error) { });
        };

        
        vm.CancelTicketGroup = function (ticketGroupId) {
            vm.showCancel = true;
            vm.tgtc = ticketGroupId;
        };

        vm.CancelTicketGroupDismiss = function () {
            vm.showCancel = false;
            vm.tgtc = 0;
        };

        vm.CannotCancelTicketGroupDismiss = function() {
            vm.showCannotCancel = false;
        }

        vm.CancelTicketGroupVerified = function () {
            User.CancelTicketGroup({ "ticketGroupId": vm.tgtc })
            .$promise.then(function (data) {
                if (data) {
                    if(data.message && data.message === 'Ticket group on hold') {
                        vm.CancelTicketGroupDismiss();
                        vm.showCannotCancel = true;
                        return;
                    }
                    $state.reload();
                }
            }, function (error) { });
        };
    }

})();
;
(function () {
    'use strict';

    angular
        .module('eltazkaraApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('register', {
            parent: 'app',
            url: '/users/profile',
            views: {
                'content@': {
                    templateUrl: 'components/users/profile.html',
                    controller: 'ProfileController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        }).state('account', {
            parent: 'app',
            url: '/users/account',
            views: {
                'content@': {
                    templateUrl: 'components/users/account.html',
                    controller: 'AccountController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        }).state('boughtTickets', {
            parent: 'app',
            url: '/users/orders',
            views: {
                'content@': {
                    templateUrl: 'components/users/boughtTickets.html',
                    controller: 'BoughtTicketsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        }).state('soldTickets', {
            parent: 'app',
            url: '/users/tickets_for_sale',
            views: {
                'content@': {
                    templateUrl: 'components/users/soldTickets.html',
                    controller: 'SoldTicketsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        }).state('order', {
            parent: 'app',
            url: '/users/order',
            views: {
                'content@': {
                    templateUrl: 'components/users/order.html',
                    controller: 'OrderController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        })
        .state('verify', {
            parent: 'app',
            url: '/users/verify',
            views: {
                'content@': {
                    templateUrl: 'components/users/verifyRegistration.html',
                    controller: 'VerifyController',
                    controllerAs: 'vm'
                }
            }
        }).state('thanks', {
            parent: 'app',
            url: '/users/emailVerifiy/:code',
            views: {
                'content@': {
                    templateUrl: 'components/users/thanks.html',
                    controller: 'ThanksController',
                    controllerAs: 'vm'
                }
            }
        }).state('balanceSheet', {
            parent: 'app',
            url: '/users/balanceSheet',
            views: {
                'content@': {
                    templateUrl: 'components/users/balanceSheet.html',
                    controller: 'balanceSheetController',
                    controllerAs: 'vm'
                }
            }
        })
    }
})();
;
(function() {
	'use strict';
	angular.module('eltazkaraApp').factory('userInfo', userInfo);
	userInfo.$inject = ['$resource'];
	function userInfo($resource) {
		var service = $resource(
			window.backendUrl + 'Users',
			{},
			{
				getProfileInfoDetails: {
					method: 'POST',
					isArray: false,
					url: window.backendUrl + 'Users/GetProfileInfo'
				},
				saveProfileInfoDetails: {
					method: 'POST',
					isArray: false,
					url: window.backendUrl + 'Users/UpdateProfileInfo'
				},
				getLocation: {
					method: 'POST',
					isArray: false,
					url: window.backendUrl + 'Locations/GetLocation'
				},
				saveLocation: {
					method: 'POST',
					isArray: false,
					url: window.backendUrl + 'Locations/SaveLocation'
				},
				getCompanyInfoDetails: {
					method: 'POST',
					isArray: false,
					url: window.backendUrl + 'Users/GetCompanyInfo'
				},
				saveCompanyInfoDetails: {
					method: 'POST',
					isArray: false,
					url: window.backendUrl + 'Users/UpdateCompanyInfo'
				},
				getAllCountries: {
					method: 'GET',
					isArray: true,
					url: window.backendUrl + 'Locations/GetCountries'
				},
				getCompanyCountries: {
					method: 'GET',
					isArray: true,
					url: window.backendUrl + 'Locations/GetCompanyCountries'
				},
				getCountryCities: {
					method: 'POST',
					isArray: false,
					url: window.backendUrl + 'Locations/GetCountryCities'
				},
				getEmail: {
					method: 'POST',
					isArray: false,
					url: window.backendUrl + 'Users/GetEmail'
				},
				saveEmail: {
					method: 'POST',
					isArray: false,
					url: window.backendUrl + 'Users/SaveEmail'
				},
				getMobile: {
					method: 'POST',
					isArray: false,
					url: window.backendUrl + 'Users/GetMobile'
				},
				saveMobile: {
					method: 'POST',
					isArray: false,
					url: window.backendUrl + 'Users/SaveMobile'
				},
				savePassword: {
					method: 'POST',
					isArray: false,
					url: window.backendUrl + 'Users/SavePassword'
				},
				SendSMSVerifiy: {
					method: 'POST',
					isArray: false,
					url: window.backendUrl + 'Users/SendVerificationMsg'
				},
				uploadId: {
					method: 'POST',
					isArray: false,
					url: window.backendUrl + 'Users/UpdateNationalId'
				},

				getWhereToRedirectAfterVerify: function() {
					return this.wehreToRedirect;
				},
				setWhereToRedirectAfterVerify: function(value) {
					this.wehreToRedirect = value;
				}
			}
		);
		service.data = '#/users/account';
		service.getData = function() {
			return this.data;
		};
		service.sendData = function(data) {
			this.data = data;
			//$rootScope.$broadcast('data_shared');
		};
		service.Mailsent = false;
		service.getMailSent = function() {
			return this.Mailsent;
		};
		service.setMailSent = function(data) {
			this.Mailsent = data;
			//$rootScope.$broadcast('data_shared');
		};
		service.smsSent = false;
		service.getSmsSent = function() {
			return this.smsSent;
		};
		service.setSmsSent = function(data) {
			this.smsSent = data;
			//$rootScope.$broadcast('data_shared');
		};
		return service;
	}
})();
;
(function () {
    'use strict';

    angular
        .module('eltazkaraApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User($resource) {
        var service = $resource(window.backendUrl + 'Users', {}, {
            'GetBoughtTickets': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Users/GetBoughtTickets"
            },
            'HasSoldTickets': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Users/HasSoldTickets"
            },
            'GetSoldTickets': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Users/GetSoldTickets"
            },
            'CancelSellRequest': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Users/CancelSellRequest"
            },
            'CancelTicketGroup': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Users/CancelTicketGroup"
            },
            'GetReceipt': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Users/GetReceipt"
            },
            'checkVerification': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Users/CheckVerification"
            },
            'getMobileNumber': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Users/GetMobile"
            },
            'verifyMobileNumber': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Users/Verify"
            },
            'resendVerificationCode': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Users/ResendCode"
            },
            'changeMobileNumber': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Users/UpdateMobile"
            },
            'CheckEmailPhone': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Users/CheckEmailIfExist"
            }
            ,
            'ResetPasswordUsingMail': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Users/ResetPasswordUsingMail"
            },
            'UpdateMobileAndSendSMS': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Users/UpdateMobileAndSendSMS"
            },
            'IsUserBlocked': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Users/IsUserBlocked"
            },
            'IsUserBlockedOrDeleted': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Users/IsUserBlockedOrDeleted"
            }
        });
        service.showVerify = true;
        service.getShowVerify = function () {
            return this.showVerify;
        };
        service.setShowVerify = function (data) {
            this.showVerify = data;
            //$rootScope.$broadcast('data_shared');
        };
        return service;
    }
})();
;
(function () {
  "use strict";
  angular
    .module("eltazkaraApp")
    .controller("ThanksController", ThanksController);

  ThanksController.$inject = [
    "$state",
    "$stateParams",
    "$cookies",
    "thankservice",
    "userInfo",
  ];

  function ThanksController(
    $state,
    $stateParams,
    $cookies,
    thankservice,
    userInfo
  ) {
    var vm = this;
    vm.code = $stateParams.code;

    if (vm.code == "SendVerificationEmail") {
      $cookies.remove("refresh2");

      if (
        $cookies.get("MailSent") == "false" ||
        $cookies.get("MailSent") == null
      ) {
        thankservice.SendVerificationEmailToUser({}).$promise.then(
          function (data) {
            vm.showButton = false;

            if (data.status == "true") {
              document.getElementById("result").innerHTML =
                "Please check your email to verify your account.";
            } else
              document.getElementById("result").innerHTML =
                "An error has occured.";
          },
          function (error) {}
        );

        userInfo.setMailSent(true);
        $cookies.remove("MailSent");
        $cookies.put("MailSent", "true");
      } else {
        vm.showButton = true;
      }
    } else {
      thankservice.VerifiyEmail({ code: vm.code }).$promise.then(
        function (data) {
          if (data) {
            if (data.status === "false") {
              document.getElementById("result").innerHTML =
                "You must login to verify your account ";
            } else if (data.status === "true") {
              if (
                $cookies.get("refresh2") != "true" ||
                $cookies.get("refresh2") == null
              ) {
                $cookies.put("refresh2", "true");
                window.location.reload(true);
              }

              document.getElementById("result").innerHTML =
                "Thank You. Your email has been verified successfully.";
            }
          }
        },
        function (error) {
          document.getElementById("result").innerHTML = "There is an error";
        }
      );
    }

    vm.ResendMail = function () {
      $cookies.remove("MailSent");
      $cookies.put("MailSent", "false");
      $state.reload();
    };
  }
})();
;
(function () {
    'use strict';

    angular
        .module('eltazkaraApp')
        .factory('thankservice', thankservice);

    thankservice.$inject = ['$resource'];

    function thankservice($resource) {
        var service = $resource(window.backendUrl + 'Users', {}, {
            'VerifiyEmail': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Users/AcceptLinkToVerifiedMail"
            },
            'SendVerificationEmailToUser': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Users/SendVerificationLinkToMail"
            }
        });
        return service;
    }
})();
;
(function () {
    'use strict';

    angular
    .module('eltazkaraApp')
    .controller('balanceSheetController', balanceSheetController);

    balanceSheetController.$inject = [
    '$http',
    '$rootScope',
    'NgTableParams',
    'User',
    '$state'
    ];

    function balanceSheetController($http, $rootScope, NgTableParams, User, $state) {
        var vm = this;
    };
})();;
(function () {
    'use strict';

    angular
        .module('eltazkaraApp')
        .factory('Balance', Balance);

    Balance.$inject = ['$resource'];

    function Balance($resource) {
        var service = $resource(window.backendUrl + 'Users', {}, {
            'balanceSheet': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Users/BalanceSheet"
            }
        });
        return service;
    }
})();
;

(function () {
    'use strict';

    angular
        .module('eltazkaraApp')
        .controller('NotFoundController', NotFoundController);

    NotFoundController.$inject = [
        '$rootScope'
    ];

    function NotFoundController($rootScope) {
        var vm = this;
    }
})();
;
(function () {
  "use strict";

  angular.module("eltazkaraApp").controller("EventController", EventController);

  EventController.$inject = [
    "NgTableParams",
    "$stateParams",
    "$rootScope",
    "$window",
    "Filters",
    "Event",
    "User",
    "Socialshare",
    "PHANTOM_URL",
  ];

  function EventController(
    NgTableParams,
    $stateParams,
    $rootScope,
    $window,
    Filters,
    Event,
    User,
    Socialshare,
    PHANTOM_URL
  ) {
    var vm = this;
    vm.id = $stateParams.id;
    vm.requestSize = 5;
    vm.countPerLoad = 5;
    vm.listOffset = 0;
    $rootScope.sharingEnabled = true;

    vm.filters = {
      CategoryId: -1,
      PerformerId: -1,
      VenueId: -1,
    };

    function createUsingFullOptions() {
      var initialParams = { count: vm.requestSize };

      var initialSettings = {
        counts: [],
        dataset: vm.list,
      };

      return new NgTableParams(initialParams, initialSettings);
    }

    vm.EventDetails;
    vm.eventLoading = false;
    vm.StartEventDay;
    vm.StartEventMonth;
    vm.StartEventYear;
    vm.EndEventDay;
    vm.EndEventMonth;
    vm.EndEventYear;
    vm.loadingMore;
    vm.loadMoreText = "Load More";
    vm.list = [];
    vm.hasPerformances = false;
    vm.hasPerformancesFiltered = false;
    vm.allCategories = [];
    vm.allEvents = [];
    vm.allEventsLoading = false;
    vm.allVenues = [];
    vm.buyBlocked = false;
    vm.sellBlocked = false;
    vm.hasTickets = false;

    vm.getEvent = function () {
      vm.eventLoading = true;

      Event.getEvent({ Id: vm.id }).$promise.then(
        function (data) {
          vm.eventLoading = false;

          if (data) {
            var dataList = data.AllEvents;
            var tempItem = {
              name: dataList[0].Name,
              Description: dataList[0].Description,
              Image: dataList[0].Image,
              ParentCategory: dataList[0].ParentCategory,
              ParentCategories: dataList[0].ParentCategories,
              EventRestrection: dataList[0].EventRestrection,
            };

            vm.EventDetails = tempItem;
          }
        },
        function (error) {
          vm.eventLoading = false;
        }
      );
    };

    vm.getPerformances = function (more) {
      var listLimit = vm.countPerLoad;

      if (more) {
        vm.loadingMore = true;
        vm.loadMoreText = "Please wait...";
      } else {
        vm.listOffset = 0;
        vm.requestSize = vm.countPerLoad;
        vm.allEventsLoading = true;
      }

      Event.getEventPerformances({
        Id: vm.id,
        Offset: vm.listOffset,
        Limit: listLimit,
        Filters: vm.filters,
      }).$promise.then(
        function (data) {
          vm.allEventsLoading = false;

          if (data) {
            if (data.DataList.length > 0)
              vm.hasPerformances = vm.hasPerformancesFiltered = true;
            else {
              if (data.Filtered) {
                vm.hasPerformancesFiltered = false;
              }
            }

            var dataList = data.DataList;
            vm.list = more ? vm.list : [];
            vm.lastCall = data.LastCall;

            for (var i = 0; i < dataList.length; i++) {
              if (dataList[i].IsSellBlocked == true) {
                vm.sellBlocked = true;
              }

              if (dataList[i].IsBuyBlocked == true) {
                vm.buyBlocked = true;
              }

              if (dataList[i].AvailableTicket > 0) {
                vm.hasTickets = true;
              }

              var tempItem = {
                venueid: dataList[i].venueid,
                Name: dataList[i].Name,
                EventId: dataList[i].EventId,
                EventName: dataList[i].EventName,
                Description: dataList[i].Description,
                Performence: dataList[i].Performence,
                PerformenceId: dataList[i].PerformenceId,
                venue: dataList[i].venue,
                startDate: dataList[i].startDate,
                EndDate: dataList[i].EndDate,
                dayName: dataList[i].dayName,
                day: dataList[i].day,
                month: dataList[i].month,
                year: dataList[i].year,
                time: dataList[i].time,
                period: dataList[i].period,
                AvailableTicket: dataList[i].AvailableTicket,
                IsClosedBooking: dataList[i].IsClosedBooking,
                IsSellBlocked: dataList[i].IsSellBlocked,
                IsBuyBlocked: dataList[i].IsBuyBlocked,
              };

              vm.list.push(tempItem);
              vm.StartEventDay = dataList[0].day;
              vm.StartEventMonth = dataList[0].month;
              vm.StartEventYear = dataList[0].year;
              vm.EndEventDay = dataList[dataList.length - 1].Endday;
              vm.EndEventMonth = dataList[dataList.length - 1].Endmonth;
              vm.EndEventYear = dataList[dataList.length - 1].Endyear;
            }

            vm.getAllFilters();
          }

          if (more) {
            vm.loadingMore = false;
            vm.loadMoreText = "Load More";
          }

          vm.customConfigParams = createUsingFullOptions();
        },
        function (error) {
          vm.allEventsLoading = false;
        }
      );
    };

    vm.getAllFilters = function () {
      Filters.getEventFilters({ id: vm.id }).$promise.then(
        function (data) {
          if (data) {
            vm.allCategories = data.EventCategories;

            if (vm.allCategories.length > 1) {
              vm.allCategories.unshift({
                CategoryId: -1,
                CategoryName: "All",
              });
            } else if (vm.allCategories.length === 1) {
              vm.allCategories[0].CategoryId = -1;
            } else {
              vm.allCategories.unshift({
                CategoryId: -1,
                CategoryName: "No categories",
              });
            }

            vm.allPerformers = data.EventPerformers;

            if (vm.allPerformers.length > 1) {
              vm.allPerformers.unshift({
                PerformerId: -1,
                PerformerName: "All",
              });
            } else if (vm.allPerformers.length === 1) {
              vm.allPerformers[0].PerformerId = -1;
            } else {
              vm.allPerformers.unshift({
                PerformerId: -1,
                PerformerName: "No performers",
              });
            }

            vm.allVenues = data.EventVenues;

            if (vm.allVenues.length > 1) {
              vm.allVenues.unshift({
                VenueId: -1,
                VenueName: "All",
              });
            } else if (vm.allVenues.length === 1) {
              vm.allVenues[0].VenueId = -1;
            } else {
              vm.allVenues.unshift({
                VenueId: -1,
                VenueName: "No venues",
              });
            }
          }

          vm.customConfigParams = createUsingFullOptions();
        },
        function (error) {}
      );
    };

    vm.getEvent();
    vm.getPerformances(false);

    vm.loadMore = function () {
      vm.listOffset = vm.requestSize;
      vm.requestSize += vm.countPerLoad;
      vm.customConfigParams.count(vm.requestSize);
      vm.getPerformances(true);
    };

    vm.trySell = function (performanceId) {
      if ($rootScope.User && $rootScope.User.Email) {
        User.IsUserBlockedOrDeleted({
          UserId: $rootScope.User.UserId,
        }).$promise.then(
          function (data) {
            if (data.status == "true") {
              location.href = "#/performance/" + performanceId + "/sell";
            } else {
              location.href = "#/";
              $rootScope.PopUpTitle = "Blocked User";

              $rootScope.PopUpDescription =
                "You do not have access. Please contact the administrator.";

              $rootScope.showPopup = true;
            }
          },
          function (error) {}
        );
      } else {
        vm.toggleLoginPanel();
      }
    };

    vm.share = function () {
      $rootScope.siteTitle = "Tixawy";

      Socialshare.share({
        provider: "facebook",
        attrs: {
          socialshareUrl: PHANTOM_URL,
        },
      });
    };

    vm.toggleLoginPanel = function () {
      $window.scrollTo(0, 0);
      $rootScope.loginPanelActive = !$rootScope.loginPanelActive;
      document.getElementById("userLoginEmail").value = "";
      document.getElementById("userLoginPassword").value = "";
      document.getElementById("userLoginRemember").checked = false;
      $rootScope.userLoginError = false;
      vm.User = {};
      vm.errors = {};
    };
  }
})();
;
(function () {
    'use strict';

    angular
        .module('eltazkaraApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('event', {
            parent: 'app',
            url: '/event/:id',
            views: {
                'content@': {
                    templateUrl: 'components/events/event.html',
                    controller: 'EventController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('eltazkaraApp')
        .factory('Event', Event);

    Event.$inject = ['$resource'];

    function Event($resource) {
        var service = $resource(window.backendUrl + '/Events', {}, {
            'getEvent': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Events/GetEvent"
            },
            'getEventPerformances': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Events/GetEventPerformances"
            }
        });

        return service;
    }
})();
;
(function () {
    'use strict';
    angular
        .module('eltazkaraApp')
        .controller('PerformerController', PerformerController);
    PerformerController.$inject = [
      '$rootScope',
      'NgTableParams',
      '$stateParams',
      '$window',
      'Filters',
      'Performer',
      'User'
    ];
    function PerformerController($rootScope, NgTableParams, $stateParams, $window, Filters, Performer, User,PerformerEvents ) {
        var vm = this;
        vm.id = $stateParams.id;
        vm.requestSize = 5; //HS:initial list size
        vm.countPerLoad = 5; //HS:increase per step
        vm.listOffset = 0; //HS:load more start index
        vm.filters = {
            "CategoryId": -1,
            "EventId": -1,
            "VenueId": -1
        };
        vm.months = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];
        vm.customConfigParams = createUsingFullOptions();
        function createUsingFullOptions() {
            var initialParams = {
                count: vm.requestSize
            };
            var initialSettings = {
                counts: [],
                dataset: vm.list
            };
            return new NgTableParams(initialParams, initialSettings);
        }
        vm.loadingMore;
        vm.loadMoreText = "Load More";
        //HS:Performer data functions
        vm.list = [];
        vm.hasPerformances = false;
        vm.hasPerformancesFiltered = false;
        vm.allCategories = [];
        vm.allEvents = [];
        vm.allEventsLoading = false;
        vm.allVenues = [];
        //HS:Item
        vm.getPerformer = function () {
            vm.performerLoading = true;
            Performer.getPerformer({ "id": vm.id })
                .$promise.then(function (data) {
                    vm.performerLoading = false;
                    if (data.PerformerDetails) {
                        var dataList = data.PerformerDetails;
                        var tempItem = {
                            "name": dataList[0].Name,
                            "Description": dataList[0].Description,
                            "Image": dataList[0].Image,
                            "Facebook": dataList[0].Facebook,
                            "Website": dataList[0].Website,
                            "Views": dataList[0].Views,
                        };
                        vm.performerDetails = tempItem;
                    }
                }, function (error) { vm.performerLoading = false; })
        }
        //HS:Datalist
        vm.getPerformances = function (more) {
            var listLimit = vm.countPerLoad;
            if (more) {
                vm.loadingMore = true;
                vm.loadMoreText = "Please wait...";
            }
            else {
                vm.listOffset = 0;
                vm.requestSize = vm.countPerLoad;
                vm.allEventsLoading = true;
            }
            Performer.getPerformerPerformances({
                "Id": vm.id,
                "Offset": vm.listOffset,
                "Limit": listLimit,
                "Filters": vm.filters
            })
            .$promise.then(function (data) {
                vm.allEventsLoading = false;
                if (data.DataList) {
                    if (data.DataList.length > 0) {
                        vm.hasPerformances = vm.hasPerformancesFiltered = true;
                    }
                    else {
                        if (data.Filtered) {
                            vm.hasPerformancesFiltered = false;
                        }
                    }
                    var dataList = data.DataList;
                    vm.list = more ? vm.list : [];
                    vm.lastCall = data.LastCall;
                    for (var i = 0; i < dataList.length; i++) {
                        var tempItem = {
                            "Name": dataList[i].Name,
                            "EventId": dataList[i].EventId,
                            "EventName": dataList[i].EventName,
                            "Description": dataList[i].Description,
                            "Performence": dataList[i].Performence,
                            "PerformenceId": dataList[i].PerformenceId,
                            "venue": dataList[i].venue,
                            "venueid": dataList[i].venueid,
                            "startDate": dataList[i].startDate,
                            "EndDate": dataList[i].EndDate,
                            "dayName": dataList[i].dayName,
                            "day": dataList[i].day,
                            "month": dataList[i].month,
                            "year": dataList[i].year,
                            "time": dataList[i].time,
                            "period": dataList[i].period,
                            "avTickets": dataList[i].AvailableTicket,
                            "IsClosedBooking": dataList[i].IsClosedBooking,
                            "IsBuyBlocked": dataList[i].IsBuyBlocked,
                            "IsSellBlocked":dataList[i].IsSellBlocked,
                            "Num_Performances_InEvent": dataList[i].Num_Performances_InEvent,
                        };
                        vm.list.push(tempItem);
                    }
                    //HS:Filters firing
                    vm.getAllFilters();
                }
                if (more) {
                    vm.loadingMore = false;
                    vm.loadMoreText = "Load More";
                }
                vm.customConfigParams = createUsingFullOptions();
            }, function (error) { vm.allEventsLoading = false; })
        }
        //HS:Filters
        vm.getAllFilters = function () {
            Filters.getPerformerFilters({
                "id": vm.id
            })
            .$promise.then(function (data) {
                if (data) {
                    vm.allCategories = data.PerformerCategories;
                    if (vm.allCategories.length > 1) {
                        vm.allCategories.unshift({
                            "CategoryId": -1,
                            "CategoryName": "All"
                        });
                    }
                    else if (vm.allCategories.length === 1) {
                        vm.allCategories[0].CategoryId = -1;
                    }
                    else {
                        vm.allCategories.unshift({
                            "CategoryId": -1,
                            "CategoryName": "No categories"
                        });
                    }
                    vm.allEvents = data.PerformerEvents;
                    if (vm.allEvents.length > 1) {
                        vm.allEvents.unshift({
                            "EventId": -1,
                            "EventName": "All"
                        });
                    }
                    else if (vm.allEvents.length === 1) {
                        vm.allEvents[0].EventId = -1;
                    }
                    else {
                        vm.allEvents.unshift({
                            "EventId": -1,
                            "EventName": "No events"
                        });
                    }
                    vm.allVenues = data.PerformerVenues;
                    if (vm.allVenues.length > 1) {
                        vm.allVenues.unshift({
                            "VenueId": -1,
                            "VenueName": "All"
                        });
                    }
                    else if (vm.allVenues.length === 1) {
                        vm.allVenues[0].VenueId = -1;
                    }
                    else {
                        vm.allVenues.unshift({
                            "VenueId": -1,
                            "VenueName": "No venues"
                        });
                    }
                }
                vm.customConfigParams = createUsingFullOptions();
            }, function (error) { })
        }
        //HS:Functions firing
        //HS:Item
        vm.getPerformer();
        //HS:Datalist
        vm.getPerformances(false);
        /**---------------------------------------------------------------------------------------------------------------------------------*/
        vm.loadMore = function () {
            vm.listOffset = vm.requestSize;
            vm.requestSize += vm.countPerLoad;
            vm.customConfigParams.count(vm.requestSize);
            vm.getPerformances(true);
        }
        //HS:sell button click action
        vm.trySell = function (PerformanceId) {
            if ($rootScope.User && $rootScope.User.Email) {
                User.IsUserBlockedOrDeleted({ "UserId": $rootScope.User.UserId })
                .$promise.then(function (data) {
                    if (data.status == "true") {
                        location.href = "#/performance/" + PerformanceId + "/sell";
                    }
                    else {
                        location.href = "#/";
                        $rootScope.PopUpTitle = "Blocked User";
                        $rootScope.PopUpDescription = "You don't have access please contact with Admin";
                        $rootScope.showPopup = true;
                    }
                }, function (error) { })
            }
            else {
                vm.toggleLoginPanel();
            }
        }
        vm.toggleLoginPanel = function () {
          $window.scrollTo(0, 0);
          $rootScope.loginPanelActive = !$rootScope.loginPanelActive;
          document.getElementById("userLoginEmail").value = "";
          document.getElementById("userLoginPassword").value = "";
          document.getElementById("userLoginRemember").checked = false;
          $rootScope.userLoginError = false;
          vm.User = {};
          vm.errors = {};
        };

    }
})();
;
(function () {
    'use strict';

    angular
        .module('eltazkaraApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('performer', {
            parent: 'app',
            url: '/performer/:id',
            views: {
                'content@': {
                    templateUrl: 'components/performers/performer.html',
                    controller: 'PerformerController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();
;
(function () {
    'use strict';
     
    angular
        .module('eltazkaraApp')
        .factory('Performer', Performer);

    Performer.$inject = ['$resource'];

    function Performer($resource) {
        var service = $resource(window.backendUrl + 'Performers', {}, {
            'getPerformer': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Performers/GetPerformer"
            },
            'getPerformerPerformances': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Performers/GetPerformerPerformances"
            }
        });

        return service;
    }
})();
;
(function () {
  "use strict";

  angular
    .module("eltazkaraApp")
    .controller("PerformanceController", PerformanceController)
    .filter("MoreQuantityFilter", MoreQuantityFilter);

  PerformanceController.$inject = [
    "$scope",
    "$rootScope",
    "$stateParams",
    "$location",
    "$window",
    "Performance",
    "NgTableParams",
    "PerformersService",
    "TicketsService",
    "$state",
    "User",
    "$cookies",
  ];

  function PerformanceController(
    $scope,
    $rootScope,
    $stateParams,
    $location,
    $window,
    Performance,
    NgTableParams,
    PerformersService,
    TicketsService,
    $state,
    User,
    $cookies
  ) {
    var vm = this;
    vm.PerformanceLoading = false;
    vm.data = [];
    vm.id = $stateParams.id;
    vm.listSize = 5;
    vm.CountPerPage = 5;
    vm.moreTickets;
    vm.totalQuantitiesTrimmed = [];
    vm.PerformanceDetails = {};

    if ($cookies.get("refresh") != null) {
      $cookies.remove("refresh");
      window.location.reload(true);
    }

    vm.getPerformance = function () {
      vm.PerformanceLoading = true;

      Performance.getPerformance({
        Id: vm.id,
        CountPerPage: vm.CountPerPage,
        PageIndex: vm.PageIndex,
      }).$promise.then(
        function (data) {
          vm.PerformanceLoading = false;

          if (data) {
            var dataList = data.AllPerformances;

            if (dataList.length > 0) {
              vm.PerformanceDetails = dataList[0];

              if (vm.PerformanceDetails.AvailableTickets == 0) {
                vm.showPerformanceData = false;
                vm.dontShow = false;
              } else {
                vm.dontShow = true;
              }
            }
          }
        },
        function (error) {
          vm.PerformanceLoading = false;
        }
      );
    };

    vm.performers = [];

    vm.getPerformers = function () {
      PerformersService.getPerformers({ PerformanceId: vm.id }).$promise.then(
        function (data) {
          if (data) {
            vm.performers = data;
          }
        }
      );
    };

    // Link to performer page
    vm.goPerformer = function (performerId) {
      $location.path("performer/" + performerId);
    };

    // Datalist
    vm.getTickets = function () {
      TicketsService.getTicketsList({ PerformanceId: vm.id }).$promise.then(
        function (data) {
          if (data.TicketList) {
            vm.data = data.TicketList;
            vm.totalQuantities = data.TotalQuantities;

            if (vm.totalQuantities.length > 6) {
              for (var qty = 0; qty < 5; qty++) {
                vm.totalQuantitiesTrimmed.push(vm.totalQuantities[qty]);
              }

              vm.totalQuantitiesTrimmed.push(vm.totalQuantities[5] + "+");
            } else {
              vm.totalQuantitiesTrimmed = vm.totalQuantities;
            }

            vm.totalTickets = data.TotalTickets;
            vm.minPrice = data.MinPrice;

            vm.customConfigParams = new NgTableParams(
              {
                count: vm.listSize,
              },
              {
                counts: [],
                filterOptions: { filterFilterName: "MoreQuantityFilter" },
                dataset: vm.data,
              }
            );

            vm.moreTickets = vm.CountPerPage < vm.data.length;
            vm.bindFilters();

            if (vm.customConfigParams.total() < 1) {
              vm.showPerformanceData = false;
            } else {
              vm.showPerformanceData = true;
            }
          }
        }
      );
    };

    vm.getPerformance();
    vm.getPerformers();
    vm.getTickets();

    vm.loadMore = function () {
      if (vm.moreTickets) {
        vm.listSize += vm.CountPerPage;
        vm.customConfigParams.count(vm.listSize);
      }

      vm.moreTickets =
        vm.moreTickets && vm.data.length > vm.customConfigParams.count();

      vm.customConfigParams.reload();
    };

    vm.bindFilters = function () {
      $scope.$watch(
        "[vm.ticketgroupPriceFilter, vm.ticketgroupQuantityFilter]",
        function () {
          vm.customConfigParams.filter().TicketPrice =
            vm.ticketgroupPriceFilter;

          vm.customConfigParams.filter().Quantities =
            vm.ticketgroupQuantityFilter;

          vm.customConfigParams.reload();
        }
      );
    };

    vm.openPhotoSwipe = function () {
      var pswpElement = document.querySelectorAll(".pswp")[0];

      // Build items array
      var items = [
        {
          src: vm.PerformanceDetails.SeatmapImage2,
          w: 1960,
          h: 1268,
          title: "swipe to exit",
        },
      ];

      var options = {
        history: false,
        focus: false,
        showAnimationDuration: 0,
        hideAnimationDuration: 0,
      };

      var gallery = new PhotoSwipe(
        pswpElement,
        PhotoSwipeUI_Default,
        items,
        options
      );

      gallery.init();
    };

    vm.buyPerformanceTickets = function (ticket, quantity) {
      if ($rootScope.User && $rootScope.User.Email) {
        User.IsUserBlockedOrDeleted({
          UserId: $rootScope.User.UserId,
        }).$promise.then(
          function (data) {
            if (data.status == "true") {
              Performance.isTicketGroupCancelled(ticket).$promise.then(
                function (data) {
                  if (!data.status) {
                    $rootScope.PopUpTitle = "Ticket Not Found";
                    $rootScope.PopUpDescription =
                      "This ticket may have been cancelled or no longer exists.";

                    $rootScope.showPopup = true;
                    location.href = "#/";
                    return;
                  }

                  $state.go("payment", {
                    id: vm.id,
                    ticket: ticket,
                    performanceDetails: vm.PerformanceDetails,
                  });
                },
                function (error) {
                  $rootScope.PopUpTitle = "Error";

                  $rootScope.PopUpDescription =
                    "Something went wrong. Please try again or contact the administration.";

                  $rootScope.showPopup = true;
                  window.location.reload(true);
                }
              );
            } else {
              location.href = "#/";
              $rootScope.PopUpTitle = "Blocked User";

              $rootScope.PopUpDescription =
                "You don't have access. Please contact the administration.";

              $rootScope.showPopup = true;
            }
          },
          function (error) {}
        );
      } else {
        vm.toggleLoginPanel();
      }
    };

    // Sell button click action
    vm.trySell = function () {
      if ($rootScope.User && $rootScope.User.Email) {
        User.IsUserBlockedOrDeleted({
          UserId: $rootScope.User.UserId,
        }).$promise.then(
          function (data) {
            if (data.status == "true") {
              location.href = "#/performance/" + vm.id + "/sell";
            } else {
              location.href = "#/";
              $rootScope.PopUpTitle = "Blocked User";

              $rootScope.PopUpDescription =
                "You do not have access. Please contact the administrator.";

              $rootScope.showPopup = true;
            }
          },
          function (error) {}
        );
      } else {
        vm.toggleLoginPanel();
      }
    };

    vm.toggleLoginPanel = function () {
      $window.scrollTo(0, 0);
      $rootScope.loginPanelActive = !$rootScope.loginPanelActive;
      document.getElementById("userLoginEmail").value = "";
      document.getElementById("userLoginPassword").value = "";
      document.getElementById("userLoginRemember").checked = false;
      $rootScope.userLoginError = false;
      vm.User = {};
      vm.errors = {};
    };
  }

  function MoreQuantityFilter() {
    return function (data, selectedTicket) {
      return (data || []).filter(function (curTicket) {
        var qCriteria = true;
        var pCriteria = true;
        var length = curTicket.Quantities.length;
        var curPrice = curTicket.TicketPrice;
        var curQuantity = curTicket.Quantities;
        var maxNum = curQuantity.sort()[length - 1];
        var selectedPrice = selectedTicket.TicketPrice;
        var selectedQuantity = selectedTicket.Quantities;

        if (selectedQuantity) {
          if (selectedQuantity.indexOf("+") > -1) {
            selectedQuantity = 6;
            qCriteria = qCriteria && maxNum > selectedQuantity;
          } else {
            selectedQuantity = parseInt(selectedQuantity);
            qCriteria = curQuantity.indexOf(selectedQuantity) > -1;
          }
        }

        if (selectedPrice) {
          var pCriteria = curPrice <= selectedPrice;
        }

        return qCriteria && pCriteria;
      });
    };
  }
})();
;
(function () {
  "use strict";

  angular.module("eltazkaraApp").config(stateConfig);
  stateConfig.$inject = ["$stateProvider"];

  function stateConfig($stateProvider) {
    $stateProvider.state("performance", {
      parent: "app",
      url: "/performance/:id",
      views: {
        "content@": {
          templateUrl: "components/performances/performance.html",
          controller: "PerformanceController",
          controllerAs: "vm",
        },
      },
      resolve: {
        translatePartialLoader: [
          "$translate",
          "$translatePartialLoader",
          function ($translate, $translatePartialLoader) {
            $translatePartialLoader.addPart("global");
          },
        ],
        auth: function (Principal, $q, $state) {
          return Principal.identity(true).then(function (res) {
            if (!res.IsPhoneVerified || !res.IsEmailVerified) {
              $state.go("account", {});
              return $q.reject("User not verified");
            }

            return true;
          });
        },
      },
    });
  }
})();
;
(function () {
    'use strict';

    angular
        .module('eltazkaraApp')
        .factory('Performance', Performance);

    Performance.$inject = ['$resource'];

    function Performance($resource) {
        var service = $resource(window.backendUrl + 'Performances', {}, {
            'getPerformance': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Performances/GetPerformance"
            },
            'isTicketGroupCancelled': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Performances/IsTicketGroupCancelled"
            }
        });

        return service;
    }
})();
;
(function () {
    'use strict';

    angular
        .module('eltazkaraApp')
        .factory('PerformersService', PerformersService);

    PerformersService.$inject = ['$resource'];

    function PerformersService($resource) {
        var service = $resource(window.backendUrl + 'Performances', {}, {
            'getPerformers': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Performances/GetPerformers"
            }
        });

        return service;
    }
})();
;
(function () {
    'use strict';

    angular
        .module('eltazkaraApp')
        .factory('TicketsService', TicketsService);

    TicketsService.$inject = ['$resource'];

    function TicketsService($resource) {
        var service = $resource(window.backendUrl + 'Performances', {}, {
            'getTicketsList': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Performances/GetTickets"
            }
        });

        return service;
    }
})();;
(function () {
    'use strict';
    angular
        .module('eltazkaraApp')
        .controller('VenueController', VenueController);
    VenueController.$inject = [
      '$scope',
      '$rootScope',
      'NgTableParams',
      '$stateParams',
      '$window',
      'Filters',
      'Venue',
      'User'
    ];
    function VenueController($scope, $rootScope, NgTableParams, $stateParams, $window, Filters, Venue, User, VenueEvents) {
        var vm = this;
        vm.id = $stateParams.id;
        vm.requestSize = 5; //HS: initial list size
        vm.countPerLoad = 5; //HS: increase per step
        vm.listOffset = 0; //HS: load more start index
        vm.filters = {
            "CategoryId": -1,
            "EventId": -1,
            "PerformerId": -1
        };
        vm.customConfigParams = createUsingFullOptions();
        function createUsingFullOptions() {
            var initialParams = {
                count: vm.requestSize
            };
            var initialSettings = {
                counts: [],
                dataset: vm.list
            };
            return new NgTableParams(initialParams, initialSettings);
        }
        vm.openPhotoSwipe = function () {
            var pswpElement = document.querySelectorAll('.pswp')[0];
            // build items array
            var items = [
                {
                    src: 'assets/images/temp/seating.jpg',
                    w: 1960,
                    h: 1268
                },
                {
                    src: 'assets/images/temp/seating2.jpg',
                    w: 1274,
                    h: 938
                }
            ];
            var options = {
                history: false,
                focus: false,
                showAnimationDuration: 0,
                hideAnimationDuration: 0
            };
            var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
            gallery.init();
        };
        vm.loadingMore;
        vm.loadMoreText = "Load More";
        //HS: Venue data functions
        vm.list = [];
        vm.hasPerformances = false;
        vm.hasPerformancesFiltered = false;
        vm.allCategories = [];
        vm.allEvents = [];
        vm.allEventsLoading = false;
        vm.allVenues = [];
        vm.VenueDetails;
        vm.venueLoading = false;
        //HS: Item
        vm.getVenue = function () {
            vm.venueLoading = true;
            Venue.getVenue({ "Id": vm.id })
            .$promise.then(function (data) {
                vm.venueLoading = false;
                if (data.AllVenues) {
                    var dataList = data.AllVenues;
                    if (dataList.length > 0) {
                        var tempItem = {
                            "name": dataList[0].Name,
                            "Description": dataList[0].Description,
                            "Image": dataList[0].Image,
                            "Image2": dataList[0].Image2,
                            "SeatmapUrl": dataList[0].SeatmapUrl,
                            "Facebook": dataList[0].Facebook,
                            "Website": dataList[0].Website,
                            "Views": dataList[0].Views,
                            "Address": dataList[0].Address,
                            "Long": dataList[0].Long,
                            "Latt": dataList[0].Latt,
                            "Phone": dataList[0].Phone
                        };
                        vm.VenueDetails = tempItem;
                    }
                }
            }, function (error) { vm.venueLoading = false; })
        }
        //HS: Datalist
        vm.getPerformances = function (more) {
            var listLimit = vm.countPerLoad;
            if (more) {
                vm.loadingMore = true;
                vm.loadMoreText = "Please wait...";
            }
            else {
                vm.listOffset = 0;
                vm.requestSize = vm.countPerLoad;
                vm.allEventsLoading = true;
            }
            Venue.getVenuePerformances({
                "Id": vm.id,
                "Offset": vm.listOffset,
                "Limit": listLimit,
                "Filters": vm.filters
            })
            .$promise.then(function (data) {
                vm.allEventsLoading = false;
                if (data.DataList) {
                    if (data.DataList.length > 0) {
                        vm.hasPerformances = vm.hasPerformancesFiltered = true;
                    }
                    else {
                        if (data.Filtered) {
                            vm.hasPerformancesFiltered = false;
                        }
                    }
                    var dataList = data.DataList;
                    vm.list = more ? vm.list : [];
                    vm.lastCall = data.LastCall;
                    for (var i = 0; i < dataList.length; i++) {
                        var tempItem = {
                            "PerformenceId": dataList[i].PerformenceId,
                            "Name": dataList[i].Name,
                            "EventId": dataList[i].EventId,
                            "EventName": dataList[i].EventName,
                            "Description": dataList[i].Description,
                            "Performence": dataList[i].Performence,
                            "venue": dataList[i].venue,
                            "startDate": dataList[i].startDate,
                            "EndDate": dataList[i].EndDate,
                            "dayName": dataList[i].dayName,
                            "day": dataList[i].day,
                            "month": dataList[i].month,
                            "year": dataList[i].year,
                            "time": dataList[i].time,
                            "period": dataList[i].period,
                            "avTickets": dataList[i].AvailableTicket,
                            "IsClosedBooking": dataList[i].IsClosedBooking,
                            "IsBuyBlocked": dataList[i].IsBuyBlocked,
                            "IsSellBlocked": dataList[i].IsSellBlocked,
                        };
                        vm.list.push(tempItem);
                    }
                    if (vm.list.length < 1) {
                        vm.showVenuePerformances = false;
                    } else {
                        vm.showVenuePerformances = true;
                    }
                    //HS: Filters firing
                    vm.getAllFilters();
                }
                if (more) {
                    vm.loadingMore = false;
                    vm.loadMoreText = "Load More";
                }
                vm.customConfigParams = createUsingFullOptions();
            }, function (error) { vm.allEventsLoading = false; })
        }
        //HS: Filters
        vm.getAllFilters = function () {
            Filters.getVenueFilters({
                "id": vm.id
            })
            .$promise.then(function (data) {
                if (data) {
                    vm.allCategories = data.VenueCategories;
                    if (vm.allCategories.length > 1) {
                        vm.allCategories.unshift({
                            "CategoryId": -1,
                            "CategoryName": "All"
                        });
                    }
                    else if (vm.allCategories.length === 1) {
                        vm.allCategories[0].CategoryId = -1;
                    }
                    else {
                        vm.allCategories.unshift({
                            "CategoryId": -1,
                            "CategoryName": "No categories"
                        });
                    }
                    vm.allPerformers = data.VenuePerformers;
                    if (vm.allPerformers.length > 1) {
                        vm.allPerformers.unshift({
                            "PerformerId": -1,
                            "PerformerName": "All"
                        });
                    }
                    else if (vm.allPerformers.length === 1) {
                        vm.allPerformers[0].PerformerId = -1;
                    }
                    else {
                        vm.allPerformers.unshift({
                            "PerformerId": -1,
                            "PerformerName": "No performers"
                        });
                    }
                    vm.allEvents = data.VenueEvents;
                    if (vm.allEvents.length > 1) {
                        vm.allEvents.unshift({
                            "EventId": -1,
                            "EventName": "All"
                        });
                    }
                    else if (vm.allEvents.length === 1) {
                        vm.allEvents[0].EventId = -1;
                    }
                    else {
                        vm.allEvents.unshift({
                            "EventId": -1,
                            "EventName": "No events"
                        });
                    }
                }
                vm.customConfigParams = createUsingFullOptions();
            }, function (error) { })
        }
        //HS: Function firing
        //HS: Item
        vm.getVenue();
        //HS: Datalist
        vm.getPerformances(false);
        vm.loadMore = function () {
            vm.listOffset = vm.requestSize;
            vm.requestSize += vm.countPerLoad;
            vm.customConfigParams.count(vm.requestSize);
            vm.getPerformances(true);
        }
        //HS:sell button click action
        vm.trySell = function(performanceId){
              if($rootScope.User&&$rootScope.User.Email)
                {
                    User.IsUserBlockedOrDeleted({"UserId": $rootScope.User.UserId})
                    .$promise.then(function (data) {
                    if (data.status == "true") {
                      location.href = "#/performance/" + performanceId + "/sell";
                    }
                    else {
                      location.href = "#/";
                      $rootScope.PopUpTitle = "Blocked User";
                      $rootScope.PopUpDescription = "You don't have access please contact with Admin";
                      $rootScope.showPopup = true;
                      }
                    }, function (error) { })
                }
              else
              {
                vm.toggleLoginPanel();
              }
        }
        vm.toggleLoginPanel = function () {
          $window.scrollTo(0, 0);
          $rootScope.loginPanelActive = !$rootScope.loginPanelActive;
          document.getElementById("userLoginEmail").value = "";
          document.getElementById("userLoginPassword").value = "";
          document.getElementById("userLoginRemember").checked = false;
          $rootScope.userLoginError = false;
          vm.User = {};
          vm.errors = {};
        };
    }
})();
;
(function () {
  'use strict';

  angular
      .module('eltazkaraApp')
      .config(stateConfig);

  stateConfig.$inject = ['$stateProvider'];

  function stateConfig($stateProvider) {
      $stateProvider.state('venue', {
    parent: 'app',
    url: '/venue/:id',
    views: {
      'content@': {
          templateUrl: 'components/venues/venue.html',
        controller: 'VenueController',
        controllerAs: 'vm'
      }
    },
    resolve: {
      translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
        $translatePartialLoader.addPart('global');
      }]
    }
  });
  }
})();
;
(function () {
    'use strict';

    angular
        .module('eltazkaraApp')
        .factory('Venue', Venue);

    Venue.$inject = ['$resource'];

    function Venue($resource) {
        var service = $resource(window.backendUrl + 'Venues', {}, {
            'getVenue': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Venues/GetVenues"
            },
            'getVenuePerformances': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Venues/GetVenuePerformances"
            }
        });

        return service;
    }
})();
;
(function () {
    'use strict';
    angular
        .module('eltazkaraApp')
        .factory('Filters', Filters);
    Filters.$inject = ['$resource'];
    function Filters($resource) {
        var service = $resource(window.backendUrl, {}, {
            //HS:Categories
            'getCategoryFilters': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Categories/GetFilters"
            },
            //HS:Events
            'getEventFilters': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Events/GetFilters"
            },
            //HS:Performers
            'getPerformerFilters': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Performers/GetFilters"
            },
            //HS:Venues
            'getVenueFilters': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Venues/GetFilters"
            }
        });
        return service;
    }
})();
;
(function () {
    'use strict';
    angular
        .module('eltazkaraApp')
        .factory('fieldsService', fields);
    function fields() {
        return {
            //HS:Reset all ng models in the given form
            reset: function (objs, toggled) {
                for (var i = 0; i < objs.length; i++) {
                    var obj = objs[i][0];
                    if (obj instanceof Object) {
                        var objProps = objs[i][1];

                        if (!toggled) {
                            if (objProps.length > 0) {
                                for (var i = 0; i < objProps.length; i++) {
                                    obj[objProps[i]] = obj[objProps[i] + 'Copy'];
                                }
                            }
                            else {
                                for (var prop in obj) {
                                    if (prop.indexOf('Copy') > -1) continue;

                                    obj[prop] = obj[prop + 'Copy'];
                                }
                            }
                        }
                        else {
                            for (var prop in obj) {
                                if (prop.indexOf('Copy') > -1) continue;
                                obj[prop + 'Copy'] = obj[prop];
                            }
                        }
                    }
                }
            }
        }
    }
})();
;
(function () {
  'use strict';

  angular
      .module('eltazkaraApp')
      .controller('TicketsController', TicketsController);

  TicketsController.$inject = [
    '$http',
    '$rootScope',
    'localStorageService'
  ];

  function TicketsController($http, $rootScope, localStorageService) {
      var self = this;

      self.TicketPerPage = 10;
      self.CurrentPage = 1;
      self.TicketsList = [];

      self.getItems = function () {
          $http({
              method: "POST",
              url: window.backendUrl + "Performances/GetEventTickets",
              headers: { 'Content-Type': 'application/json' },
              data: JSON.stringify({ "PageIndex": self.CurrentPage, "CountPerPage": self.TicketPerPage })
          }).then(function mySucces(response) {
              if (response.data.length == 0) {
              }
              else {
                  var TicketData;
                  var TicketsCount = response.data.length;
                  for (var i = 0; i < Ticketscount; i++) {
                      TicketData = JSON.parse(response.data[i].FullJSON).Object;
                      if (TicketData) {
                          var tempItem = {
                              "id": TicketData.TicketId,
                              "DateSold": TicketData.DateSold,
                              "Seat": TicketData.Seat,
                              "Status": TicketData.Status,
                              "TicketGroupId": TicketData.TicketGroupId,
                          };
                          self.TicketsList.push(tempItem);
                      }
                  }
              }
          }, function myError(response) {
          });
      }
      self.getItems();
  }

})();
;
(function () {
  'use strict';

  angular
      .module('eltazkaraApp')
      .config(stateConfig);

  stateConfig.$inject = ['$stateProvider'];

  function stateConfig($stateProvider) {
    $stateProvider.state('tickets', {
      parent: 'app',
      url: '/tickets',
      views: {
        'content@': {
          templateUrl: 'components/tickets/tickets.html',
          controller: 'TicketsController',
          controllerAs: 'vm'
        }
      },
      resolve: {
        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
          $translatePartialLoader.addPart('global');
        }]
      }
    });
  }
})();
;
(function () {
  'use strict';

  angular
      .module('eltazkaraApp')
      .controller('RequestsController', RequestsController)
      .service('RequestsService', RequestsService);
      RequestsService.$inject = ['$resource'];

      function RequestsService($resource) {
          var service = $resource(window.backendUrl + 'Requests', {}, {
              'AddRequest': {
                  method: 'POST', isArray: false,
                  url: window.backendUrl + "Requests/SaveRequest"
              },
              'getRequestTypes2': {
                  method: 'GET', isArray: true,
                  url: window.backendUrl + "Requests/GetRequestTypes"
              },
              'getUserInfo': {
                  method: 'GET', isArray: false,
                  url: window.backendUrl + "Requests/GetUserInfoIFLoggedIn"
              }
          });
          return service;
      }
  RequestsController.$inject = [
    '$rootScope',
    'RequestsService',
    '$state'
  ];

  function RequestsController($rootScope,RequestsService, $state) {
      var vm = this;
      if ($rootScope.User) {
          vm.id = $rootScope.User.UserId;
          vm.getUserInfo = function () {
              RequestsService.getUserInfo()
                  .$promise.then(function (data) {
                      if (data) {
                          vm.UserName = data.name;
                          vm.UserEmail = data.email;
                      }
                  }, function (error) { })
          };

          vm.getUserInfo();
      }
      else
          vm.id = 0;
      vm.RequestsTypes = [];
      vm.type = $state.params.type.split("_")[0] + " " + $state.params.type.split("_")[1];
      vm.getRequestTypes = function () {
          RequestsService.getRequestTypes2()
              .$promise.then(function (data) {
                  if (data) {
                      vm.Types = data;
                      for (var i = 0; i < vm.Types.length;i++){
                          if (vm.Types[i].isHidden == false) {
                              vm.RequestsTypes.push(vm.Types[i]);
                          }
                      }
                      for (var i = 0; i < vm.RequestsTypes.length; i++) {
                          if ((vm.RequestsTypes[i].name)==(vm.type)) {
                              vm.SelectedType = vm.RequestsTypes[i];
                              break;
                          }
                      }

                  }
              }, function (error) { })
      };

      vm.getRequestTypes();

      var clicked = false;
      vm.submitText = "Submit";
      vm.saveRequestData = function (bool) {
          if (!clicked) {
              vm.submitText = "Please Wait..."
              clicked = true;
              if (!bool)
                  return;
              if (vm.id != 0) {
                  vm.Name = vm.UserName;
                  vm.Email = vm.UserEmail;
              }
              RequestsService.AddRequest({
                  "Subject": vm.requestSubject,
                  "RequestTypeId": vm.SelectedType,
                  "Name": vm.Name,
                  "Mobile": vm.Mobile,
                  "Email": vm.Email,
                  "Body": vm.requestBody
              })
              .$promise.then(function (data) {
                  if (data) {
                      $state.go('home', {});
                  }
              }, function (error) {
                  clicked = false;
                  vm.submitText = "Submit";
                  $rootScope.PopUpTitle = "Error";
                  $rootScope.PopUpDescription = "Cannot submit, please conact admin, or try later";
                  $rootScope.PopError = true;
              })
          };
      }

  }

})();
;
(function () {
    'use strict';

    angular
        .module('eltazkaraApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requests', {
            parent: 'app',
            url: '/requests/:type',
            views: {
                'content@': {
                    templateUrl: 'components/requests/addRequest.html',
                    controller: 'RequestsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                checkRequestType: function($stateParams, $state) {
                    var type = $stateParams.type;
                    var types = ["Add_Event", "Add_Artist", "Add_Venue", "Contact_Us"];
                    if (types.indexOf(type) < 0) {
                        $state.go("app");
                    }
                },
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();
;
(function () {
    "use strict";

    angular
        .module("eltazkaraApp")
        .controller("PaymentController", PaymentController);

    PaymentController.$inject = [
        "$rootScope",
        "PaymentService",
        "$location",
        "$state",
        "$window",
        "$stateParams",
        "userInfo",
    ];

    function PaymentController(
        $rootScope,
        PaymentService,
        $location,
        $state,
        $window,
        $stateParams,
        userInfo
    ) {
        var vm = this;
        vm.id = $stateParams.id;
        vm.stateParams = $state.params;
        vm.proceedClicked = false;
        vm.regex = { postalCode: /^[1-9]\d*$/ };
        vm.isPaymentSelected = false;
        vm.paymentMethod;
        vm.isTermsAgreed = false;
        vm.order = null;
        vm.orderLoading = false;
        vm.isLoggedIn = false;
        vm.userCountry = "";
        vm.userCity = "";
        vm.userAddress = "";
        vm.userPostalCode = "";
        vm.isSold = false;
        vm.DeliveryCities = [];
        vm.DeliveryCityId;
        vm.SelectedCourier;
        vm.Couriers = [];
        vm.CourierId;

        vm.initPage = function () {
            if ($rootScope.User && $rootScope.User.Email) vm.isLoggedIn = true;

            if (vm.stateParams.ticket != null) {
                vm.ticketGroupId = vm.stateParams.ticket.TicketGroupId;
                vm.ticketsNumber = vm.stateParams.ticket.SelectedQuantity;
            } else location.href = "#/performance/" + vm.id + "";

            if ($rootScope.User) {
                vm.userName = $rootScope.User.Name;
                vm.userEmail = $rootScope.User.Email;
                vm.userPhone = $rootScope.User.MobileNumber;
            }
            vm.initDeliveryCities();
            vm.initCouriers();
            vm.reviewOrder();
        };

        vm.initDeliveryCities = function () {
            PaymentService.getDeliveryCities().$promise.then(function (data) {
                vm.DeliveryCities = data;
            });
        };

        vm.initCouriers = function () {
            PaymentService.getCouriers().$promise.then(function (data) {
                vm.Couriers = data;
                vm.SelectedCourier = data[0];
            });
        };

        vm.reviewOrder = function () {
            if ($rootScope.User) {
                vm.orderLoading = true;
                PaymentService.reviewOrder({
                    UserId: $rootScope.User.UserId,
                    TicketGroupId: vm.ticketGroupId,
                    TicketsNumber: vm.ticketsNumber,
                }).$promise.then(
                    function (data) {
                        vm.orderLoading = false;
                        if (data) {
                            vm.order = data;
                            if (!vm.order.IsPhoneVerified) {
                                userInfo.sendData(
                                    "#/performance/" + vm.order.PerformanceId
                                );
                            }
                        }
                    },
                    function (error) {
                        vm.orderLoading = false;
                    }
                );
            }
        };

        vm.initPage();

        vm.setPaymentMethod = function (mehtod) {
            vm.isPaymentSelected = true;
            vm.paymentMethod = mehtod;
        };

        vm.verifyPhone = function (mehtod) {
            vm.isPaymentSelected = true;
            vm.paymentMethod = mehtod;
        };

        vm.proceedPayment = function () {
            if (!vm.proceedClicked && vm.isPaymentSelected) {
                vm.proceedClicked = true;

                var notes =
                    vm.order.UserDeliveryNote != null
                        ? vm.order.UserDeliveryNote
                        : null;

                PaymentService.generateOrder({
                    TicketGroupId: vm.ticketGroupId,
                    TicketsNumber: vm.ticketsNumber,
                    PaymentMethod: vm.paymentMethod,
                    City: vm.order.UserCity,
                    Address: vm.order.UserAddress,
                    PostalCode: vm.order.UserPostalCode,
                    DeliveryNotes: notes,
                    DeliveryCityId: vm.DeliveryCityId,
                    CourierId: vm.SelectedCourier.CourierId,
                }).$promise.then(
                    function (data) {
                        if (data) {
                            if (data.message == "ZalFol") {
                                $state.go(
                                    "orderPayment",
                                    { orderRef: data.orderRef },
                                    { reload: "orderPayment" }
                                );

                                vm.orderRef = data.orderRef;
                            } else if (data.message == "TicketOwner") {
                                vm.isTicketOwner = true;
                            } else if (data.message == "TicketsSold") {
                                vm.isSold = true;
                            } else if (data.message == "LimitExceeded") {
                                vm.limitExceeded = true;
                            }
                        }
                    },
                    function (error) {
                        console.log(error);
                        $window.reload();
                    }
                ).finally(function () {
                    vm.proceedClicked = false;
                });
            }
        };

        vm.printt = function () {
            console.log(vm.SelectedCourier);
        };

        vm.toggleLoginPanel = function () {
            $window.scrollTo(0, 0);
            $rootScope.loginPanelActive = !$rootScope.loginPanelActive;
            document.getElementById("userLoginEmail").value = "";
            document.getElementById("userLoginPassword").value = "";
            document.getElementById("userLoginRemember").checked = false;
            $rootScope.userLoginError = false;
            vm.User = {};
            vm.errors = {};
        };

        vm.returnToPerformance = function () {
            location.href = "#/performance/" + vm.id + "";
        };
    }
})();
;
(function () {
    "use strict";

    angular
        .module("eltazkaraApp")
        .controller("PaymentDetailsController", PaymentDetailsController);

    PaymentDetailsController.$inject = [
        "$http",
        "localStorageService",
        "PaymentService",
        "utilsService",
        "$scope",
        "$rootScope",
        "$state",
        "$stateParams",
        "$location",
        "$timeout",
        "$window",
        "$sce",
    ];

    function PaymentDetailsController(
        $http,
        localStorageService,
        PaymentService,
        utilsService,
        $scope,
        $rootScope,
        $state,
        $stateParams,
        $location,
        $timeout,
        $window,
        $sce
    ) {
        var vm = this;

        vm.IsNewCard =
            vm.existingCard =
            vm.showCards =
            vm.timeExceeded =
            vm.backToCardsList =
                false;

        vm.months = [
            "01",
            "02",
            "03",
            "04",
            "05",
            "06",
            "07",
            "08",
            "09",
            "10",
            "11",
            "12",
        ];

        vm.orderRef = $stateParams.orderRef;
        vm.SelectedCreditCard;
        vm.publicIp;
        vm.mins;

        //Get Order Details
        vm.getOrder = function () {
            PaymentService.getOrder({ OrderRef: vm.orderRef }).$promise.then(
                function (data) {
                    if (data) {
                        if (data.message == "4041") {
                            vm.finsihTimer();
                        } else {
                            vm.cardYears = data.CardYears;
                            vm.selectedYear = data.CardYears[0] + "";
                            vm.selectedMonth = "01";
                            vm.order = [];
                            vm.order = data;

                            if (data.PaymentStatus == 2) {
                                vm.paymentFailed = true;
                            } else if (data.Status == 2) {
                                vm.paymentDone = true;
                                vm.paymentLoaded = true;
                            } else if (
                                data.Status == 3 ||
                                data.RemainingTime <= 0
                            ) {
                                vm.finsihTimer();
                            } else {
                                vm.mins = data.RemainingTime;
                                vm.orderLoaded = true;
                                vm.showPayment = true;
                                vm.generateForm();
                            }
                        }
                    }
                },
                function (error) {
                    console.log(error);
                }
            );
        };

        //Payfort iframe injection
        vm.generateForm = function () {
            var http = new XMLHttpRequest();
            var url = window.backendUrl + "Payment/GetKashierFrameUrl";
            http.open("post", url, true);
            http.setRequestHeader("Content-type", "application/json");

            http.onreadystatechange = function () {
                //Call a function when the state changes.
                if (http.readyState == 4 && http.status == 200) {
                    vm.paymentLoaded = true;
                    vm.kashierIFrameSrc = $sce.trustAsResourceUrl(
                        http.response
                    );
                }
            };

            http.send(JSON.stringify({ orderRef: $stateParams.orderRef }));
        };

        //Redirect to orders page
        vm.returnToOrders = function () {
            $state.go("boughtTickets", {}, { reload: "boughtTickets" });
        };

        //On Timer Finish
        vm.finsihTimer = function () {
            vm.showPayment = false;

            PaymentService.cancelOrder({ OrderRef: vm.orderRef }).$promise.then(
                function (data) {
                    if (data.orderStatus == 3) {
                        vm.timeExceeded = true;
                    }
                },
                function (error) {
                    console.log(error);
                }
            );
        };

        vm.init = function () {
            if ($stateParams.paymentSuccess) {
                return (vm.paymentDone = true);
            }

            vm.getOrder();
            vm.bindEvents();
        };

        vm.bindEvents = function () {
            $rootScope.$on(
                "hub:orderPaidSuccessfully",
                function (e, orderReference) {
                    alert(orderReference);
                    if (orderReference === vm.orderRef) {
                        vm.paymentDone = true;
                    }
                }
            );
        };

        vm.init();
    }

    //iframe onload/state changes
    window.setIframeLoaded = function () {
        window.setTimeout(function () {
            PaymentDetailsController.paymentLoaded = true;
        }, 1000);
    };
})();
;
(function () {
  'use strict';

  angular
      .module('eltazkaraApp')
      .controller('PaymentSuccessController', PaymentSuccessController);

  PaymentSuccessController.$inject = [
    '$rootScope',
    'localStorageService',
    '$timeout',
    'PaymentService'
  ];

  function PaymentSuccessController($rootScope, localStorageService,$timeout,PaymentService) {
    var vm = this;
    vm.theCanvas='';
    vm.order=[];
    if($rootScope.User)
      vm.id = $rootScope.User.UserId;

    vm.getPaymentSuccess = function () {
      PaymentService.getPaymentSuccess({ "UserId": vm.id , "OrderReference":2})
      .$promise.then(function (data) {
        if (data) {
          var input = {
            "reference": data.Reference,
            "performanceName": data.PerformanceName,
            "performanceDate": data.PerformanceDate,
            "performanceDay": data.PerformanceDay,
            "performanceTime": data.PerformanceTime,
            "performanceVenue": data.PerformanceVenue,
            "ticketBlock": data.TicketBlock,
            "ticketRow": data.TicketRow,
            "ticketsNumber": data.TicketsNumber,
            "ticketPrice": data.TicketPrice,
            "ticketsTotalPrice": data.TicketsTotalPrice,
            "orderFees": data.OrderFees,
            "orderTotal": data.OrderTotal,
            "orderImage": data.OrderImage,
            "usedCard":data.UsedCard
          };
          vm.order = input;
        }
      }, function (error) { })
    }
    vm.getPaymentSuccess();
    //Show the invoice so script can capture it
    document.getElementById('invoice').classList.add('show');
    html2canvas(document.getElementById('invoice'), {
      onrendered: function(canvas) {
        vm.theCanvas=canvas;
        vm.invoiceLoading=false;
      }
    });
    //Hide it again very fast :D
    document.getElementById('invoice').classList.remove('show');
    vm.genInvoice=function(){
      var invoiceWindow=window.open(vm.theCanvas.toDataURL("image/png"),'_blank');
    }

  }

})();
;
(function () {
    'use strict';

    angular
        .module('eltazkaraApp')
        .controller('PaymentSuccessPopupController', PaymentSuccessPopupController);

    PaymentSuccessPopupController.$inject = ['$scope', '$rootScope', '$timeout'];

    function PaymentSuccessPopupController($scope, $rootScope, $timeout) {
        var vm = this;

        $('.orderCountDown', window.parent.document).fadeOut();

        $timeout(function () {
            $rootScope.$broadcast('timer-stop');
        }, 1000);

        vm.returnToOrders = function () {
            window.top.location = '#/users/orders'
        };
    }

})();
;
(function() {
    'use strict';

    angular
        .module('eltazkaraApp')
        .controller('PaymentFailedPopupController', PaymentFailedPopupController);

    PaymentFailedPopupController.$inject = ['$scope', '$rootScope', '$timeout'];

    function PaymentFailedPopupController($scope, $rootScope, $timeout) {
        var vm = this;

        $('.orderCountDown', window.parent.document).fadeOut();

        $timeout(function() {
            $rootScope.$broadcast('timer-stop');
        }, 1000);

        vm.returnToOrders = function() {
            window.top.location = '#/users/orders'
        };
    }

})();;
(function () {
    "use strict";

    angular
        .module("eltazkaraApp")
        .controller("PaymentResultController", PaymentResultController);

    PaymentResultController.$inject = [
        "$state",
        "$location",
        "PaymentService",
        "utilsService",
    ];

    function PaymentResultController(
        $state,
        $location,
        PaymentService,
        utilsService
    ) {
        var vm = this;

        vm.handlePaymentResult = function () {
            var queryStr = utilsService.getQueryParamsStr();
            var queryParams = $location.search();

            if (queryStr) {
                vm.orderRef = queryParams.merchantOrderId;

                return PaymentService.handlePaymentRedirection({
                    query: queryStr,
                }).$promise.then(
                    function (res) {
                        vm.navigateToOrderDetails(res && res.Status === 2);
                    },
                    function (error) {
                        console.log(error);
                        vm.navigateToOrderDetails();
                    }
                );
            }

            $state.go("home");
        };

        vm.init = function () {
            vm.handlePaymentResult();
        };

        vm.navigateToOrderDetails = function (success) {
            var params = {
                orderRef: vm.orderRef,
            };

            if (success) {
                params.paymentSuccess = true;
            }

            $state.go("orderPayment", params);
        };

        vm.init();
    }
})();
;
(function () {
  "use strict";

  angular.module("eltazkaraApp").config(stateConfig);
  stateConfig.$inject = ["$stateProvider"];

  function stateConfig($stateProvider, $rootScope) {
    $stateProvider
      .state("payment", {
        parent: "app",
        url: "/payment/:id",
        cache: false,
        params: { ticket: null, performanceDetails: null },
        views: {
          "content@": {
            templateUrl: "components/payments/payment.html",
            controller: "PaymentController",
            controllerAs: "vm",
          },
        },
      })
      .state("orderPayment", {
        parent: "app",
        cache: false,
        url: "/payment_details/:orderRef",
        params: { paymentSuccess: false },
        views: {
          "content@": {
            templateUrl: "components/payments/paymentDetails.html",
            controller: "PaymentDetailsController",
            controllerAs: "vm",
          },
        },
        resolve: {
          translatePartialLoader: [
            "$translate",
            "$translatePartialLoader",
            function ($translate, $translatePartialLoader) {
              $translatePartialLoader.addPart("global");
            },
          ],
        },
      })
      .state("paymentSuccess", {
        parent: "app",
        cache: false,
        url: "/payment_success/:orderRef",
        // params: {orderRef: null, performanceDetails: null},
        views: {
          "content@": {
            templateUrl: "components/payments/paymentSuccessPopup.html",
            controller: "PaymentSuccessPopupController",
            controllerAs: "vm",
          },
        },
      })
      .state("paymentFailed", {
        parent: "app",
        cache: false,
        url: "/payment_failed/:orderRef",
        // params: {orderRef: null, performanceDetails: null},
        views: {
          "content@": {
            templateUrl: "components/payments/paymentFailedPopup.html",
            controller: "PaymentFailedPopupController",
            controllerAs: "vm",
          },
        },
      })
      .state("orderDetails", {
        parent: "app",
        url: "/order_details",
        cache: false,
        views: {
          "content@": {
            templateUrl: "components/payments/paymentSuccess.html",
            controller: "PaymentSuccessController",
            controllerAs: "vm",
          },
        },
      })
      .state("paymentResult", {
        parent: "app",
        cache: false,
        url: "/payment_result",
        views: {
          "content@": {
            template: null,
            controller: "PaymentResultController",
            controllerAs: "vm",
          },
        },
        onEnter: [
          "$rootScope",
          function ($rootScope) {
            $rootScope.noContent = true;
          },
        ],
      })
      .state("sell", {
        parent: "app",
        url: "/performance/:id/sell",
        params: { ticket: null, performanceDetails: null },
        views: {
          "content@": {
            templateUrl: "components/payments/sell.html",
            controller: "SellController",
            controllerAs: "vm",
          },
        },
      });
  }
})();
;
(function () {
    'use strict';

    angular
        .module('eltazkaraApp')
        .factory('PaymentService', PaymentService);

    PaymentService.$inject = ['$resource'];

    function PaymentService($resource) {
        var service = $resource(window.backendUrl + '/Orders', {}, {
            'generateOrder': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Orders/OnCreateOrder"
            },
            'getOrder': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Orders/GetOrder"
            },
            'getUserCards': {
                method: 'POST', isArray: true,
                url: window.backendUrl + "Users/GetUserCards"
            },
            'getPaymentSuccess': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Orders/PaymentSuccessResponse"
            },
            'handlePaymentRedirection': {
                method: 'GET', isArray: false,
                params: {
                    query: '@query'
                },
                url: window.backendUrl + "Payment/KashierPaymentResult?:query"
            },
            'reviewOrder': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Orders/ReviewOrder"
            },
            'getPerformance': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Sell/GetPerformance"
            },
            'saveSellRequest': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Sell/SaveSellRequest"
            },
            'payOrder': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Orders/OnPay"
            },
            'cancelOrder': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Orders/AutoCancelOrders"
            },
            'AddCreditCard': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Users/AddCreditCard"
            },
            'checkOrderPayment':{
                method: 'POST', isArray: false,
                url: window.backendUrl + "Orders/CheckOrderPayment"
            },
            'getDeliveryCities': {
                method: 'GET', isArray: true,
                url: window.backendUrl + "Locations/GetDeliveryCities"
            },
            'getCouriers': {
                method: 'GET', isArray: true,
                url: window.backendUrl + "Locations/getCouriers"
            }
        });
        return service;
    }
})();
;
(function () {
  "use strict";

  angular
    .module("eltazkaraApp")
    .controller("SellController", PaymentController);

  PaymentController.$inject = [
    "$rootScope",
    "$state",
    "$stateParams",
    "PaymentService",
  ];

  function PaymentController($rootScope, $state, $stateParams, PaymentService) {
    if (!$rootScope.User) {
      $rootScope.loginPanelActive = true;
    }

    var vm = this;
    vm.id = $stateParams.id;
    vm.NumberOfTickets = vm.TicketsType = vm.Section = vm.Block = vm.Row = "";
    vm.StartingSeatNumber = vm.SellPrice = vm.printedPrice = "";
    
		vm.Bundles = [
      { name: "Any", id: 1 },
      { name: "Pair", id: 2 },
      { name: "Full", id: 3 },
      { name: "Pair Last", id: 4 },
    ];
    
		vm.PerformanceDetails;
    vm.IsIdUploaded = true;
    vm.performanceLoading = false;
    vm.submitClickable = true;
    vm.showSeating = true;
    vm.SelectedSeatingType = "1";
    vm.incrementType = "Standard";

		vm.getPerformance = function () {
      vm.performanceLoading = true;

			PaymentService.getPerformance({ Id: vm.id }).$promise.then(
        function (data) {
          vm.performanceLoading = false;

					if (data) {
            vm.PerformanceDetails = data;

						if (!data.IsPhoneVerified || !data.IsEmailVerified) {
              $state.go("account", {});
            }

						vm.IsIdUploaded = vm.PerformanceDetails.IsIdUploaded;
            vm.SelectedBundle = vm.PerformanceDetails.Bundles[0];
            vm.SelectedSection = vm.PerformanceDetails.Sections[0];
            vm.SelectedTicketType = vm.PerformanceDetails.TicketTypes[0];
            vm.updateSelectedSection();
          } else {
            vm.goToHome();
          }
        },
        function (error) {
          vm.performanceLoading = false;
        }
      );
    };

		vm.getPerformance();

    vm.goToAccountSettings = function () {
      $state.go("account", {});
    };

    vm.goToHome = function () {
      $state.go("home", {});
    };

    vm.updateSelectedSection = function () {
      if (vm.SelectedSection) {
        if (
          vm.SelectedSection.name.toLocaleLowerCase().includes("standing") ||
          vm.SelectedSection.name.toLocaleLowerCase().includes("free seating")
        ) {
          vm.showSeating = false;
          vm.StartingSeatNumber = "";
          vm.incrementType = "";
          vm.Block = "";
          vm.Row = "";
        } else {
          vm.StartingSeatNumber = "1";
          vm.incrementType = "Standard";
          vm.showSeating = true;
        }
      }
    };

    vm.saveRequestData = function (bool) {
      if (!bool || !vm.submitClickable) {
				return;
			}

      vm.submitClickable = false;
      
			if (vm.SelectedSection == null) {
        PaymentService.saveSellRequest({
          performanceId: vm.PerformanceDetails.PerformanceId,
          numberOfTickets: vm.NumberOfTickets,
          ticketTypeId: vm.SelectedTicketType.id,
          bundleId: vm.SelectedBundle.id,
          block: vm.Block,
          row: vm.Row,
          startSeat: vm.StartingSeatNumber,
          ticketPrice: vm.SellPrice,
          printedPrice: vm.printedPrice,
          IncrementSeatingType: vm.incrementType,
          IsSeating: vm.showSeating,
        }).$promise.then(
          function (data) {
            if (data) {
              if ((data.message = "success")) $state.go("soldTickets", {});
            }
          },
          function (error) {}
        );
      } else {
        PaymentService.saveSellRequest({
          performanceId: vm.PerformanceDetails.PerformanceId,
          numberOfTickets: vm.NumberOfTickets,
          ticketTypeId: vm.SelectedTicketType.id,
          sectionId: vm.SelectedSection.id,
          bundleId: vm.SelectedBundle.id,
          block: vm.Block,
          row: vm.Row,
          startSeat: vm.StartingSeatNumber,
          ticketPrice: vm.SellPrice,
          printedPrice: vm.printedPrice,
          IncrementSeatingType: vm.incrementType,
          IsSeating: vm.showSeating,
        }).$promise.then(
          function (data) {
            if (data) {
              if ((data.message = "success")) $state.go("soldTickets", {});
            }
          },
          function (error) {}
        );
      }
    };
  }
})();
;
(function () {
    'use strict';

    angular
        .module('eltazkaraApp')
        .controller('CategoryController', CategoryController)
        .directive('myRepeatDirective', function () {
            return function (scope, element, attrs) {
                //if(scope.$index)
            };
        });

    CategoryController.$inject = [
        '$rootScope',
        'NgTableParams',
        '$stateParams',
        '$window',
        'CategoryEvents',
        'SubCategory',
        'Filters',
        'User'
    ];

    function CategoryController($rootScope, NgTableParams, $stateParams, $window, CategoryEvents, SubCategory, Filters, User) {
        var vm = this;
        vm.id = $stateParams.id;
        vm.countPerLoad = 5; //HS:Increase per step
        vm.requestSize = vm.countPerLoad; //HS:Initial list size
        vm.listOffset = 0; //HS:Load more start index
        vm.customConfigParams = createUsingFullOptions();

        function createUsingFullOptions() {
            var initialParams = {
                count: vm.requestSize
            };

            var initialSettings = {
                counts: [],
                dataset: vm.list
            };

            return new NgTableParams(initialParams, initialSettings);
        }

        vm.loadingMore;
        vm.loadMoreText = "Load More";
        vm.CurrentGrandParentId;
        vm.CurrentParentId;
        vm.list = [];
        vm.categoryPerformancesLoading = false;
        vm.hasPerformances = false;
        vm.hasPerformancesFiltered = false;
        vm.SubCategoriesList = [];
        vm.SiblingsCategories = [];
        vm.GrandParentCategories = [];
        vm.featuredEvent;

        vm.filters = {
            "CategoryId": -1,
            "EventId": -1,
            "PerformerId": -1,
            "VenueId": -1
        };

        vm.allSubCategories = [];
        vm.allEvents = [];
        vm.allPerformers = [];
        vm.allVenues = [];
        vm.availableTickets = 0;
        vm.categoryDetails;

        vm.getPerformances = function (more) {
            var listLimit = vm.countPerLoad;

            if (more) {
                vm.loadingMore = true;
                vm.loadMoreText = "Please wait...";
            }
            else {
                vm.listOffset = 0;
                vm.requestSize = vm.countPerLoad;
            }

            vm.categoryPerformancesLoading = true;

            CategoryEvents.getcategoryEvents({
                "Id": vm.id,
                "Offset": vm.listOffset,
                "Limit": listLimit,
                "Filters": vm.filters
            }).$promise.then(function (data) {
                vm.categoryPerformancesLoading = false;

                if (data.EventDetails) {
                    if (data.EventDetails.length > 0)
                        vm.hasPerformances = vm.hasPerformancesFiltered = true;
                    else {
                        if (data.Filtered)
                            vm.hasPerformancesFiltered = false;
                    }

                    vm.list = more ? vm.list : [];
                    vm.lastCall = data.LastCall;

                    for (var i = 0; i < data.EventDetails.length; i++) {
                        var tempItem = {
                            "venueid": data.EventDetails[i].venueid,
                            "Name": data.EventDetails[i].Name,
                            "EventId": data.EventDetails[i].EventId,
                            "EventName": data.EventDetails[i].EventName,
                            "Num_Performances_InEvent": data.EventDetails[i].Num_Performances_InEvent,
                            "Description": data.EventDetails[i].Description,
                            "Performence": data.EventDetails[i].Performence,
                            "PerformenceId": data.EventDetails[i].PerformenceId,
                            "venue": data.EventDetails[i].venue,
                            "startDate": data.EventDetails[i].startDate,
                            "EndDate": data.EventDetails[i].EndDate,
                            "dayName": data.EventDetails[i].dayName,
                            "day": data.EventDetails[i].day,
                            "month": data.EventDetails[i].month,
                            "year": data.EventDetails[i].year,
                            "time": data.EventDetails[i].time,
                            "period": data.EventDetails[i].period,
                            "IsClosedBooking": data.EventDetails[i].IsClosedBooking,
                            "IsSellBlocked": data.EventDetails[i].IsSellBlocked,
                            "IsBuyBlocked": data.EventDetails[i].IsBuyBlocked,
                            "avTickets": data.EventDetails[i].AvailableTicket,
                        };

                        vm.availableTickets += data.EventDetails[i].AvailableTicket;
                        vm.list.push(tempItem);
                    }

                    vm.getAllFilters();
                }

                if (more) {
                    vm.loadingMore = false;
                    vm.loadMoreText = "Load More";
                }

                vm.customConfigParams = createUsingFullOptions();
            }, function (error) { vm.categoryPerformancesLoading = false; })
        }

        vm.getNumber = function (num) {
            return new Array(num);
        }

        vm.subCategoriesLength = 0;
        vm.sbilingsCategoryLength = 0;

        vm.getsubcategory = function () {
            SubCategory.getSubCategory({ "Id": vm.id }).$promise.then(function (data) {
                if (data.ChildCategories) {
                    vm.CurrentParentId = data.CurrentParentId;
                    vm.CurrentGrandParentId = data.CurrentGrandParentId;
                    vm.ParentId = data.ParentId;

                    var tempItem = {
                        "Name": data.Name,
                        "Theme": data.Theme,
                        "Id": data.Id,
                        "ParentId": data.ParentId,
                        "ParentName": data.ParentName
                    };

                    vm.categoryDetails = tempItem;
                    vm.subCategoriesLength = data.ChildCategories.length;
                    vm.sbilingsCategoryLength = data.SiblingsCategories.length;
                    vm.number = Math.ceil(vm.subCategoriesLength / 6);
                    vm.sbilingsNumber = Math.ceil(vm.sbilingsCategoryLength / 6);

                    if (vm.subCategoriesLength > 0) {
                        for (var i = 0; i < vm.subCategoriesLength; i++) {
                            var tempItem = {
                                "ChildCategoryName": data.ChildCategories[i].ChildCategoryName,
                                "Id": data.ChildCategories[i].Id
                            };

                            vm.SubCategoriesList[i] = tempItem;
                        }
                    }

                    for (var i = 0; i < data.SiblingsCategories.length; i++) {
                        var tempItem = {
                            "ChildCategoryName": data.SiblingsCategories[i].ChildCategoryName,
                            "Id": data.SiblingsCategories[i].Id
                        };

                        vm.SiblingsCategories[i] = tempItem;
                    }

                    for (var i = 0; i < data.GrandParentCategories.length; i++) {
                        var tempItem = {
                            "GrandParentName": data.GrandParentCategories[i].GrandParentName,
                            "GrandParentId": data.GrandParentCategories[i].GrandParentId,
                        };

                        vm.GrandParentCategories.push(tempItem);
                    }
                }
            }, function (error) { });
        };

        //Sub item theme
        vm.GetSubCategoryTheme = function () {
            CategoryEvents.GetSubCategoryTheme({ "Id": vm.id }).$promise.then(function (data) {
                if (data.Theme)
                    $rootScope.theme = data.Theme;
                
                vm.getPerformances(false);
                vm.getsubcategory();
                vm.getFeaturedEvent();
            }, function (error) { });
        };

        //Sub item theme
        vm.GetSubCategoryTheme();

        vm.ParentExist = function (ParentId) {
            for (var i = 0; i < vm.GrandParentCategories.length; i++) {

                if (ParentId == vm.GrandParentCategories[i].GrandParentId)
                    return false;
            }

            return true;
        };

        vm.HasFeatureEvent = false;

        vm.getFeaturedEvent = function () {
            CategoryEvents.getFeaturedEvent({ "Id": vm.id }).$promise.then(function (data) {
                vm.HasFeatureEvent = true;
                if (data) {
                    var tempItem = {
                        "venueid": data.venueid,
                        "Name": data.Name,
                        "EventId": data.EventId,
                        "EventName": data.EventName,
                        "Description": data.Description,
                        "Performence": data.Performence,
                        "PerformenceId": data.PerformenceId,
                        "venue": data.venue,
                        "Image4": data.Image4,
                        "startDate": data.startDate,
                        "EndDate": data.EndDate,
                        "dayName": data.dayName,
                        "day": data.day,
                        "month": data.month,
                        "year": data.year,
                        "time": data.time,
                        "period": data.period,
                        "IsClosedBooking": data.IsClosedBooking,
                        "IsBuyBlocked": data.IsBuyBlocked,
                        "IsSellBlocked": data.IsSellBlocked,
                        "avTickets": data.AvailableTicket,
                    };

                    vm.featuredEvent = tempItem;

                    if (vm.featuredEvent.Name.length > 45) {
                        vm.featuredEvent.Name = vm.featuredEvent.Name.substring(0, 45);
                        vm.featuredEvent.Name += "...";
                    }
                }
            }, function (error) { });
        };

        vm.subsDisabled = false;

        vm.getAllFilters = function () {
            Filters.getCategoryFilters({ "id": vm.id }).$promise.then(function (data) {
                if (data) {
                    vm.allSubCategories = data.CategorySubcategories;

                    if (vm.allSubCategories.length >= 1) {
                        vm.allSubCategories.unshift({
                            "CategoryId": -1,
                            "CategoryName": "All"
                        });
                    }
                    else {
                        vm.allSubCategories.unshift({
                            "CategoryId": -1,
                            "CategoryName": "No subcategories"
                        });
                    }

                    vm.allEvents = data.CategoryEvents;

                    if (vm.allEvents.length > 1) {
                        vm.allEvents.unshift({
                            "EventId": -1,
                            "EventName": "All"
                        });
                    }
                    else if (vm.allEvents.length === 1) {
                        vm.allEvents[0].EventId = -1;
                    }
                    else {
                        vm.allEvents.unshift({
                            "EventId": -1,
                            "EventName": "No events"
                        });
                    }

                    vm.allVenues = data.CategoryVenues;

                    if (vm.allVenues.length > 1) {
                        vm.allVenues.unshift({
                            "VenueId": -1,
                            "VenueName": "All"
                        });
                    }
                    else if (vm.allVenues.length === 1) {
                        vm.allVenues[0].VenueId = -1;
                    }
                    else {
                        vm.allVenues.unshift({
                            "VenueId": -1,
                            "VenueName": "No venues"
                        });
                    }

                    vm.allPerformers = data.CategoryPerformers;

                    if (vm.allPerformers.length > 1) {
                        vm.allPerformers.unshift({
                            "PerformerId": -1,
                            "PerformerName": "All"
                        });
                    }
                    else if (vm.allPerformers.length === 1) {
                        vm.allPerformers[0].PerformerId = -1;
                    }
                    else {
                        vm.allPerformers.unshift({
                            "PerformerId": -1,
                            "PerformerName": "No performers"
                        });
                    }
                }

                vm.customConfigParams = createUsingFullOptions();
            }, function (error) { })
        };

        vm.loadMore = function () {
            vm.listOffset = vm.requestSize;
            vm.requestSize += vm.countPerLoad;
            vm.customConfigParams.count(vm.requestSize);
            vm.getPerformances(true);
        };
        
        vm.trySell = function (performanceId) {
            if ($rootScope.User && $rootScope.User.Email) {
                User.IsUserBlockedOrDeleted({ "UserId": $rootScope.User.UserId }).$promise.then(function (data) {
                    if (data.status == "true")
                        location.href = "#/performance/" + performanceId + "/sell";
                    else {
                        location.href = "#/";
                        $rootScope.PopUpTitle = "Blocked User";
                        $rootScope.PopUpDescription = "You don't have access please contact with Admin";
                        $rootScope.showPopup = true;
                    }
                }, function (error) { });
            }
            else
                vm.toggleLoginPanel();
        };
        
        vm.toggleLoginPanel = function () {
            $window.scrollTo(0, 0);
            $rootScope.loginPanelActive = !$rootScope.loginPanelActive;
            document.getElementById("userLoginEmail").value = "";
            document.getElementById("userLoginPassword").value = "";
            document.getElementById("userLoginRemember").checked = false;
            $rootScope.userLoginError = false;
            vm.User = {};
            vm.errors = {};
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('eltazkaraApp')
        .controller('CategoriesController', CategoriesController);

    CategoriesController.$inject = [
      'Category'
    ];

    function CategoriesController(Category) {
        var vm = this;
        vm.categoriesLoading = false;
        vm.CategoriesList = [];
        vm.getPerformences = function () {
            vm.categoriesLoading = true;
            Category.getAllCategories({})
                .$promise.then(function (data) {
                    vm.categoriesLoading = false;
                    if (data) {
                        var dataList = data;
                        for (var i = 0 ; i < dataList.length ; i++) {
                            var tempItem = {
                                "categoryId": dataList[i].CategoryId,
                                "Name": dataList[i].ParentCategory,
                                "Theme": dataList[i].Theme,
                                "ChildCategories": dataList[i].ChildCategories,
                            };
                            vm.CategoriesList[i] = tempItem;
                        }
                    }
                }, function (error) { vm.categoriesLoading = false; })
        }
        vm.getPerformences();
    }

})();
;
(function () {
  'use strict';

  angular
      .module('eltazkaraApp')
      .config(stateConfig);

  stateConfig.$inject = ['$stateProvider'];

  function stateConfig($stateProvider) {
    $stateProvider.state('categories', {
      parent: 'app',
      url: '/categories',
      views: {
        'content@': {
            templateUrl: 'components/categories/categories.html',
          controller: 'CategoriesController',
          controllerAs: 'vm'
        }
      },
      resolve: {
        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
          $translatePartialLoader.addPart('global');
        }]
      }
    }).state('category', {
      parent: 'app',
      url: '/category/:id',
      views: {
        'content@': {
            templateUrl: 'components/categories/category.html',
          controller: 'CategoryController',
          controllerAs: 'vm'
        }
      },
      resolve: {
        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
          $translatePartialLoader.addPart('global');
        }]
      }
    });
  }
})()
;
(function () {
    'use strict';

    angular
        .module('eltazkaraApp')
        .factory('Category', Category);

    Category.$inject = ['$resource'];

    function Category($resource) {
        var service = $resource(window.backendUrl + 'Categories', {}, {
            'getAllCategories': {
                method: 'POST', isArray: true,
                url: window.backendUrl + "Categories/GetAllCategories"
            }
        });

        return service;
    }
})();
;
(function () {
    'use strict';

    angular
        .module('eltazkaraApp')
        .factory('CategoryEvents', CategoryEvents);

    CategoryEvents.$inject = ['$resource'];

    function CategoryEvents($resource) {
        var service = $resource(window.backendUrl + 'Categories', {}, {
            'getcategoryEvents': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Categories/GetCategoryPerformances"
            },
            'getFeaturedEvent': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Categories/GetFeaturedEvent"
            },
            'GetSubCategoryTheme': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Categories/GetSubCategoryTheme"
            }
        });

        return service;
    }
})();
;
(function () {
    'use strict';

    angular
        .module('eltazkaraApp')
        .factory('SubCategory', SubCategory);

    SubCategory.$inject = ['$resource'];

    function SubCategory($resource) {
        var service = $resource(window.backendUrl + 'Categories', {}, {
            'getSubCategory': {
                method: 'POST', isArray: false,
                url: window.backendUrl + "Categories/GetSubCategory"
            }
        });

        return service;
    }
})();
;
(function () {
    'use strict';

    var dependencies = [

    ];

    angular.module('eltazkara.utils', dependencies);

    angular
        .module('eltazkaraApp')
        .directive('spinner', renderSpinner);

    //HS:Ticket group price directive
    function renderSpinner() {
        return {
            restrict: 'E',
            template:  
                '<div class="{{give}}" style="text-align:{{push}};background:white">' +
                    '<img style="width:50px" src="../../assets/images/spinner.gif" />' +
                '</div>',
            link: function (scope, elem, attr) {
                scope.push = attr.push;
                scope.give = attr.give;
            }
        };
    }

})();;
(function () {
  'use strict';

  angular
      .module('eltazkara.utils')
      .directive('appenzaUpload', uploadDirective);

  uploadCtrl.$inject = [
    '$scope',
    'localStorageService',
    '$timeout',
    '$rootScope'
  ]

  function uploadDirective() {
    return {
      restrict: 'AE',
      controller: uploadCtrl,
      controllerAs: 'uploader',
      bindToController: true,
      scope: {
        showUpload: '=showUpload',
        files: '=files',
        modelType: '=modelType',
        trigger: '&',
        remainder: '@remainder'
      },
      templateUrl: 'components/utils/upload.html'
    };
  }

  function uploadCtrl($scope, localStorageService, $rootScope) {
    // define controller scope
    var uploader = this;

    uploader.filesAsData = [];
    uploader.remainingFiles = uploader.remainder;

    uploader.initialize = function () {
      uploader.showDialog = true;
      uploader.uniqueFileName = "";
      uploader.uniques = [];
      uploader.isAttachment = false;
      uploader.fileNames = [];
      uploader.filesSizes = [];
      uploader.finishedFile = [];
      uploader.sizeLimit = 105857600000;
      uploader.uploadProgress = [];
      uploader.showProgress = true;
      uploader.showFiles = false;
      uploader.flag = 0;
      uploader.imagesDataName = "imagesData_" + uploader.modelType;
      uploader.creds = {
        bucket: 'eltazkara-dev',
        access_key: 'AKIAIIOV5IY4W2WXHLXA',
        secret_key: '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'
      };

      var images = localStorageService.get('images');
      if (images) {
        uploader.filesUniqueNames = images;
      } else {
        uploader.filesUniqueNames = "";
      }
    };

    uploader.upload = function () {
      if (!uploader.files) return;

      AWS.config.update({
        accessKeyId: uploader.creds.access_key,
        secretAccessKey: uploader.creds.secret_key
      });

      AWS.config.region = 'us-west-2';

      var bucket = new AWS.S3({params: {Bucket: uploader.creds.bucket}});

      if (uploader.files) {
        uploader.flag = 1;
        for (var i = 0; i < uploader.files.length; i++) {
          uploader.uploadProgress.push(0);
          uploader.fileNames.push(uploader.files[i].name);
          uploader.filesSizes.push(uploader.files[i].size);
        }
      }

      if (uploader.files) {
        for (var i = 0; i < uploader.files.length; i++) {
          uploader.file = uploader.files[i];
          // Perform File Size Check First
          var fileSize = Math.round(parseInt(uploader.file.size));
          if (fileSize > uploader.sizeLimit) {
            var msg = 'Sorry, your attachment is too big. Maximum ' + uploader.fileSizeLabel(uploader.sizeLimit) + ' file attachment allowed' + '\nFile Too Large';
            $rootScope.showToast(msg);
            return false;
          }
          // Prepend Unique String To Prevent Overwrites
          uploader.uniqueFileName = uploader.uniqueString() + '-' + uploader.file.name;
          uploader.name = uploader.file.name;
          uploader.uniques.push(uploader.uniqueFileName);
          uploader.finishedFile[uploader.uniqueFileName] = -2;

          var params = {
            Key: uploader.uniqueFileName,
            ContentType: uploader.file.type,
            Body: uploader.file,
            ServerSideEncryption: 'AES256',
            ACL: 'public-read'
          };

          var options = {partSize: 5 * 1024 * 1024, queueSize: 1};

          bucket.upload(params, options, function (err, data) {
            if (err) {
              return false;
            }
            else {
              // Reset The Progress Bar
              setTimeout(function () {
                uploader.uploadProgress[uploader.fileNames.indexOf(uploader.file.name)] = 0;
                uploader.$digest();
              }, 4000);
            }
          }).on('httpUploadProgress', function (progress) {
            var key = progress.key;
            var index = uploader.fileNames.indexOf(key.substring(key.indexOf('-') + 1, key.length));
            var loaded = Math.round(progress.loaded / progress.total * 100);
            uploader.uploadProgress[index] = loaded === 100 ? 99 : loaded;
            $scope.$digest();
          }).send(function (err, data) {
            var key = data.key ? data.key : data.Key;
            var index = uploader.fileNames.indexOf(key.substring(key.indexOf('-') + 1, key.length));
            uploader.uploadProgress[index] = 100;
            $scope.$digest();
            if (data.Key) {
              var index = uploader.fileNames.indexOf(data.Key.substring(data.Key.indexOf('-') + 1, data.Key.length));
              uploader.addUrlToResources(data.Key, uploader.files[index].type);
            } else {
              var index = uploader.fileNames.indexOf(data.key.substring(data.key.indexOf('-') + 1, data.key.length));
              uploader.addUrlToResources(data.key, uploader.files[index].type);
            }
            if (key) {
              uploader.filesAsData.push(data.Location);
            }
          });
        }
      } else {
        // No File Selected
      }
    };

    uploader.fileSizeLabel = function (size) {
      var roundedSize = parseInt(size, 10);
      var megaByte = roundedSize / 1024.0 / 1024.0;
      var kiloByte = roundedSize / 1024.0;
      var byte = roundedSize;
      if (megaByte < 1 && kiloByte < 1) {
        return byte.toFixed(2) + 'B';
      } else if (megaByte < 1) {
        return kiloByte.toFixed(2) + 'KB';
      } else {
        return megaByte.toFixed(2) + 'MB';
      }
    };

    uploader.trackUploads = function () {
      var curFlag = 1;
      for (var progress in uploader.uploadProgress) {
        curFlag &= (uploader.uploadProgress[progress] === 100);
      }
      if (curFlag) {
        uploader.showProgress = false;
        uploader.showFiles = true;
        uploader.storeImagesData();
        $scope.$digest();
      }
    };

    uploader.uniqueString = function () {
      var text = "";
      var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

      for (var i = 0; i < 8; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }
      return text;
    }

    uploader.truncateString = function (index) {
      if (uploader.files) {
        if (uploader.files[index]) {
          var trueName = uploader.files[index].name;
          if (trueName.length > 15)
            return '...';
        }
      }
    };

    uploader.storeImagesData = function () {
      var imagesData = localStorageService.get(uploader.imagesDataName);
      if (imagesData) {
        var toStoreData = imagesData.concat(uploader.filesAsData.filter(function (item) {
          return imagesData.indexOf(item) < 0;
        }));
        localStorageService.set(uploader.imagesDataName, toStoreData);
      } else {
        localStorageService.set(uploader.imagesDataName, uploader.filesAsData);
      }
    };

    uploader.deleteImage = function (index) {
      var imagesData = localStorageService.get(uploader.imagesDataName);
      imagesData.splice(index, 1);
      localStorageService.set(uploader.imagesDataName, imagesData);
      uploader.filesAsData.splice(index, 1);
    }

    uploader.addUrlToResources = function (key, originalFileType) {
      var fileName = key;
      uploader.finishedFile[fileName] = 0;
      if (uploader.filesUniqueNames.length > 0) {
        uploader.filesUniqueNames += "," + key;
      } else {
        uploader.filesUniqueNames = key;
      }
      uploader.trackUploads();
    };

    uploader.updateChoosenFiles = function (files) {
      if (files.length > uploader.remainingFiles) {
        $rootScope.showToast('number of remaining images is only ' + uploader.remainingFiles);
      } else {
        uploader.initialize();
        uploader.remainingFiles -= uploader.files.length;
        uploader.files = files;
        $scope.$digest();
        uploader.upload();
      }
    };

    uploader.close = function () {
      uploader.storeImagesData();
      if (uploader.filesUniqueNames.length > 0) {
        var success = localStorageService.set('images', uploader.filesUniqueNames);
        if (success) {
          uploader.showUpload = false;
          uploader.showDialog = false;
        }
      } else {
        uploader.showDialog = false;
        uploader.showUpload = false;
      }
      uploader.trigger();
    };

    (function () {
      uploader.initialize();
      if (uploader.files.length > uploader.remainingFiles) {
        $rootScope.showToast('number of remaining images is only ' + uploader.remainder);
        uploader.showDialog = false;
        uploader.showUpload = false;
      } else {
        uploader.remainingFiles -= uploader.files.length;
        uploader.upload();
      }
    }());
  };

})();
;
// This directive writen by Ahmed Islam
(function() {
	'use strict';

	angular.module('eltazkara.utils').directive('eturnPopup', uploadDirective);

	popupCtrl.$inject = ['$scope', '$rootScope', '$attrs'];

	function uploadDirective() {
		return {
			restrict: 'AE',
			transclude: true,
			controller: popupCtrl,
			controllerAs: 'poper',
			bindToController: true,
			scope: {
				title: '@',
				printable: '@',
				closable: '@',
				showPoper: '='
			},
			templateUrl: 'components/utils/popup.html'
		};
	}

	function popupCtrl($scope, $rootScope, $attrs) {
		// define controller scope
		var poper = this;
		poper.title = $attrs.title;
		poper.printable = $attrs.printable;
		poper.closable = $attrs.closable;
		poper.showPopup = true;
		poper.id = $attrs.id;
		poper.spread = typeof($attrs.spread) !== 'undefined';
		poper.closePoper = function() {
			poper.showPopup = false;
			poper.showPoper = false;
		};
		poper.print = function() {
			//$("#printableArea").css("background", "rgba(255,255,255,0.5)");
			var printContents = document.getElementById('printableArea')
				.innerHTML;
			var popupWin = window.open('', '', '');
			popupWin.document.open();
			popupWin.document.write(
				'<html>' +
					document.head.innerHTML +
					'<body onload="window.print()">' +
					'<div style="background: rgba(255,255,255,0.5);' +
					'display: inline-block;' +
					'padding: 30px;' +
					'width: 800px;' +
					'margin-left: calc(50% - 400px);' +
					'color: black;">' +
					printContents +
					'</div>' +
					'</body></html>'
			);
			popupWin.document.close();
		};
	}
})();
;
(function() {
	'use strict';

	angular.module('eltazkara.utils').directive('file', file);

	file.$inject = [];

	function file() {
		return {
			restrict: 'AE',
			scope: {
				file: '@',
				trigger: '&'
			},
			link: fileLinker
		};
	}

	function fileLinker(scope, el, attrs) {
		el.bind('change', function(event) {
			var files = event.target.files;
			scope.$parent.$parent.vm.myFile = files[0];
			scope.files = files;
			scope.$parent.files = files;
			if (angular.isDefined(scope.trigger)) {
				scope.trigger({ files: scope.files });
			}
			scope.$apply();
		});
	}
})();
;
(function () {
  'use strict';
  
  angular
      .module('eltazkara.utils')
      .directive('infiniteScroll', infiniteScroll)
  
  infiniteScroll.$inject = [];
  
  function infiniteScroll() {
    return {
      restrict: 'A',
      scope: {
        addMore: '&addMore',
        disableLoadMore: '=disableLoadMore'
      },
      link: infiniteScrollLinker
    }
  }

  function infiniteScrollLinker(scope, element, attrs) {
    var lastLeftLocation = 0;
    element.scroll(function (e) {
      if (scope.disableLoadMore)
        return;

      var $width = element.outerWidth()
      var $scrollWidth = element[0].scrollWidth;
      var $scrollLeft = element.scrollLeft();

      var delta = $scrollWidth - $width - $scrollLeft;
      if ((delta >= 0 && delta <= 5) || (delta <= 0 && delta <= 5) &&
          lastLeftLocation <= $scrollLeft) {
        scope.addMore();
      }

      lastLeftLocation = e.currentTarget.scrollLeft;
    });
  }
})();;
(function () {
  'use strict';

  angular
      .module('eltazkara.utils')
      .directive('scroll', file);

  file.$inject = [];

  function file() {
    return {
      restrict: 'A',
      scope: {
        scrollTo: '@'
      },
      link: scrollLinker
    }
  };

  function scrollLinker(scope, $elm, attrs) {
    $elm.on('click', function() {                                                    
        $('html,body').animate({scrollTop: $(scope.scrollTo).offset().top }, "slow");
    });
  }

})();
;
(function () {
    'use strict';
    angular
        .module('eltazkaraApp')
        .directive('fullName', checkNameInput)
        .directive('mobilePhone', ['$rootScope', '$timeout', function($rootScope, $timeout) {
            return {
                restrict: 'A',
                scope: {
                    mobileNumber: '@number'
                },
                bindToController: true,
                controller: 'TopBarController as local',
                link: function (scope, element, attrs) {
                    var inputs = [];
    
                    element.on('keyup', function(event) {
                        $timeout(function() {
                            
        
                            if(/^(20|0){0,1}1[5]{1}[0-9]{8}$/.test(event.target.value)) {
                                console.log('WE NUMBERRRRRRRRRRRRRRRRRRRRR');
                                var model = element.controller('ngModel');
                                model.$valid = true;
                                model.$invalid = false;
                                scope.$apply();
                            }
                        });
                        
                    });
    
                    element.on('keydown', function (event) {
                        //var lastInput = element.context.value[element.context.value.length - 1];
                        if (validPhoneDigits.indexOf(event.keyCode) < 0) {
                            if (event.keyCode === 187 || event.keyCode === 61) {
                                if (event.shiftKey && event.keyCode) {
                                    if (event.target.selectionStart === 0) {
                                        if (element.context.value[event.target.selectionStart] === "+") {
                                            event.preventDefault();
                                            return;
                                        }
                                    }
                                    else {
                                        event.preventDefault();
                                        return;
                                    }
                                    return;
                                }
                            }
                            event.preventDefault();
                        }
                        else if (primaryDigits.indexOf(event.keyCode) > -1) {
                            if ((event.shiftKey && event.keyCode)) {
                                event.preventDefault();
                                return;
                            }
                            else if (event.keyCode === 189 || event.keyCode === 173) {
                                if (event.target.selectionStart === 0) {
                                    event.preventDefault();
                                    return;
                                }
                                else {
                                    if (element.context.value[event.target.selectionStart] === "+"
                                        || element.context.value[event.target.selectionStart - 1] === "+") {
                                        event.preventDefault();
                                        return;
                                    }
                                }
                            }
                        }
                        else {
                             if (event.keyCode === 109) {
                                if (event.target.selectionStart === 0) {
                                    event.preventDefault();
                                    return;
                                }
                                else {
                                    if (element.context.value[event.target.selectionStart] === "+"
                                        || element.context.value[event.target.selectionStart - 1] === "+") {
                                        event.preventDefault();
                                        return;
                                    }
                                }
                             }
                             else if((event.keyCode === 48 || event.keyCode === 57) && event.shiftKey) {
                                 event.preventDefault();
                             }
                        }
                        //inputs.push(event.keyCode);
                    });
                }
            }
        }])
        .directive('price', checkPriceInput)
        .directive('ticketsNum', checkNumberOfTickets)
        .directive('match', matchPass);
    
    //HS: Valid name input
    var validLetters = [];
    for (var i = 65; i < 91; i++) {
        validLetters.push(i);
    }
    validLetters.push(8, 9, 13, 16, 17, 18, 19, 20, 27, 32, 33, 34, 35, 36, 37, 38, 39, 40, 45, 46);
    //HS: Valid phone input
    var validPhoneDigits = [];
    for (var i = 48; i < 58; i++) {
        validPhoneDigits.push(i);
    }
    validPhoneDigits.push(8, 9, 13, 16, 17, 18, 19, 20, 27, 33, 34, 35, 36, 37, 38, 39, 40, 45, 46, 144, 173, 189);
    for (var i = 96; i < 110; i++) {
        if (i === 106) continue;
        validPhoneDigits.push(i);
    }
    var primaryDigits = [];
    for (var i = 49; i < 57; i++) {
        primaryDigits.push(i);
    }
    primaryDigits.push(189);
    //HS: Valid price input
    var validPhoneDigitsCopy = angular.copy(validPhoneDigits);
    var validPriceDigits = [];
    var phonePriceDiff = [107, 109, 173, 189];
    for (var i = 0; i < phonePriceDiff.length; i++) validPhoneDigitsCopy.splice(validPhoneDigitsCopy.indexOf(phonePriceDiff[i]), 1);
    validPriceDigits = validPhoneDigitsCopy;
    function checkNameInput() {
        return {
            restrict: 'A',
            link: function (scope, element) {
                element.bind('keydown', function (event) {
                    if (validLetters.indexOf(event.keyCode) < 0) {
                        event.preventDefault();
                    }
                });
            }
        };
    }
    //HS:Phone number directive
    // function checkPhoneInput() {
    //     return {
    //         restrict: 'A',
    //         scope: true,
    //         controller:'TopBarController as local',
    //         link: function (scope, element, attrs, $timeout) {
    //             var inputs = [];
    //             console.log(scope);

    //             element.on('keyup', function(event) {
    //                 console.log(scope.local);
    //                 console.log(scope.local.User);
    //                 console.log(scope.local.User.MobileNumber);
    //                 console.log(scope.local.User.MobileNumber.$valid);
    //                 var model = element.controller('ngModel');
    //                 console.log(model);

    //                 $timeout(function() {
    //                     model.$setValidity('ng-valid-ng-pattern', true);
    //                 });

    //                 var elem = event.target;
    //                 var $elem = angular.element(event.target);
    //                 var val = elem.value;
                    
    //                 // console.log(elem);
    //                 // console.log($elem);
    //                 console.log(val);
    //                 console.log(window);



    //                 var isValid = $elem.intlTelInput('isValidNumber');
    //                 console.log(isValid);

    //                 if(/^(20|0){0,1}1[5]{1}[0-9]{8}$/.test(val)) {
    //                     console.log('WE NUMBERRRRRRRRRRRRRRRRRRRRR');
    //                     elem.$setValidity(true);
    //                 }
    //             });

    //             element.on('keydown', function (event) {
    //                 //var lastInput = element.context.value[element.context.value.length - 1];
    //                 if (validPhoneDigits.indexOf(event.keyCode) < 0) {
    //                     if (event.keyCode === 187 || event.keyCode === 61) {
    //                         if (event.shiftKey && event.keyCode) {
    //                             if (event.target.selectionStart === 0) {
    //                                 if (element.context.value[event.target.selectionStart] === "+") {
    //                                     event.preventDefault();
    //                                     return;
    //                                 }
    //                             }
    //                             else {
    //                                 event.preventDefault();
    //                                 return;
    //                             }
    //                             return;
    //                         }
    //                     }
    //                     event.preventDefault();
    //                 }
    //                 else if (primaryDigits.indexOf(event.keyCode) > -1) {
    //                     if ((event.shiftKey && event.keyCode)) {
    //                         event.preventDefault();
    //                         return;
    //                     }
    //                     else if (event.keyCode === 189 || event.keyCode === 173) {
    //                         if (event.target.selectionStart === 0) {
    //                             event.preventDefault();
    //                             return;
    //                         }
    //                         else {
    //                             if (element.context.value[event.target.selectionStart] === "+"
    //                                 || element.context.value[event.target.selectionStart - 1] === "+") {
    //                                 event.preventDefault();
    //                                 return;
    //                             }
    //                         }
    //                     }
    //                 }
    //                 else {
    //                      if (event.keyCode === 109) {
    //                         if (event.target.selectionStart === 0) {
    //                             event.preventDefault();
    //                             return;
    //                         }
    //                         else {
    //                             if (element.context.value[event.target.selectionStart] === "+"
    //                                 || element.context.value[event.target.selectionStart - 1] === "+") {
    //                                 event.preventDefault();
    //                                 return;
    //                             }
    //                         }
    //                      }
    //                      else if((event.keyCode === 48 || event.keyCode === 57) && event.shiftKey) {
    //                          event.preventDefault();
    //                      }
    //                 }
    //                 //inputs.push(event.keyCode);
    //             });
    //         }
    //     };
    // }
    //HS:Ticket group price directive
    function checkPriceInput() {
        return {
            restrict: 'A',
            link: function (scope, element) {
                element.bind('keydown', function (event) {
                    if (validPriceDigits.indexOf(event.keyCode) < 0) {
                        event.preventDefault();
                    }
                    else if (event.keyCode === 48 || event.keyCode === 96) {
                        if (event.target.selectionStart === 0) {
                            event.preventDefault();
                        }
                    }
                });
            }
        };
    }
    //HS:Max number of tickets directive
    function checkNumberOfTickets($timeout, $parse) {
        return {
            restrict: 'A',
            require: 'ngModel',
            controller: 'SellController',
            controllerAs: 'vm',
            link: function (scope, elem, attrs, ctrl) {
                scope.bundlesCopy = angular.copy(scope.vm.Bundles);
                scope.$watch('vm.NumberOfTickets', function (oldVal, newVal) {
                    scope.theCopy = [];
                    angular.element(elem).on("keyup", function (e) {
                        var theCopy = angular.copy(scope.bundlesCopy);
                        if (scope.vm.NumberOfTickets != null && scope.vm.NumberOfTickets.length === 3) {
                            e.preventDefault();
                            return;
                        }
                        scope.$apply(function () {
                            if (parseInt(scope.vm.NumberOfTickets) % 2 !== 0) {
                                if (parseInt(scope.vm.NumberOfTickets) === 1) {
                                    theCopy.splice(1, 3);
                                    //theCopy.splice(2, 1);
                                    scope.vm.PerformanceDetails.Bundles = theCopy;
                                    scope.vm.SelectedBundle = theCopy[0];
                                }
                                else {
                                    theCopy.splice(1, 1);
                                    scope.vm.PerformanceDetails.Bundles = theCopy;
                                    scope.vm.SelectedBundle = theCopy[0];
                                }
                            }
                            else {
                                scope.vm.PerformanceDetails.Bundles = theCopy;
                                scope.vm.SelectedBundle = theCopy[0];
                            }
                        })
                    });
                    if (parseInt(scope.vm.NumberOfTickets) > 25) {
                        scope.vm.NumberOfTickets = 25;
                    }
                    else if (parseInt(scope.vm.NumberOfTickets) < 1) {
                        scope.vm.NumberOfTickets = 25;
                    }
                }, true)
            }
        };
    }
    //HS:Password confirmation directive
    function matchPass() {
        return {
            restrict: 'A',
            scope: true,
            require: 'ngModel',
            link: function (scope, elem, attrs, control) {
                var checker = function () {
                    var passConf = scope.$eval(attrs.ngModel);
                    var pass = scope.$eval(attrs.match);
                    return passConf == pass;
                };
                scope.$watch(checker, function (validity) {
                    control.$setValidity("matched", validity);
                });
            }
        };
    }
})();


// function checkPhoneInput() {
//     return {
//         restrict: 'A',
//         scope: true,
//         controller:'TopBarController as local',
//         link: function (scope, element, attrs, $timeout) {
//             var inputs = [];
//             console.log(scope);

//             element.on('keyup', function(event) {
//                 console.log(scope.local);
//                 console.log(scope.local.User);
//                 console.log(scope.local.User.MobileNumber);
//                 console.log(scope.local.User.MobileNumber.$valid);
//                 var model = element.controller('ngModel');
//                 console.log(model);

//                 $timeout(function() {
//                     model.$setValidity('ng-valid-ng-pattern', true);
//                 });

//                 var elem = event.target;
//                 var $elem = angular.element(event.target);
//                 var val = elem.value;
                
//                 // console.log(elem);
//                 // console.log($elem);
//                 console.log(val);
//                 console.log(window);



//                 var isValid = $elem.intlTelInput('isValidNumber');
//                 console.log(isValid);

//                 if(/^(20|0){0,1}1[5]{1}[0-9]{8}$/.test(val)) {
//                     console.log('WE NUMBERRRRRRRRRRRRRRRRRRRRR');
//                     elem.$setValidity(true);
//                 }
//             });

//             element.on('keydown', function (event) {
//                 //var lastInput = element.context.value[element.context.value.length - 1];
//                 if (validPhoneDigits.indexOf(event.keyCode) < 0) {
//                     if (event.keyCode === 187 || event.keyCode === 61) {
//                         if (event.shiftKey && event.keyCode) {
//                             if (event.target.selectionStart === 0) {
//                                 if (element.context.value[event.target.selectionStart] === "+") {
//                                     event.preventDefault();
//                                     return;
//                                 }
//                             }
//                             else {
//                                 event.preventDefault();
//                                 return;
//                             }
//                             return;
//                         }
//                     }
//                     event.preventDefault();
//                 }
//                 else if (primaryDigits.indexOf(event.keyCode) > -1) {
//                     if ((event.shiftKey && event.keyCode)) {
//                         event.preventDefault();
//                         return;
//                     }
//                     else if (event.keyCode === 189 || event.keyCode === 173) {
//                         if (event.target.selectionStart === 0) {
//                             event.preventDefault();
//                             return;
//                         }
//                         else {
//                             if (element.context.value[event.target.selectionStart] === "+"
//                                 || element.context.value[event.target.selectionStart - 1] === "+") {
//                                 event.preventDefault();
//                                 return;
//                             }
//                         }
//                     }
//                 }
//                 else {
//                      if (event.keyCode === 109) {
//                         if (event.target.selectionStart === 0) {
//                             event.preventDefault();
//                             return;
//                         }
//                         else {
//                             if (element.context.value[event.target.selectionStart] === "+"
//                                 || element.context.value[event.target.selectionStart - 1] === "+") {
//                                 event.preventDefault();
//                                 return;
//                             }
//                         }
//                      }
//                      else if((event.keyCode === 48 || event.keyCode === 57) && event.shiftKey) {
//                          event.preventDefault();
//                      }
//                 }
//                 //inputs.push(event.keyCode);
//             });
//         }
//     };
// };


(function () {
  'use strict';

  angular
      .module('eltazkara.utils')
      .directive('fieldEditable', fieldEditable);

  fieldEditable.$inject = [];

  function fieldEditable() {
    return {
      restrict: 'A',
      scope: {
        isOpen: '&'
      },
      link: fieldEditableLinker
    }
  };

  function fieldEditableLinker(scope, $elm, attrs) {
    scope.isOpen=true;
  }

})();
;
(function () {
    'use strict';

    angular
        .module('eltazkaraApp')
        .factory('FilesService', Files);//

    Files.$inject = ['$resource'];

    function Files($resource) {
        var service = $resource(window.backendUrl + 'Files', {}, {
            'uploadToBlobStorage': {
                method: 'POST', 
                isArray: false,
                url: window.backendUrl + "Files/UploadToAzureBlobStorage",
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8'
                }
            },
            'uploadToS3': {
                method: 'POST', 
                isArray: false,
                url: window.backendUrl + "Files/UploadToS3Bucket",
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8'
                }
            }
        });
        
        return service;
    }
})();
;
(function () {
    "use strict";

    angular.module("eltazkaraApp").factory("utilsService", utils);

    function utils() {
        return {
            getQueryParams: function () {
                var queryString = window.location.hash;
                var params = {};
                var regex = /[?&]([^=]+)=([^&]*)/g;
                var match;

                while ((match = regex.exec(queryString)) !== null) {
                    params[match[1]] = match[2];
                }

                return params;
            },
            getQueryParamsStr: function () {
                var queryString = window.location.hash;
                var str = "";
                var idx = 0;
                var regex = /[?&]([^=]+)=([^&]*)/g;
                var match;

                while ((match = regex.exec(queryString)) !== null) {
                    if (idx > 0) {
                        str += "&";
                    }

                    str += match[1] + "=" + match[2];
                    idx++;
                }

                return str !== "" ? str : undefined;
            },
        };
    }
})();
;
(function () {
  'use strict';

  angular
      .module('eltazkara.auth', [])

})();
;
(function () {
  "use strict";

  angular.module("eltazkara.auth").factory("Account", Account);
  Account.$inject = ["$resource", "$rootScope", "$injector"];

  function Account($resource, $rootScope, $injector) {
    var service = $resource(
      window.backendUrl + "Users/getUserData",
      {},
      {
        get: {
          method: "GET",
          isArray: false,
          url: window.backendUrl + "Users/getUserData",
          interceptor: {
            response: function (response) {
              if (response.data.Name) {
                if (
                  response.data.IsBlocked == true ||
                  response.data.Deleted == true
                ) {
                  var auth = $injector.get("Auth");
                  auth.logout();
                } else {
                  $rootScope.User = response.data;
                }
              } else if (
                response.data.redirect &&
                $rootScope.loggedOut != true
              ) {
                var auth = $injector.get("Auth");
                auth.logout();
              }

              return response;
            },
          },
        },
      }
    );

    return service;
  }
})();
;
(function () {
  'use strict';

  angular
      .module('eltazkara.auth')
      .factory('Activate', Activate);

  Activate.$inject = ['$resource'];

  function Activate($resource) {
    var service = $resource(window.backendUrl + 'activate', {}, {
      'get': {method: 'GET', params: {}, isArray: false}
    });

    return service;
  }
})();
;
(function () {
    'use strict';

    angular
        .module('eltazkara.auth')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$rootScope', '$localStorage', '$sessionStorage', '$q', 'Account', '$state', '$cookies'];

    function AuthServerProvider($http, $rootScope, $localStorage, $sessionStorage, $q, Account, $state, $cookies) {
        var service = {
            getToken: getToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken() {
            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function login(credentials) {

            //3alala ya radwan mattshalsh
            var loginUrl = window.backendUrl.replace("api/", "token");
            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
            return $http.post(loginUrl, credentials.Body, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
                .success(authenticateSuccess).
                error(function (error) {
                    $rootScope.loginClick = false;
                    $rootScope.LoginSubmit = "Login";
                    $rootScope.userLoginError = true;
            });


            function authenticateSuccess(data, status, headers, config) {
                var authorizationData = {
                    token: data.access_token,
                    userName: data.userName,
                    refreshToken: data.refresh_token,
                    useRefreshTokens: true
                };
                $cookies.put('expires',data[".expires"]);
                $rootScope.userLoginError = false;
                $rootScope.loggedOut = false;

                service.storeAuthenticationToken(authorizationData, credentials.rememberMe);

                if($rootScope.redirectVerifyAfterLogin == true) {
                    $sessionStorage.IsGoVerifiy = true;
                }

                window.location.reload(true);

                return jwt;
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if (rememberMe) {
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout() {
            $http({
                method : "GET",
                url : window.backendUrl + "Account/Logout"
            })
            .then(function (response) {})
            .catch(function (error) {
                console.log(error)
            })
            .finally(function() {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                window.location.reload(true);
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('eltazkara.auth')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$stateParams', '$sessionStorage', '$q', 'Principal', 'AuthServerProvider', 'Account', 'Activate', '$http', '$cookies', '$filter', 'fb'];

    function Auth($rootScope, $state, $stateParams, $sessionStorage, $q, Principal, AuthServerProvider, Account, Activate, $http, $cookies, $filter, fb) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            login: login,
            getPreviousState: getPreviousState,
            logout: logout,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount,
            isAuthenticated: isAuthenticated
        };

        return service;

        function activateAccount(key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize(force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen() {
                var isAuthenticated = Principal.isAuthenticated();
                $rootScope.Date = $filter('date')(new Date(), 'yyyyMMddHHmmss');

                if ($cookies.get('expires') != null) {
                    var expiryDate = $filter('date')(new Date($cookies.get('expires')), 'yyyyMMddHHmmss');
                    if ($rootScope.Date.toString() > expiryDate) {
                        $cookies.remove('expires');
                        logout();
                    }
                }

                if (isAuthenticated) {
                    $rootScope.loggedOut = false;
                } else {
                    $rootScope.loggedOut = true;
                }

                if ($sessionStorage.IsGoVerifiy) {
                    if ($sessionStorage.IsGoVerifiy == true) {
                        $sessionStorage.IsGoVerifiy = false;
                        $state.go('verify');
                    }
                }

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account'
                    && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register'
                        || $rootScope.toState.name === 'social-auth')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }
        }

        function login(credentials) {
            AuthServerProvider.login(credentials);
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if (rememberMe) {
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }

            window.location.reload(true);
        }

        function logout() {
            $rootScope.loggedOut = true;
            AuthServerProvider.logout();
            Principal.authenticate(null);
            $rootScope.User = null;
            fb.logout();
            $state.go('home');
        }

        function updateAccount(account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }

        function isAuthenticated() {
            return Principal.isAuthenticated();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('eltazkara.auth')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account', 'User', '$localStorage'];

    function Principal($q, Account, User, $localStorage) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved,
            isVerifiedUser: isVerifiedUser
        };

        return service;

        function authenticate(identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority(authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority(authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function (_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function () {
                return false;
            });
        }

        function identity(force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen(account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);

                // User.get({ login: _identity.login });
            }

            function getAccountCatch() {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated() {
            return _authenticated;
        }

        function isIdentityResolved() {
            return angular.isDefined(_identity);
        }

        function isVerifiedUser() {
            return $localStorage.IsGoVerifiy;
        }
    }
})();
;


(function () {
  'use strict';

  angular
      .module('eltazkara.auth')
      .service('SearchData', SearchData);

  function SearchData() {
    var service = {};
    var data;
    service.setData = function (data) {
      self.data = data;
    }
    service.getData = function () {
      return self.data;
    }
    return service;
  }
})();

;
(function () {
    'use strict';

    angular
        .module('eltazkara.auth')
        .factory('User', User);

    User.$inject = ['$resource', '$rootScope'];

    function User($resource, $rootScope) {
        var service = $resource(window.backendUrl + 'users/:login', {}, {
            'query': { method: 'GET', isArray: true },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    $rootScope.user = data;
                    return data;
                }
            },
            'save': { method: 'POST' },
            'update': {
                method: 'PUT',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    $rootScope.user = data;
                    return data;
                }
            },
            'delete': { method: 'DELETE' },
        });
        return service;
    }
})();
;
(function () {
  'use strict';

  angular
      .module('eltazkara.topBar', [])

})();;
//(function () {
'use strict';

angular.module('eltazkara.topBar')
    .controller('TopBarController', TopBarController)
    .factory('RegistrationService', RegistrationService)
    .factory('stateService', stateService)
    .directive('dismissMenu', dismissMenu)
    //.directive('dismissPopup', dismissPopup)
    .directive('myEnter', function () {
        return function (scope, element, attrs) {
            element.bind("keydown keypress", function (event) {
                if (event.which === 13) {
                    scope.$apply(function () {
                        scope.$eval(attrs.myEnter);
                    });
                    event.preventDefault();
                }
            });
        }
    });

TopBarController.$inject = [
    '$rootScope',
    '$scope',
    'Auth',
    '$cookies',
    '$location',
    '$timeout',
    'RegistrationService',
    'UserData',
    'Category',
    'AuthServerProvider',
    '$window',
    '$document',
    '$state',
    '$stateParams',
    '$http',
    'SearchData',
    'User',
    'FB_APP_ID'
];
function TopBarController(
    $rootScope,
    $scope,
    Auth,
    $cookies,
    $location,
    $timeout,
    RegistrationService,
    UserData,
    Category,
    AuthServerProvider,
    $window,
    $document,
    $state,
    $stateParams,
    $http,
    SearchData,
    User,
    FB_APP_ID) {
    var vm = this;
    vm.searchEndpoint = window.search;
    
    $rootScope.isMobile = window.mobileAndTabletcheck = function () {
        var check = false;
        (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    };

    vm.showVerify = User.getShowVerify();

    //AI: If iphone safari
    var ua = window.navigator.userAgent;
    var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
    var webkit = !!ua.match(/WebKit/i);
    var iOSSafari = iOS && webkit && !ua.match(/CriOS/i);

    if (iOS && webkit && iOSSafari) {
        //AI: The following listener to stop the pinch-to-zoom in iphone/ipad Safari
        document.documentElement.addEventListener('touchstart', function (event) {
            if (event.touches.length > 1) {
                event.preventDefault();
            }
        }, false);

        //AI: The following listener to stop the double-tap-to-zoom in iphone/ipad Safari
        var lastTouchEnd = 0;

        document.documentElement.addEventListener('touchend', function (event) {
            var now = (new Date()).getTime();
            if (now - lastTouchEnd <= 300) {
                event.preventDefault();
            }
            lastTouchEnd = now;
        }, false);
    }

    //AI: This is for login/signup switcher in small devices that can't hold two views at the same time
    $rootScope.signUpView = true;

    vm.initLoginView = function () {
        $rootScope.clientWidth = 0;
        vm.resizeHandler();
    };

    vm.resizeHandler = function () {
        //Solve mobile browsers bug when it trigger resize on scroll
        if (window.innerWidth != $rootScope.clientWidth) {
            $rootScope.clientWidth = window.innerWidth;
            if ($rootScope.clientWidth <= 768)
                $rootScope.signUpView = false
            else
                $rootScope.signUpView = true;
        }
    };

    vm.openMobileMenu = function () {
        $rootScope.mobileMenuOpen = true;
    };

    vm.closeMobileMenu = function () {
        $rootScope.mobileMenuOpen = false;
    };

    vm.toggleLoginView = function () {
        $rootScope.signUpView = !$rootScope.signUpView;
    };

    vm.forgotPassword = false;
    
    vm.forgotPasswordToggler = function () {
        vm.forgotPassword = !vm.forgotPassword;
        vm.resetPasswordEmailNotExist = false;
        vm.resetPasswordEmailSubmitted = false;
        vm.resetPasswordEmailSent = false;
        vm.resetpasswordemail = null;
        vm.mailSendSuccessfully = false;
        $rootScope.userLoginError = false;
    };

    //Initialize Login/Signup View
    vm.initLoginView();

    $(window).resize(function () {
        vm.resizeHandler();
        //AI:Rootscope must be updated to avoid resize bug like mobile/tablet rotation
        $rootScope.$apply();
    });

    $rootScope.userMenu = false;

    vm.toggleUserMenu = function () {
        $rootScope.userMenu = !$rootScope.userMenu;
    };

    vm.default = {};

    //used root scope to send this variable to index (Advised by Islam Taha)
    $rootScope.loginPanelActive = false;

    vm.toggleLoginPanel = function () {
        if ($rootScope.clientWidth > 768 || ($rootScope.clientWidth <= 768 && $rootScope.signUpView)) {
            document.getElementById("ufullname").value = "";
            document.getElementById("uphone").value = "";
            document.getElementById("uemail").value = "";
            document.getElementById("upass").value = "";
            document.getElementById("confirmpass").value = "";

            if (!$rootScope.loginPanelActive) {
                vm.registrationSubmitted = false;
            }
        }

        if (($rootScope.clientWidth > 768 || ($rootScope.clientWidth <= 768 && !$rootScope.signUpView)) && !vm.forgotPassword) {
            document.getElementById("userLoginEmail").value = "";
            document.getElementById("userLoginPassword").value = "";
            document.getElementById("userLoginRemember").checked = false;
        }

        vm.confirmedPasswordError = false;
        vm.forgotPassword = false;
        vm.resetPasswordEmailNotExist = false;
        vm.resetpasswordemail = null;
        vm.resetPasswordEmailSubmitted = false;
        vm.resetPasswordEmailSent = false;
        vm.mailSendSuccessfully = false;
        vm.resetpasswordemail = null;
        vm.userClaimChecked = false;
        $rootScope.loginPanelActive = !$rootScope.loginPanelActive;
        $rootScope.userLoginError = false;
        vm.User = {};
        vm.errors = {};
        $rootScope.$emit('app:loginPanelToggled');
    };

    //This function for UI simulation ONLY and MUST BE DELETED
    vm.tempChangeTheme = function (theme) {
        $rootScope.theme = theme;
    };

    vm.regex = {};
    vm.credentials = {};
    vm.CategoriesList = [];

    vm.getNumber = function (num) {
        return new Array(num);
    };

    vm.childernLength = [];
    vm.number = [];

    vm.getsubcategory = function () {
        Category.getAllCategories({})
            .$promise.then(function (data) {
                if (data) {
                    for (var i = 0; i < data.length; i++) {
                        var tempItem = {
                            "categoryId": data[i].CategoryId,
                            "Name": data[i].ParentCategory,
                            "Theme": data[i].Theme,
                            "ChildCategories": data[i].ChildCategories,
                        };
                        vm.childernLength[i] = data[i].ChildCategories.length;
                        vm.number[i] = Math.ceil(vm.childernLength[i] / 6);
                        vm.CategoriesList[i] = tempItem;
                    }
                }

            }, function (error) { })
    };

    vm.getsubcategory();
    vm.isLoggedIn = false;

    vm.checkLogin = function () {
        if (AuthServerProvider.getToken() == undefined)
            vm.isLoggedIn = false;
        else
            vm.isLoggedIn = true;
    };

    vm.checkLogin();
    var accountText = UserData.getKey("Name", "Login");
    $rootScope.accountText = accountText.split(" ")[0];
    $rootScope.logoutText = UserData.getKey("LogoutText", "");

    vm.regex = {
        //Name: /^[a-z]([-']?[a-z]+)*( [a-z]([-']?[a-z]+)*)+$/,
        //Name: /^[a-z]*( [a-z]+)$/,
        //Name: /^[a-z]*( )$/,
        //Name: /\b[^\d\s]+\b/g,
        Name: /\s/g,
        Email: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9]+$/
    };

    vm.submitText = "Sign Up";
    vm.existPhone = false;
    vm.existEmail = false;
    vm.registrationSubmitted = false;
    vm.registrationSent = false;
    vm.confirmedPasswordError = false;
    vm.logoutText = UserData.getKey("LogoutText", "");
    vm.fbAppId = FB_APP_ID;
    vm.loginError = "";
    $rootScope.userLoginError = false;
    vm.errors = {};

    vm.User = {
        Name: "",
        MobileNumber: "+20",
        Email: "",
        Password: "",
        ConfirmPassword: ""
    };

    //Save Data
    vm.SaveData = function (registrationForm) {
        vm.registrationSubmitted = true;

        if (registrationForm.$valid && vm.submitText == 'Sign Up' && vm.userClaimChecked) {
            vm.registrationSent = true;
            vm.submitText = 'Please Wait...';

            User.CheckEmailPhone({ "MobileNumber": vm.User.MobileNumber, "Email": vm.User.Email })
                .$promise.then(function (data) {
                    if (data) {
                        if (data["email"] == "true")
                            vm.existEmail = true;
                        else
                            vm.existEmail = false;

                        if (data["mobileNumber"] == "true")
                            vm.existPhone = true;
                        else
                            vm.existPhone = false;

                        if (vm.existPhone == true || vm.existPhone == true) return;
                    }
                }, function (error) {
                    vm.registrationSent = false;
                    vm.submitText = "Sign Up";
                });

            var data = {};
            var user = vm.User;
            data.User = user;

            RegistrationService.SaveFormData(data).then(function (d) {
                if (typeof (d) === 'object') {
                    UserData.set(d);
                    vm.toggleLoginPanel();
                    $cookies.put('SmsSent', 'true');
                    $rootScope.redirectVerifyAfterLogin = true;
                    vm.doUserLogin(data);

                    if (d == 'mobile used') {
                        vm.errors.MobileNumber = "Mobile number is already registered.";
                    }
                    else if (d == 'email used') {
                        //alert(d);s
                        vm.errors.Email = "Email address is already registered."
                    }
                }
                vm.registrationSent = false;
                vm.submitText = "Sign Up";
            }, function (error) {
                vm.registrationSent = false;
                vm.submitText = "Sign Up";
            });
        }
    };

    vm.logout = function () {
        Auth.logout();
        $rootScope.loggedOut = true;
    };

    $rootScope.loginClick = false;
    $rootScope.LoginSubmit = "Login";

    vm.doUserLogin = function (userData) {
        vm.data = {};

        if (userData) {
            vm.credentials.userLoginEmail = userData.User.MobileNumber;
            vm.credentials.userLoginPassword = userData.User.Password;
            vm.credentials.userLoginRemember = false;
            vm.data.Body = "username=" + vm.credentials.userLoginEmail + "&password=" + encodeURIComponent(vm.credentials.userLoginPassword)
                + "&grant_type=password" + "&client_id=ngAuthApp" + "&client_secret=0";

            if (vm.credentials.userLoginRemember == null)
                vm.data.rememberMe = false;
            else
                vm.data.rememberMe = true;

            Auth.login(vm.data);
        }
        else {
            vm.credentials.userLoginEmail = document.getElementById("userLoginEmail").value;
            vm.credentials.userLoginPassword = document.getElementById("userLoginPassword").value;
            vm.credentials.userLoginRemember = document.getElementById("userLoginRemember").value;
            vm.data.Body = "username=" + vm.credentials.userLoginEmail + "&password=" + encodeURIComponent(vm.credentials.userLoginPassword)
                + "&grant_type=password" + "&client_id=ngAuthApp" + "&client_secret=0";

            if (vm.credentials.userLoginRemember == null)
                vm.data.rememberMe = false;
            else
                vm.data.rememberMe = true;

            User.IsUserBlocked({ "User": vm.credentials.userLoginEmail, "Password": encodeURIComponent(vm.credentials.userLoginPassword) })
                .$promise.then(function (data) {
                    if (data.status == "true") {
                        $rootScope.PopUpTitle = "Login Error";
                        $rootScope.PopUpDescription = "Please Contact Admin, Your Email Is Blocked";
                        $rootScope.PopError = true;
                    }
                    else {
                        if ($rootScope.loginClick == false) {
                            $rootScope.LoginSubmit = "Please Wait...";
                            $rootScope.loginClick = true;
                            Auth.login(vm.data);
                        }
                    }
                }, function (error) { });
        }
    }

    vm.countDownCounter = 5;

    vm.countDown = function () {
        if (vm.forgotPassword && vm.countDownCounter > 0) {
            $timeout(function () {
                vm.countDownCounter--;
                vm.countDown();
            }, 1000)
        }
        else {
            vm.forgotPassword = vm.mailSendSuccessfully = false;
            vm.countDownCounter = 5;
        }
    };

    vm.resetpasswordemail = "";
    vm.ResetPassowrdButtonText = "Send";

    vm.resetpassword = function (resetPasswordForm) {
        vm.resetPasswordEmailSubmitted = true;

        if (resetPasswordForm.$valid) {
            if (vm.ResetPassowrdButtonText == "Send") {
                vm.ResetPassowrdButtonText = "Wait..";
                vm.resetPasswordEmailSent = true;

                User.ResetPasswordUsingMail({ "Email": vm.resetpasswordemail })
                    .$promise.then(function (data) {
                        if (data) {
                            if (data.status === "No user account is associated with this email") {
                                vm.resetPasswordEmailNotVerified = false;
                                vm.resetPasswordEmailNotExist = true;
                                vm.mailSendSuccessfully = false;
                            }
                            else if (data.status === "Mail was sent successfully") {
                                vm.resetPasswordEmailNotVerified = false;
                                vm.resetPasswordEmailNotExist = false;
                                vm.mailSendSuccessfully = true;
                                vm.countDown();
                            }

                            vm.ResetPassowrdButtonText = "Send";
                            vm.resetPasswordEmailSent = false;
                        }
                    }, function (error) {
                        vm.resetPasswordEmailSent = false;
                    });
            }
        }
    };

    vm.itemSelected = function (item) {
        if (item.originalObject) {
            var selectedItem = item.originalObject;
            if (selectedItem.type == 'Performance')
                location.href = "#/performance/" + selectedItem.id + "";
            else if (selectedItem.type == 'Performer')
                location.href = "#/performer/" + selectedItem.id + "";
            else if (selectedItem.type == 'Venue')
                location.href = "#/venue/" + selectedItem.id + "";
            else if (selectedItem.type == 'Event')
                location.href = "#/event/" + selectedItem.id + "";
        }
    };

    vm.searchResult = function () {
        var text = document.getElementById('headerSearchField_value').value;

        if (text && text.length > 2) {
            $http({
                url: window.search + text,
                method: "GET"
            }).then(function (response) {
                var res = response.data;

                if (res != "NotValid") {
                    SearchData.setData(res);
                    var currentState = $state.current.name;

                    if (currentState == 'search')
                        $rootScope.initSearchPage();
                    else
                        location.href = "/#search";
                }
            });
        }
    };

    //Check if logged in
    if ($rootScope.User) {
        if ($rootScope.User.Name)
            $rootScope.User.Name = $rootScope.User.Name.split(" ")[0];
        else
            vm.isLoggedIn = false;
    }
    else
        vm.isLoggedIn = false;

    vm.confirmedPasswordFunc = function () {
        if (vm.User.ConfirmPassword == vm.User.Password) {
            vm.confirmedPasswordError = false;
            vm.confirmPassEmpty = false;
        }
        else if (vm.User.ConfirmPassword == "") {
            vm.confirmedPasswordError = false;
            vm.confirmPassEmpty = true;
        }
        else {
            vm.confirmedPasswordError = true;
            vm.confirmPassEmpty = false;
        }
    };

    $rootScope.isArabic = function (text) {
        if (typeof (text) == 'undefined') return;
        var firstChar = text.substr(0, 1);
        return /[\u0600-\u06FF]/.test(firstChar);
    };
};

function RegistrationService($http, $q) {
    var fac = {};

    fac.SaveFormData = function (data) {
        var defer = $q.defer();
        $http({
            url: window.backendUrl + "Users/Register",
            method: 'POST',
            data: JSON.stringify(data),
            crossDomain: true,
            withCredentials: false,
            headers: { 'content-type': 'application/json' }
        }).success(function (d) {
            defer.resolve(d);
        }).error(function (e) {
            console.log('Error', e);
            defer.reject(e);
        });

        return defer.promise;
    }

    return fac;
}

function dismissMenu($rootScope, $document) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            $document.bind('click', function (event) {
                if ($rootScope.userMenu) {
                    if (element.find(event.target).length > 0) return;
                    $rootScope.$apply(function () {
                        $rootScope.userMenu = false;
                    });
                };
            });
        }
    };
};

function stateService($rootScope, $state) {
    var from, to;

    $rootScope.$on("$stateChangeSuccess", function (event, fromState, toState) {
        from = fromState.name;
    });

    return {
        getPrev: function () {
            return from;
        }
    }
}
;
(function () {
  'use strict';

  angular
      .module('eltazkara.footer', [])

})();
;
(function () {
  'use strict';

  angular
      .module('eltazkara.footer')
      .controller('FooterController', FooterController);

  FooterController.$inject = [
    '$rootScope'
  ];

  function FooterController($rootScope) {
    var footerC = this;
    footerC.date = new Date();
  }


})();
;
(function () {

  'use strict';

  angular
      .module('eltazkara.social', []);

})();;
(function () {
    'use strict';

    angular
        .module('eltazkara.social')
        .factory('fb', facebookFactory)
        .directive('facebook', facebookDirective);

    // Directive
    function facebookDirective() {
        return {
            restrict: 'A',
            scope: true,
            rootScope: true,
            controller: facebookCtrl,
            link: facebookLinker
        }
    }

    function facebookFactory() {
        var logout = function () {
            FB.logout();
        };

        return {
            logout: logout
        }
    }

    facebookCtrl.$inject = ['$scope', '$rootScope', 'Facebook', '$cookies', 'Auth', '$state'];

    // Controller
    function facebookCtrl($scope, $rootScope, Facebook, $cookies, Auth, $state) {
        (function (d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s);
            js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));

        function login() {
            FB.login(function (response) {
                if (response.authResponse) {
                    $scope.auth = response.authResponse;
                    fetch();
                }
            }, { auth_type: 'reauthenticate', scope: 'email,user_photos,user_gender' });
        };

        function fetch() {
            Facebook.post({
                accessToken: $scope.auth.accessToken,
                client_id: "ngAuthApp",
                client_secret: 0
            }, function (response) {
                if (response.data.status && response.data.status == "Success") {
                    var authorizationData = {
                        token: response.data.access_token,
                        userName: response.data.userName,
                        refreshToken: response.data.refresh_token,
                        expires_in: response.data.expires_in,
                        token_type: response.data.token_type
                    };

                    Auth.loginWithToken(authorizationData, true).then(function () {
                        Auth.authorize(true);
                        $rootScope.loggedOut = false;

                        if (response.data.redirect === 'setting') {
                            $rootScope.facebookUser = true;
                            $rootScope.redirecSetting = true;
                            $state.go('account');
                        }
                    });
                }
                else {
                    $rootScope.PopUpTitle = "Login Error";
                    $rootScope.PopUpDescription = response.data.status;
                    $rootScope.PopError = true;
                    FB.logout();
                }
            }, function (error) {
                FB.logout();
                console.log(error);
            });
        }

        $scope.getLoginStatus = function () {
            FB.getLoginStatus(function (response) {
                if (response.status === 'connected') {
                    scope.auth = response.authResponse;
                }

                scope.login_status = response.status;
                scope.stopLoading();
                scope.$apply();
            });
        }

        $scope.fetch = function () {
            if ($scope.login_status == 'connected') {
                fetch();
            } else {
                login();
            }
        };

        $scope.stopLoading = function () {
            $rootScope.startLoading(false, true);
        }

        function logout() {
            FB.logout(function (response) {
                $rootScope.$apply(function () {
                    $rootScope.user = _self.user = {};
                });
            });
        }
    }

    // Linker
    function facebookLinker(scope, element, attrs) {
        window.fbAsyncInit = function () {
            FB.init({
                appId: attrs.facebook,
                cookie: true,
                xfbml: true,
                version: 'v2.5'
            });

            FB.getLoginStatus(function (response) {
                if (response.status === 'connected') {
                    scope.auth = response.authResponse;
                }

                scope.login_status = response.status;
                scope.stopLoading();
                scope.$apply();
            });
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('eltazkara.social')
        .factory('Facebook', Facebook);

    Facebook.$inject = ['$rootScope', '$resource'];

    function Facebook($rootScope, $resource) {
        var service = $resource(window.backendUrl + 'Account/FacebookLogin', {}, {
            'post': {
                method: 'POST', params: { accessToken: '@accessToken', client_id: '@client_id', client_secret: '@client_secret' },
                interceptor: {
                    response: function (response) {
                        return response;
                    }
                }
            }
        });
        return service;
    }
})();
;
(function () {
  'use strict';

  angular
      .module('eltazkaraApp')
      .config(stateConfig);

  stateConfig.$inject = ['$stateProvider'];

  function stateConfig($stateProvider) {
    $stateProvider.state('social-login', {
      url: '/login',
      views: {
        'content@': {
          templateUrl: 'social/social-login.html',
          controller: 'SocialLoginController',
          controllerAs: 'vm'
        }
      },
      resolve: {
        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
          $translatePartialLoader.addPart('global');
        }]
      }
    });
  }
})();
;
(function () {
  'use strict';

  angular
      .module('eltazkaraApp')
      .controller('SocialLoginController', SocialLoginController);

  SocialLoginController.$inject = [
    'GooglePlus',
    'Google',
    'Auth',
    '$rootScope',
    '$cookies'
  ];

  function SocialLoginController(GooglePlus, Google, Auth, $rootScope, $cookies) {
    var vm = this;

    vm.googleLogin = function () {
      GooglePlus.login().then(function (authResult) {
        Google.post({accessToken: authResult.access_token}, function (data) {
          var token = $cookies.get('social-authentication');
          Auth.loginWithToken(token, false).then(function () {
            $cookies.remove('social-authentication');
            Auth.authorize(true);
            $rootScope.doTheBack();
          });
        });
      }, function (err) {
      });
    };
  };
})();
;
(function () {
  'use strict';

  angular
      .module('eltazkara.social')
      .factory('Google', Google);

  Google.$inject = ['$resource'];

  function Google($resource) {
    var service = $resource(window.backendUrl + 'google', {}, {
      'post': {
        method: 'POST', params: {accessToken: '@accessToken'},
        interceptor: {
          response: function (response) {
            // expose response
            return response;
          }
        }
      }
    });

    return service;
  }
})();
;
(function () {
    'use strict';

    angular
        .module('eltazkara.interceptor', [])
        .factory('httpInterceptor', ['$q', '$injector', '$timeout', '$rootScope', function ($q, $injector, $timeout, $rootScope) {
            return {
                request: function (request) {
                    return request;
                },
                response: function (response) {
                    if (!response.config.override) 
                        response.config.override = true;

                    var http = $injector.get('$http');

                    if (http.pendingRequests.length < 1) {
                        $timeout(function () {
                            $rootScope.htmlReady();
                        }, 1000);
                    }

                    return response
                },
                responseError: function (response) {
                    //var faviconRequested = response.config.url.indexOf("favicon") > -1;
                    var componentRequested = response.config.url.indexOf("Events") > -1 ||
                        response.config.url.indexOf("Performances") > -1 ||
                        response.config.url.indexOf("Performers") > -1 ||
                        response.config.url.indexOf("Venues") > -1;
                    if (response.status === 404 && componentRequested) {
                        $injector.get("$state").go('404');
                        return $q.reject(response);
                    }
                    return $q.reject(response);
                }
            };
        }])
        .config(['$httpProvider', function ($httpProvider) {
            $httpProvider.interceptors.push('httpInterceptor');
        }]);
})();
//$rootScope.$broadcast('loading:hide');
(function () {
  'use strict';

  angular
      .module('eltazkara.config', [])

})();
;
(function () {
  'use strict';

  angular
      .module('eltazkara.handler', [])

})();
;
(function () {
  'use strict';

  angular
    .module('eltazkara.config')
    .config(httpConfig);

  httpConfig.$inject = [
    '$urlRouterProvider',
    '$httpProvider',
    'httpRequestInterceptorCacheBusterProvider',
    '$urlMatcherFactoryProvider',
    '$locationProvider'
  ];

  function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider, $locationProvider) {
    delete $httpProvider.defaults.headers.common['X-Requested-With'];

    //Cache everything except rest api requests
    httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

    $urlRouterProvider.otherwise("/home");
    //$httpProvider.defaults.withCredentials = true;
    $httpProvider.interceptors.push('errorHandlerInterceptor');
    $httpProvider.interceptors.push('authExpiredInterceptor');
    $httpProvider.interceptors.push('authInterceptor');

    $urlMatcherFactoryProvider.type('boolean', {
      name: 'boolean',
      decode: function (val) { return val === true || val === 'true'; },
      encode: function (val) { return val ? 1 : 0; },
      equals: function (a, b) { return this.is(a) && a === b; },
      is: function (val) { return [true, false, 0, 1].indexOf(val) >= 0; },
      pattern: /bool|true|0|1/
    });
  }
})();
;
(function () {
  'use strict';

  angular
      .module('eltazkara.config')
      .config(localStorageConfig);

  localStorageConfig.$inject = [
    '$localStorageProvider',
    '$sessionStorageProvider',
    'localStorageServiceProvider',
    'cfpLoadingBarProvider'
  ];

  function localStorageConfig($localStorageProvider, $sessionStorageProvider, localStorageServiceProvider, cfpLoadingBarProvider) {
    $localStorageProvider.setKeyPrefix('eltazkara-');
    $sessionStorageProvider.setKeyPrefix('eltazkara-');

    localStorageServiceProvider.setPrefix('eltazkara');
    localStorageServiceProvider.setStorageType('sessionStorage');

    cfpLoadingBarProvider.includeSpinner = false;
  }
})();
;
(function () {
  'use strict';

  angular
      .module('eltazkaraApp')
      .config(compileServiceConfig);

  compileServiceConfig.$inject = ['$compileProvider', 'DEBUG_INFO_ENABLED'];

  function compileServiceConfig($compileProvider, DEBUG_INFO_ENABLED) {
    /*
     * Disable debug data on prod profile to improve performance.
     *
     * If you wish to debug an application with this information
     * then you should open up a debug console in the browser
     * then call this method directly in this console:
     *
     * angular.reloadWithDebugInfo();
     *
     */

    $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);
  }
})();;
(function () {
  'use strict';

  angular
      .module('eltazkara.handler')
      .factory('stateHandler', stateHandler);

  stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$window', 'Auth', 'Principal'];

  function stateHandler($rootScope, $state, $sessionStorage, $window, Auth, Principal) {
    return {
      initialize: initialize
    };

    function initialize() {
      //$rootScope.VERSION = VERSION;

      var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
        $rootScope.toState = toState;
        $rootScope.toStateParams = toStateParams;
        $rootScope.fromState = fromState;

        // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
        if (toState.external) {
          event.preventDefault();
          $window.open(toState.url, '_self');
        }

        if (Principal.isIdentityResolved()) {
          Auth.authorize();
        }

      });

      var statesArray = [];
      $rootScope.backtransition = false;

      var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
        //Reset Theme
        $rootScope.theme='';
        //var titleKey = 'global.title';
        //
        // //Set the page title key to the one configured in state or use default one
        //if (toState.data.pageTitle) {
        //  titleKey = toState.data.pageTitle;
        //}
        //translationHandler.updateTitle(titleKey);

        // scroll to top
        document.body.scrollTop = document.documentElement.scrollTop = 0;

        $rootScope.backtransition = false;

        statesArray.push(fromState.name);

        var found = statesArray.indexOf(toState.name);
        if (found != -1) {

          var foundIndex = statesArray.indexOf(toState.name);
          statesArray.splice(foundIndex + 1, statesArray.length - foundIndex - 1);
          $rootScope.backtransition = true;
        }
      });

      $rootScope.$on('$destroy', function () {
        if (angular.isDefined(stateChangeStart) && stateChangeStart !== null) {
          stateChangeStart();
        }
        if (angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null) {
          stateChangeSuccess();
        }
      });
    }
  }
})();
;
(function () {
  'use strict';

  angular
      .module('eltazkara.interceptor')
      .factory('authExpiredInterceptor', authExpiredInterceptor);


  authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

  function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
    var service = {
      responseError: responseError
    };

    return service;

    function responseError(response) {
      if (response.status === 401) {
        delete $localStorage.authenticationToken;
        delete $sessionStorage.authenticationToken;
        var Principal = $injector.get('Principal');
        if (Principal.isAuthenticated()) {
          var Auth = $injector.get('Auth');
          Auth.authorize(true);
        }
      }
      return $q.reject(response);
    }
  }
})();
;
(function () {
  "use strict";

  angular
    .module("eltazkara.interceptor")
    .factory("authInterceptor", authInterceptor);

  authInterceptor.$inject = [
    "$localStorage",
    "$sessionStorage",
  ];

  function authInterceptor(
    $localStorage,
    $sessionStorage
  ) {
    var service = {
      request: request,
    };

    return service;

    function request(config) {
      /*jshint camelcase: false */
      config.headers = config.headers || {};

      var authData =
        $localStorage.authenticationToken ||
        $sessionStorage.authenticationToken;

      if (authData) {
        config.headers.Authorization = "Bearer " + authData.token;
        config.headers.AuthorizationRefesh = "Bearer " + authData.refreshToken;
      }

      return config;
    }
  }
})();
;
(function () {
  'use strict';

  angular
      .module('eltazkara.interceptor')
      .factory('errorHandlerInterceptor', errorHandlerInterceptor);

  errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

  function errorHandlerInterceptor($q, $rootScope) {
    var service = {
      responseError: responseError
    };

    return service;

    function responseError(response) {
      if (response.status === 401) {
          $rootScope.$emit('eltazkara.httpUnAuthorized', response);
      }
      return $q.reject(response);
    }
  }
})();
;
(function () {
    'use strict';

    angular
        .module('eltazkaraApp')
        .factory('hubFactory', ['$rootScope', 'Hub', function ($rootScope, Hub) {
            var hub = new Hub('elTazkaraHub', {
                listeners: {
                    'SendOrderSuccessfullyPaid': function (orderReference) {
                        console.log(orderReference);
                        $rootScope.$emit('hub:orderPaidSuccessfully', orderReference);
                    }
                },
                errorHandler: function (error) { console.log('%c' + error, 'color: #fff'); },
                hubDisconnected: function () {
                    if (hub.connection.lastError) {
                        hub.connection.start();
                    }
                },
                logging: true,
                rootPath: window.backendUrl.replace('api/', 'signalr'),
                stateChanged: function (state) {
                    switch (state.newState) {
                        case $.signalR.connectionState.connecting:
                            console.log('Connecting to SignalR hub...');
                            break;
                        case $.signalR.connectionState.connected:
                            console.log('Connected to SignalR hub.');
                            break;
                        case $.signalR.connectionState.reconnecting:
                            console.log('Reconnecting to SignalR hub...');
                            break;
                        case $.signalR.connectionState.disconnected:
                            console.log('Disconnected from SignalR hub.');
                            hub.connection.start();
                            break;
                    }
                }
            });

            return hub;
        }]);
})()
;
(function () {
  'use strict';

  angular
    .module('eltazkaraApp')
    .config(stateConfig);

  stateConfig.$inject = ['$stateProvider'];

  function stateConfig($stateProvider) {
    $stateProvider.state('terms', {
      parent: 'app',
      url: '/terms',
      views: {
        'content@': {
          templateUrl: 'static/terms.html'
        }
      },

      resolve: {
        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
          $translatePartialLoader.addPart('global');
        }]
      }
    })
      .state('privacy', {
        parent: 'app',
        url: '/privacy',
        views: {
          'content@': {
            templateUrl: 'static/privacy.html',
            controller: 'NotFoundController',
            controllerAs: 'vm'
          }
        }
      })
      .state('sellerAgreement', {
        parent: 'app',
        url: '/seller-agreement',
        views: {
          'content@': {
            templateUrl: 'static/sellerAgreement.html',
            controller: 'NotFoundController',
            controllerAs: 'vm'
          }
        }
      })
      .state('buyerAgreement', {
        parent: 'app',
        url: '/buyer-agreement',
        views: {
          'content@': {
            templateUrl: 'static/buyerAgreement.html',
            controller: 'NotFoundController',
            controllerAs: 'vm'
          }
        }
      })
      .state('cookies', {
        parent: 'app',
        url: '/cookies',
        views: {
          'content@': {
            templateUrl: 'static/cookies.html',
            controller: 'NotFoundController',
            controllerAs: 'vm'
          }
        }
      })
      .state('about', {
        parent: 'app',
        url: '/about',
        views: {
          'content@': {
            templateUrl: 'static/about.html',
            controller: 'NotFoundController',
            controllerAs: 'vm'
          }
        }
      })
      ;
  }
})();
;(function(){angular.module('eltazkaraApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/index.html','<!DOCTYPE html>\n<html lang="en" ng-app="eltazkaraApp">\n    \n<head>\n    <title>Tixawy</title>\n    <meta charset="utf-8" />\n    <meta http-equiv="X-UA-Compatible" content="IE=edge" />\n    <meta name="description" content="">\n    <meta name="viewport" content="initial-scale=1, maximum-scale=1, user-scalable=no" />\n    <meta name="fragment" content="!" />\n    <!--<meta http-equiv="Content-Security-Policy" content="default-src *; style-src \'self\' \'unsafe-inline\'; img-src \'self\' * data:; script-src \'self\' \'unsafe-inline\' \'unsafe-eval\' http://localhost:* http://connect.facebook.net/* ">-->\n    <meta http-equiv="CACHE-CONTROL" content="NO-CACHE" />\n    <meta http-equiv="CACHE-CONTROL" content="NO-STORE" />\n    <meta property="og:locale" content="en_US">\n    <meta property="og:type" content="website">\n    <meta property="og:title" content="{{$root.siteTitle}}">\n    <meta property="og:description" content="">\n    <meta property="og:url" content="">\n    <meta property="og:site_name" content="">\n    <meta property="og:image" content="">\n    <meta property="og:image:secure_url" content="">\n    <meta property="og:image:width" content="512">\n    <meta property="og:image:height" content="512">\n    <!-- Global site tag (gtag.js) - Google Analytics -->\n    <script async src="https://www.googletagmanager.com/gtag/js?id=UA-116043963-1"></script>\n    <script>\n        window.dataLayer = window.dataLayer || [];\n\n        function gtag() {\n            dataLayer.push(arguments);\n        }\n        gtag(\'js\', new Date());\n        gtag(\'config\', \'UA-116043963-1\');\n    </script>\n    <!-- Google Adsense Code -->\n    <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"></script>\n    <script>\n        (adsbygoogle = window.adsbygoogle || []).push({\n            google_ad_client: "ca-pub-6095727307803703",\n            enable_page_level_ads: true\n        });\n    </script>\n    <!-- Facebook Pixel Code -->\n    <script>\n        ! function (f, b, e, v, n, t, s) {\n            if (f.fbq) return;\n            n = f.fbq = function () {\n                n.callMethod ?\n                    n.callMethod.apply(n, arguments) : n.queue.push(arguments)\n            };\n            if (!f._fbq) f._fbq = n;\n            n.push = n;\n            n.loaded = !0;\n            n.version = \'2.0\';\n            n.queue = [];\n            t = b.createElement(e);\n            t.async = !0;\n            t.src = v;\n            s = b.getElementsByTagName(e)[0];\n            s.parentNode.insertBefore(t, s)\n        }(window, document, \'script\',\n            \'https://connect.facebook.net/en_US/fbevents.js\');\n        fbq(\'init\', \'2402960026691308\');\n        fbq(\'track\', \'PageView\');\n    </script>\n    <noscript>\n        <img height="1" width="1" style="display:none"\n            src="https://www.facebook.com/tr?id=2402960026691308&ev=PageView&noscript=1" />\n    </noscript>\n    <!-- End Facebook Pixel Code -->\n\n\n    <link rel="stylesheet" href="https://unpkg.com/ng-table@2.0.2/bundles/ng-table.min.css" />\n    <link rel="icon" href="assets/images/fav.png" />\n    <!-- build:css assets/css/vendor.css -->\n    <!-- bower:css  -->\n    <link rel="stylesheet" href="bower_components/photoswipe/dist/photoswipe.css" />\n    <link rel="stylesheet" href="bower_components/photoswipe/dist/default-skin/default-skin.css" />\n    <link rel="stylesheet" href="bower_components/angular-loading-bar/build/loading-bar.css" />\n    <link rel="stylesheet" href="bower_components/angucomplete-alt/angucomplete-alt.css" />\n    <link rel="stylesheet" href="bower_components/slick-carousel/slick/slick.css" />\n    <link rel="stylesheet" href="bower_components/intl-tel-input/build/css/intlTelInput.css" />\n    <!-- endinject -->\n    <!-- endbuild -->\n    <!-- build:css assets/css/main.css -->\n    <link rel="stylesheet" href="assets/css/style.css" />\n    <link rel="stylesheet" href="assets/css/responsive.css" />\n    <!-- endbuild -->\n</head>\n\n<body ng-class="{loginOpened:$root.loginPanelActive,isMobile:$root.isMobile(),sideMenuActive:$root.mobileMenuOpen}"\n    theme="{{ $root.theme }}">\n    <div ng-class="{\'d-none\':$root.noContent}" class="mainDiv" id="scrollingArea">\n        <div ui-view="topBar" class="toolbar"></div>\n        <div ui-view="content" class="mainView" ng-show="!$root.loginPanelActive"></div>\n        <footer ui-view="footer" class="footerView" ng-show="!$root.loginPanelActive"></footer>\n    </div>\n    <!-- build:js app/vendor.js -->\n    <!-- bower:js -->\n    <!-- <script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.3.1/jquery.min.js"></script> -->\n    <script src="bower_components/jquery/dist/jquery.min.js"></script>\n    <script src="bower_components/signalr/jquery.signalR.js"></script>\n    <script src="bower_components/angular/angular.js"></script>\n    <script src="bower_components/angular-route/angular-route.js"></script>\n    <script src="bower_components/angular-ui-router/release/angular-ui-router.min.js"></script>\n    <script src="bower_components/angular-ui-router/release/stateEvents.min.js"></script>\n    <script src="bower_components/angular-aria/angular-aria.js"></script>\n    <script src="bower_components/angular-resource/angular-resource.min.js"></script>\n    <script src="bower_components/angular-local-storage/dist/angular-local-storage.min.js"></script>\n    <script src="bower_components/ngstorage/ngStorage.js"></script>\n    <script src="bower_components/angular-cookies/angular-cookies.js"></script>\n    <script src="bower_components/angular-cache-buster/angular-cache-buster.js"></script>\n    <script src="bower_components/messageformat/messageformat.js"></script>\n    <script src="bower_components/angular-loading-bar/build/loading-bar.js"></script>\n    <script src="bower_components/angular-translate/angular-translate.js"></script>\n    <script src="bower_components/angular-translate-interpolation-messageformat/angular-translate-interpolation-messageformat.js"></script>\n    <script src="bower_components/angular-translate-loader-partial/angular-translate-loader-partial.js"></script>\n    <script src="bower_components/angular-translate-storage-cookie/angular-translate-storage-cookie.js"></script>\n    <script src="bower_components/ng-file-upload/ng-file-upload.js"></script>\n    <script src="bower_components/angular-lazy-img/release/angular-lazy-img.js"></script>\n    <script src="bower_components/angular-touch/angular-touch.js"></script>\n    <script src="bower_components/angucomplete-alt/dist/angucomplete-alt.min.js"></script>\n    <script src="bower_components/angular-socialshare/dist/angular-socialshare.js"></script>\n    <script src="bower_components/slick-carousel/slick/slick.min.js"></script>\n    <script src="bower_components/moment/min/moment.min.js"></script>\n    <script src="bower_components/moment/min/locales.min.js"></script>\n    <script src="bower_components/humanize-duration/humanize-duration.js"></script>\n    <script src="bower_components/angular-timer/dist/angular-timer.min.js"></script>\n    <script src="bower_components/ngmap/build/scripts/ng-map.min.js"></script>\n    <script src="bower_components/photoswipe/dist/photoswipe.min.js"></script>\n    <script src="bower_components/photoswipe/dist/photoswipe-ui-default.min.js"></script>\n    <script src="https://ajax.googleapis.com/ajax/libs/angularjs/1.4.8/angular.min.js"></script>\n    <script src="bower_components/intl-tel-input/build/js/intlTelInput.min.js"></script>\n    <script src="bower_components/intl-tel-input/build/js/utils.js"></script>\n    <script src="bower_components/ng-intl-tel-input/ng-intl-tel-input.module.js"></script>\n    <script src="bower_components/ng-intl-tel-input/ng-intl-tel-input.provider.js"></script>\n    <script src="bower_components/ng-intl-tel-input/ng-intl-tel-input.directive.js"></script>\n    <script src="bower_components/angular-signalr-hub/signalr-hub.min.js"></script>\n    <script src="assets/scripts/html2canvas.js"></script>\n    <script src="assets/scripts/angular-seo-master/angular-seo.js"></script>\n    <script src="bower_components/aws-sdk/dist/aws-sdk.js"></script>\n    <!-- endinject -->\n    <!-- endbuild -->\n    <script src="https://unpkg.com/ng-table@2.0.2/bundles/ng-table.min.js"></script>\n    <script src="https://maps.google.com/maps/api/js?key=AIzaSyDAVYpNj9N1RF2rmxGdGjiJZuaQsRwZp78"></script>\n    <!-- build:js app/app.js  -->\n    <!-- inject:js -->\n    <script src="app.js"></script>\n    <script src="app.constants.js"></script>\n    <script src="app.state.js"></script>\n    <script src="components/search/search.controller.js"></script>\n    <script src="components/search/search.state.js"></script>\n    <script src="components/home/home.controller.js"></script>\n    <script src="components/home/home.state.js"></script>\n    <script src="components/home/home.service.js"></script>\n    <script src="components/users/users.controller.js"></script>\n    <script src="components/users/verify.controller.js"></script>\n    <script src="components/users/profile.controller.js"></script>\n    <script src="components/users/account.controller.js"></script>\n    <script src="components/users/boughtTickets.controller.js"></script>\n    <script src="components/users/soldTickets.controller.js"></script>\n    <script src="components/users/users.state.js"></script>\n    <script src="components/users/userInfo.service.js"></script>\n    <script src="components/users/users.service.js"></script>\n    <script src="components/users/thanks.controller.js"></script>\n    <script src="components/users/thanks.service.js"></script>\n    <script src="components/users/balanceSheet.controller.js"></script>\n    <script src="components/users/balanceSheet.service.js"></script>\n    <script src="components/users/404.controller.js"></script>\n    <script src="components/events/event.controller.js"></script>\n    <script src="components/events/events.state.js"></script>\n    <script src="components/events/events.service.js"></script>\n    <script src="components/performers/performer.controller.js"></script>\n    <script src="components/performers/performers.state.js"></script>\n    <script src="components/performers/performer.service.js"></script>\n    <script src="components/performances/performance.controller.js"></script>\n    <script src="components/performances/performances.state.js"></script>\n    <script src="components/performances/performences.service.js"></script>\n    <script src="components/performances/performers.service.js"></script>\n    <script src="components/performances/tickets.service.js"></script>\n    <script src="components/venues/venue.controller.js"></script>\n    <script src="components/venues/venues.state.js"></script>\n    <script src="components/venues/venues.service.js"></script>\n    <script src="components/utils/filters.service.js"></script>\n    <script src="components/utils/fields.service.js"></script>\n    <script src="components/tickets/tickets.controller.js"></script>\n    <script src="components/tickets/tickets.state.js"></script>\n    <script src="components/requests/requests.controller.js"></script>\n    <script src="components/requests/requests.state.js"></script>\n    <script src="components/payments/payment.controller.js"></script>\n    <script src="components/payments/paymentDetails.controller.js"></script>\n    <script src="components/payments/paymentSuccess.controller.js"></script>\n    <script src="components/payments/paymentSuccessPopup.controller.js"></script>\n    <script src="components/payments/paymentFailedPopup.controller.js"></script>\n    <script src="components/payments/paymentResult.controller.js"></script>\n    <script src="components/payments/payments.state.js"></script>\n    <script src="components/payments/payment.service.js"></script>\n    <script src="components/payments/sell.controller.js"></script>\n    <script src="components/categories/category.controller.js"></script>\n    <script src="components/categories/categories.controller.js"></script>\n    <script src="components/categories/categories.state.js"></script>\n    <script src="components/categories/categories.service.js"></script>\n    <script src="components/categories/category.service.js"></script>\n    <script src="components/categories/subcategory.service.js"></script>\n    <script src="components/utils/utils.module.js"></script>\n    <script src="components/utils/upload.directive.js"></script>\n    <script src="components/utils/popup.directive.js"></script>\n    <script src="components/utils/file.directive.js"></script>\n    <script src="components/utils/infiniteScroll.directive.js"></script>\n    <script src="components/utils/scroll.directive.js"></script>\n    <script src="components/utils/inputs.directive.js"></script>\n    <script src="components/utils/fieldEditable.directive.js"></script>\n    <script src="services/files.service.js"></script>\n    <script src="services/utilities.service.js"></script>\n    <script src="services/auth/eltazkara.auth.js"></script>\n    <script src="services/auth/account.service.js"></script>\n    <script src="services/auth/activate.service.js"></script>\n    <script src="services/auth/auth.jwt.service.js"></script>\n    <script src="services/auth/auth.service.js"></script>\n    <script src="services/auth/principal.service.js"></script>\n    <script src="services/auth/searchData.service.js"></script>\n    <script src="services/user/user.service.js"></script>\n    <script src="layouts/topBar/topBar.module.js"></script>\n    <script src="layouts/topBar/topBar.controller.js"></script>\n    <script src="layouts/footer/footer.module.js"></script>\n    <script src="layouts/footer/footer.controller.js"></script>\n    <script src="social/eltazkara.social.js"></script>\n    <script src="social/facebook.directive.js"></script>\n    <script src="social/facebook.service.js"></script>\n    <script src="social/social.state.js"></script>\n    <script src="social/social-login.controller.js"></script>\n    <script src="social/google.service.js"></script>\n    <script src="blocks/interceptor/eltazkara.interceptor.js"></script>\n    <script src="blocks/config/eltazkara.config.js"></script>\n    <script src="blocks/handlers/eltazkara.handler.js"></script>\n    <script src="blocks/config/http.config.js"></script>\n    <script src="blocks/config/localstorage.config.js"></script>\n    <script src="blocks/config/compile.config.js"></script>\n    <script src="blocks/handlers/state.handler.js"></script>\n    <script src="blocks/interceptor/auth-expired.interceptor.js"></script>\n    <script src="blocks/interceptor/auth.interceptor.js"></script>\n    <script src="blocks/interceptor/errorhandler.interceptor.js"></script>\n    <script src="factories/hub.factory.js"></script>\n    <script src="static/static.state.js"></script>\n    <!-- endinject -->\n    <!-- endbuild -->\n</body>\n\n</html>');
$templateCache.put('app/social/social-login.html','<div class="centerDiv">\n  <div class="homeCarousel">\n    <div class="homeCarouselTitle">\n      <h1>Please login</h1>\n      <span>You have to be a Tapdeal user!</span>\n    </div>\n  </div>\n  <div class="thanks">\n    <svg viewbox="0 0 24 24">\n      <path d="M12,17A2,2 0 0,0 14,15C14,13.89 13.1,13 12,13A2,2 0 0,0 10,15A2,2 0 0,0 12,17M18,8A2,2 0 0,1 20,10V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V10C4,8.89 4.9,8 6,8H7V6A5,5 0 0,1 12,1A5,5 0 0,1 17,6V8H18M12,3A3,3 0 0,0 9,6V8H15V6A3,3 0 0,0 12,3Z"/>\n    </svg>\n    <p>Please login to proceed adding your item!</p>\n\n    <md-button class="md-raised formButton facebook leftIcon" data-facebook="825968940862033" ng-click="fetch()">\n      <svg viewbox="0 0 24 24">\n        <path d="M17,2V2H17V6H15C14.31,6 14,6.81 14,7.5V10H14L17,10V14H14V22H10V14H7V10H10V6A4,4 0 0,1 14,2H17Z"/>\n      </svg>\n      Login With Facebook\n    </md-button>\n    <br/>\n    <md-button class="md-raised formButton google leftIcon" ng-click="vm.googleLogin()">\n      <svg viewbox="0 0 53 53">\n        <path d="M19.6671,25.7867c-0.0075,1.7935,0,3.5869,0.0076,5.3803c3.0067,0.098,6.0208,0.0527,9.0275,0.098   c-1.3262,6.6689-10.3989,8.8315-15.199,4.4761C8.5674,31.9206,8.801,23.5412,13.9327,19.992   c3.5869-2.8635,8.6884-2.1552,12.2752,0.324c1.4092-1.3036,2.7278-2.6977,4.0013-4.1445   c-2.984-2.3812-6.6462-4.0767-10.5421-3.8958c-8.1307-0.2713-15.6059,6.8497-15.7415,14.9805   c-0.52,6.6462,3.8506,13.1644,10.0222,15.5155c6.1489,2.3661,14.031,0.7535,17.957-4.77c2.5922-3.4889,3.1498-7.98,2.8484-12.1999   C29.7194,25.7641,24.6933,25.7716,19.6671,25.7867z"/>\n        <path xmlns="http://www.w3.org/2000/svg" d="M49.0704,25.7641c-0.0151-1.4996-0.0226-3.0067-0.0301-4.5062c-1.4996,0-2.9916,0-4.4836,0   c-0.0151,1.4996-0.0301,2.9991-0.0377,4.5062c-1.5071,0.0075-3.0067,0.0151-4.5062,0.0302c0,1.4995,0,2.9915,0,4.4836   c1.4995,0.0151,3.0066,0.0302,4.5062,0.0452c0.0151,1.4996,0.0151,2.9991,0.0302,4.4987c1.4996,0,2.9916,0,4.4911,0   c0.0075-1.4996,0.015-2.9991,0.0301-4.5062c1.5071-0.0151,3.0067-0.0226,4.5062-0.0377c0-1.4921,0-2.9916,0-4.4836   C52.0771,25.7792,50.57,25.7792,49.0704,25.7641z"/>\n      </svg>\n      Login With Google\n    </md-button>\n\n    <div class="formControls">\n      <md-button class="md-raised formButton dark leftIcon" ng-click="doTheBack();">\n        <svg viewbox="0 0 24 24">\n          <path d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z"/>\n        </svg>\n        Back\n      </md-button>\n    </div>\n  </div>\n</div>');
$templateCache.put('app/static/about.html','<div style="padding: 20px">\n    <h1><strong>About Tixawy</strong></h1>\n\n    <p>*Tixawy is your most secure platform for ticket trading; we aim to create the easiest more safe experience in\n        purchase &amp; sale process from fan to fan.<br />Our dedicated team always makes sure our fans get the best\n        service through customer support also take the time to verify each ticket and monitor any suspicious user\n        activity</p>\n    <p>&nbsp;</p>\n\n    <h2><strong>About TIXAWY Fees</strong></h2>\n\n    <p>We work hard to make purchases via TIXAWY safe, simple and secure. We offer our customers a convenient,\n        hassle-free way of buying tickets that may be unavailable elsewhere by connecting them with sellers.</p>\n\n    <p>While a transaction may look and feel simple (we work hard to make it so), purchases on a marketplace like TIXAWY\n        are actually quite complicated. Unlike a typical retail transaction, there are three parties involved here: the\n        buyer, the seller, and us in the middle making sure the whole thing goes off without a hitch.</p>\n\n    <p>Our order fee which is 10% on the selling price covers all the things going on in the background; we operate a\n        cutting-edge website and, on the people front, have a dedicated Egypt-based call center in Cairo and a sizeable\n        team here in our Cairo HQ dealing with sellers on your behalf. Of course, as with any online transaction the\n        credit card companies also want their cut! The vast majority of our customers have no need to call on that, but\n        for the rare few that do, you can book confidently knowing that you&rsquo;ll never be out of pocket if your\n        tickets don&rsquo;t come through, we cover that.</p>\n\n    <p>We are able to do all of the above and keep our fees competitive. A growing customer base suggests buyers see the\n        value in the service that we provide and choose to come back and book with us again.</p>\n    <p>&nbsp;</p>\n    <p>&nbsp;</p>\n</div>');
$templateCache.put('app/static/buyerAgreement.html','<div style="padding: 20px">\n    <h1 style="text-align: center;"><strong>Tixawy Buyer Agreement</strong></h1>\n    <p>&nbsp;</p>\n\n    <h3> <strong><span>Our\n                100% Buyer Guarantee is designed to give you full peace-of-mind, safety, and security.</span></strong>\n    </h3>\n    \n    <h3> <strong><span>You\n                will receive full-service customer care</span></strong></h3>\n    <p> <span>At Tixawy we believe that\n            our customers deserve more than just the tickets you order. We know your ticket purchase is important, and\n            we believe you deserve dedicated, helpful assistance from start-to-finish. That is why we are proud to be a\n            Full Service provider.</span></p>\n    <p> <span>We never pass along your\n            information, and we\'re always here to help you with your order. You have our full dedication to provide you\n            the industry\'s best service and protection so that you can focus on enjoying your event rather than shopping\n            or worrying about your tickets!</span></p>\n\n    <h3> <strong><span>Your\n                transaction will be safe and secure</span></strong></h3>\n    <p> <span>We fully believe our\n            customers\' private and personal information should remain that way. We use best-in-class industry standards\n            on privacy and security to ensure your transactions are 100% safe and secure. In particular, we do NOT share\n            your credit card information to whichever broker or other individual happens to be selling the tickets.\n            Instead, we work on your behalf to procure your tickets, make payments to sellers, and handle any problems\n            so you can have full peace of mind when placing your order.&nbsp;</span></p>\n\n\n    <h3> <strong><span>Your\n                tickets will be delivered before the event</span></strong></h3>\n    <p> <span>We recognize that many of\n            our customers purchase tickets at the last minute, or perhaps just as the event is announced. In all cases,\n            delivering tickets to you requires skillful coordination and communication. To lay any such logistics\n            concerns to rest, we guarantee that we will deliver your tickets to you in time for the event, or your money\n            back. We always prefer to send tickets via secured couriers.</span></p>\n\n\n    <h3> <strong><span>Your\n                tickets will be valid and authentic</span></strong></h3>\n    <p> <span>From our inception and as\n            part of our mission, we have been dedicated to taking the fear out of buying tickets online. Tixawy has\n            among the strongest relationships with licensed, certified, and professional ticket resellers in Egypt. All\n            sellers are rigorously evaluated according to their business practices and track record, and we guarantee\n            your tickets to be valid and authentic, or your money back.</span></p>\n\n    <h3> <strong><span>Your\n                order will be accurate</span></strong></h3>\n    <p> <span>We work in tight\n            collaboration with our ticket resellers for your order, and we guarantee that the tickets you receive are\n            identical, comparable or better than the ones you ordered.</span></p>\n    <h3> <strong><span>You\n                will be fully refunded for a canceled event</span></strong></h3>\n    <p> <span>If an event is canceled\n            with no rescheduled date, you are naturally entitled to a full refund of the purchase price, excluding\n            delivery charges. For events that are rescheduled, we will assist you with any ticket reissuing concerns or\n            help you sell your tickets if the new date is no longer desirable to you.</span></p>\n</div>');
$templateCache.put('app/static/cookies.html','<div style="padding: 20px">\n  <h1 style="text-align: center;"><strong>Cookies and other technologies</strong></h1>\n  <p>When you use our sites (including mobile sites or mobile apps), we and third party organizations may collect\n    information by using \'cookies\' and other technologies (for simplicity we refer to all such technologies as\n    &lsquo;cookies&rsquo;). For a list of the companies which use cookies and how they use them please access our Cookie\n    Consent Tool. This is always available at the bottom corner of our sites. By continuing to use this site, when you\n    create an account or when you buy/sell tickets, you agree to us and third party organizations using cookies in line\n    with your cookie settings. You can use the Cookie Consent Tool to change your preferences at any time. For\n    information about how your personal information is used please see our Privacy Policy.</p>\n  <p>&nbsp;</p>\n\n  <h2><strong>What are cookies and how do they work?</strong></p>\n  <p>Cookies are small bits of text that are downloaded to your computer or other device when you visit a website. Your\n    browser sends these cookies back to the website every time you visit the site again, so it can recognize you and can\n    then tailor what you see on the screen.</p>\n  <p>&nbsp;</p>\n\n  <h2><strong>What do we use cookies for?</strong></p>\n  <p>Our Cookie Consent Tool tells you which companies use which type of cookies. We have summarized the cookie types\n    into the following three categories:</p>\n\n  <p><strong>- To provide you with the service you have asked for</strong></p>\n  <p>For example keeping you logged in during your visit. Without cookies the site might forget you and you\'d have to\n    constantly log back in. When you buy tickets, cookies make sure they\'re still in your shopping basket when you get\n    to the checkout.</p>\n\n  <p><strong>- To show adverts that are more relevant to your interests</strong></p>\n  <p>For example we and third party organizations may use cookies to restrict the number of times you see the same\n    advert or to show other adverts that may be more relevant to you - often called online behavioral advertising (OBA).\n    OBA is a way of using information about your web-browsing activity, collected by using cookies, to group you with\n    other users into interest groups and show you advertisements based on those interests.</p>\n\n  <p><strong>- To analyze and improve your browsing experience</strong></p>\n  <p>For example, for analysis purposes, we like to know what pages and links are popular and which ones don\'t get used\n    so much to help us keep our sites relevant and up to date. We also use them to customize your visits to the site,\n    for example to remember choices you make such as your language or region.</p>\n  <p>&nbsp;</p>\n\n  <h2><strong>Using browser settings to manage cookies</strong></h2>\n  <p>In addition to our Cookie Consent Tool, most browsers will enable you to manage your cookies preferences e.g. have\n    the browser notify you when you receive a new cookie or use it to disable cookies altogether. If you do decide to\n    disable or delete them altogether some sites won&rsquo;t work as well as they rely on cookies to provide you with\n    the service you have requested.</p>\n</div>');
$templateCache.put('app/static/privacy.html','<div style="padding: 20px">\n  <h1 style="text-align: center;"><strong>TIXAWY Privacy Policy</strong></h1>\n\n  <p>As a leader in our industry, TIXAWY realizes that earning and retaining your trust is of paramount importance and\n    it\'s a responsibility we take very seriously.</p>\n  <p>This Privacy Policy sets forth our policies regarding the collection, use and protection of the personal\n    information of those using TIXAWY. Personal information (or &ldquo;personal data&rdquo; as defined in the Data\n    Protection Act 1998) means any information that can identify a specific individual, such as name and, address,\n    telephone number, e-mail address or credit card number.</p>\n  <p>We encourage you to review our Privacy Policy below. You should know that your personal information will never be\n    shared with third parties except with your agreement.</p>\n  <p><strong>This Privacy Policy explains the following:</strong></p>\n\n  <p><strong>What personal information does TIXAWY gather from me and how is this information used?</strong></p>\n  <p>When browsing our site, you are not required to provide any personal information unless and until you choose to\n    make a purchase or sign up for one of our e-mail newsletters or other services as described below.</p>\n  <p>&nbsp;</p>\n\n  <h2><strong>Making a Purchase</strong></h2>\n  <p>In order to purchase tickets and related services through our site, you must provide us with certain personal\n    information such as your name, your credit card number and expiration date, your credit card billing address, your\n    telephone number and your e-mail address. If you are buying tickets for one or more people other than yourself, you\n    will need to make sure that each of these other travelers / clients agrees, in advance, that you may disclose their\n    personal information to us.</p>\n  <p>&nbsp;</p>\n\n  <h2><strong>Client Registration</strong></h2>\n  <p>In order to purchase tickets, you must provide us with your personal details for several reason including: (i)\n    personal identification; (ii) to allow us to contact you for customer service purposes, when necessary; (iii) to\n    customize the content of our site to meet your specific needs; and (iv) to make product improvements to our site. In\n    addition, we need your e-mail address to confirm your booking of each ticket or other product you transact on our\n    site. As a TIXAWY client, you will also occasionally receive updates from us about ticket sales in your area,\n    special offers, new company services, and other noteworthy items. However, you may choose at any time to no longer\n    receive these types of e-mail messages.</p>\n  <p>&nbsp;</p>\n\n  <h2><strong>Client Profile</strong></h2>\n  <p>As a TIXAWY client, you can choose to complete your online profile by providing us with event preferences,\n    credit-card billing information, delivery address, and other personal information. This information is primarily\n    used to assist you in purchasing tickets quickly without having to type in the same information repeatedly.</p>\n  <p>&nbsp;</p>\n\n  <h2><strong>How We Use Personal Information</strong></h2>\n  <p>Your personal information is used by us to contact you by post, phone or by email when necessary in connection with\n    transactions entered by you on the Site. From time to time, TIXAWY may contact you by post or by email, with\n    information or offers regarding upcoming events, products, services or customer surveys. If you do not wish to be\n    contacted by TIXAWY about upcoming events, products, services or surveys please contact us by emailing to\n    unsubscribe@tixawy.com</p>\n  <p>TIXAWY may from time to time, share your personal information with its affiliated companies. From time to time,\n    Affiliated companies may contact you by post or by email with information or offers regarding upcoming events,\n    products, services or customer surveys.</p>\n  <p>&nbsp;</p>\n\n  <h2><strong>Promotions &amp; Sweepstakes</strong></h2>\n  <p>TIXAWY frequently sponsors promotions and sweepstakes to give clients the opportunity to win tickets and related\n    prizes. Information collected by us for such activities can include contact information and survey questions. We use\n    contact information to notify contest winners and survey information to develop promotions and product improvements\n    to the TIXAWY website.</p>\n  <p>&nbsp;</p>\n\n  <h2><strong>Automatic Logging of Session Data</strong></h2>\n  <p>We automatically log generic information about your computer\'s connection to the Internet, which we call "session\n    data", that is anonymous and not linked to any personal information. Session data consists of things such as IP\n    address, operating system and type of browser software being used and the activities conducted by the user while on\n    our site. An IP address is a number that lets computers attached to the Internet, such as our web servers, know\n    where to send data back to the user, such as the pages of the site the user wishes to view. We collect session data\n    because it helps us analyze such things as what items visitors are likely to click on most, the way visitors are\n    clicking through the site, how many visitors are surfing to various pages on the site, how long visitors to the site\n    are staying and how often they are visiting. It also helps us diagnose problems with our servers and lets us better\n    administer our systems. Although such information does not identify any visitor personally, it is possible to\n    determine from an IP address a visitor\'s Internet Service Provider (ISP) and the approximate geographic location of\n    his or her point of connectivity.</p>\n  <p>&nbsp;</p>\n\n  <h2><strong>Cookies</strong></h2>\n  <p>Cookies are small pieces of information that are stored by your browser on your computer\'s hard drive. There are\n    many myths circulating about cookies, but you should know that cookies are only read by the server that placed them,\n    and are unable to do such things as run programs on your computer, plant viruses or harvest your personal\n    information. The use of cookies is very common on the internet and TIXAWY\'s use of cookies is similar to that of\n    such sites as Ebay, Yahoo!, BBC.com and other reputable online companies. First and foremost, you can rest assured\n    that no personally identifiable information ("PII") about you (e.g., name, address, etc.) is gathered or stored in\n    the cookies placed by the TIXAWY web site and, as a result, none can be passed on to any third parties.</p>\n  <p>Our Site uses cookies to keep track of what you have purchased. We use cookies to deliver content specific to your\n    interests, to save your password (if you have supplied us with one) so you do not have to re-enter it each time you\n    visit our Site, and for other purposes, such as informing you that you may have made multiple bookings for specific\n    events on our Site.</p>\n  <p>&nbsp;</p>\n  <p>&nbsp;</p>\n  <h2><strong>Other</strong></h2>\n  <p>From time to time we may add or enhance services available on the site. To the extent these services are provided\n    and used by you, we will use the information you provide to facilitate the service requested. For example, if you\n    email us with a question, we will use your email address, name, nature of the question, etc. to respond to your\n    question. We may also store such information to assist us in making the site the better and easier to use.</p>\n\n  <p><strong>How can I opt-out of receiving your promotional emails?</strong></p>\n  <p>At any time, you can unsubscribe from our TIXAWY newsletter or similar services through the provided link,\n    accessible through the newsletter or by emailing unsubscribe@tixawy.com</p>\n  <p>You only receive e-mail updates from us about ticket sales in your area, special offers, new services, and other\n    noteworthy items. We hope you will find these updates interesting and informative. Of course, if you would rather\n    not receive them, please click on the "unsubscribe" link or follow the instructions in each e-mail message. TIXAWY\n    reserves the right to limit membership to those who will accept e-mails. Clients will be notified via e-mail prior\n    to any actions taken.</p>\n\n  <p><strong>What safeguards are in place to protect the loss, misuse or alteration of my personal information?</strong></p>\n  <p>All personal information you provide to TIXAWY is transmitted using SSL (Secure Socket Layer) encryption. SSL is a\n    proven coding system that lets your browser automatically encrypt, or scramble, data before you send it to us.</p>\n\n  <p><strong>What other information should I know about my privacy?</strong></p>\n  <p>If you are a buyer, TIXAWY will disclose your name, contact number and address details to the courier company for\n    order fulfilment purposes only.</p>\n  <p>We use a credit card processing company to bill you for goods and services. We will disclose your name, billing\n    address and credit card information to these credit card companies. But these companies do not retain, share, store\n    or use personally identifiable information for any other purposes other than the billing for good and services.\n    Additionally your contact details may be used by the courier as part of their address label to facilitate delivery\n    and enable them to contact you directly in the event of any delivery issues.</p>\n  <p>In addition to the circumstances described above, TIXAWY may disclose client information if required to do so by\n    law, court order, as requested by other government or law enforcement authority, or in the good faith belief that\n    disclosure is otherwise necessary or advisable including, without limitation, to protect the rights or properties of\n    TIXAWY or its affiliated companies or when we have reason to believe that disclosing the information is necessary to\n    identify, contact or bring legal action against someone who may be causing interference with our rights or\n    properties, whether intentionally or otherwise, or when anyone else could be harmed by such activities.</p>\n  <p>This policy is effective as of the publication date set out at the bottom of this page. Any material changes in the\n    way TIXAWY uses personal information will be described in future versions of this Privacy Statement. Of course, you\n    may always submit concerns regarding our Privacy Statement or our privacy practices via email. TIXAWY will attempt\n    to respond to all reasonable concerns or inquiries within five business days of receipt.</p>\n  <p>In the event that TIXAWY is sold, or some of their respective assets are transferred to another party, your\n    personal information could be one of the transferred assets. If your personal information is transferred, use of\n    your personal information will remain subject to this Privacy Policy. Your personal information will be passed on to\n    a successor in interest in the event of a liquidation or administration of TIXAWY (as applicable).</p>\n  <p>This policy is effective as of January 01, 2018. Any material changes in the way TIXAWY uses personal information\n    will be described in future versions of this Privacy Statement. Of course, you may always submit concerns regarding\n    our Privacy Statement or our privacy practices via email, please contact us at <a\n      href="mailto:info@tixawy.com">info@tixawy.com</a></p>\n</div>');
$templateCache.put('app/static/sellerAgreement.html','<div style="padding: 20px">\n    <h1 style="text-align: center;"><strong>Tixawy Seller Agreement</strong></h1>\n    <h3>1 - Introduction</h3>\n    <p>A) Introduction. This document sets out the terms and\n        conditions (the &ldquo;Agreement&rdquo;) under which TIXAWY LLC (hereinafter referred as "TIXAWY",\n        &ldquo;Us&rdquo; or "We" where applicable) grants ticket sellers ("you", "You", &ldquo;Your&rdquo; or\n        "Selling Member") a license to list and offer tickets for sale on the TIXAWY Website at www.tixawy.com\n        (the "Website") to third party buyers ("Buyer" or "Buyers"). By using the Website and listing tickets\n        for sale on the Website you expressly agree to be bound by the following terms and\n        conditions.</p>\n    <p>We strongly recommend that you read and understand this\n        Agreement, and in any event by continuing to use our Website and sell tickets via our Website you will\n        be bound by the terms and conditions of this Agreement.</p>\n    <p>B) Modification. If we decide to amend, alter or\n        otherwise change the terms of the Agreement, we shall notify you by posting a revised version of the\n        Agreement on the Website and emailing you at your registered email address. Such new agreement will\n        automatically take effect and replace the terms of this Agreement. Your continued use of the Website\n        will constitute your acceptance of the revised Agreement. If you do not agree with the terms of this\n        Agreement or any revised version of this Agreement, immediately remove any of your ticket listings from\n        the Website and do not continue to use the Website.</p>\n    <p>C) About Us. TIXAWY LLC is a limited liability company\n        registered in Egypt. We can be reached at 01007828451 or +202 27515016 (Int&rsquo;l). Alternatively you\n        can reach us https://www.tixawy.com/#/requests/Contact_Us. We are not a box office or event promoter.\n    </p>\n    <p>&nbsp;</p>\n    <h3>2 - BECOMING A SELLING MEMBER</h3>\n    <p>A) Requirements. To be entitled to sell tickets or ticket packages via the\n        Website and therefore become a Selling Member of TIXAWY you must agree to accept the terms and\n        conditions of this Agreement and must have a valid credit or debit card that we approve and accept. It\n        is in TIXAWY\'s absolute discretion to decide if you qualify (or continue to be qualified) as a Selling\n        Member.</p>\n    <p>B) User Name and Password. On becoming a Selling Member of TIXAWY you will be provided\n        with a user name and password to access your personal account on the Website and use the services\n        contained therein. You are solely responsible for maintaining the security of your username and password\n        and for all activity that occurs on your personal account under your username and password.\n    </p>\n    <p>C) Reachable. The Selling Member agrees to be reachable by telephone\n        during normal business hours. It is Selling Member\'s duty to respond to all enquiries from TIXAWY in\n        relation to ticket or ticket packages the Selling Member has listed for sale on the Website by telephone\n        and/or email in a prompt and timely manner. Selling Member recognizes that in order to facilitate an\n        efficient marketplace for live event tickets, certain enquiries and disputes need to be resolved\n        quickly, particularly in the cases of upcoming events. Selling Member therefore agrees to respond to all\n        enquiries specifically related to orders placed for tickets it has listed for sale on the Website from\n        TIXAWY within 24 hours or by the specified deadline provided in writing via email or post. Failure to do\n        so may result in a default credit/refund at the expense of the Selling Member. The Selling Member shall\n        handle the management of their account in a reasonable and cooperative manner. If any abusive or\n        threatening behavior is reported, TIXAWY reserves the right to terminate its business relationship with\n        the Selling Member with immediate effect and without notice to the Selling Member.</p>\n    <p>D) Business Sellers. If you are selling tickets as a business you are required\n        to declare this under the &lsquo;my account&rsquo; tab. You will need to tick the &lsquo;business\n        seller&rsquo; box and provide accurate business name and contact details. </p>\n    <p>&nbsp;</p>\n    <h3>3 - LISTING PROCESS</h3>\n    <p>A) Listing Tickets as a Selling\n        Member. Approved Selling\n        Members of TIXAWY may list tickets for sale on the Website. As part of the listing process, the Selling\n        Member must assign a price to the tickets and provide information such as the event, date, section,, and\n        row. Further instructions and requirements on listing items can be found once logged in on the Website.\n        By placing a ticket for sale on the Website you are offering to sell that particular ticket to a Buyer\n        for the price assigned to it by you. </p>\n    <p>B) Marketplace. Please note that TIXAWY provides an\n        open market place through which tickets may be purchased or sold by our Buyers and Selling Members. We\n        do not take ownership of any tickets listed by You and We are therefore not party to any contracts that\n        arise when tickets are sold and purchased via the Website. Please also note that there is no guarantee\n        given by TIXAWY (or otherwise) that your tickets will sell and, in the event that they do not sell,\n        TIXAWY will not be responsible for their purchase.</p>\n    <p>C) Ticket Description. For each ticket YOU list for sale on the Website, you agree\n        to provide full and accurate details of the section and row which is printed on the tickets for sale.\n        For Standing or General Admission tickets you agree to describe them as \'General Admission\'. You agree\n        to describe the tickets listed for sale on the Website in the most honest and non-misleading\n        manner.</p>\n    <p>In the event you cannot locate the correct section under\n        which to list your tickets you agree to contact TIXAWY for resolution before listing your tickets for\n        sale. If a listing is deemed to be misleading then you agree that any associated orders may be declared\n        void, and you will be liable for any charges incurred due to refunded or replacement tickets.\n    </p>\n    <p>D) Seating Arrangements. All tickets listed in a single\n        listing must be seated together.</p>\n    <p>E) Restricted View or other restrictions. You are\n        required to provide any additional information which is printed on the tickets related to restricted\n        view, family section, no alcohol permitted, concessions, etc.</p>\n    <p>F) Guaranteed Ticket Fulfilment. Once you offer to sell\n        a particular listing of tickets, you are contractually bound to supply that ticket to Tixawy. Ticket\n        listings are a legal representation of actual seat location and other details relevant to the tickets.\n    </p>\n    <p>G) Accurate Pricing. Ticket market prices are volatile\n        and can change on an hourly basis at times. With this in mind, the Selling Member accepts full\n        responsibility for maintaining current prices on the Website of its tickets. No matter what the price or\n        circumstances, the Selling Member agrees to fulfill the order at the price agreed at the time the Buyer\n        accepts the offer for sale. For this reason it is essential that you maintain up-to-date and accurate\n        prices at all times. It is Your responsibility to ensure that the details You provide in relation to\n        tickets that You list for sale on the Website are full and accurate. If You have listed prices of a\n        ticket incorrectly and it is, in our reasonable opinion, that the price you provided was an error then\n        we may try and resolve the issue with the applicable Buyer providing you notify us of the error within\n        48 hours of the sale confirmation email. However, you must take full responsibility for any errors you\n        make in listing tickets for sale as once a Buyer purchases tickets via the Website a legal contract is\n        made.</p>\n    <p>H) Taxes. You are responsible for including all taxes, including\n        Value Added Tax (VAT) and any other taxes required on your listings, in the prices you list on Our\n        Websites. If in doubt, please seek advice of a tax expert to determine which taxes you are required to\n        collect from Buyers.</p>\n    <p>I) Indemnity. It is the responsibility of the Selling\n        Member to provide full and accurate details of tickets it wishes to list for sale on the Website.\n        Failure to provide full and accurate details (including without limitation seat location details and the\n        price) may lead to TIXAWY or applicable Buyers suffering loss or damage and You agree to indemnify and\n        hold harmless TIXAWY and applicable Buyers from and against all losses, liabilities, damages, fines,\n        expenses and costs arising out of or in connection with Your failure to provide full and accurate\n        details of tickets that You list for sale on the Website. </p>\n    <p>&nbsp;</p>\n    <h3>4 - SELL PROCESS</h3>\n    <p>A) Confirmed Orders. When we receive an order from a Buyer for tickets that you\n        have listed we will inform you via email. A confirmation email will be sent to the Selling Member\'s\n        indicated email address.</p>\n    <p>B) Pending Orders. In certain cases, we may require additional fraud checks\n        with respect to an order and will inform you that an order is pending but undergoing fraud checks. In\n        such circumstances, We will subsequently inform you that the order has either been approved/confirmed or\n        cancelled. You cannot amend or remove a ticket listing, description, or price once the order has been\n        marked as &lsquo;pending&rsquo; until we inform you that the order is otherwise cancelled due to failing\n        fraud checks.</p>\n    <p>C) Cancellations. If an event for which you sell tickets via the Website is\n        cancelled and not re-scheduled then You agree to refund the amount paid by the applicable Buyer for\n        those tickets provided that the Buyer returns the original tickets to You (via Us) in good time for You\n        to obtain a full face value refund from the promoter or organizer of the applicable event. We will be\n        unable to make payment of any courier costs where an event is cancelled. If you are notified of any\n        changes to the event and/or tickets (including, without limitation, where alternative seats have been\n        provided instead of the original seats), you shall immediately notify TIXAWY of any such changes and\n        where applicable, provide full details of the alternative seats. TIXAWY will endeavor to then contact\n        your buyer to advise of the changes however we reserve the right to discount or cancel the order at our\n        discretion. We can&rsquo;t be held liable for courier costs incurred in the sending of replacement /\n        alternate tickets. Whilst we try to ensure the accuracy of orders, sometimes technical errors may occur.\n        In the event that a technical error has resulted in an incorrect order TIXAWY will notify you within 48\n        hours, and the order will be cancelled to allow you to relist your tickets.</p>\n    <p>In rare circumstances TIXAWY may be required to cancel\n        and refund a confirmed order if payment is recalled by the associated bank. Where possible we will\n        contact you to advise you of the cancellation and allow you the option to relist your tickets.\n    </p>\n    <p>&nbsp;</p>\n    <h3>5 - DELIVERY PROCESS</h3>\n    <p>A) Delivery. The Selling Member agrees to deliver the exact ticket as\n        advertised on the website. The Selling Member accepts ultimate responsibility for secure and timely\n        delivery of the tickets and agrees to ship via the specified delivery method and to insure the\n        delivery.</p>\n    <p>The Selling Member agrees to dispatch tickets with a\n        valid returns address displayed on the envelope (i.e. TIXAWY PO Box address).</p>\n    <p>The Selling Member agrees to deliver tickets to Tixawy\n        within 24 hours after listing on the website, or within 24 hours of those tickets becoming available,\n        not including weekends and holidays.</p>\n    <p>In the event that incorrect tickets are dispatched in\n        error, we must be informed within 48 hours of dispatch in order to attempt a resolution. We are unable\n        to deal with mistakes or errors notified to us after 48 hours of the date of dispatch.\n    </p>\n    <p>In the event that e-tickets are uploaded The Selling\n        Member agrees to be responsible for ensuring that the correct tickets are uploaded and valid for use.\n        The Selling Member takes full responsibility for any errors made in uploading tickets. If a ticket is\n        uploaded incorrectly and you subsequently fail to notify us or provide incorrect tickets to the Buyer\n        then we shall be entitled to charge you 150% of the value of the transaction made by that Buyer for Your\n        tickets.</p>\n    <p>B) Missed Pickup. The Selling Member agrees to cooperate with TIXAWY delivery\n        processes. If a pickup is scheduled and confirmed with the Selling Member, and the Selling Member is\n        unavailable at the scheduled time, resulting in a pickup cancellation or re-booking, the Selling Member\n        may be charged Missed Pickup fees. </p>\n    <p>&nbsp;</p>\n    <h3>6 - PAYMENT PROCESS</h3>\n    <p>A) Payment to Sellers. TIXAWY will make payment to\n        Selling Members once tickets have been received by Buyers AND the applicable event to which the tickets\n        relate has taken place. This is necessary to provide a safe and trusted marketplace. Successfully\n        fulfilled orders will be paid 7 to 10 working days after the event has taken place. In the event of\n        non-fulfilment or non-entry for the buyer payment may be held for up to one calendar month after the\n        event while our team investigates the dispute. </p>\n    <p>&nbsp;</p>\n    <h3>8 - WARRANTIES &amp; INDEMNITIES</h3>\n    <p>A) Warranties. The Selling Member warrants to and for\n        the benefit of TIXAWY, the following:-</p>\n    <p>(1) All tickets listed by the Selling Member\n        are:-</p>\n    <p>(i) Either "on-hand" or already ordered and 100%\n        guaranteed and available for immediate sale at the prices listed;</p>\n    <p>(ii) the property of the Selling Member or the Selling\n        Member is authorized to sell such ticket (by law, contract or otherwise) and no third party rights\n        (including any intellectual property rights) are infringed by the Selling Member in listing the ticket\n        for sale via TIXAWY;</p>\n    <p>(iii) Not stolen, counterfeit or in any way contain\n        fraudulent, inaccurate or misleading information;</p>\n    <p>(iv) not obtained through unauthorized framing of or\n        linking to any website, or unauthorized use of any robot, spider or other automated device or any other\n        illegal or unauthorized activity;</p>\n    <p>(v) Not offered for sale in breach of any terms and\n        conditions applicable to such ticket.</p>\n    <p>(2) In offering tickets for sale via TIXAWY it is complying with\n        all applicable laws, regulations and codes of practice including, but not limited to, consumer or other\n        legislation which regulates the activities of secondary ticket agents;</p>\n    <p>(3) All information the Selling Member provides to TIXAWY in\n        respect of itself (when applying to become a Selling Member or at any time thereafter) is true and\n        accurate in all respects.</p>\n    <p>B) Indemnities. The Selling Member undertakes as a continuing undertaking\n        to indemnify and keep TIXAWY fully indemnified against any liability, cost, loss, damage or expense\n        incurred or suffered by TIXAWY arising in respect of or as a consequence of a breach of any of the\n        obligations, warranties or representations it provides in this Agreement. </p>\n    <p>C) Liability. We shall in no circumstances be liable to\n        you for any indirect or consequential losses or any loss (whether direct or indirect) of profits,\n        revenue, business, savings, goodwill or reputation arising out of your use of the Website, including\n        without limitation from your sale of tickets or other goods or services. In respect of each transaction\n        you make via the Website, our liability to you whether in contract, tort or otherwise shall be limited\n        in aggregate to the total amount paid by you in relation to such transaction. </p>\n    <p>Nothing in this Agreement is intended nor shall it be\n        construed as an attempt by any party to exclude or limit its liability for any liability which cannot be\n        excluded or limited under applicable law, including without limitation its liability for death or\n        personal injury caused by its negligence or for its fraudulent misrepresentation. </p>\n    <p>&nbsp;</p>\n\n    <h3>9 - TERM AND TERMINATION</h3>\n    <p>A) Term. Subject to B), this Agreement shall commence\n        on the date [you first list tickets for sale on the Website] OR [ the date We activate your account on\n        the Website] and shall continue in force unless and until either party gives the other at least thirty\n        (30) days notice in writing to terminate this Agreement.</p>\n    <p>B) Termination. Either party may terminate this\n        Agreement immediately by giving written notice to the other if the other (i) commits a material or\n        persistent breach of its obligations under this Agreement and, in the case of a breach which is capable\n        or remedy, fails to remedy it after being given five (5) days written notice specifying the breach and\n        requiring it to be remedied; or (ii) is unable to pay its debts, becomes subject to an administration\n        order or makes any voluntary arrangement or composition with its creditors, or an encumbrancer takes\n        possession of or a receiver is appointed over the property or assets of the other party or the other\n        party is wound up or ceases or threatens to cease to carry on business except for the purposes of\n        reconstruction of the company or, in the case of an individual, is declared bankrupt.\n    </p>\n    <p>TIXAWY may terminate this Agreement immediately if, in\n        its reasonable opinion, the Selling Member is involved or likely to be involved in any illegal\n        activity.</p>\n    <p>TIXAWY shall be entitled to suspend any Selling Member\n        account for one calendar month or such longer term as determined by TIXAWY in its discretion, if the\n        Selling Member breaches any of the terms of these Seller Terms. Failure to fulfil includes supplying\n        tickets different to those originally advertised to the buyer without TIXAWY&rsquo;s prior approval. If\n        the Selling Member account is suspended three or more times in a calendar year, TIXAWY shall be entitled\n        to terminate this Agreement with immediate effect and without notice to the Selling\n        Member.</p>\n    <p>C) Consequences of termination. Termination or expiry\n        of this Agreement shall not affect the rights or liabilities of either party accrued prior to and\n        including the date of termination or expiry and/or any terms intended expressly or by implication to\n        survive termination or expiry. </p>\n    <p>&nbsp;</p>\n\n    <h3>10 - ADDITIONAL INFORMATION</h3>\n    <p>A) Privacy Policy. TIXAWY warrants that the Selling\n        Member data will be held by it in the strictest confidence and its use is subject to TIXAWY&rsquo;s\n        privacy policy available from time to time on the Website. Access to Selling Member\'s data will be\n        limited to TIXAWY personnel only. TIXAWY reserves the right to accumulate aggregate data trends and to\n        make such aggregate data available to Selling Members and strategic partners. We will not disclose your\n        details to any Buyer unless required to do so by any regulatory or governmental or other authority with\n        relevant powers to which either party is subject to or submits.</p>\n    <p>B) Intellectual Property Rights. The content and\n        software on the Website (including without limitation copyrights, trademarks, design rights, patents and\n        other intellectual property rights) is the property of TIXAWY and/or its suppliers and licensors and is\n        fully protected by Egypt and international worldwide intellectual property laws. You may not without our\n        permission reproduce, edit, publish or transmit any of the contents of this Website. All rights in the\n        trade mark and logo &ldquo;TIXAWY&rdquo; are expressly reserved to TIXAWY and all goodwill derived from\n        use of the &ldquo;TIXAWY&rdquo; trade mark or logo accrues to TIXAWY</p>\n    <p>C) No agency. The Selling Member and TIXAWY are\n        independent contractors, and no agency, partnership, joint venture, employer-employee or\n        franchisor-franchisee relationship is intended or created by this Agreement and neither shall have any\n        authority to bind the other in any way. </p>\n    <p>&nbsp;</p>\n\n    <h3>11 - MISCELLANEOUS.</h3>\n    <p>A) This Agreement (and all documents incorporated by\n        reference) constitutes the entire agreement between the parties pertaining to the subject matter hereof\n        and supersedes all prior agreements and understandings between the parties hereto with respect to the\n        subject matter hereof, whether written or oral. No amendment, modification or supplement of any\n        provision of this Agreement will be valid or effective unless made in accordance with the express terms\n        of this Agreement. If any provision of this Agreement is held to be invalid or unenforceable under any\n        circumstances, its application in any other circumstances and the remaining provisions of this Agreement\n        shall not be affected.</p>\n    <p>B) No failure or delay by TIXAWY in exercising any of\n        its rights under this Agreement should be deemed to be a waiver thereof and no waiver of a breach of a\n        provision of this Agreement shall be deemed to be a waiver of any subsequent breach.</p>\n    <p>C) You may not assign or transfer this Agreement, or\n        any of its rights or obligations, without the prior written consent of TIXAWY, which we can refuse in\n        our absolute discretion.</p>\n    <p>D) Nothing in this Agreement is intended to confer\n        benefits, rights or remedies unto any person or entity other than the parties hereto and their\n        successors and permitted assigns.</p>\n    <p>E) The subject heading at the beginning of each\n        paragraph of this Agreement is for reference purposes only and in no way defines, limits, construes or\n        describes the scope or extent of such paragraph.</p>\n    <p>F) Any notices required or permitted to be given under\n        this Agreement shall be in writing and sent by registered post addressed (i) if to TIXAWY, to the\n        registered office set out above and (ii) if to you to the Billing Address set out in your Selling Member\n        profile.</p>\n    <p>G) This Agreement shall be governed by and construed in\n        accordance with the law of Egypt and both parties agree to submit to the exclusive jurisdiction of the\n        Egyptian Courts.</p>\n</div>');
$templateCache.put('app/static/terms.html','');
$templateCache.put('app/components/categories/categories.html','<spinner ng-if="vm.categoriesLoading" give="contents" push="center"></spinner>\n<div class="contents borderedBottom categoriesListingGroup" ng-repeat="category in vm.CategoriesList" category={{category.Theme}}  >\n        <h1><a href="#/category/{{category.categoryId}}">{{category.Name}} Events</a></h1>\n        <!-- <div  class="categoriesListingGroupLinks">\n            <a ng-repeat="subcategory in category.ChildCategories" href="#/category/{{subcategory.Id}}">{{subcategory.ChildCategoryName}}</a>\n        </div> -->\n</div>\n\n');
$templateCache.put('app/components/categories/category.html','<div class="navSubCategories">\n    <!-- This will be refined after ng-repeat with the real data -->\n    <div class="navSubCategoriesGroups" ng-class="{subsView:vm.ParentId && vm.CurrentParentId != 0}">\n        <h1 ng-if="vm.ParentId && vm.subCategoriesLength > 0 ">\n            <a href="#/category/{{vm.categoryDetails.ParentId}}">\n                <svg viewBox="0 0 24 24">\n                    <path d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" />\n                </svg>\n            </a>\n            {{vm.categoryDetails.Name}}\n        </h1>\n        <h1 ng-if="vm.ParentId && vm.ParentExist(vm.ParentId) && vm.subCategoriesLength == 0">\n            <a href="#/category/{{vm.categoryDetails.ParentId}}">\n                <svg viewBox="0 0 24 24">\n                    <path d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" />\n                </svg>\n            </a>\n            {{vm.categoryDetails.ParentName}}\n        </h1>\n        <div class="navSubCategoriesGroup" ng-if="vm.subCategoriesLength > 0" \n            ng-repeat="i in vm.getNumber(vm.number) track by $index" >\n            <a ng-repeat="subcategory in vm.SubCategoriesList.slice($parent.$index * 6, $parent.$index * 6 + 6)" \n                href="#/category/{{subcategory.Id}}">\n                {{subcategory.ChildCategoryName}}\n            </a>\n        </div>\n        <div class="navSubCategoriesGroup" \n            ng-if="vm.ParentId && vm.CurrentGrandParentId == 1 && vm.subCategoriesLength == 0" \n            ng-repeat="i in vm.getNumber(vm.sbilingsNumber) track by $index">\n            <a ng-repeat="subcategory in vm.SiblingsCategories.slice($parent.$index * 6, $parent.$index * 6 + 6)" \n                ng-class="{active:vm.categoryDetails.Id == subcategory.Id}" \n                href="#/category/{{subcategory.Id}}">\n                {{subcategory.ChildCategoryName}}\n            </a>\n        </div>\n        <div style="padding-left: 0px; margin-left: 0px" class="navSubCategoriesGroup" \n            ng-if="vm.ParentId && vm.CurrentGrandParentId == 0 && vm.subCategoriesLength == 0" \n            ng-repeat="i in vm.getNumber(vm.sbilingsNumber) track by $index">\n            <a ng-repeat="subcategory in vm.SiblingsCategories.slice($parent.$index * 6, $parent.$index * 6 + 6)" \n                ng-class="{active:vm.categoryDetails.Id == subcategory.Id}" \n                href="#/category/{{subcategory.Id}}">\n                {{subcategory.ChildCategoryName}}\n            </a>\n        </div>\n    </div>\n    <div ng-if="vm.HasFeatureEvent==true && $root.clientWidth > 860" class="categoryFeaturedEvent">\n        <h1>Trending Event</h1>\n        <div class="unitFocused" type="event">\n            <h1>\n                <a href="#/performance/{{vm.featuredEvent.PerformenceId}}">\n                    {{vm.featuredEvent.Name}}\n                </a>\n            </h1>\n            <div class="unitFocusedData">\n                <div class="unitFocusedImg">\n                    <a href=""><!--<img ng-src="assets/images/temp/{{vm.featuredEvent.Image}}_250x130.jpg" />--></a>\n                    <a href="">\n                        <img ng-src="{{vm.featuredEvent.Image4}}" />\n                    </a>\n                </div>\n                <div class="unitFocusedDataCore">\n                    <p>\n                        {{vm.featuredEvent.day}} {{vm.featuredEvent.month}} <span>{{vm.featuredEvent.time}}</span>\n                    </p>\n                    <div class="globalButtonsBar vertical">\n                        <a ng-if="vm.featuredEvent.avTickets > 0 && vm.featuredEvent.IsBuyBlocked != true" \n                            href="#/performance/{{vm.featuredEvent.PerformenceId}}" \n                            class="globalButton borderedButton" color="nevy">\n                            buy tickets\n                        </a>\n                        <a ng-if="vm.featuredEvent.IsSellBlocked != true" \n                            ng-click="vm.trySell(vm.featuredEvent.PerformenceId)" \n                            class="globalButton borderedButton" color="red">\n                            sell tickets\n                        </a>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<spinner ng-if="vm.categoryPerformancesLoading" give="contents" push="center"></spinner>\n<div class="contents" ng-if="vm.hasPerformances && !vm.categoryPerformancesLoading">\n    <div class="contentsTitle">\n        <h1>\n            {{vm.categoryDetails.Name}} Events\n        </h1>\n    </div>\n    <div class="contentsCore">\n        <div class="eventsListFilter eventsListFilterIdentifier">\n            <div class="eventsListFilterUnit">\n                <p>\n                    Category\n                </p>\n                <select ng-model="vm.filters.CategoryId"\n                        ng-init="vm.filters.CategoryId = -1"\n                        ng-options="category.CategoryId as category.CategoryName for category in vm.allSubCategories"\n                        ng-disabled="vm.allSubCategories.length === 1"\n                        ng-change="vm.getPerformances(false)"></select>\n            </div>\n            <div class="eventsListFilterUnit">\n                <p>\n                    Event\n                </p>\n                <select ng-model="vm.filters.EventId"\n                        ng-init="vm.filters.EventId = -1"\n                        ng-options="event.EventId as event.EventName for event in vm.allEvents"\n                        ng-change="vm.getPerformances(false)"></select>\n            </div>\n            <div class="eventsListFilterUnit">\n                <p>\n                    Venue\n                </p>\n                <select ng-model="vm.filters.VenueId"\n                        ng-init="vm.filters.VenueId = -1"\n                        ng-options="venue.VenueId as venue.VenueName for venue in vm.allVenues"\n                        ng-change="vm.getPerformances(false)"></select>\n            </div>\n            <div class="eventsListFilterUnit">\n                <p>\n                    Performer\n                </p>\n                <select ng-model="vm.filters.PerformerId"\n                        ng-init="vm.filters.PerformerId = -1"\n                        ng-options="performer.PerformerId as performer.PerformerName for performer in vm.allPerformers"\n                        ng-disabled="vm.allPerformers.length < 2"\n                        ng-change="vm.getPerformances(false)"></select>\n            </div>\n        </div>\n    </div>\n    <div class="contentsCore" ng-show="!vm.hasPerformancesFiltered">\n        <p>\n            No events found.\n        </p>\n    </div>\n    <table ng-table="vm.customConfigParams" class="eventsList eventsListIdentifier" \n        show-filter="true" ng-show="vm.hasPerformancesFiltered">\n        <tr ng-repeat="event in $data">\n            <td title="\'Date\'" sortable="\'startDate\'">\n                <div class="dateDayFocus inEventsList">\n                    <div class="dateDayFocusDay">\n                        <p>\n                            {{event.day}}\n                        </p>\n                    </div>\n                    <div class="dateDayFocusRest">\n                        <p>\n                            {{event.month}} {{event.year}}\n                        </p>\n                        <p class="day">\n                            {{event.dayName}}, {{event.time}}\n                        </p>\n                    </div>\n                    <p ng-if="$root.clientWidth <= 860 && $root.clientWidth > 600" class="venueNameInDateCell">\n                        <a href="#/venue/{{event.venueid}}">\n                            {{event.venue}}\n                        </a>\n                    </p>\n                </div>\n            </td>\n            <td title="\'Event\'" sortable="\'Performence\'" class="eventsListEventCell">\n                <h1>\n                    <a href="#/performance/{{event.PerformenceId}}">{{event.Performence}}</a>\n                </h1>\n                <p class="eventName">\n                    <a ng-if="event.Num_Performances_InEvent > 1" href="#/event/{{event.EventId}}">\n                        {{event.Name}}\n                    </a>\n                </p>\n                <p class="avTickets" ng-if="$root.clientWidth <= 600">\n                    {{event.avTickets}} tickets available\n                </p>\n                <p ng-if="$root.clientWidth <= 600" class="venueNameInDateCell">\n                    <a href="#/venue/{{event.venueid}}">\n                        {{event.venue}}\n                    </a>\n                </p>\n                <div class="globalButtonsBar edged" ng-if="$root.clientWidth <= 420">\n                    <a ng-if="event.avTickets >0 && event.IsBuyBlocked!=true" \n                        href="#/performance/{{event.PerformenceId}}" \n                        class="globalButton borderedButton" color="nevy">\n                        buy tickets\n                    </a>\n                    <a ng-if="event.IsSellBlocked != true" href="javascript:;" \n                        class="globalButton borderedButton" color="red" \n                        ng-click="vm.trySell(event.PerformenceId)">\n                        sell tickets\n                    </a>\n                </div>\n            </td>\n            <td title="\'Venue\'" sortable="\'venue\'" ng-if="$root.clientWidth>860">\n                <p>\n                    <a href="#/venue/{{event.venueid}}">\n                        {{event.venue}}\n                    </a>\n                </p>\n            </td>\n            <td ng-if="$root.clientWidth>600">\n                <p class="avTickets">\n                    {{event.avTickets}} tickets available\n                </p>\n            </td>\n            <td ng-if="$root.clientWidth>420">\n                <div class="globalButtonsBar otherSide" \n                    ng-class="{edged:$root.clientWidth>860,vertical:$root.clientWidth<=860}">\n                    <a ng-if="event.avTickets !=0 && event.IsBuyBlocked!=true" \n                        href="#/performance/{{event.PerformenceId}}" \n                        class="globalButton borderedButton" color="nevy">\n                        buy tickets\n                    </a>\n                    <a ng-if="event.IsSellBlocked != true" href="javascript:;" \n                        class="globalButton borderedButton" color="red" \n                        ng-click="vm.trySell(event.PerformenceId)">\n                        sell tickets\n                    </a>\n                </div>\n            </td>\n        </tr>\n    </table>\n    <div class="globalButtonsBar midTopSpace extraWidth">\n        <a href="javascript:void(0);" class="globalButton borderedButton" color="lightGrey"\n           ng-click="vm.loadMore()"\n           ng-hide="vm.lastCall">\n            {{vm.loadMoreText}}\n        </a>\n    </div>\n    <div eturn-popup title="{{$root.PopUpTitle}}" closable=true \n        ng-if="$root.showPopup == true" show-poper="$root.showPopup">\n        {{$root.PopUpDescription}}\n    </div>\n</div>\n');
$templateCache.put('app/components/categories/subcategory.html','<div class="navSubCategories">\n    <div class="navSubCategoriesGroups subsView">\n        <h1>\n            <a href="#/category/{{vm.categoryDetails.ParentCategoryId}}">\n                <svg viewBox="0 0 24 24">\n                    <path d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" />\n                </svg>\n            </a>\n            {{vm.categoryDetails.Name}}\n        </h1>\n        <div class="navSubCategoriesGroup">\n            <a ng-repeat="subcategory in vm.SubCategoriesList" href="#/category/{{subcategory.Id}}">\n                {{subcategory.ChildCategoryName}}\n            </a>\n        </div>\n    </div>\n    <div class="categoryFeaturedEvent">\n        <h1>\n            Trending Event\n        </h1>\n        <div class="unitFocused" type="event">\n            <h1>\n                <a href="">\n                    Al Ahly vs al zamalek #111\n                </a>\n            </h1>\n            <div class="unitFocusedData">\n                <div class="unitFocusedImg">\n                    <a href="">\n                        <img src="assets/images/temp/ahlyvszamalek_250x130.jpg" />\n                    </a>\n                </div>\n                <div class="unitFocusedDataCore">\n                    <p>\n                        Today <span>08:00</span> PM\n                    </p>\n                    <div class="globalButtonsBar vertical">\n                        <a href="" class="globalButton borderedButton" color="nevy">\n                            buy tickets\n                        </a>\n                        <a href="" class="globalButton borderedButton" color="red">\n                            sell tickets\n                        </a>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div class="contents">\n    <div class="contentsTitle">\n        <h1>\n            <a href="#/category/{{vm.categoryDetails.Id}}">\n                {{vm.categoryDetails.ParentCategoryName}}\n            </a>\n            {{vm.categoryDetails.Name}} Events\n        </h1>\n    </div>\n    <div class="eventsListFilter">\n        <div class="eventsListFilterUnit">\n            <p>\n                Category\n            </p>\n            <select>\n                <option>Football</option>\n                <option>Egyptian League</option>\n                <option>Cup Of Egypt</option>\n            </select>\n        </div>\n        <div class="eventsListFilterUnit">\n            <p>\n                Event\n            </p>\n            <select>\n                <option>All Events</option>\n                <option>Egyptian League</option>\n                <option>Egyptian Squash Tournament</option>\n            </select>\n        </div>\n        <div class="eventsListFilterUnit">\n            <p>\n                Venue\n            </p>\n            <select>\n                <option>All Venues</option>\n                <option>Cairo International Stadium</option>\n                <option>Borg Al Arab Stadium</option>\n                <option>Pyramids</option>\n            </select>\n        </div>\n        <div class="eventsListFilterUnit">\n            <p>\n                Performer\n            </p>\n            <select>\n                <option>All Performers</option>\n                <option>Al Ahly</option>\n                <option>Al Zamalik</option>\n                <option>Egyptian Handball Team</option>\n            </select>\n        </div>\n    </div>\n    <table ng-table="vm.customConfigParams" class="eventsList" show-filter="true">\n        <tr ng-repeat="event in vm.CategoryPerformncesDetails">\n            <td title="\'Date\'" sortable="\'fullDate\'">\n                <div class="dateDayFocus inEventsList">\n                    <div class="dateDayFocusDay">\n                        <p>\n                            {{event.day}}\n                        </p>\n                    </div>\n                    <div class="dateDayFocusRest">\n                        <p>\n                            {{event.month}} {{event.year}}\n                        </p>\n                        <p class="day">\n                            {{event.dayName}}, {{event.time}}\n                        </p>\n                    </div>\n                </div>\n            </td>\n            <td title="\'Event\'" sortable="\'Name\'" class="eventsListEventCell">\n                <h1>\n                    <a href="#/performance/{{event.PerformenceId}}">\n                        {{event.Performence}}\n                    </a>\n                </h1>\n                <p class="eventName">\n                    <a href="#/event/{{event.EventId}}">\n                        {{event.Name}}\n                    </a>\n                </p>\n            </td>\n            <td title="\'Venue\'" sortable="\'venue\'">\n                <p>\n                    <a href="#/venue/{{event.venueid}}">\n                        {{event.venue}}\n                    </a>\n                </p>\n            </td>\n            <td>\n                <p class="avTickets">\n                    {{event.avTickets}} tickets availabo\n                </p>\n            </td>\n            <td>\n                <div class="globalButtonsBar edged otherSide">\n                    <a href="" class="globalButton borderedButton" color="nevy">\n                        buy tickets\n                    </a>\n                    <a href="" class="globalButton borderedButton" color="red">\n                        sell tickets\n                    </a>\n                </div>\n            </td>\n        </tr>\n    </table>\n</div>');
$templateCache.put('app/components/events/event.html','<spinner ng-if="vm.eventLoading" give="contents" push="center"></spinner>\n<div class="featuredEventsCarousel" ng-if="!vm.eventLoading">\n    <div class="featuredEventsCarouselFeaturedUnit">\n        <div class="featuredEventsCarouselFeaturedUnitImage">\n            <!--<img src="assets/images/temp/{{vm.EventDetails.Image}}_810x387.jpg" />-->\n            <img src="{{vm.EventDetails.Image}}" />\n        </div>\n        <div class="featuredEventsCarouselFeaturedUnitData">\n            <h1>{{vm.EventDetails.name}}</h1>\n            <div class="featuredEventsCarouselFeaturedUnitDataContents">\n                <div class="dateRange">\n                    <div class="dateDayFocus white big">\n                        <div class="dateDayFocusDay">\n                            <p>{{vm.StartEventDay}}</p>\n                        </div>\n                        <div class="dateDayFocusRest">\n                            <p>{{ vm.StartEventMonth}}</p>\n                            <p class="day">{{vm.StartEventYear}}</p>\n                        </div>\n                    </div>\n                    <div class="dateRangeTo">\n                        <svg viewBox="0 0 24 24">\n                            <path d="M22,12L18,8V11H3V13H18V16L22,12Z" />\n                        </svg>\n                    </div>\n                    <div class="dateDayFocus white big">\n                        <div class="dateDayFocusDay">\n                            <p>{{vm.EndEventDay}}</p>\n                        </div>\n                        <div class="dateDayFocusRest">\n                            <p>{{vm.EndEventMonth}}</p>\n                            <p class="day">{{vm.EndEventYear}}</p>\n                        </div>\n                    </div>\n                </div>\n                <div class="featuredEventsRules">\n                    <h2 ng-if="vm.EventDetails.EventRestrection.length!=0">Event Rules</h2>\n                    <div class="featuredEventsRulesUnits">\n                        <div class="row">\n                            <div class="featuredEventsRule" tooltipposition="left" ng-repeat="rest in vm.EventDetails.EventRestrection" tooltip="No {{rest.RestrectionName}}">\n                                <svg ng-if="rest.RestrectionName==\'recording\'"><use xlink:href="#noVideoRecording" /></svg>\n                                <svg ng-if="rest.RestrectionName==\'camera\'"><use xlink:href="#noCameras" /></svg>\n                                <svg ng-if="rest.RestrectionName==\'drinking\'"><use xlink:href="#noDrinks" /></svg>\n                                <svg ng-if="rest.RestrectionName==\'food\'"><use xlink:href="#noFood" /></svg>\n                                <svg ng-if="rest.RestrectionName==\'smoking\'"><use xlink:href="#noSmoking" /></svg>\n                                <svg ng-if="rest.RestrectionName==\'children\'"><use xlink:href="#noChildren" /></svg>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class="globalButtonsBar">\n                    <a class="globalButton callToAction nevy" scroll href="javascript:void(0);" scroll-to="#performancesTable" ng-if="vm.hasPerformances && vm.buyBlocked!=true && vm.hasTickets==true">\n                        Buy<span>Tickets</span>\n                    </a>\n                    <a ng-if="vm.hasPerformances && vm.sellBlocked!=true" scroll href="javascript:void(0);" scroll-to="#performancesTable" class="globalButton callToAction red">Sell<span>Tickets</span></a>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div class="contents borderedBottom lessTop" ng-if="!vm.eventLoading">\n    <div class="eventsListFilter breadCrumb">\n        <p>\n            <a href="#/home">Home</a>\n            <span ng-repeat="category in vm.EventDetails.ParentCategories">\n                <span>\n                    <svg><use xlink:href="#breadCrumbArrow" /></svg>\n                </span>\n                <a href="#/category/{{category.ParentCategoryId}}">{{category.ParentCategory}}</a>\n            </span>\n            <span>\n                <svg><use xlink:href="#breadCrumbArrow" /></svg>\n            </span>\n            <span>{{vm.EventDetails.name}}</span>\n        </p>\n    </div>\n    <div class="contentsTitle withSide">\n        <h1>About {{vm.EventDetails.name}}</h1>\n        <div class="titleSocials">\n            <a href="javascript:;" class="facebook" id="share" tooltip="Share on Facebook"\n               ng-click="vm.share()">\n                <svg><use xlink:href="#facebookIcon" /></svg>\n            </a>\n        </div>\n    </div>\n    <div class="contentsCore textData" ng-class="{rtlContents:$root.isArabic(vm.EventDetails.Description)}">\n        <p>\n            {{vm.EventDetails.Description}}\n        </p>\n    </div>\n</div>\n<div ng-if="vm.hasPerformances && !vm.eventLoading" class="contents">\n    <div class="contentsTitle">\n        <h1>{{vm.EventDetails.name}} Performances</h1>\n    </div>\n    <div class="contentsCore">\n        <div class="eventsListFilter eventsListFilterIdentifier">\n            <div class="eventsListFilterUnit">\n                <p>Category</p>\n                <select ng-model="vm.filters.CategoryId"\n                        ng-init="vm.filters.CategoryId = -1"\n                        ng-options="category.CategoryId as category.CategoryName for category in vm.allCategories"\n                        ng-change="vm.getPerformances()"></select>\n            </div>\n            <div class="eventsListFilterUnit">\n                <p>Event</p>\n                <select disabled>\n                    <option value="{{vm.EventDetails.id}}">\n                        {{vm.EventDetails.name}}\n                    </option>\n                </select>\n            </div>\n            <div class="eventsListFilterUnit">\n                <p>Venue</p>\n                <select ng-model="vm.filters.VenueId"\n                        ng-init="vm.filters.VenueId = -1"\n                        ng-options="venue.VenueId as venue.VenueName for venue in vm.allVenues"\n                        ng-change="vm.getPerformances(false)"></select>\n            </div>\n            <div class="eventsListFilterUnit">\n                <p>Performer</p>\n                <select ng-model="vm.filters.PerformerId"\n                        ng-init="vm.filters.PerformerId = -1"\n                        ng-options="performer.PerformerId as performer.PerformerName for performer in vm.allPerformers"\n                        ng-change="vm.getPerformances(false)"></select>\n            </div>\n        </div>\n    </div>\n    <spinner ng-if="vm.allEventsLoading" give="contents" push="center"></spinner>\n    <div class="contentsCore" ng-show="!vm.hasPerformancesFiltered && !vm.allEventsLoading">\n        <p>No Performances Found.</p>\n    </div>\n    <table ng-table="vm.customConfigParams" class="eventsList eventsListIdentifier" show-filter="true" id="performancesTable"\n           ng-show="vm.hasPerformancesFiltered && !vm.allEventsLoading">\n        <tr ng-repeat="event in $data">\n            <td title="\'Date\'" sortable="\'startDate\'" class="dateCell">\n                <div class="dateDayFocus inEventsList">\n                    <div class="dateDayFocusDay">\n                        <p>{{event.day}}</p>\n                    </div>\n                    <div class="dateDayFocusRest">\n                        <p>{{event.month}} {{event.year}}</p>\n                        <p class="day">{{event.dayName}}, {{event.time}}</p>\n                    </div>\n                    <p ng-if="$root.clientWidth<=860 && $root.clientWidth>600" class="venueNameInDateCell"><a href="#/venue/{{event.venueid}}">{{event.venue}}</a></p>\n                </div>\n            </td>\n            <td title="\'Event\'" sortable="\'Performence\'" class="eventsListEventCell">\n                <h1><a href="#/performance/{{event.PerformenceId}}">{{event.Performence}}</a></h1>\n                <p class="avTickets" ng-if="$root.clientWidth<=600">{{event.AvailableTicket}} Tickets Available</p>\n                <p ng-if="$root.clientWidth<=600" class="venueNameInDateCell"><a href="#/venue/{{event.venueid}}">{{event.venue}}</a></p>\n                <div class="globalButtonsBar edged" ng-if="$root.clientWidth<=420">\n                    <a ng-if="event.AvailableTicket>0 && event.IsBuyBlocked!=true" href="#/performance/{{event.PerformenceId}}" class="globalButton borderedButton" color="nevy">buy tickets</a>\n                    <a ng-if="event.IsSellBlocked!= true" href="javascript:;" class="globalButton borderedButton" color="red" ng-click="vm.trySell(event.PerformenceId)">Sell tickets</a>\n                </div>\n            </td>\n            <td title="\'Venue\'" sortable="\'venue\'" ng-if="$root.clientWidth>860">\n                <p><a href="#/venue/{{event.venueid}}">{{event.venue}}</a></p>\n            </td>\n            <td ng-if="$root.clientWidth>600">\n                <p class="avTickets">{{event.AvailableTicket}} Tickets Available</p>\n            </td>\n            <td ng-if="$root.clientWidth>420">\n                <div class="globalButtonsBar otherSide" ng-class="{edged:$root.clientWidth>860,vertical:$root.clientWidth<=860}">\n                    <a ng-if="event.AvailableTicket > 0 && event.IsBuyBlocked!=true" href="#/performance/{{event.PerformenceId}}" class="globalButton borderedButton" color="nevy">buy tickets</a>\n                    <a ng-if="event.IsSellBlocked != true" href="javascript:;" class="globalButton borderedButton" color="red" ng-click="vm.trySell(event.PerformenceId)">Sell tickets</a>\n                </div>\n            </td>\n        </tr>\n    </table>\n    <div class="globalButtonsBar midTopSpace extraWidth">\n        <a href="javascript:void(0);" class="globalButton borderedButton" color="lightGrey"\n           ng-click="vm.loadMore()"\n           ng-hide="vm.lastCall">\n            {{vm.loadMoreText}}\n        </a>\n    </div>\n    <div eturn-popup title="{{$root.PopUpTitle}}" closable=true ng-if="$root.showPopup == true" show-poper="$root.showPopup">\n        {{$root.PopUpDescription}}\n    </div>\n</div>\n');
$templateCache.put('app/components/home/home.html','<!-- Featured Events Carousel Start -->\n<spinner ng-if="vm.featuredEvents.length === 0 && !vm.NoFeatured" give="contents" push="center"></spinner>\n<div ng-if="vm.NoFeatured" class="featuredEventsCarousel noResults">\n    <img src="assets/images/no-featured.png" />\n    <h2>Nothing to display here.</h2>\n</div>\n<div class="featuredEventsCarousel" ng-if="vm.featuredEvents.length > 0">\n    <div class="featuredEventsCarouselFeaturedUnits" ng-class="{\'invisible\':vm.carouselInitializing}">\n        <div class="featuredEventsCarouselFeaturedUnit" ng-repeat="event in vm.featuredEvents"\n             ng-init="$last ? vm.initCarousel() : angular.noop()">\n             <div class="featuredEventsCarouselFeaturedUnitImage">\n                <!--<img src="assets/images/temp/{{event.Image}}_810x387.jpg" />-->\n                <a href="#/event/{{event.Id}}"><img ng-src="{{event.Image}}" /></a>\n            </div>\n            <div class="featuredEventsCarouselFeaturedUnitData">\n                <h1>{{event.Name}}</h1>\n                <div class="featuredEventsCarouselFeaturedUnitDataContents">\n                    <div class="dateRange">\n                        <div class="dateDayFocus white big">\n                            <div class="dateDayFocusDay">\n                                <p>{{event.StartDay}}</p>\n                            </div>\n                            <div class="dateDayFocusRest">\n                                <p>{{event.StartMonthOfYear}}</p>\n                                <p class="day">{{event.StartYear}}</p>\n                            </div>\n                        </div>\n                        <div class="dateRangeTo">\n                            <svg viewBox="0 0 24 24">\n                                <path d="M22,12L18,8V11H3V13H18V16L22,12Z" />\n                            </svg>\n                        </div>\n                        <div class="dateDayFocus white big">\n                            <div class="dateDayFocusDay">\n                                <p>{{event.EndDay}}</p>\n                            </div>\n                            <div class="dateDayFocusRest">\n                                <p>{{event.EndMonthOfYear}}</p>\n                                <p class="day">{{event.EndYear}}</p>\n                            </div>\n                        </div>\n                    </div>\n                    <div class="featuredEventsCarouselFeaturedUnitIntro" ng-class="{rtlContents:$root.isArabic(Performance.Description)}">\n                        <p>\n                            {{event.Description}}\n                        </p>\n                    </div>\n                    <div class="globalButtonsBar">\n                        <a class="globalButton callToAction nevy" href="#/event/{{event.Id}}" ng-if="event.OpenForBuying">\n                            Buy<span>Tickets</span>\n                        </a>\n                        <a ng-if="event.OpenForSelling" ng-click="vm.trySell(\'event\', event.Id)" class="globalButton callToAction red">\n                            Sell<span>Tickets</span>\n                        </a>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div class="featuredEventsCarouselNav">\n    <div class="featuredEventsCarouselNavUnits">\n        <!-- UI Note:Category attribute used for styling-->\n        <div class="featuredEventsCarouselNavUnit" ng-repeat="event in vm.featuredEvents" category="{{Performance.CategoryTheme}}">\n            <div class="featuredEventsCarouselNavUnitEdge"></div>\n            <div class="featuredEventsCarouselNavUnitEdge featuredEventsCarouselNavUnitEdgeEnd"></div>\n            <div class="featuredEventsCarouselNavUnitFocus">\n                <div class="featuredEventsCarouselNavUnitFocusImage">\n                    <img ng-src="{{event.Image2}}" />\n                </div>\n                <div class="featuredEventsCarouselNavUnitFocusCore">\n                    <div class="dateDayFocus">\n                        <div class="dateDayFocusDay">\n                            <p>{{event.StartDay}}</p>\n                        </div>\n                        <div class="dateDayFocusRest">\n                            <p>{{event.StartMonthOfYear}}</p>\n                            <p class="day">{{event.StartDayOfWeek}}</p>\n                        </div>\n                        <!-- <div class="dateDayFocusTime">{{Performance.Time}}</div> -->\n                    </div>\n                    \n                    <div class="featuredEventsCarouselNavUnitFocusCoreSeats">\n                        <p>\n                            <span>{{event.TicketCount}}</span> Seats\n                        </p>\n                    </div>\n                </div>\n            </div>\n            <div class="featuredEventsCarouselNavUnitDetails">\n                <div class="featuredEventsCarouselNavUnitDetailsBordered">\n                    <h1>{{event.Name}}</h1>\n                    <p>{{event.VenueName}}</p>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<!-- Featured Events Carousel End -->\n<!-- Categories Start -->\n<spinner ng-if="vm.CategoriesEvents.length === 0" give="contents" push="center"></spinner>\n<div ng-if="vm.CategoriesEvents.length > 0" class="contents borderedBottom">\n    <div class="layoutUnit layoutThird contentsBorderedRight" ng-repeat="category in vm.CategoriesEvents" category="{{category.Theme}}">\n        <h1><span class="categoryTag"></span>{{category.Name}} Events</h1>\n        <div class="contentsCore">\n            <!-- UI Note:size attribute used for styling-->\n            <p ng-if="category.Events.length === 0">No events.</p>\n            <div class="flipperFlip" ng-repeat="event in category.Events | limitTo:3">\n                <div class="flipper">\n                    <div class="unitWithImage front" size="100">\n                        <div class="unitWithImageImg">\n                            <img ng-src="{{event.Image2}}" />\n                        </div>\n                        <div class="unitWithImageData">\n                            <h1>{{event.Name}}</h1>\n                            <div class="dateRangeTo">\n                                <p class="date">\n                                    {{event.StartDay}} {{event.StartMonthOfYear}} {{event.StartYear}} <!--<span>{{Performance.Time}}</span>-->\n                                </p>\n                                <svg viewBox="0 0 24 24">\n                                    <path d="M22,12L18,8V11H3V13H18V16L22,12Z" />\n                                </svg>\n                                <p class="date">\n                                    {{event.EndDay}} {{event.EndMonthOfYear}} {{event.EndYear}} <!--<span>{{Performance.Time}}</span>-->\n                                </p>\n                            </div>\n                            <p>{{event.VenueName}}</p>\n                        </div>\n                    </div>\n                    <div class="unitWithImage back">\n                        <div class="unitByDateDateBlock">\n                            <div class="unitByDateDateBlockDate">\n                                <p class="dayName">{{event.StartDayOfWeek}}</p>\n                                <p class="day">{{event.StartDay}}</p>\n                                <p class="month">{{event.StartMonthOfYear}}</p>\n                            </div>\n                            <!-- <div class="unitByDateDateBlockTime">\n                                <p>{{Performance.Time}}</p>\n                            </div> -->\n                        </div>\n                        <div class="unitWithImageData">\n                            <h1><a href="#/event/{{event.Id}}">{{event.Name}}</a></h1>\n                            <p><a href="#/venue/{{event.VenueId}}">{{event.VenueName}}</a></p>\n                            <div class="globalButtonsBar edged tinyTopSpace">\n                                <a href="#/event/{{event.Id}}" ng-if="event.OpenForBuying" class="globalButton borderedButton" color="nevy">buy tickets</a>\n                                <a ng-if="event.OpenForSelling" ng-click="vm.trySell(\'event\', event.Id)" class="globalButton borderedButton" color="red">Sell tickets</a>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class="globalButtonsBar topSpace">\n            <a ng-if="category.Events.length > 3" href="#/category/{{category.Id}}" class="globalButton borderedButton" color="grey">See All</a>\n        </div>\n    </div>\n</div>\n<!-- Categories End -->\n<!-- Populars Start -->\n<div class="contents">\n    <div class="layoutUnit layoutThird popularVenue">\n        <h1>Popular venue</h1>\n        <spinner ng-if="vm.PopularVenue.Name == null" give="contentsCore" push="left"></spinner>\n        <div ng-if="vm.PopularVenue.Name != null" class="unitFocused" type="venue">\n            <h1>{{vm.PopularVenue.Name}}</h1>\n            <div class="unitFocusedData">\n                <div class="unitFocusedImg">\n                    <img ng-src="{{vm.PopularVenue.Image}}" />\n                </div>\n                <div class="unitFocusedDataCore">\n                    <p class="upcomingCount">{{vm.PopularVenue.EventsCount}}</p>\n                    <p>Upcoming<br />Events</p>\n                </div>\n            </div>\n            <a href="#/venue/{{vm.PopularVenue.VenueId}}" class="hitArea"></a>\n        </div>\n        <div class="contentsCore">\n            <div class="unitWithImage" ng-repeat="Performance in vm.VenuePerformances" category="{{Performance.CategoryTheme}}">\n                <div class="unitByDateDateBlock">\n                    <div class="unitByDateDateBlockDate">\n                        <p class="dayName">{{Performance.DayName}}</p>\n                        <p class="day">{{Performance.DayNumber}}</p>\n                        <p class="month">{{Performance.MonthName}}</p>\n                    </div>\n                    <div class="unitByDateDateBlockTime">\n                        <p>{{Performance.Time}}</p>\n                    </div>\n                </div>\n                <div class="unitWithImageData">\n                    <h1><a href="#/performance/{{Performance.PerformanceId}}">{{Performance.Name}}</a></h1>\n                    <div class="globalButtonsBar edged tinyTopSpace">\n                        <a ng-if="Performance.TicketsSum>0 && Performance.IsBuyBlocked!=true" href="#/performance/{{Performance.PerformanceId}}" class="globalButton borderedButton" color="nevy">buy tickets</a>\n                        <a ng-if="Performance.IsSellBlocked!=true" ng-click="vm.trySell(\'performance\', Performance.PerformanceId)" class="globalButton borderedButton" color="red">Sell tickets</a>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class="layoutUnit layoutThird contentsBorderedRight">\n        <h1>trending today</h1>\n        <spinner ng-if="vm.TrendingToday.length === 0 && !vm.NoTrending" give="contentsCore" push="left"></spinner>\n        <p ng-if="vm.NoTrending">No Trending.</p>\n        <div class="unitFocused" type="event" ng-repeat="Performance in vm.TrendingToday">\n            <h1><a href="#/performance/{{Performance.PerformanceId}}">{{Performance.Name}}</a></h1>\n            <div class="unitFocusedData">\n                <div class="unitFocusedImg">\n                    <a href="#/performance/{{Performance.PerformanceId}}"><img ng-src="{{Performance.Image4}}" /></a>\n                </div>\n                <div class="unitFocusedDataCore">\n                    <p>{{Performance.DayNumber}} {{Performance.MonthName}} <span>{{Performance.Time}}</span> {{Performance.Time_AM_OR_PM}}</p>\n                    <div class="globalButtonsBar vertical">\n                        <a ng-if="Performance.TicketsSum>0 && Performance.IsBuyBlocked!=true" href="#/performance/{{Performance.PerformanceId}}" class="globalButton borderedButton" color="nevy">buy tickets</a>\n                        <a ng-if="Performance.IsSellBlocked!=true" ng-click="vm.trySell(\'performance\', Performance.PerformanceId)" class="globalButton borderedButton" color="red">Sell tickets</a>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class="layoutUnit layoutThird contentsBorderedRight homePerformers">\n        <h1>Popular performers</h1>\n        <spinner ng-if="vm.PopularPerformers.length === 0" give="contentsCore" push="left"></spinner>\n        <div class="contentsCore imagesBlocks">\n            <a ng-repeat="Performer in vm.PopularPerformers" href="#/performer/{{Performer.PerformerId}}"><img ng-src="{{Performer.Image2}}" /></a>\n        </div>\n    </div>\n    <div eturn-popup title="{{$root.PopUpTitle}}" closable=true ng-if="$root.showPopup == true" show-poper="$root.showPopup">\n        {{$root.PopUpDescription}}\n    </div>\n</div>\n<!-- Populars End -->\n');
$templateCache.put('app/components/payments/payment.html','<div class="contents borderedBottom">\n  <div class="eventsListFilter breadCrumb">\n    <p>\n      <a href="#/home">Home</a>\n      <span>\n        <svg>\n          <use xlink:href="#breadCrumbArrow" />\n        </svg>\n      </span>\n      <span>{{vm.order.PerformanceName}}</span>\n      <span>\n        <svg>\n          <use xlink:href="#breadCrumbArrow" />\n        </svg>\n      </span>\n      <span>Order Details</span>\n    </p>\n  </div>\n  <div class="contentsTitle withSide withSideButton">\n    <h1>Order Details</h1>\n  </div>\n  <spinner ng-if="vm.orderLoading" give="contents" push="center"></spinner>\n  <div\n    id="orderDetails"\n    class="contentsCore borderedBottom"\n    ng-if="!vm.orderLoading"\n  >\n    <div class="contentsHalf">\n      <div class="unitWithImage" size="250x130">\n        <div class="unitWithImageImg">\n          <img src="{{vm.order.PerformanceImage}}" />\n        </div>\n        <div class="unitWithImageData">\n          <h1>{{vm.order.PerformanceName}}</h1>\n          <p class="date">{{vm.order.PerformanceDate}}</p>\n          <p class="date">\n            {{vm.order.PerformanceDay}}\n            <span>{{vm.order.PerformanceTime}}</span>\n          </p>\n          <p>{{vm.order.PerformanceVenue}}</p>\n        </div>\n      </div>\n    </div>\n    <div class="contentsHalf startWithpadding borderedStartWith">\n      <div class="tableLike noLastBorder condensed">\n        <div class="rowLike">\n          <div class="cellLike">\n            <p>Seats</p>\n          </div>\n          <div\n            class="cellLike"\n            ng-if="vm.order.IsSeating || (vm.order.TicketRow!=null && vm.order.TicketsNumber>1) "\n          >\n            <p\n              ng-if="vm.order.Section!=null && vm.order.IncrementType==\'Standard  \'"\n            >\n              Section {{vm.order.Section}}/ Row {{vm.order.TicketRow}} / Seats\n              From {{vm.order.StartSeat}} To {{vm.order.StartSeat +\n              vm.order.TicketsNumber-1}}\n            </p>\n            <p\n              ng-if="vm.order.Section==null && vm.order.IncrementType==\'Standard  \'"\n            >\n              Row {{vm.order.TicketRow}} / Seats From {{vm.order.StartSeat}} To\n              {{vm.order.StartSeat + vm.order.TicketsNumber-1}}\n            </p>\n            <p\n              ng-if="vm.order.Section!=null && vm.order.IncrementType!=\'Standard  \'"\n            >\n              Section {{vm.order.Section}}/ Row {{vm.order.TicketRow}} / Seats\n              From {{vm.order.StartSeat}} To {{(vm.order.StartSeat +\n              ((vm.order.TicketsNumber-1)*2))}}\n            </p>\n            <p\n              ng-if="vm.order.Section==null  && vm.order.IncrementType!=\'Standard  \'"\n            >\n              Row {{vm.order.TicketRow}} / Seats From {{vm.order.StartSeat}} To\n              {{vm.order.StartSeat + ((vm.order.TicketsNumber-1)*2)}}\n            </p>\n          </div>\n          <div\n            class="cellLike"\n            ng-if="vm.order.IsSeating || (vm.order.TicketRow!=null && vm.order.TicketsNumber==1) "\n          >\n            <p ng-if="vm.order.Section==null">\n              Row {{vm.order.TicketRow}} / Seat {{vm.order.StartSeat}}\n            </p>\n            <p ng-if="vm.order.Section!=null">\n              Section {{vm.order.Section}} / Row {{vm.order.TicketRow}} / Seat\n              {{vm.order.StartSeat}}\n            </p>\n          </div>\n          <div class="cellLike" ng-if="(vm.order.TicketRow==null)">\n            <p>{{vm.order.Section}}</p>\n          </div>\n        </div>\n        <div class="rowLike">\n          <div class="cellLike">\n            <p>Number of Tickets</p>\n          </div>\n          <div class="cellLike" ng-if="vm.order.IsSeating">\n            <p ng-if="vm.order.TicketsNumber>1">\n              {{vm.order.TicketsNumber}} - Your seats will be together.\n            </p>\n            <p ng-if="vm.order.TicketsNumber<2">{{vm.order.TicketsNumber}}</p>\n          </div>\n          <div class="cellLike" ng-if="!vm.order.IsSeating">\n            <p>{{vm.order.TicketsNumber}}</p>\n          </div>\n        </div>\n        <div class="rowLike">\n          <div class="cellLike">\n            <p>Price per Ticket</p>\n          </div>\n          <div class="cellLike">\n            <h1 class="price">LE {{vm.order.TicketPrice}}<span>.00</span></h1>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n<div ng-form="billingForm">\n  <!-- AI: Contact info only appears for loggedin user -->\n  <div\n    ng-if="vm.isLoggedIn && vm.order.IsPhoneVerified"\n    class="contents borderedBottom"\n  >\n    <div class="contentsTitle withSide withSideButton">\n      <h1>Contact Information</h1>\n    </div>\n    <div class="contentsCore">\n      <div class="profileSwitchView active">\n        <div class="accountRow borderedBottom">\n          <div class="accountRowLabel">\n            <p>Full Name</p>\n          </div>\n          <div class="accountRowValue">\n            <div class="globalForm">\n              <div class="globalFormUnit balanced sidedButton">\n                <input type="text" value="{{vm.userName}}" disabled />\n                <a\n                  href="#/users/profile"\n                  class="globalButton inputSidedButton"\n                  color="blue"\n                  >Change</a\n                >\n              </div>\n            </div>\n          </div>\n        </div>\n        <div\n          class="accountRow borderedBottom"\n          ng-class="{active:vm.emailAddressToggle}"\n        >\n          <div class="accountRowLabel">\n            <p>Email Address</p>\n          </div>\n          <div class="accountRowValue">\n            <div class="globalForm">\n              <div class="globalFormUnit balanced sidedButton">\n                <input type="text" value="{{vm.userEmail}}" disabled />\n                <a\n                  href="#/users/account"\n                  class="globalButton inputSidedButton"\n                  color="blue"\n                  >Change</a\n                >\n              </div>\n            </div>\n          </div>\n        </div>\n        <div\n          class="accountRow borderedBottom"\n          ng-class="{active:vm.emailAddressToggle}"\n        >\n          <div class="accountRowLabel">\n            <p>Mobile Number</p>\n          </div>\n          <div class="accountRowValue">\n            <div class="globalForm">\n              <div class="globalFormUnit balanced sidedButton">\n                <input type="text" value="{{vm.userPhone}}" disabled />\n                <a\n                  href="#/users/account"\n                  class="globalButton inputSidedButton"\n                  color="blue"\n                  >Change</a\n                >\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <!-- AI: Billing info only appears for loggedin user -->\n  <div\n    ng-if="vm.isLoggedIn && vm.order.IsPhoneVerified"\n    class="contents borderedBottom"\n  >\n    <div class="contentsTitle withSide withSideButton">\n      <h1>Shipping Information</h1>\n    </div>\n    <div class="contentsCore">\n      <div class="profileSwitchView active">\n        <div class="accountRow borderedBottom">\n          <div class="accountRowLabel">\n            <p>Courier</p>\n          </div>\n          <div class="accountRowValue">\n            <div class="globalFormUnit balanced sidedButton">\n              <select\n                name="deliveryCourier"\n                id="deliveryCourier"\n                data-ng-model="vm.SelectedCourier"\n                ng-change="vm.printt()"\n                ng-init="vm.CourierId = 1"\n                data-ng-options="c.Name for c in vm.Couriers"\n                class="form-control"\n              ></select>\n            </div>\n          </div>\n        </div>\n        <div ng-if="!vm.SelectedCourier.IsPickup">\n          <div class="accountRow borderedBottom">\n            <div class="accountRowLabel">\n              <p>City (Delivery is only in Egypt)</p>\n            </div>\n            <div class="accountRowValue">\n              <div class="globalFormUnit balanced sidedButton">\n                <select\n                  name="deliveryCity"\n                  id="deliveryCity"\n                  ng-model="vm.DeliveryCityId"\n                  ng-init="vm.DeliveryCityId = 2"\n                  ng-options="area.DeliveryCityId as area.Name for area in vm.DeliveryCities"\n                  class="form-control"\n                ></select>\n              </div>\n            </div>\n          </div>\n          <div class="accountRow borderedBottom">\n            <div class="accountRowLabel">\n              <p>Address</p>\n            </div>\n            <div class="accountRowValue">\n              <div class="globalForm">\n                <div class="globalFormUnit balanced sidedButton">\n                  <input type="text" ng-model="vm.order.UserAddress" required />\n                  <p\n                    ng-if="!vm.order.UserAddress && vm.proceedClicked"\n                    class="accountError mini"\n                  >\n                    Address is required\n                  </p>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class="accountRow borderedBottom">\n            <div class="accountRowLabel">\n              <p>Postal Code</p>\n            </div>\n            <div class="accountRowValue">\n              <div class="globalForm">\n                <div class="globalFormUnit balanced sidedButton">\n                  <input\n                    type="text"\n                    id="billingPostalCode"\n                    name="billingPostalCode"\n                    ng-model="vm.order.UserPostalCode"\n                    ng-pattern="vm.regex.postalCode"\n                  />\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class="accountRow borderedBottom">\n            <div class="accountRowLabel">\n              <p>Delivery Note</p>\n            </div>\n            <div class="accountRowValue">\n              <div class="globalForm">\n                <div class="globalFormUnit balanced sidedButton textareaForTwo">\n                  <textarea\n                    cols="35"\n                    id="billingDeliveryNote"\n                    name="billingDeliveryNote"\n                    ng-model="vm.order.UserDeliveryNote"\n                  />\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <!-- AI: Payment only appears for loggedin user -->\n  <div\n    ng-if="vm.isLoggedIn && vm.order.IsPhoneVerified"\n    class="contents borderedBottom"\n  >\n    <div class="contentsTitle paymentMethods withSide withSideButton">\n      <h1>Payment Method</h1>\n    </div>\n    <div class="contentsCore paymentMethods">\n      <div\n        class="globalFormUnitCheck globalFormUnitRadio big"\n        ng-click="vm.setPaymentMethod(\'kashier\')"\n      >\n        <input type="radio" name="payMethod" />\n        <div class="globalFormUnitCheckCore">\n          <svg viewBox="0 0 24 24">\n            <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />\n          </svg>\n        </div>\n        <img src="assets/images/payment/visa.png" />\n        <img src="assets/images/payment/mastercard.png" />\n      </div>\n      <div class="globalFormUnitCheck globalFormUnitCheckMini">\n        <input type="checkbox" ng-click="vm.isTermsAgreed=!vm.isTermsAgreed" />\n        <div class="globalFormUnitCheckCore">\n          <svg viewBox="0 0 24 24">\n            <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />\n          </svg>\n        </div>\n        <p>\n          I have read and agreed to\n          <a href="#/buyer-agreement" target="_blank"\n            >Tixawy\'s Buyer Agreement</a\n          >.\n        </p>\n      </div>\n    </div>\n    <div class="globalButtonsBar topSpace">\n      <a\n        href="javascript:void(0)"\n        ng-if="!vm.isPaymentSelected || !vm.isTermsAgreed || billingForm.$invalid || vm.proceedClicked"\n        class="globalButton callToAction otherSide"\n        disabled\n        >Proceed With Payment</a\n      >\n      <a\n        ng-if="vm.isPaymentSelected && vm.isTermsAgreed && billingForm.$valid && !vm.proceedClicked"\n        class="globalButton callToAction blue otherSide"\n        ng-click="vm.proceedPayment()"\n        >Proceed With Payment</a\n      >\n    </div>\n  </div>\n</div>\n<div ng-if="vm.isLoggedIn && vm.order && !vm.order.IsPhoneVerified">\n  <div class="contents">\n    <div class="contentsTitle">\n      <h1>Please Verify Your Phone To Proceed</h1>\n    </div>\n    <div class="contentsCore">\n      <div class="globalButtonsBar edged">\n        <a\n          href="#/users/verify"\n          ng-click="vm.verifyPhone()"\n          class="globalButton callToAction blue"\n        >\n          Verify Phone\n        </a>\n      </div>\n    </div>\n  </div>\n</div>\n<div ng-if="!vm.isLoggedIn">\n  <div class="contents">\n    <div class="contentsTitle">\n      <h1>Please Login to proceed</h1>\n    </div>\n    <div class="contentsCore">\n      <div class="globalButtonsBar edged">\n        <a\n          href="javascript:void(0);"\n          ng-click="vm.toggleLoginPanel()"\n          class="globalButton callToAction blue"\n        >\n          Login to Tixawy\n        </a>\n        <a\n          href="javascript:void(0);"\n          color="red"\n          class="globalButton callToAction normalChars regularFont"\n        >\n          Cancel\n        </a>\n      </div>\n    </div>\n  </div>\n</div>\n<div eturn-popup title="Ticket Sold" ng-if="vm.isSold" show-poper="vm.isSold">\n  <div class="tableLike">\n    <p>Sorry! Ticket has been sold.</p>\n  </div>\n  <div class="globalButtonsBar topSpace">\n    <a\n      ng-click="vm.returnToPerformance()"\n      class="globalButton callToAction blue otherSide"\n      >OK</a\n    >\n  </div>\n</div>\n<div\n  eturn-popup\n  title="Limit Exceeded"\n  ng-if="vm.limitExceeded"\n  show-poper="vm.limitExceeded"\n>\n  <div class="tableLike">\n    <p>Sorry! You have exceeded your limit of pending orders.</p>\n  </div>\n  <div class="globalButtonsBar topSpace">\n    <a\n      ng-click="vm.returnToPerformance()"\n      class="globalButton callToAction blue otherSide"\n      >OK</a\n    >\n  </div>\n</div>\n<div\n  eturn-popup\n  title="Not Allowed"\n  ng-if="vm.isTicketOwner"\n  show-poper="vm.isTicketOwner"\n>\n  <div class="tableLike">\n    <p>Sorry! You can not buy your own ticket.</p>\n  </div>\n  <div class="globalButtonsBar topSpace">\n    <a\n      ng-click="vm.returnToPerformance()"\n      class="globalButton callToAction blue otherSide"\n      >OK</a\n    >\n  </div>\n</div>\n');
$templateCache.put('app/components/payments/paymentDetails.html','<div class="contents borderedBottom">\n    <div class="eventsListFilter breadCrumb">\n        <p>\n            <a href="#/home">Home</a>\n            <span>\n        <svg><use xlink:href="#breadCrumbArrow" /></svg>\n      </span>\n            <span>{{vm.order.PerformanceName}}</span>\n            <span>\n        <svg><use xlink:href="#breadCrumbArrow" /></svg>\n      </span>\n            <span>Payment Details</span>\n        </p>\n    </div>\n    <div class="contentsTitle withSide withSideButton">\n        <h1>Order #{{vm.order.Reference}}</h1>\n    </div>\n    <div class="contentsCore borderedBottom">\n        <div class="contentsHalf">\n            <div class="unitWithImage" size="250x130">\n                <div class="unitWithImageImg">\n                    <img src="{{vm.order.OrderImage}}">\n                </div>\n                <div class="unitWithImageData">\n                    <h1>{{vm.order.PerformanceName}}</h1>\n                    <p class="date">{{vm.order.PerformanceDate}}</p>\n                    <p class="date">{{vm.order.PerformanceDay}} \n                        <span>{{vm.order.PerformanceTime}}</span>\n                    </p>\n                    <p>{{vm.order.PerformanceVenue}}</p>\n                </div>\n            </div>\n        </div>\n        <div class="contentsHalf startWithpadding borderedStartWith">\n            <div class="tableLike noLastBorder condensed">\n                <div class="rowLike">\n                    <div class="cellLike">\n                        <p>Seats</p>\n                    </div>\n                    <div class="cellLike" \n                         ng-if="vm.order.IsSeating \n                                || (vm.order.TicketRow != null && vm.order.TicketsNumber > 1)">\n                        <p ng-if="vm.order.Section != null && vm.order.IncrementType == \'Standard  \'">\n                            Section {{vm.order.Section}} / Row {{vm.order.TicketRow}} / Seats \n                            From {{vm.order.StartSeat}} \n                            To {{vm.order.StartSeat + vm.order.TicketsNumber - 1}}\n                        </p>\n                        <p ng-if="vm.order.Section == null && vm.order.IncrementType == \'Standard  \'">\n                            Row {{vm.order.TicketRow}} / Seats \n                            From {{vm.order.StartSeat}} \n                            To {{vm.order.StartSeat + vm.order.TicketsNumber - 1}}\n                        </p>\n                        <p ng-if="vm.order.Section != null && vm.order.IncrementType != \'Standard  \'">\n                            Section {{vm.order.Section}} / Row {{vm.order.TicketRow}} / Seats \n                            From {{vm.order.StartSeat}} \n                            To {{(vm.order.StartSeat + ((vm.order.TicketsNumber - 1) * 2))}}\n                        </p>\n                        <p ng-if="vm.order.Section == null && vm.order.IncrementType != \'Standard  \'">\n                            Row {{vm.order.TicketRow}} / Seats \n                            From {{vm.order.StartSeat}} \n                            To {{vm.order.StartSeat + ((vm.order.TicketsNumber - 1) * 2)}}\n                        </p>\n                    </div>\n                    <div class="cellLike" \n                         ng-if="vm.order.IsSeating \n                                || (vm.order.TicketRow != null && vm.order.TicketsNumber == 1) ">\n                        <p ng-if="vm.order.Section == null">\n                            Row {{vm.order.TicketRow}} / Seat {{vm.order.StartSeat}} \n                        </p>\n                        <p ng-if="vm.order.Section != null">\n                            Section {{vm.order.Section}} / Row {{vm.order.TicketRow}} / \n                            Seat {{vm.order.StartSeat}} \n                        </p>\n\n                    </div>\n                    <div class="cellLike" \n                         ng-if="!vm.order.IsSeating && (vm.order.TicketBlock == null \n                                && vm.order.TicketRow == null)">\n                        <p>{{vm.order.Section}}</p>\n                    </div>\n                </div>\n                <div class="rowLike">\n                    <div class="cellLike">\n                        <p>Number of Tickets</p>\n                    </div>\n                    <div class="cellLike" ng-if="vm.order.IsSeating">\n                        <p ng-if="vm.order.TicketsNumber>1">\n                            {{vm.order.TicketsNumber}} - Your seats will be together.\n                        </p>\n                        <p ng-if="vm.order.TicketsNumber<2">{{vm.order.TicketsNumber}}</p>\n                    </div>\n                    <div class="cellLike" ng-if="!vm.order.IsSeating">\n                        <p>{{vm.order.TicketsNumber}}</p>\n                    </div>\n                </div>\n                <div class="rowLike">\n                    <div class="cellLike">\n                        <p>Price per Ticket</p>\n                    </div>\n                    <div class="cellLike">\n                        <h1 class="price">LE {{vm.order.TicketPrice}}<span>.00</span></h1>\n                    </div>\n                </div>\n            </div>\n\n        </div>\n    </div>\n</div>\n<div class="contents borderedBottom">\n    <div class="contentsHalf startWithpadding changeFloatingOnPaymentDetails borderedStartWith">\n        <div class="contentsTitle withSide withSideButton">\n            <h1>Order Summary</h1>\n            <div ng-if="$root.clientWidth <= 620">\n                <div class="orderCountDown" ng-if="vm.mins>0">\n                    <timer ng-if="vm.mins <= 1400" countdown="vm.mins" max-time-unit="\'minute\'" \n                           interval="1000" finish-callback="vm.finsihTimer()">\n                        {{mminutes}}:{{sseconds}}\n                    </timer>\n                    <timer ng-if="vm.mins >  1400" countdown="vm.mins" max-time-unit="\'hour\'"\n                           interval="1000" finish-callback="vm.finsihTimer()">\n                        {{hhours}} h {{mminutes}} m {{sseconds}} s\n                    </timer>\n                </div>\n            </div>\n            <div class="contentsCore">\n                <div class="tableLike">\n                    <div class="rowLike rowLikeHead">\n                        <div class="cellLike addMoreSpace">\n                            <p>Item</p>\n                        </div>\n                        <div class="cellLike center">\n                            <p>QTY</p>\n                        </div>\n                        <div class="cellLike otherSide">\n                            <p>Price</p>\n                        </div>\n                        <div class="cellLike otherSide">\n                            <p>Total</p>\n                        </div>\n                    </div>\n                    <div class="rowLike">\n                        <div class="cellLike" \n                             ng-class="{\'rtlContents\':$root.isArabic(vm.order.PerformanceName)}" \n                             ng-style=\'{"text-align":\n                                      ($root.isArabic(vm.order.PerformanceName)?"left":null)}\'>\n                            <p>{{vm.order.PerformanceName}} Ticket</p>\n                        </div>\n                        <div class="cellLike center">\n                            <p>{{vm.order.TicketsNumber}}</p>\n                        </div>\n                        <div class="cellLike otherSide">\n                            <p>LE {{vm.order.TicketPrice}}</p>\n                        </div>\n                        <div class="cellLike otherSide">\n                            <p>LE {{vm.order.TicketsTotalPrice}}</p>\n                        </div>\n                    </div>\n                    <div ng-repeat="fees in vm.order.OrderFees" class="rowLike">\n                        <div class="cellLike">\n                            <p>{{fees.FeeName}}</p>\n                        </div>\n                        <div class="cellLike center">\n                            <p></p>\n                        </div>\n                        <div class="cellLike otherSide">\n                            <p></p>\n                        </div>\n                        <div class="cellLike otherSide">\n                            <!-- <p>LE  {{vm.order.OrderFees}}</p> -->\n                            LE {{fees.FeeValue}}\n                        </div>\n                    </div>\n\n                    <div ng-repeat="fees in vm.order.OrderTaxes" class="rowLike">\n                        <div class="cellLike">\n                            <p>{{fees.FeeName}}</p>\n                        </div>\n                        <div class="cellLike center">\n                            <p></p>\n                        </div>\n                        <div class="cellLike otherSide">\n                            <p></p>\n                        </div>\n                        <div class="cellLike otherSide">\n                            <!-- <p>LE  {{vm.order.OrderFees}}</p> -->\n                            {{fees.FeeValue}}\n                        </div>\n                    </div>\n                </div>\n                <div class="resetTotal">\n                    <p>Total <span>LE  {{vm.order.OrderGrandTotal}}</span></p>\n                </div>\n            </div>\n            <!--Order Summary -->\n        </div>\n    </div>\n    <div class="contentsHalf  endWithPadding">\n        <div class="contentsTitle withSide">\n            <h1>Card Details</h1>\n            <div ng-if="$root.clientWidth > 620">\n                <div class="orderCountDown" ng-if="vm.mins>0">\n                    <timer ng-if="vm.mins <= 1400" countdown="vm.mins" max-time-unit="\'minute\'" \n                           interval="1000" finish-callback="vm.finsihTimer()">\n                        {{mminutes}}:{{sseconds}}\n                    </timer>\n                    <timer ng-if="vm.mins >  1400" countdown="vm.mins" max-time-unit="\'hour\'" \n                           interval="1000" finish-callback="vm.finsihTimer()">\n                        {{hhours}} h {{mminutes}} m {{sseconds}} s\n                    </timer>\n                </div>\n            </div>\n        </div>\n        <!-- Visa Payment  -->\n        <div class="paymentFrameHolder" ng-show="vm.showPayment">\n            <div class="accountRowLabel">\n                <!-- <p>Pay with card</p> -->\n            </div>\n            <div>\n                <div ng-if="vm.orderLoaded">\n                    <iframe width="100%" height="510" ng-src={{vm.kashierIFrameSrc}} scrolling="yes" \n                            frameborder="0" onload="setIframeLoaded()"></iframe>\n                </div>\n                <div class="paymentPreloader" ng-if="!vm.paymentLoaded">\n                    <div class="spinner">\n                        <div class="dot1"></div>\n                        <div class="dot2"></div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div eturn-popup title="You Ran Out Of Time" ng-if="vm.timeExceeded" show-poper="vm.timeExceeded">\n        <div class="tableLike">\n            <p>\n                If you\u2019ve entered payment details your order may have been processed,\n                so don\u2019t place another order yet \u2013 you will find this order in your orders page within\n                the hour if your order was successful.\n            </p>\n        </div>\n        <div class="globalButtonsBar topSpace">\n            <a ng-click="vm.returnToOrders()" class="globalButton callToAction blue otherSide">OK</a>\n        </div>\n    </div>\n\n    <div eturn-popup title="Payment Failed" ng-if="vm.paymentFailed" show-poper="vm.paymentFailed">\n        <div class="tableLike">\n            <p> The payment process for this order has failed!\n            </p>\n        </div>\n        <div class="globalButtonsBar topSpace">\n            <a ng-click="vm.returnToOrders()" class="globalButton callToAction blue otherSide">OK</a>\n        </div>\n    </div>\n\n    <div eturn-popup title="Payment Success" ng-if="vm.paymentDone">\n        <div class="tableLike">\n            <p> Payment done successfully for this order. The receipt will be under "Order History"\n            </p>\n        </div>\n        <div class="globalButtonsBar topSpace">\n            <a ng-click="vm.returnToOrders()" class="globalButton callToAction blue otherSide">\n                Go To My Orders\n            </a>\n        </div>\n    </div>');
$templateCache.put('app/components/payments/paymentFailedPopup.html','<div eturn-popup spread title="payment Failed">\n    <div class="tableLike">\n        <p>\n            Payment has been Failed for this order. All your receipts will be under "Order History" \n            on your orders page.\n        </p>\n    </div>\n    <div class="globalButtonsBar topSpace">\n        <a ng-click="vm.returnToOrders()" class="globalButton callToAction blue otherSide">\n            Go To My Orders\n        </a>\n    </div>\n</div>');
$templateCache.put('app/components/payments/paymentSuccess.html','<div class="contents borderedBottom">\n  <div class="eventsListFilter breadCrumb">\n    <p>\n      <a href="#/home">Home</a>\n      <span>\n          <svg><use xlink:href="#breadCrumbArrow" /></svg>\n      </span>\n      <span>Checkout</span>\n      <span>\n          <svg><use xlink:href="#breadCrumbArrow" /></svg>\n      </span>\n      <span>Payment Success</span>\n    </p>\n  </div>\n\n\n\n  <div class="invoice" id="invoice">\n    <div class="invoiceHead">\n      <div class="invoiceHeadData">\n        <p>\n          <span>Order Placed:</span> {{vm.order.performanceDate}}\n        </p>\n        <p>\n          <span>Order Number:</span> {{vm.order.reference}}\n        </p>\n        <p>\n          <span>Order Total:</span> LE  {{vm.order.orderTotal}}\n        </p>\n      </div>\n      <img src="assets/images/logoBlack.png"/>\n    </div>\n    <div class="invoiceBody">\n      <div class="invoiceUnit">\n        <div class="invoiceUnitTitle">\n          <h1>Order Details</h1>\n        </div>\n        <div class="invoiceUnitBody">\n          <div class="tableLike">\n            <div class="rowLike rowLikeHead">\n              <div class="cellLike">\n                <p>Item</p>\n              </div>\n              <div class="cellLike center">\n                <p>QTY</p>\n              </div>\n              <div class="cellLike otherSide">\n                <p>Price</p>\n              </div>\n              <div class="cellLike otherSide">\n                <p>Total</p>\n              </div>\n            </div>\n            <div class="rowLike">\n              <div class="cellLike">\n                <p>Al Ahly VS Al Ismaily Match Ticket</p>\n              </div>\n              <div class="cellLike center">\n                <p>{{vm.order.ticketsNumber}}</p>\n              </div>\n              <div class="cellLike otherSide">\n                <p>LE  {{vm.order.ticketPrice}}</p>\n              </div>\n              <div class="cellLike otherSide">\n                <p>LE  {{vm.order.ticketsTotalPrice}}</p>\n              </div>\n            </div>\n            <div class="rowLike">\n              <div class="cellLike">\n                <p>Services Fees</p>\n              </div>\n              <div class="cellLike center">\n                <p></p>\n              </div>\n              <div class="cellLike otherSide">\n                <p></p>\n              </div>\n              <div class="cellLike otherSide">\n                <p>LE  {{vm.order.orderFees}}</p>\n              </div>\n            </div>\n          </div>\n          <div class="resetTotal">\n            <p>Total <span>LE  {{vm.order.orderTotal}}</span></p>\n          </div>\n        </div>\n      </div>\n      <div class="invoiceUnit">\n        <div class="invoiceUnitTitle">\n          <h1>Payment Information</h1>\n        </div>\n        <div class="invoiceUnitBody">\n          <div class="tableLike noBorders">\n            <div class="rowLike">\n              <div class="cellLike">\n                <p><span>Payment Method</span></p>\n                <p>Visa | Last digits: {{vm.order.usedCard}}</p>\n                <div class="invUp">\n                  <p><span>Billing Address</span></p>\n                  <p>{{vm.order.billingName}}</p>\n                  <p>{{vm.order.billingAddress}}</p>\n                  <p>{{vm.order.billingCity}}, {{vm.order.billingCountry}}</p>\n                </div>\n              </div>\n              <div class="cellLike center invoiceTotals">\n                <p>Item(s) Subtotal: <span>LE  {{vm.order.orderTotal}}</span></p>\n                <p class="dashes">-----</p>\n                <p>Total before tax: <span>LE  {{vm.order.orderTotal}}</span></p>\n                <p>Estimated tax to be collected: <span>LE  {{vm.order.orderTaxes}}</span></p>\n                <p class="dashes">-----</p>\n                <p>Grand Total: <span>LE  {{vm.order.orderTaxTotal}}</span></p>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class="contentsTitle withSide withSideButton">\n    <h1>Order #65564552</h1>\n    <a href="javascript:void(0);" class="globalButton borderedButton autoWidth iconButton" color="grey" ng-click="vm.genInvoice()" ng-class="{loading:vm.invoiceLoading}">\n      <svg viewBox="0 0 24 24" ng-if="vm.invoiceLoading">\n        <path d="M12,6V9L16,5L12,1V4A8,8 0 0,0 4,12C4,13.57 4.46,15.03 5.24,16.26L6.7,14.8C6.25,13.97 6,13 6,12A6,6 0 0,1 12,6M18.76,7.74L17.3,9.2C17.74,10.04 18,11 18,12A6,6 0 0,1 12,18V15L8,19L12,23V20A8,8 0 0,0 20,12C20,10.43 19.54,8.97 18.76,7.74Z" />\n      </svg>\n      View Invoice\n    </a>\n  </div>\n  <div class="contentsCore borderedBottom">\n    <div class="contentsHalf">\n      <div class="unitWithImage" size="250x130">\n        <div class="unitWithImageImg">\n          <img src="assets/images/temp/{{vm.order.orderImage}}_250x130.jpg">\n        </div>\n        <div class="unitWithImageData">\n          <h1><a href="">{{vm.order.performanceName}}</a></h1>\n          <p class="date">{{vm.order.performanceDate}}</p>\n          <p class="date">{{vm.order.performanceDay}} <span>{{vm.order.performanceTime}}</span></p>\n          <p><a href="">{{vm.order.performanceVenue}}</a></p>\n        </div>\n      </div>\n    </div>\n    <div class="contentsHalf startWithpadding borderedStartWith">\n      <div class="tableLike noLastBorder condensed">\n        <div class="rowLike">\n          <div class="cellLike">\n            <p>Seats</p>\n          </div>\n          <div class="cellLike">\n            <p>Block {{vm.order.ticketBlock}}, Row {{vm.order.ticketRow}}</p>\n          </div>\n        </div>\n        <div class="rowLike">\n          <div class="cellLike">\n            <p>Number of Tickets</p>\n          </div>\n          <div class="cellLike">\n            <p>{{vm.order.ticketsNumber}} - Your seats will be together.</p>\n          </div>\n        </div>\n        <div class="rowLike">\n          <div class="cellLike">\n            <p>Price per Ticket</p>\n          </div>\n          <div class="cellLike">\n                <h1 class="price">LE {{vm.order.ticketPrice}}<span>.00</span></h1>\n          </div>\n        </div>\n      </div>\n\n    </div>\n  </div>\n</div>\n<div class="contents borderedBottom paymentSuccess">\n  <div class="contentsHalf endWithPadding relativeThis">\n    <div class="contentsTitle withSide">\n      <h1>Payment Success</h1>\n    </div>\n\n    <div class="contentsCore">\n      <svg viewBox="0 0 24 24">\n          <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />\n      </svg>\n      <p>Using Card *** **** *** {{vm.order.usedCard}}</p>\n      <p>You will find <a href="">this order</a> in <a href="">My Orders</a> section.</p>\n\n    </div>\n  </div>\n  <div class="contentsHalf startWithpadding borderedStartWith">\n    <div class="contentsTitle withSide withSideButton">\n      <h1>Order Summary</h1>\n    </div>\n    <div class="contentsCore">\n      <div class="tableLike">\n        <div class="rowLike rowLikeHead">\n          <div class="cellLike">\n            <p>Item</p>\n          </div>\n          <div class="cellLike center">\n            <p>QTY</p>\n          </div>\n          <div class="cellLike otherSide">\n            <p>Price</p>\n          </div>\n          <div class="cellLike otherSide">\n            <p>Total</p>\n          </div>\n        </div>\n        <div class="rowLike">\n          <div class="cellLike">\n            <p>{{vm.order.performanceName}} Ticket</p>\n          </div>\n          <div class="cellLike center">\n            <p>{{vm.order.ticketsNumber}}</p>\n          </div>\n          <div class="cellLike otherSide">\n            <p>LE  {{vm.order.ticketPrice}}</p>\n          </div>\n          <div class="cellLike otherSide">\n            <p>LE  {{vm.order.ticketsTotalPrice}}</p>\n          </div>\n        </div>\n        <div class="rowLike">\n          <div class="cellLike">\n            <p>Services Fees</p>\n          </div>\n          <div class="cellLike center">\n            <p></p>\n          </div>\n          <div class="cellLike otherSide">\n            <p></p>\n          </div>\n          <div class="cellLike otherSide">\n            <p>LE  {{vm.order.orderFees}}</p>\n          </div>\n        </div>\n      </div>\n      <div class="resetTotal">\n        <p>Total <span>LE  {{vm.order.orderTotal}}</span></p>\n      </div>\n      <div class="globalButtonsBar topSpace">\n        <a href="" class="globalButton callToAction red fullWidth">Cancel This Order</a>\n      </div>\n    </div>\n  </div>\n</div>\n');
$templateCache.put('app/components/payments/paymentSuccessPopup.html','<div eturn-popup spread title="Payment Success">\n  <div class="tableLike">\n    <p>Payment done successfully for this order. The receipt will be under "Order History" on your orders page.\n    </p>\n  </div>\n  <div class="globalButtonsBar topSpace">\n    <a ng-click="vm.returnToOrders()" class="globalButton callToAction blue otherSide">Go To My Orders</a>\n  </div>\n</div>');
$templateCache.put('app/components/payments/sell.html','<div class="contents">\n\t<div class="contentsTitle">\n\t\t<h1>Sell Tickets</h1>\n\t</div>\n\t<spinner\n\t\tng-if="vm.performanceLoading"\n\t\tgive="contentsCore"\n\t\tpush="center"\n\t></spinner>\n\t<form\n\t\tclass="contentsCore"\n\t\tname="sellForm"\n\t\tng-submit="vm.saveRequestData()"\n\t\tng-if="!vm.performanceLoading"\n\t>\n\t\t<div class="globalForm">\n\t\t\t<div class="globalFormTwoUnits">\n\t\t\t\t<div class="globalFormUnit">\n\t\t\t\t\t<p>Category</p>\n\t\t\t\t\t<input\n\t\t\t\t\t\ttype="text"\n\t\t\t\t\t\tvalue="{{ vm.PerformanceDetails.CategoryName }}"\n\t\t\t\t\t\tdisabled\n\t\t\t\t\t/>\n\t\t\t\t</div>\n\t\t\t\t<div class="globalFormUnit">\n\t\t\t\t\t<p>Event</p>\n\t\t\t\t\t<input\n\t\t\t\t\t\ttype="text"\n\t\t\t\t\t\tvalue="{{ vm.PerformanceDetails.PerformanceName }}"\n\t\t\t\t\t\tdisabled\n\t\t\t\t\t/>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="globalFormThreeUnits">\n\t\t\t\t<div\n\t\t\t\t\tclass="globalFormUnit"\n\t\t\t\t\tng-class="{error:sellForm.numberOfTickets.$error.pattern}"\n\t\t\t\t>\n\t\t\t\t\t<p>Number of Tickets</p>\n\t\t\t\t\t<span ng-show="sellForm.numberOfTickets.$error.pattern">\n\t\t\t\t\t\tMaximum 25 tickets\n\t\t\t\t\t</span>\n\t\t\t\t\t<input\n\t\t\t\t\t\ttype="text"\n\t\t\t\t\t\tname="numberOfTickets"\n\t\t\t\t\t\tid="numberOfTickets"\n\t\t\t\t\t\tng-model="vm.NumberOfTickets"\n\t\t\t\t\t\tplaceholder="Maximum 25"\n\t\t\t\t\t\ttickets-num\n\t\t\t\t\t\tprice\n\t\t\t\t\t\tmobile-phone\n\t\t\t\t\t\trequired\n\t\t\t\t\t\tng-pattern="/^\\d*[1-9]\\d*$/"\n\t\t\t\t\t/>\n\t\t\t\t</div>\n\t\t\t\t<div\n\t\t\t\t\tclass="globalFormUnit"\n\t\t\t\t\tng-class="{error:sellForm.ticketsType.$error.pattern}"\n\t\t\t\t>\n\t\t\t\t\t<p>Tickets Type</p>\n\t\t\t\t\t<select\n\t\t\t\t\t\tdisabled\n\t\t\t\t\t\tdata-ng-options="ticketType.name for ticketType in vm.PerformanceDetails.TicketTypes"\n\t\t\t\t\t\tng-model="vm.SelectedTicketType"\n\t\t\t\t\t></select>\n\t\t\t\t</div>\n\t\t\t\t<div class="globalFormUnit">\n\t\t\t\t\t<p>Section</p>\n\t\t\t\t\t<select\n\t\t\t\t\t\tng-if="vm.SelectedSection"\n\t\t\t\t\t\tdata-ng-options="section.name for section in vm.PerformanceDetails.Sections"\n\t\t\t\t\t\tdata-ng-model="vm.SelectedSection"\n\t\t\t\t\t\tng-change="vm.updateSelectedSection()"\n\t\t\t\t\t></select>\n\t\t\t\t\t<input\n\t\t\t\t\t\tng-if="!vm.SelectedSection"\n\t\t\t\t\t\ttype="text"\n\t\t\t\t\t\tvalue="No Sections Available"\n\t\t\t\t\t\tdisabled\n\t\t\t\t\t/>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="globalFormThreeUnits">\n\t\t\t\t<div\n\t\t\t\t\tclass="globalFormUnit"\n\t\t\t\t\tng-class="{error:sellForm.sellPrice.$error.pattern}"\n\t\t\t\t>\n\t\t\t\t\t<p>Sell Price</p>\n\t\t\t\t\t<span ng-show="sellForm.sellPrice.$error.pattern">\n\t\t\t\t\t\tInvalid Sell Price\n\t\t\t\t\t</span>\n\t\t\t\t\t<input\n\t\t\t\t\t\ttype="text"\n\t\t\t\t\t\tname="sellPrice"\n\t\t\t\t\t\tid="sellPrice"\n\t\t\t\t\t\tng-model="vm.SellPrice"\n\t\t\t\t\t\trequired\n\t\t\t\t\t\tng-pattern="/^[0-9]*$/"\n\t\t\t\t\t/>\n\t\t\t\t\t<!-- ng-pattern="/^[+]?([0-9]+(?:[\\.][0-9]*)?|\\.[0-9]+)$/" -->\n\t\t\t\t</div>\n\t\t\t\t<div\n\t\t\t\t\tclass="globalFormUnit"\n\t\t\t\t\tng-class="{error:sellForm.printedPrice.$error.pattern}"\n\t\t\t\t>\n\t\t\t\t\t<p>Price Printed on Ticket</p>\n\t\t\t\t\t<span ng-show="sellForm.printedPrice.$error.pattern">\n\t\t\t\t\t\tInvalid Price\n\t\t\t\t\t</span>\n\t\t\t\t\t<input\n\t\t\t\t\t\ttype="text"\n\t\t\t\t\t\tname="printedPrice"\n\t\t\t\t\t\tid="printedPrice"\n\t\t\t\t\t\tng-model="vm.printedPrice"\n\t\t\t\t\t\trequired\n\t\t\t\t\t\tng-pattern="/^[0-9]*$/"\n\t\t\t\t\t/>\n\t\t\t\t\t<!-- ng-pattern="/^[+]?([0-9]+(?:[\\.][0-9]*)?|\\.[0-9]+)$/" -->\n\t\t\t\t</div>\n\t\t\t\t<div class="globalFormUnit">\n\t\t\t\t\t<p>How To Sell</p>\n\t\t\t\t\t<select\n\t\t\t\t\t\tdata-ng-options="bundel.name for bundel in vm.PerformanceDetails.Bundles"\n\t\t\t\t\t\tdata-ng-model="vm.SelectedBundle"\n\t\t\t\t\t></select>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="globalFormThreeUnits" ng-if="vm.showSeating">\n\t\t\t\t<div\n\t\t\t\t\tclass="globalFormUnit"\n\t\t\t\t\tng-class="{error:sellForm.row.$error.pattern}"\n\t\t\t\t>\n\t\t\t\t\t<p>Row</p>\n\t\t\t\t\t<span ng-show="sellForm.row.$error.pattern">\n\t\t\t\t\t\tInvalid Row\n\t\t\t\t\t</span>\n\t\t\t\t\t<input\n\t\t\t\t\t\ttype="text"\n\t\t\t\t\t\tname="row"\n\t\t\t\t\t\tid="row"\n\t\t\t\t\t\tng-model="vm.Row"\n\t\t\t\t\t\trequired\n\t\t\t\t\t/>\n\t\t\t\t\t<!-- ng-pattern="/^[a-zA-Z0-9]*$/" -->\n\t\t\t\t</div>\n\t\t\t\t<div\n\t\t\t\t\tclass="globalFormUnit"\n\t\t\t\t\tng-class="{error:sellForm.startingSeatNumber.$error.pattern}"\n\t\t\t\t\tng-if="vm.showSeating"\n\t\t\t\t>\n\t\t\t\t\t<p>Starting Seat Number</p>\n\t\t\t\t\t<span ng-show="sellForm.startingSeatNumber.$error.pattern">\n\t\t\t\t\t\tInvalid Seat Number\n\t\t\t\t\t</span>\n\t\t\t\t\t<input\n\t\t\t\t\t\ttype="text"\n\t\t\t\t\t\tname="startingSeatNumber"\n\t\t\t\t\t\tid="startingSeatNumber"\n\t\t\t\t\t\tng-model="vm.StartingSeatNumber"\n\t\t\t\t\t\trequired\n\t\t\t\t\t\tng-pattern="/^\\d*[1-9]\\d*$/"\n\t\t\t\t\t/>\n\t\t\t\t</div>\n\t\t\t\t<div class="globalFormUnit">\n\t\t\t\t\t<p>Increment Seating Type</p>\n\t\t\t\t\t<select\n\t\t\t\t\t\tng-model="vm.incrementType"\n\t\t\t\t\t\tng-change="vm.showSeats(vm.SelectedSeatingType)"\n\t\t\t\t\t>\n\t\t\t\t\t\t<option value="Standard"\n\t\t\t\t\t\t\t>Standard ex. Seats 1, 2, 3</option\n\t\t\t\t\t\t>\n\t\t\t\t\t\t<option value="Odd/Even"\n\t\t\t\t\t\t\t>Odd/Even ex. Seats 1, 3, 5</option\n\t\t\t\t\t\t>\n\t\t\t\t\t</select>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="globalFormUnitCheck globalFormUnitCheckMini">\n\t\t\t<input type="checkbox" ng-model="vm.Agree" />\n\t\t\t<div class="globalFormUnitCheckCore">\n\t\t\t\t<svg viewBox="0 0 24 24">\n\t\t\t\t\t<path\n\t\t\t\t\t\td="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"\n\t\t\t\t\t/>\n\t\t\t\t</svg>\n\t\t\t</div>\n\t\t\t<p>\n\t\t\t\tI have read and agreed to the\n\t\t\t\t<a href="#/seller-agreement" target="_blank"\n\t\t\t\t\t>Tixawy\'s Seller Agreement</a\n\t\t\t\t>.\n\t\t\t</p>\n\t\t</div>\n\t\t<div class="globalButtonsBar topSpace">\n\t\t\t<a\n\t\t\t\tng-click="vm.saveRequestData(vm.Agree && !(sellForm.$invalid) && !(sellForm.$pristine))"\n\t\t\t\tclass="globalButton callToAction blue otherSide"\n\t\t\t\tng-disabled="!vm.Agree || !vm.submitClickable|| (sellForm.$invalid) || (sellForm.$pristine)"\n\t\t\t>\n\t\t\t\tSubmit\n\t\t\t</a>\n\t\t</div>\n\t</form>\n</div>\n\n<div eturn-popup title="National Id!" ng-if="!vm.IsIdUploaded">\n\t<div class="tableLike">\n\t\t<p>\n\t\t\tNational ID is not submitted yet. Please submit it to be able to send sell\n\t\t\trequests.\n\t\t</p>\n\t</div>\n\t<div class="globalButtonsBar topSpace">\n\t\t<a\n\t\t\tng-click="vm.goToAccountSettings()"\n\t\t\tclass="globalButton callToAction blue otherSide"\n\t\t\t>Account</a\n\t\t>\n\t</div>\n</div>\n');
$templateCache.put('app/components/performances/performance.html','<spinner ng-if="vm.PerformanceLoading" give="contents" push="center"></spinner>\n<div class="featuredEventsCarousel" ng-if="!vm.PerformanceLoading">\n    <div class="featuredEventsCarouselFeaturedUnit">\n        <div class="featuredEventsCarouselFeaturedUnitImage">\n            <img src="{{vm.PerformanceDetails.Image}}" />\n        </div>\n        <div class="featuredEventsCarouselFeaturedUnitData">\n            <h1>{{vm.PerformanceDetails.Name}}</h1>\n            <div class="featuredEventsCarouselFeaturedUnitDataContents">\n                <div class="dateDayFocus white">\n                    <div class="dateDayFocusDay"\n                        ng-class="{alignMiddle:vm.PerformanceDetails.Year!==\'\'}">\n                        <p>{{vm.PerformanceDetails.Day}}</p>\n                    </div>\n                    <div class="dateDayFocusRest">\n                        <p>{{vm.PerformanceDetails.Month}}</p>\n                        <p class="day">{{vm.PerformanceDetails.Year}}</p>\n                        <p class="day">{{vm.PerformanceDetails.DayName}}</p>\n                    </div>\n                    <p class="dateDayFocusTime">{{vm.PerformanceDetails.Time}}</p>\n                    <!-- <div class="dateDayFocusRest">\n                        <p>{{vm.PerformanceDetails.Month}}</p>\n                        <p class="day">{{vm.PerformanceDetails.Year}}</p>\n                    </div>\n                    <p class="dateDayFocusTime">{{vm.PerformanceDetails.DayName}} {{vm.PerformanceDetails.Time}}</p> -->\n                </div>\n                <div class="featuredEventsCarouselFeaturedUnitVenue"\n                    ng-if="vm.PerformanceDetails.Venue!=null">\n                    <svg>\n                        <use xlink:href="#venueIcon" /></svg>\n                    <div class="featuredEventsCarouselFeaturedUnitVenueName">\n                        <p>{{vm.PerformanceDetails.Venue}}</p>\n                    </div>\n                    <a href="#/venue/{{vm.PerformanceDetails.VenueId}}" class="hitArea"></a>\n                </div>\n                <div class="featuredEventsRules">\n                    <h2 ng-if="vm.PerformanceDetails.EventRestrictions.length!=0">Event Rules</h2>\n                    <div class="featuredEventsRulesUnits">\n                        <div class="row">\n                            <div class="featuredEventsRule" tooltipposition="left"\n                                ng-repeat="rest in vm.PerformanceDetails.EventRestrictions" tooltip="No {{rest.name}}">\n                                <svg ng-if="rest.name==\'recording\'">\n                                    <use xlink:href="#noVideoRecording" /></svg>\n                                <svg ng-if="rest.name==\'camera\'">\n                                    <use xlink:href="#noCameras" /></svg>\n                                <svg ng-if="rest.name==\'drinking\'">\n                                    <use xlink:href="#noDrinks" /></svg>\n                                <svg ng-if="rest.name==\'food\'">\n                                    <use xlink:href="#noFood" /></svg>\n                                <svg ng-if="rest.name==\'smoking\'">\n                                    <use xlink:href="#noSmoking" /></svg>\n                                <svg ng-if="rest.name==\'children\'">\n                                    <use xlink:href="#noChildren" /></svg>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class="globalButtonsBar">\n                    <a ng-if="vm.PerformanceDetails.AvailableTickets>0 &&vm.PerformanceDetails.IsBuyBlocked!=true &&vm.PerformanceDetails.IsVisible==true"\n                        class="globalButton callToAction nevy" scroll href="javascript:void(0);"\n                        scroll-to="#ticketsTable">Buy<span>Tickets</span></a>\n                    <a ng-if="vm.PerformanceDetails.IsSellBlocked!=true &&vm.PerformanceDetails.IsVisible==true"\n                        href="javascript:;" class="globalButton callToAction red"\n                        ng-click="vm.trySell(vm.id)">Sell<span>Tickets</span></a>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div class="contents borderedBottom lessTop" ng-if="!vm.PerformanceLoading">\n    <div class="eventsListFilter breadCrumb">\n        <p>\n            <a href="#/home">Home</a>\n            <span ng-repeat="category in vm.PerformanceDetails.ParentCategories">\n                <span>\n                    <svg>\n                        <use xlink:href="#breadCrumbArrow" /></svg>\n                </span>\n                <a href="#/category/{{category.ParentCategoryId}}">{{category.ParentCategory}}</a>\n            </span>\n            <span>\n                <svg>\n                    <use xlink:href="#breadCrumbArrow" /></svg>\n            </span>\n            <span>{{vm.PerformanceDetails.Name}}</span>\n        </p>\n    </div>\n    <div class="contentsTitle withSide">\n        <h1>About {{vm.PerformanceDetails.Name}}</h1>\n        <div class="titleSocials">\n            <a href="" class="facebook" id="share" tooltip="Share on Facebook" socialshare\n                socialshare-provider="facebook" socialshare-text="720kb AngularJS Socialshare"\n                socialshare-hashtags="angularjs, angular-socialshare" socialshare-url={{vm.performanceUrl}}>\n                <svg>\n                    <use xlink:href="#facebookIcon" /></svg>\n            </a>\n            <a href="javascript:void(0);" class="globalButton borderedButton" color="lightGrey"\n                ng-if="$root.clientWidth<=768 && vm.PerformanceDetails.SeatmapImage2"\n                ng-click="vm.openPhotoSwipe()">Seating Map</a>\n        </div>\n    </div>\n    <div class="contentsCore textData" ng-class="{rtlContents:$root.isArabic(vm.PerformanceDetails.Description)}">\n        <p>\n            {{vm.PerformanceDetails.Description}}\n        </p>\n    </div>\n    <!--Performers List-->\n    <div class="contentsCore topSpace eventPerformers" ng-if="vm.performers.length > 0">\n        <p>\n            Event performers:\n            <a href="javascript:void(0);" ng-repeat="performer in vm.performers"\n                ng-click="vm.goPerformer(performer.PerformerId)">{{performer.PerformerName}}</a>\n        </p>\n    </div>\n</div>\n<!--<spinner ng-if="vm.PerformanceLoading" give="contents" push="center"></spinner>-->\n<div ng-if="vm.PerformanceDetails.AvailableTickets > 0 && !vm.PerformanceDetails.IsBuyBlocked \n     && vm.PerformanceDetails.IsVisible && !vm.performanceloading" class=" contents" id="ticketsTable">\n    <div class="contentsTitle">\n        <h1>\n            <span>{{vm.totalTickets}}</span>\n            Tickets from\n            <span class="price">{{vm.minPrice}}<span>.00</span></span>\n            per ticket\n        </h1>\n    </div>\n    <div class="performenceSeatingMap" ng-if="$root.clientWidth>768">\n        <!--<img src="assets/images/temp/seating2.jpg" />-->\n        <img src="{{vm.PerformanceDetails.SeatmapImage1}}" />\n    </div>\n    <div class="ticketsDataTable">\n        <div class="eventsListFilter">\n            <div class="eventsListFilterUnit">\n                <p>Price</p>\n                <input type="number" ng-model="vm.ticketgroupPriceFilter" price />\n            </div>\n            <div class="eventsListFilterUnit">\n                <p ng-if="$root.clientWidth<=420">Qty</p>\n                <p ng-if="$root.clientWidth>420">Quantity</p>\n                <select ng-model="vm.ticketgroupQuantityFilter">\n                    <option>Any</option>\n                    <option ng-repeat="quantity in vm.totalQuantitiesTrimmed | orderBy track by $index">\n                        {{quantity}}\n                    </option>\n                </select>\n            </div>\n        </div>\n        <div class="contentsCore" ng-if="vm.customConfigParams.total() < 1">\n            No tickets found.\n        </div>\n        <div class="contentsCore" ng-if="vm.customConfigParams.total() > 0">\n            <table ng-table=" vm.customConfigParams" class="eventsList" show-filter="false">\n                <tr ng-repeat="ticket in $data">\n                    <td ng-model="vm.ticketgroupPriceFilter" title="\'Price\'" filter="{TicketPrice: \'number\'}"\n                        sortable="\'TicketPrice\'" class="priceCell">\n                        <h1 class="price">LE {{ticket.TicketPrice}}<span>.00</span></h1>\n                        <span class="ticketsListlegend">Per Ticket</span>\n                    </td>\n                    <td title="\'Section\'" sortable="\'Type\'">\n                        <p class="eventName" ng-if="ticket.Row!=null && ticket.Section!=null">Section\n                            {{ticket.Section}}, Row {{ticket.Row}}</p>\n                        <p class="eventName" ng-if="ticket.Row!=null && ticket.Section==null">Row {{ticket.Row}}</p>\n                        <p class="eventName" ng-if="ticket.Row==null">{{ticket.Section}}</p>\n                        <div class="ticketsQtyMobile" ng-if="$root.clientWidth<=420">\n                            <select ng-model="ticket.SelectedQuantity">\n                                <option ng-model="ticket.SelectedQuantity"\n                                    ng-repeat="quantity in ticket.Quantities | orderBy"\n                                    ng-selected="quantity == vm.ticketgroupQuantityFilter">{{quantity}}</option>\n                            </select><span class="ticketsListlegend">Of {{ticket.RemainingTickets}}</span>\n                            <span class="ticketsListlegend">Ticket Type: {{ticket.Type}} </span>\n                        </div>\n                    </td>\n                    <td ng-model="vm.ticketgroupQuantityFilter" title="\'Qty\'" sortable="\'RemainingTickets\'"\n                        filter="{Quantities: \'select\'}" class="qtyselect" ng-if="$root.clientWidth>420">\n                        <select ng-model="ticket.SelectedQuantity">\n                            <option ng-repeat="quantity in ticket.Quantities | orderBy"\n                                ng-selected="quantity == vm.ticketgroupQuantityFilter">{{quantity}}</option>\n                        </select>\n                        <span class="ticketsListlegend">Ticket Type: {{ticket.Type}} </span>\n                    </td>\n                    <td class="ticketsBuyCell">\n                        <div class="globalButtonsBar edged otherSide single">\n                            <a ng-if="vm.PerformanceDetails.AvailableTickets >0  && vm.PerformanceDetails.IsBuyBlocked!=true"\n                                ng-click="vm.buyPerformanceTickets(ticket)" class="globalButton borderedButton"\n                                color="nevy">Buy</a>\n                            <p class="ticketsListlegend" ng-if="ticket.eTicket">e-Ticket</p>\n                        </div>\n                    </td>\n                </tr>\n            </table>\n        </div>\n        <div class="globalButtonsBar midTopSpace extraWidth">\n            <a href="javascript:void(0);" class="globalButton borderedButton" color="grey"\n                ng-show="vm.customConfigParams.settings().total > 0 && vm.moreTickets" ng-click="vm.loadMore()">\n                Load More\n            </a>\n        </div>\n    </div>\n</div>\n<!-- Root element of PhotoSwipe. Must have class pswp. -->\n<div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">\n    <div class="pswp__bg"></div>\n    <div class="pswp__scroll-wrap">\n        <div class="pswp__container">\n            <div class="pswp__item"></div>\n            <div class="pswp__item"></div>\n            <div class="pswp__item"></div>\n        </div>\n        <div class="pswp__ui pswp__ui--hidden">\n            <div class="pswp__top-bar">\n                <div class="pswp__counter"></div>\n                <!-- <button class="pswp__button pswp__button--close" title="Close (Esc)"></button> -->\n                <!-- <button class="pswp__button pswp__button--share" title="Share"></button> -->\n                <!-- <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button> -->\n                <!-- <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button> -->\n                <div class="pswp__preloader">\n                    <div class="pswp__preloader__icn">\n                        <div class="pswp__preloader__cut">\n                            <div class="pswp__preloader__donut"></div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">\n                <div class="pswp__share-tooltip"></div>\n            </div>\n            <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)"></button>\n            <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)"></button>\n            <div class="pswp__caption">\n                <div style="text-align: center" class="pswp__caption__center"></div>\n            </div>\n        </div>\n    </div>\n    <div eturn-popup title="{{$root.PopUpTitle}}" closable=true ng-if="$root.showPopup == true"\n        show-poper="$root.showPopup">\n        {{$root.PopUpDescription}}\n    </div>\n</div>\n<script type="text/javascript">\n    window.onload = function () {\n        var button = document.getElementById("share");\n\n        button.onclick = function () {\n            var title = encodeURIComponent(\'My title\');\n            var summary = encodeURIComponent(\'My message\');\n            var url = encodeURIComponent(\'https://www.mysite.com/foo\');\n            var image = encodeURIComponent(\'https://pics.mysite.com/mylogo.png\');\n\n            window.open(\'http://www.facebook.com/sharer.php?s=100&amp;p[title]=\' + title + \'&amp;p[summary]=\' + summary + \'&amp;p[url]=\' + url + \'&amp;p[images][0]=\' + image, \'sharer\', \'toolbar=0,status=0,width=548,height=325\');\n        }\n    }\n</script>');
$templateCache.put('app/components/performers/performer.html','<spinner ng-if="vm.performerLoading" give="contents" push="center"></spinner>\n<div class="banner" ng-if="!vm.performerLoading">\n    <img src="{{vm.performerDetails.Image}}" />\n</div>\n<div class="contents borderedBottom" ng-if="!vm.performerLoading">\n    <div class="contentsTitle">\n        <h1>{{vm.performerDetails.name}}</h1>\n    </div>\n    <div class="contentsCore textData" ng-class="{rtlContents:$root.isArabic(vm.performerDetails.Description)}">\n        <p>\n            {{vm.performerDetails.Description}}\n        </p>\n    </div>\n</div>\n<div class="contents" ng-if="vm.hasPerformances && !vm.performerLoading">\n    <div class="contentsTitle" ng-if="vm.hasPerformances">\n        <h1>{{vm.performerDetails.name}} Events</h1>\n    </div>\n    <div class="contentsCore">\n        <div class="eventsListFilter eventsListFilterIdentifier">\n            <div class="eventsListFilterUnit">\n                <p>Category</p>\n                <select ng-model="vm.filters.CategoryId"\n                        ng-init="vm.filters.CategoryId = -1"\n                        ng-options="category.CategoryId as category.CategoryName for category in vm.allCategories"\n                        ng-change="vm.getPerformances(false)"></select>\n            </div>\n            <div class="eventsListFilterUnit">\n                <p>Event</p>\n                <select ng-model="vm.filters.EventId"\n                        ng-init="vm.filters.EventId = -1"\n                        ng-options="event.EventId as event.EventName for event in vm.allEvents"\n                        ng-change="vm.getPerformances(false)"></select>\n            </div>\n            <div class="eventsListFilterUnit">\n                <p>Venue</p>\n                <select ng-model="vm.filters.VenueId"\n                        ng-init="vm.filters.VenueId = -1"\n                        ng-options="venue.VenueId as venue.VenueName for venue in vm.allVenues"\n                        ng-change="vm.getPerformances(false)"></select>\n            </div>\n            <div class="eventsListFilterUnit">\n                <p>Performer</p>\n                <select disabled>\n                    <option>{{vm.performerDetails.name}} </option>\n                </select>\n            </div>\n        </div>\n    </div>\n    <spinner ng-if="vm.allEventsLoading" give="contents" push="center"></spinner>\n    <div class="contentsCore" ng-show="!vm.hasPerformancesFiltered && !vm.allEventsLoading">\n        <p>No Events Found.</p>\n    </div>\n    <table ng-table="vm.customConfigParams" class="eventsList eventsListIdentifier" show-filter="true"\n           ng-show="vm.hasPerformancesFiltered && !vm.allEventsLoading">\n        <tr ng-repeat="event in $data">\n            <td title="\'Date\'" sortable="\'startDate\'" class="dateCell">\n                <div class="dateDayFocus inEventsList">\n                    <div class="dateDayFocusDay">\n                        <p>{{event.day}}</p>\n                    </div>\n                    <div class="dateDayFocusRest">\n                        <p>{{event.month}} {{event.year}}</p>\n                        <p class="day">{{event.dayName}}, {{event.time}}</p>\n                    </div>\n                    <p ng-if="$root.clientWidth<=860 && $root.clientWidth>600" class="venueNameInDateCell"><a href="#/venue/{{event.venueid}}">{{event.venue}}</a></p>\n                </div>\n            </td>\n            <td title="\'Event\'" sortable="\'Name\'" class="eventsListEventCell" data-original-title="comeon">\n                <h1><a href="#/performance/{{event.PerformenceId}}">{{event.Performence}}</a></h1>\n                <!-- AI:MUST BE HIDDEN IF SINGLE PERFORMENCE PER EVENT-->\n                <p class="eventName"><a ng-if="event.Num_Performances_InEvent>1" href="#/event/{{event.EventId}}">{{event.EventName}}</a></p>\n                <p class="avTickets" ng-if="$root.clientWidth<=600">{{event.avTickets}} Tickets Available</p>\n                <p ng-if="$root.clientWidth<=600" class="venueNameInDateCell"><a href="#/venue/{{event.venueid}}">{{event.venue}}</a></p>\n                <div class="globalButtonsBar edged" ng-if="$root.clientWidth<=420">\n                    <a ng-if="event.avTickets !=0&&event.IsBuyBlocked!=true" href="#/performance/{{event.PerformenceId}}" class="globalButton borderedButton" color="nevy">buy tickets</a>\n                    <a ng-if="event.IsSellBlocked!=true" href="javascript:;" class="globalButton borderedButton" color="red" ng-click="vm.trySell(event.PerformenceId)">Sell tickets</a>\n                </div>\n            </td>\n            <td title="\'Venue\'" sortable="\'venue\'" ng-if="$root.clientWidth>860">\n                <p><a href="#/venue/{{event.venueid}}">{{event.venue}}</a></p>\n            </td>\n            <td ng-if="$root.clientWidth>600">\n                <p class="avTickets">{{event.avTickets}} Tickets Available</p>\n            </td>\n            <td ng-if="$root.clientWidth>420">\n                <div class="globalButtonsBar otherSide" ng-class="{edged:$root.clientWidth>860,vertical:$root.clientWidth<=860}">\n                    <a ng-if="event.avTickets !=0&&event.IsBuyBlocked!=true" href="#/performance/{{event.PerformenceId}}" class="globalButton borderedButton" color="nevy">buy tickets</a>\n                    <a ng-if="event.IsSellBlocked!=true" href="javascript:;" class="globalButton borderedButton" color="red" ng-click="vm.trySell(event.PerformenceId)">Sell tickets</a>\n                </div>\n            </td>\n        </tr>\n    </table>\n    <div class="globalButtonsBar midTopSpace extraWidth">\n        <a href="javascript:void(0);" class="globalButton borderedButton" color="lightGrey"\n           ng-click="vm.loadMore()"\n           ng-hide="vm.lastCall">\n            {{vm.loadMoreText}}\n        </a>\n    </div>\n    <div eturn-popup title="{{$root.PopUpTitle}}" closable=true ng-if="$root.showPopup == true" show-poper="$root.showPopup">\n        {{$root.PopUpDescription}}\n    </div>\n</div>\n');
$templateCache.put('app/components/requests/addRequest.html','<div class="contents">\n    <div class="contentsTitle">\n        <h1>{{vm.type}}</h1>\n    </div>\n    <form class="contentsCore" name="requestForm" >\n            <div class="globalForm">\n                <div class="contentsHalf endWithPadding">\n                    <div class="globalFormUnit condensed" ng-if="vm.id==0">\n                        <p>Name</p>\n\n                        <input type="text" name="name" id="name" ng-model="vm.Name"\n                               required />\n                    </div>\n                    <div class="globalFormUnit condensed" ng-if="vm.id!=0">\n                        <p>Name</p>\n\n                        <input type="text" name="name" id="name" value="{{vm.UserName}}"\n                               disabled />\n                    </div>\n                    <div class="globalFormUnit condensed" ng-class="{error:requestForm.Email.$error.pattern}" ng-if="vm.id==0">\n                        <p>Email</p>\n                        <input type="text" name="Email" id="Email" ng-model="vm.Email" required\n                               ng-pattern=\'/^(([^<>()\\[\\]\\.,;:\\s@\\"]+(\\.[^<>()\\[\\]\\.,;:\\s@\\"]+)*)|(\\".+\\"))@(([^<>()[\\]\\.,;:\\s@\\"]+\\.)+[^<>()[\\]\\.,;:\\s@\\"]{2,})$/i\'>\n                        <span ng-show="requestForm.Email.$error.pattern">\n                            Email must be in the form of me@example.com\n                        </span>\n                    </div>\n                    <div class="globalFormUnit condensed"  ng-if="vm.id!=0">\n                        <p>Email</p>\n\n                        <input type="text" name="name" id="name" value="{{vm.UserEmail}}"\n                               disabled />\n                        \n                    </div>\n                    <div class="globalFormUnit condensed" ng-class="{error:requestForm.Mobile.$error.pattern}">\n                        <p>Mobile</p>\n                        <input type="text" name="Mobile" id="Mobile" ng-model="vm.Mobile"\n                               mobile-phone required ng-pattern="/^\\+?\\d{2}[- ]?\\d{3}[- ]?\\d{6}$/" />\n                        <span ng-show="requestForm.Mobile.$error.pattern">\n                            Invalid Mobile Number\n                        </span>\n                    </div>\n                    <div class="globalFormUnit condensed">\n                        <p>Request Type</p>\n                        <select data-ng-options="requestType.name for requestType in vm.RequestsTypes" ng-model="vm.SelectedType"></select>\n                    </div>\n                    <div class="globalFormUnit condensed" ng-class="{error:requestForm.requestSubject.$error.pattern}">\n                        <p>Subject</p>\n                        <input type="text" name="requestSubject" id="requestSubject" ng-model="vm.requestSubject"\n                               placeholder="your Subject.."\n                               required />\n                    </div>\n                </div>\n                <div class="contentsHalf">\n                    <div class="globalFormUnit textareaForFive">\n                        <p>Message</p>\n                        <textarea rows="5" cols="100" type="text" name="body" id="body" ng-model="vm.requestBody"\n                                  required />\n                    </div>\n                </div>\n\n\n        <div class="globalButtonsBar topSpace">\n            <a ng-click="vm.saveRequestData(!(requestForm.$invalid) && !(requestForm.$pristine))" class="globalButton callToAction blue otherSide" ng-disabled="requestForm.$invalid || requestForm.$pristine">\n                {{vm.submitText}}\n            </a>\n        </div>\n                </div>\n    </form>\n    <div eturn-popup title="{{$root.PopUpTitle}}" closable=true ng-if="$root.PopError == true" show-poper="$root.PopError">\n        {{$root.PopUpDescription}}\n    </div>\n</div>\n');
$templateCache.put('app/components/search/search.html','<div class="contents">\n    <div class="eventsListFilter breadCrumb">\n        <p>\n            <a href="#/home">Home</a>\n            <span>\n                <svg><use xlink:href="#breadCrumbArrow" /></svg>\n            </span>\n            <span>Search Terms</span>\n        </p>\n    </div>\n    <div class="contentsTitle borderedBottom">\n        <h1>Events</h1>\n    </div>\n    <div class="contentsCore" ng-if="!vm.hasEvents">\n        <p>No Events Found.</p>\n    </div>\n    <div class="contentsCore" ng-if="vm.hasEvents">\n        <table ng-table="vm.eventsConfig" class="eventsList" show-filter="true">\n            <tr ng-repeat="event in $data">\n                <td title="\'Date\'" sortable="\'fullDate\'">\n                    <div class="dateDayFocus inEventsList">\n                        <div class="dateDayFocusDay">\n                            <p>{{event.day}}</p>\n                        </div>\n                        <div class="dateDayFocusRest">\n                            <p>{{event.month}} {{event.year}}</p>\n                            <p class="dateDayFocusTime">{{event.dayName}}, {{event.time | date:\'MM/dd/yy h:mm:ss a\'}}</p>\n                        </div>\n                    </div>\n                </td>\n                <td title="\'Event\'" sortable="\'eventName\'" class="eventsListEventCell">\n                    <h1><a href="#/performance/{{event.id}}">{{event.performence}}</a></h1>\n                    <p class="eventName"><a href="#/event/{{event.eventId}}">{{event.eventName}}</a></p>\n                </td>\n                <td title="\'Venue\'" sortable="\'venue\'">\n                    <p><a href="#/venue/{{event.venueId}}">{{event.venue}}</a></p>\n                    <p class="avTickets" ng-if="$root.clientWidth<=580">{{event.avTickets}} Tickets Available</p>\n                    <div class="globalButtonsBar edged otherSide" ng-if="$root.clientWidth<=500">\n                        <a ng-if="event.avTickets>0 && event.IsBuyBlocked!=true" href="#/performance/{{event.id}}" class="globalButton borderedButton" color="nevy">buy tickets</a>\n                        <a  ng-if="event.IsSellBlocked!=true" ng-click="vm.sell_redirection(event)" class="globalButton borderedButton" color="red">Sell tickets</a>\n                    </div>\n                </td>\n                <td>\n                    <p class="avTickets" ng-if="$root.clientWidth>580">{{event.avTickets}} Tickets Available</p>\n                </td>\n                <td> \n                    <div ng-if="$root.clientWidth>500" class="globalButtonsBar edged otherSide">\n                        <a ng-if="event.avTickets>0 && event.IsBuyBlocked!=true" href="#/performance/{{event.id}}" class="globalButton borderedButton" color="nevy">buy tickets</a>\n                        <a ng-if="event.IsSellBlocked!=true" ng-click="vm.sell_redirection(event)" class="globalButton borderedButton" color="red">Sell tickets</a>\n                    </div>\n                </td>\n            </tr>\n        </table>\n        <div class="globalButtonsBar midTopSpace extraWidth">\n            <a ng-if="event.Performances_count > 4" href="javascript:void(0);" class="globalButton borderedButton" color="lightGrey">Load More</a>\n        </div>\n    </div>\n</div>\n<div class="contents">\n    <div class="contentsTitle borderedBottom">\n        <h1>Performers</h1>\n    </div>\n    <div class="contentsCore"  ng-if="!vm.hasperformers">\n        <p>No Performer Found.</p>\n    </div>\n        <div class="contentsCore"  ng-if="vm.hasperformers">\n            <table ng-table="vm.performersConfig" class="eventsList" show-filter="true">\n                <tr ng-repeat="performer in $data">\n                    <td title="\'Performer\'" sortable="\'name\'" class="eventsListEventCell">\n                        <h1><a href="#/performer/{{performer.id}}">{{performer.name}}</a></h1>\n                    </td>\n                    <td>\n                        <div class="globalButtonsBar edged otherSide">\n                            <a href="#/performer/{{performer.id}}" class="globalButton borderedButton" color="nevy">Details</a>\n                        </div>\n                    </td>\n                </tr>\n            </table>\n            <div class="globalButtonsBar midTopSpace extraWidth">\n                <a ng-if="performer.Performer_count > 4" href="javascript:void(0);" class="globalButton borderedButton" color="lightGrey">Load More</a>\n            </div>\n        </div>\n    </div>\n\n        <div class="contents">\n            <div class="contentsTitle borderedBottom">\n                <h1>Venues</h1>\n            </div>\n            <div class="contentsCore" ng-if="!vm.hasvenues">\n                <p>No Venues Found.</p>\n            </div>\n            <div class="contentsCore"  ng-if="vm.hasvenues">\n\n                <table ng-table="vm.venuesConfig" class="eventsList" show-filter="true">\n                    <tr ng-repeat="venue in $data">\n                        <td title="\'Venue\'" sortable="\'name\'" class="eventsListEventCell">\n                            <h1><a href="#/venue/{{venue.id}}">{{venue.name}}</a></h1>\n                        </td>\n                        <td>\n                            <div class="globalButtonsBar edged otherSide">\n                                <a href="#/venue/{{venue.id}}" class="globalButton borderedButton" color="nevy">Details</a>\n                            </div>\n                        </td>\n                    </tr>\n                </table>\n                <div class="globalButtonsBar midTopSpace extraWidth">\n                    <a ng-if="venue.Venues_count > 4" href="javascript:void(0);" class="globalButton borderedButton" color="lightGrey">Load More</a>\n                </div>\n            </div>\n        </div>\n\n');
$templateCache.put('app/components/users/404.html','<div class="contents">\n    <div class="contentsCore centeredContents">\n        <p style="margin:0;font-size:130px;line-height:110px">\n            404\n        </p>\n        <p style="margin:0;font-size:30px;">\n            Page Not Found\n        </p>\n    </div>\n\n</div>\n');
$templateCache.put('app/components/users/account.html','<div class="contents borderedBottom">\n    <div class="eventsListFilter breadCrumb">\n        <p>\n            <a href="#/home">Home</a>\n            <span>\n                <svg><use xlink:href="#breadCrumbArrow" /></svg>\n            </span>\n            <span>Account Settings</span>\n        </p>\n    </div>\n    <div class="globalButtonsBar bottomSpace">\n        <a\n            href="#/users/emailVerifiy/SendVerificationEmail"\n            class="globalButton callToAction blue"\n            ng-if="!$root.User.IsEmailVerified && $root.User.Email">\n            Verify Mail\n        </a>\n        <a\n            href="#/users/verify"\n            class="globalButton callToAction blue addMarginTopOnresponsive"\n            ng-if="!$root.User.IsPhoneVerified && $root.User.MobileNumber">\n            Verify Phone\n        </a>\n    </div>\n    <div class="contentsTitle">\n        <h1>Account Settings</h1>\n    </div>\n    <div class="contentsCore">\n        <div\n            class="accountRow borderedBottom"\n            ng-form="accountEmailForm"\n            ng-class="{active:vm.emailAddressToggle}">\n            <div class="accountRowLabel">\n                <p>Email Address</p>\n            </div>\n            <div class="accountRowValue">\n                <div class="accountRowValueData">\n                    <p>{{vm.accountInfoEmail.Address}}</p>\n                </div>\n                <div class="globalForm">\n                    <div class="globalFormUnit balanced sidedButton">\n                        <input\n                            type="text"\n                            id="email"\n                            name="email"\n                            ng-model="vm.accountInfoEmail.Address"\n                            ng-pattern="vm.regex.email"\n                            ng-change="vm.emailSubmitted = false"\n                            required />\n                        <input\n                            type="submit"\n                            value="{{vm.submitEmailText}}"\n                            class="globalButton inputSidedButton"\n                            ng-disabled="vm.emailSent"\n                            color="blue"\n                            ng-click="vm.saveEmail(accountEmailForm.$valid)" />\n                        <a\n                            href="javascript:void(0);"\n                            class="cancelEdit"\n                            ng-click="vm.toggler(\'emailAddressToggle\'); vm.resetEmailField()">Cancel</a>\n                    </div>\n                </div>\n            </div>\n            <div\n                class="accountRowControls"\n                ng-click="vm.toggler(\'emailAddressToggle\')">\n                <svg><use xlink:href="#editIcon" /></svg>\n                <p>Click to edit email address</p>\n            </div>\n            <p\n                class="accountError"\n                ng-show="accountEmailForm.email.$error.required && vm.emailSubmitted && vm.emailAddressToggle">\n                Email address is required\n            </p>\n            <p\n                class="accountError"\n                ng-show="vm.emailSubmitted && vm.emailUsed && vm.emailAddressToggle">\n                Email address is already used\n            </p>\n            <p\n                class="accountError"\n                ng-show="accountEmailForm.email.$error.pattern && vm.emailSubmitted && vm.emailAddressToggle">\n                Invalid email address\n            </p>\n        </div>\n        <!-- AI:Consider the error class please -->\n        <div\n            class="accountRow borderedBottom"\n            ng-form="accountMobileForm"\n            ng-class="{active:vm.mobileNumberToggle}">\n            <div class="accountRowLabel">\n                <p>Mobile Number</p>\n            </div>\n            <div class="accountRowValue">\n                <div class="accountRowValueData">\n                    <p>{{vm.accountInfoMobile.NumberCopy}}</p>\n                </div>\n                <div class="globalForm">\n                    <div class="globalFormUnit balanced sidedButton">\n                        <input\n                            type="text"\n                            id="mobile"\n                            name="mobile"\n                            ng-model="vm.accountInfoMobile.Number"\n                            ng-change="vm.mobileUsed = false"\n                            ng-pattern="vm.regex.mobile"\n                            mobile-phone\n                            required\n                            style="padding-left:52px" />\n                        <input\n                            type="submit"\n                            value="{{vm.submitMobileText}}"\n                            class="globalButton inputSidedButton"\n                            ng-disabled="vm.mobileSent"\n                            color="blue"\n                            ng-click="vm.saveMobile(accountMobileForm.$valid)" />\n                        <a\n                            href="javascript:void(0);"\n                            class="cancelEdit"\n                            ng-click="vm.toggler(\'mobileNumberToggle\'); vm.resetMobileField()">Cancel</a>\n                    </div>\n                </div>\n            </div>\n            <div\n                class="accountRowControls"\n                ng-click="vm.toggler(\'mobileNumberToggle\')">\n                <svg><use xlink:href="#editIcon" /></svg>\n                <p>Click to edit mobile number</p>\n            </div>\n            <p\n                class="accountError"\n                ng-show="accountMobileForm.mobile.$error.required && vm.mobileSubmitted && vm.mobileNumberToggle">\n                Mobile number is required\n            </p>\n            <p\n                class="accountError"\n                ng-show="vm.mobileSubmitted && vm.mobileUsed && vm.mobileNumberToggle">\n                Mobile number is already used\n            </p>\n            <p\n                class="accountError"\n                ng-show="accountMobileForm.mobile.$invalid \n                && !accountMobileForm.mobile.$error.required \n                && vm.mobileSubmitted\n                && vm.mobileNumberToggle">\n                Invalid mobile number\n            </p>\n        </div>\n        <div\n            class="accountRow borderedBottom"\n            ng-form="accountPasswordForm"\n            ng-class="{active:vm.passwordToggle}"\n            ng-if="!$root.User.IsFacebookUser">\n            <div class="accountRowLabel">\n                <p>Password</p>\n            </div>\n            <div class="accountRowValue">\n                <div class="accountRowValueData">\n                    <p ng-class="{green:vm.passwordReset}">\n                        {{vm.passwordText}}\n                    </p>\n                </div>\n                <div class="globalForm">\n                    <div\n                        class="globalFormUnit balanced sidedButton dateDropDowns">\n                        <p>Old Password</p>\n                        <input\n                            type="password"\n                            id="currentPassword"\n                            name="currentPassword"\n                            ng-model="vm.accountInfoPasswords.current"\n                            ng-change="vm.passwordSubmitted = false"\n                            required />\n                    </div>\n                    <div\n                        class="globalFormUnit balanced sidedButton dateDropDowns">\n                        <p>New Password</p>\n                        <input\n                            type="password"\n                            id="password"\n                            name="password"\n                            ng-model="vm.accountInfoPasswords.new"\n                            ng-required="vm.accountInfoPasswords.current.length > 0"\n                            ng-pattern="vm.regex.password"\n                            ng-model-options="{allowInvalid: true}"\n                            ng-minlength="6"\n                            ng-maxlength="30" />\n                    </div>\n                    <div\n                        class="globalFormUnit balanced sidedButton dateDropDowns">\n                        <p>Confirm New Password</p>\n                        <input\n                            type="password"\n                            id="confirmpassword"\n                            name="confirmpassword"\n                            ng-model="vm.accountInfoPasswords.confirm"\n                            match="vm.accountInfoPasswords.new" />\n                        <input\n                            type="submit"\n                            value="{{vm.submitNewPasswordText}}"\n                            class="globalButton inputSidedButton"\n                            ng-disabled="vm.passwordSent"\n                            color="blue"\n                            ng-click="vm.savePassword(accountPasswordForm)" />\n                        <a\n                            href="javascript:void(0);"\n                            class="cancelEdit"\n                            ng-click="vm.toggler(\'passwordToggle\'); vm.resetPasswordFields()">Cancel</a>\n                    </div>\n                </div>\n            </div>\n            <p\n                class="accountError"\n                ng-show="accountPasswordForm.confirmpassword.$error.matched\n                && !accountPasswordForm.password.$error.minlength\n                && !accountPasswordForm.password.$error.maxlength\n                && !accountPasswordForm.password.$error.pattern\n                && !accountPasswordForm.password.$error.required\n                && vm.passwordToggle\n                && vm.passwordSubmitted">\n                Passwords do not match\n            </p>\n            <p\n                class="accountError"\n                ng-show="accountPasswordForm.password.$error.required \n                && vm.passwordToggle \n                && vm.passwordSubmitted">\n                New password is required\n            </p>\n            <p\n                class="accountError"\n                ng-show="accountPasswordForm.password.$error.minlength\n                && !accountPasswordForm.currentPassword.$error.required\n                && vm.passwordToggle && vm.passwordSubmitted">\n                New password is too short\n            </p>\n            <p\n                class="accountError"\n                ng-show="accountPasswordForm.password.$error.maxlength \n                && vm.passwordToggle \n                && vm.passwordSubmitted">\n                New password is too long\n            </p>\n            <p\n                class="accountError"\n                ng-show="accountPasswordForm.password.$error.pattern\n                && !accountPasswordForm.password.$error.required\n                && !accountPasswordForm.password.$error.minlength\n                && !accountPasswordForm.password.$error.maxlength\n                && vm.passwordToggle && vm.passwordSubmitted">\n                New password must contain uppercase letters, lowercase letters\n                and digits\n            </p>\n            <p\n                class="accountError"\n                ng-show="accountPasswordForm.currentPassword.$error.required\n                && vm.passwordToggle\n                && vm.passwordSubmitted\n                && !vm.passwordReset">\n                Old password is required\n            </p>\n            <p\n                class="accountError"\n                ng-show="vm.incorrectPassword\n                && accountPasswordForm.$pristine\n                && !vm.duplicatePassword \n                && vm.passwordToggle\n                && vm.passwordSubmitted">\n                Incorrect password\n            </p>\n            <p\n                class="accountError"\n                ng-show="vm.duplicatePassword\n                && accountPasswordForm.$pristine\n                && vm.passwordToggle\n                && vm.passwordSubmitted">\n                Old and new passwords cannot be the same\n            </p>\n            <div\n                class="accountRowControls"\n                ng-click="vm.toggler(\'passwordToggle\')">\n                <svg><use xlink:href="#editIcon" /></svg>\n                <p>Click to edit password</p>\n            </div>\n        </div>\n\n        <div\n            class="accountRow borderedBottom"\n            ng-form="nationalIdForm"\n            ng-class="{active:vm.nationalIdToggle}">\n            <div class="accountRowLabel">\n                <p>National ID</p>\n            </div>\n\n            <div class="accountRowValue">\n                <div class="accountRowValueData">\n                    <a href="{{vm.NationalId.link}}" target="_blank">\n                        <img ng-if="vm.NationalId.link !== null" ng-src="{{vm.NationalId.link}}" />\n                    </a>\n                    <input ng-if="vm.NationalId.link === null" type="file" file="myFile" />\n                </div>\n                <div class="globalForm">\n                    <div class="globalFormUnit sidedButton">\n                        <input ng-if="vm.nationalIdToggle" type="file" file="myFile" />\n                        <a href="javascript:void(0);"\n                            class="cancelEdit"\n                            ng-click="vm.toggler(\'nationalIdToggle\'); vm.resetNationalId();">\n                            Cancel\n                        </a>\n                    </div>\n                </div>\n            </div>\n\n            <div class="accountRowControls"\n                ng-if="vm.NationalId.link !== null && !vm.nationalIdToggle"\n                ng-click="vm.toggler(\'nationalIdToggle\')">\n                <svg><use xlink:href="#editIcon" /></svg>\n                <p>Click to edit national ID</p>\n            </div>\n\n            <a href="javascript:;" ng-if="vm.NationalId.link === null || vm.nationalIdToggle" ng-click="vm.uploadFiles()">\n                <div class="accountRowControls">\n                    <svg\n                        xmlns="http://www.w3.org/2000/svg"\n                        xmlns:xlink="http://www.w3.org/1999/xlink"\n                        version="1.1"\n                        id="Capa_1"\n                        x="0px"\n                        y="0px"\n                        width="725.334px"\n                        height="725.334px"\n                        viewBox="0 0 725.334 725.334"\n                        style="enable-background:new 0 0 725.334 725.334;"\n                        xml:space="preserve">\n                        <g>\n                            <g id="Out">\n                                <g>\n                                    <path\n                                        d="M249.333,181.333c9.384,0,17.884-3.808,24.049-9.973l55.284-55.284v371.258c0,18.768,15.209,34,34,34     c18.791,0,34-15.232,34-34V116.076l55.307,55.284c6.143,6.166,14.643,9.973,24.026,9.973c18.791,0,34-15.232,34-34     c0-9.384-3.808-17.884-9.95-24.049L386.717,9.951C380.551,3.808,372.051,0,362.667,0s-17.884,3.808-24.027,9.973L225.307,123.307     c-6.166,6.143-9.974,14.643-9.974,24.026C215.333,166.101,230.543,181.333,249.333,181.333z M623.334,226.667H498.667     c-18.791,0-34,15.232-34,34s15.209,34,34,34h102v362.667h-476V294.667h102c18.791,0,34-15.232,34-34s-15.209-34-34-34H102     c-25.001,0-45.333,20.354-45.333,45.333v408c0,24.979,20.332,45.334,45.333,45.334h521.333c25.001,0,45.333-20.355,45.333-45.334     V272C668.667,247.021,648.335,226.667,623.334,226.667z" />\n                                </g>\n                            </g>\n                        </g>\n                        <g></g>\n                        <g></g>\n                        <g></g>\n                        <g></g>\n                        <g></g>\n                        <g></g>\n                        <g></g>\n                        <g></g>\n                        <g></g>\n                        <g></g>\n                        <g></g>\n                        <g></g>\n                        <g></g>\n                        <g></g>\n                        <g></g>\n                    </svg>\n                    <p>Click to upload image</p>\n                </div>\n            </a>\n        </div>\n    </div>\n</div>\n<div eturn-popup\n    title="Uploading File"\n    ng-if="vm.showInProgressPopup"\n    show-poper="vm.showInProgressPopup">\n    <div class="tableLike">\n        <p>Your file is being uploaded. Please wait...</p>\n    </div>\n</div>\n<div eturn-popup\n    title="File Error"\n    ng-if="vm.showFileErrorPopup"\n    show-poper="vm.showFileErrorPopup">\n    <div class="tableLike">\n        <p>{{vm.fileError}}</p>\n    </div>\n    <div class="globalButtonsBar topSpace">\n        <a ng-click="vm.showFileErrorPopup = false"\n            class="globalButton callToAction blue">\n            Dismiss\n        </a>\n    </div>\n</div>\n<div eturn-popup\n    title="{{vm.filePopupTitle}}"\n    ng-if="vm.showFileUploadedPopup"\n    show-poper="vm.showFileUploadedPopup">\n    <div class="tableLike">\n        <p>{{vm.filePopupBody}}</p>\n    </div>\n    <div class="globalButtonsBar topSpace">\n        <a ng-click="vm.dismissFileUploadedPopup()"\n            class="globalButton callToAction blue">\n            Dismiss\n        </a>\n    </div>\n</div>');
$templateCache.put('app/components/users/balanceSheet.html','<div class="contents">\n    <div class="eventsListFilter breadCrumb">\n        <p>\n            <a href="#/home">Home</a>\n            <span>\n                <svg><use xlink:href="#breadCrumbArrow" /></svg>\n            </span>\n            <span>Balance Sheet</span>\n        </p>\n    </div>\n    <div class="contentsTitle borderedBottom">\n        <h1>Your Balance Sheet</h1>\n    </div>\n    <div class="contentsCore" >\n        <table ng-table="vm.customConfigParamsPending" class="eventsList">\n            <tr ng-repeat="ticket in $data track by $index">\n                <td title="\'In/Out\'" class="dateCell mini">\n                    <div class="dateDayFocus inEventsList">\n                        <div class="dateDayFocusDay">\n                            <p>{{ticket.Day}}</p>\n                        </div>\n                        <div class="dateDayFocusRest">\n                            <p>{{ticket.Month}} {{ticket.Year}}</p>\n                            <p class="day">{{ticket.DayName}}, {{ticket.Time}}</p>\n                        </div>\n                    </div>\n                </td>\n                <td title="\'Price\'" class="priceCell">\n                    <h1 class="price">LE {{ticket.Price}}<span>.00</span></h1>\n                </td>\n                <td title="\'QTY\'" class="boughtCell">\n                    <h1>\n                        {{ticket.NumberOfTickets}}\n                        <span ng-if="!ticket.eTicket">Tickets</span>\n                        <span ng-if="ticket.eTicket">e-Tickets</span>\n                    </h1>\n                    <p class="eventName">Block {{ticket.Block}}, Row {{ticket.Row}}</p>\n                </td>\n                <td title="\'Event\'" class="eventsListEventCell">\n                    <h1><a href="#/performance/{{ticket.PerformanceId}}">{{ticket.PerformanceName}}</a></h1>\n                    <p class="eventName"><a href="#/event/{{ticket.EventId}}">{{ticket.EventName}}</a></p>\n                </td>\n                <td>\n                    <div class="globalButtonsBar edged otherSide">\n                        <a href="" class="globalButton borderedButton" color="grey" tooltip="Send a cancellation request"\n                           ng-click="vm.CancelSellRequest(ticket.RequestId)">\n                            {{ticket.CancelText}}\n                        </a>\n                    </div>\n                </td>\n            </tr>\n        </table>\n        <!--     <div class="globalButtonsBar midTopSpace extraWidth">\n              <a href="javascript:void(0);" class="globalButton borderedButton" color="lightGrey">Load More</a>\n            </div> -->\n    </div>\n</div>');
$templateCache.put('app/components/users/boughtTickets.html','<div class="contents">\n    <div class="eventsListFilter breadCrumb">\n        <p>\n            <a href="#/home">Home</a>\n            <span>\n                <svg><use xlink:href="#breadCrumbArrow" /></svg>\n            </span>\n            <span>Your Orders</span>\n        </p>\n    </div>\n    <div class="contentsTitle borderedBottom">\n        <h1>Orders History</h1>\n    </div>\n    <spinner ng-if="vm.ticketsLoading" push="left"></spinner>\n    <div class="contentsCore" ng-if="!vm.hasActiveTickets && !vm.ticketsLoading">\n        <p>No previous orders found.</p>\n    </div>\n    <div class="contentsCore" ng-if="vm.hasActiveTickets">\n        <table ng-table="vm.customConfigParamsActiveTable" class="eventsList" show-filter="true">\n            <tr ng-repeat="ticket in $data">\n                <!--<td title="\'Date\'" sortable="\'fullDate\'" class="dateCell mini">-->\n                <td title="\'Date\'" sortable="\'fullDate\'" class="dateCell">\n                    <div class="dateDayFocus inEventsList">\n                        <div class="dateDayFocusDay">\n                            <p>{{ticket.day}}</p>\n                        </div>\n                        <div class="dateDayFocusRest">\n                            <p>{{ticket.month}} {{ticket.year}}</p>\n                            <p class="day">{{ticket.dayName}}, {{ticket.time}}</p>\n                        </div>\n                    </div>\n                </td>\n                <td title="\'Total Price\'" sortable="\'OrderTotal\'" class="priceCell">\n                    <h1 class="price">LE {{ticket.OrderTotal}} </h1>\n                    <h1 ng-if="$root.clientWidth<=690" class="editFontSize">\n                        {{ticket.bought}}\n                        <span ng-if="!ticket.eTicket">Tickets</span>\n                        <span ng-if="ticket.eTicket">e-Tickets</span>\n                    </h1>\n                    <p ng-if="$root.clientWidth<=690 && ticket.row!=null && ticket.section!=null" class="eventName">Section {{ticket.section}}, Row {{ticket.row}}</p>\n                    <p ng-if="$root.clientWidth<=690 && ticket.row!=null && ticket.section==null" class="eventName">Row {{ticket.row}}</p>\n                    <p ng-if="$root.clientWidth<=690 && ticket.row==null" class="eventName">{{ticket.section}}</p>\n                    <h1 ng-if="$root.clientWidth<=690" class="eventName">\n                        <span ng-if="$root.clientWidth<=690">Created on</span>\n                    </h1>\n                    <p ng-if="$root.clientWidth<=690" class="eventName">{{ticket.CreatedOn}}</p>\n                </td>\n                <td ng-if="$root.clientWidth>690 " title="\'Details\'" sortable="\'FullOrderDate\'" class="boughtCell">\n                    <h1>\n                        {{ticket.bought}}\n                        <span ng-if="!ticket.eTicket">Tickets</span>\n                        <span ng-if="ticket.eTicket">e-Tickets</span>\n                    </h1>\n                    <p ng-if="ticket.row!=null && ticket.section!=null" class="eventName">Section {{ticket.section}}, Row {{ticket.row}}</p>\n                    <p ng-if="ticket.row!=null && ticket.section==null" class="eventName">Row {{ticket.row}}</p>\n                    <p class="eventName" ng-if="ticket.row ==null">{{ticket.section}}</p>\n                    <h1 class="eventName">\n                        <span>Created on</span>\n                    </h1>\n                    <p class="eventName">{{ticket.CreatedOn}}</p>\n                </td>\n                <td title="\'Event\'" sortable="\'eventName\'" class="eventsListEventCell">\n                    <h1><a href="#/performance/{{ticket.PerformanceId}}">{{ticket.performence}}</a></h1>\n                    <p class="eventName"><a ng-if="ticket.Num_Performances_InEvent>1" href="#/event/{{ticket.EventId}}">{{ticket.eventName}}</a></p>\n                    <a href="javascript:void(0);" class="globalButton borderedButton" color="green" ng-click="vm.showReceipt(ticket.OrderId)" ng-if="$root.clientWidth<=768">View Receipt</a>\n                </td>\n                <td ng-if="$root.clientWidth>768">\n                    <div class="globalButtonsBar edged otherSide">\n                        <a href="javascript:void(0);" class="globalButton borderedButton" color="green" ng-click="vm.showReceipt(ticket.OrderId)">View Receipt</a>\n                        <!-- <a href="#/categories" class="globalButton borderedButton" color="red">Resell</a>\n                        <a href="javascript:void(0);" class="globalButton borderedButton" color="green" ng-click="vm.showReceipt(ticket.OrderId)">View Receipt</a>\n                        <a href="" class="globalButton borderedButton" color="grey">Refund</a> -->\n                    </div>\n                </td>\n            </tr>\n        </table>\n        <div class="globalButtonsBar midTopSpace extraWidth">\n            <a ng-click="vm.loadMoreActive()" ng-if="vm.disableActive == false && vm.dataLength_Active > vm.CountPerPage_Active" class="globalButton borderedButton" color="lightGrey">Load More</a>\n        </div>\n    </div>\n</div>\n<div class="contents">\n    <div class="contentsTitle borderedBottom">\n        <h1>Pending Orders</h1>\n    </div>\n    <spinner ng-if="vm.ticketsLoading" push="left"></spinner>\n    <div class="contentsCore" ng-if="!vm.hasPendingTickets && !vm.ticketsLoading">\n        <p>No pending orders found.</p>\n    </div>\n    <div class="contentsCore" ng-if="vm.hasPendingTickets">\n        <table ng-table="vm.customConfigParamsPindingTable" class="eventsList" show-filter="true">\n            <tr ng-repeat="ticket in $data">\n                <!--<td title="\'Date\'" sortable="\'fullDate\'" class="dateCell mini">-->\n                <td title="\'Date\'" sortable="\'fullDate\'" class="dateCell">\n                    <div class="dateDayFocus inEventsList">\n                        <div class="dateDayFocusDay">\n                            <p>{{ticket.day}}</p>\n                        </div>\n                        <div class="dateDayFocusRest">\n                            <p>{{ticket.month}} </p>\n                            <p class="day">{{ticket.year}}</p>\n                        </div>\n                    </div>\n                </td>\n                <td title="\'Total Price\'" sortable="\'OrderTotal\'" class="priceCell">\n                    <h1 class="price">LE {{ticket.OrderTotal}} </span> </h1>\n                    <h1 ng-if="$root.clientWidth<=690" class="editFontSize">\n                        {{ticket.bought}}\n                        <span ng-if="!ticket.eTicket">Tickets</span>\n                        <span ng-if="ticket.eTicket">e-Tickets</span>\n                    </h1>\n                    <p ng-if="$root.clientWidth<=690 && ticket.row!=null && ticket.section==null" class="eventName">Row {{ticket.row}}</p>\n                    <p ng-if="$root.clientWidth<=690 && ticket.row!=null && ticket.section!=null" class="eventName">Section {{ticket.section}}, Row {{ticket.row}}</p>\n                    <p ng-if="$root.clientWidth<=690 && ticket.row==null" class="eventName">{{ticket.section}}</p>\n                    <h1 ng-if="$root.clientWidth<=690" class="eventName">\n                        <span>Created on</span>\n                    </h1>\n                    <p ng-if="$root.clientWidth<=690" class="eventName">{{ticket.CreatedOn}}</p>\n                </td>\n                <td ng-if="$root.clientWidth>690" title="\'Details\'" sortable="\'FullOrderDate\'" class="boughtCell">\n                    <h1>\n                        {{ticket.bought}}\n                        <span ng-if="!ticket.eTicket">Tickets</span>\n                        <span ng-if="ticket.eTicket">e-Tickets</span>\n                    </h1>\n                    <p class="eventName" ng-if="ticket.row!=null &&  ticket.section!=null">Section {{ticket.section}}, Row {{ticket.row}}</p>\n                    <p class="eventName" ng-if="ticket.row!=null && ticket.section==null">Row {{ticket.row}}</p>\n                    <p class="eventName" ng-if="ticket.row==null">Standing</p>\n                    <h1 class="eventName">\n                        <span>Created on</span>\n                    </h1>\n                    <p class="eventName">{{ticket.CreatedOn}}</p>\n                </td>\n                <td title="\'Event\'" sortable="\'eventName\'" class="eventsListEventCell">\n                    <h1><a href="#/performance/{{ticket.PerformanceId}}">{{ticket.performence}}</a></h1>\n                    <p class="eventName"><a ng-if="ticket.Num_Performances_InEvent>1" href="#/event/{{ticket.EventId}}">{{ticket.eventName}}</a></p>\n                    <div class="globalButtonsBar edged otherSide single changeFloating" ng-if="$root.clientWidth<615">\n                        <a ng-click="vm.proceedToPayment(ticket.OrderRef)" class="globalButton borderedButton" color="nevy">to payment</a>\n                    </div>\n                </td>\n                <td class="ticketsBuyCell" ng-if="$root.clientWidth>=615">\n                    <div class="globalButtonsBar edged otherSide single">\n                        <a ng-click="vm.proceedToPayment(ticket.OrderRef)" class="globalButton borderedButton" color="nevy">to payment</a>\n                    </div>\n                </td>\n            </tr>\n            <style>\n                .ng-table-pager {\n                    display: none;\n                }\n            </style>\n        </table>\n        <div class="globalButtonsBar midTopSpace extraWidth">\n            <a ng-click="vm.loadMorePending()" ng-show="vm.disablePending == false && vm.dataLength_pinding >  vm.CountPerPage_Pending" class="globalButton borderedButton" color="lightGrey">Load More</a>\n        </div>\n    </div>\n</div>\n\n<div class="contents">\n    <div class="contentsTitle borderedBottom">\n        <h1>Cancelled Orders</h1>\n    </div>\n    <spinner ng-if="vm.ticketsLoading" push="left"></spinner>\n    <div class="contentsCore" ng-if="!vm.hasHistoryTickets && !vm.ticketsLoading">\n        <p>No history orders found.</p>\n    </div>\n    <div class="contentsCore" ng-if="vm.hasHistoryTickets">\n        <table ng-table="vm.customConfigParamsHistoryTable" class="eventsList" show-filter="true">\n            <tr ng-repeat="ticket in $data">\n                <!--<td title="\'Date\'" sortable="\'fullDate\'" class="dateCell mini">-->\n                <td title="\'Date\'" sortable="\'fullDate\'" class="dateCell">\n                    <div class="dateDayFocus inEventsList">\n                        <div class="dateDayFocusDay">\n                            <p>{{ticket.day}}</p>\n                        </div>\n                        <div class="dateDayFocusRest">\n                            <p>{{ticket.month}} {{ticket.year}}</p>\n                            <p class="day">{{ticket.dayName}}, {{ticket.time}}</p>\n                        </div>\n                    </div>\n                </td>\n                <td title="\'Total Price\'" sortable="\'OrderTotal\'" class="priceCell">\n                    <h1 class="price">LE {{ticket.OrderTotal}}</h1>\n                    <h1 ng-if="$root.clientWidth<=690">\n                        {{ticket.bought}}\n                        <span ng-if="!ticket.eTicket">Tickets</span>\n                        <span ng-if="ticket.eTicket">e-Tickets</span>\n                    </h1>\n                    <p ng-if="$root.clientWidth<=690 && ticket.row!=null && ticket.section!=null" class="eventName">Section {{ticket.section}}, Row {{ticket.row}}</p>\n                    <p ng-if="$root.clientWidth<=690 && ticket.row!=null && ticket.section==null" class="eventName">Row {{ticket.row}}</p>\n                    <p ng-if="$root.clientWidth<=690 && ticket.row==null" class="eventName" ">{{ticket.section}}</p>\n                </td>\n                <td ng-if="$root.clientWidth>690" title="\'Details\'" sortable="\'FullOrderDate\'" class="boughtCell">\n                    <h1>\n                        {{ticket.bought}}\n                        <span ng-if="!ticket.eTicket">Tickets</span>\n                        <span ng-if="ticket.eTicket">e-Tickets</span>\n                    </h1>\n                    <p class="eventName" ng-if="ticket.row!=null && ticket.section!=null">Section {{ticket.section}}, Row {{ticket.row}}</p>\n                    <p class="eventName" ng-if="ticket.row!=null && ticket.section==null">Row {{ticket.row}}</p>\n                    <p class="eventName" ng-if="ticket.row==null">{{ticket.section}}</p>\n                    <h1 class="eventName">\n                        <span>Created on</span>\n                    </h1>\n                    <p class="eventName">{{ticket.CreatedOn}}</p>\n                </td>\n                <td title="\'Event\'" sortable="\'eventName\'" class="eventsListEventCell">\n                    <h1><a href="#/performance/{{ticket.PerformanceId}}">{{ticket.performence}} </a></h1>\n                    <p class="eventName"><a ng-if="ticket.Num_Performances_InEvent>1" href="#/event/{{ticket.EventId}}">{{ticket.eventName}}</a></p>\n                    <h1 ng-if="$root.clientWidth<=690" class="eventName">\n                        <span>Created on</span>\n                    </h1>\n                    <p ng-if="$root.clientWidth<=690" class="eventName">{{ticket.CreatedOn}}</p>\n                </td>\n            </tr>\n        </table>\n        <div class="globalButtonsBar midTopSpace extraWidth">\n            <a ng-click="vm.loadMoreHistory()" ng-if="vm.disableHistory == false && vm.dataLength_History > vm.CountPerPage_History" class="globalButton borderedButton" color="lightGrey">Load More</a>\n        </div>\n    </div>\n</div>\n\n<div class="contents">\n    <div class="contentsTitle borderedBottom">\n        <h1>Refunded Orders</h1>\n    </div>\n    <spinner ng-if="vm.ticketsLoading" push="left"></spinner>\n    <div class="contentsCore" ng-if="!vm.hasRefundedTickets && !vm.ticketsLoading">\n        <p>No refunded orders found.</p>\n    </div>\n    <div class="contentsCore" ng-if="vm.hasRefundedTickets">\n        <table ng-table="vm.customConfigParamsRefundTable" class="eventsList" show-filter="true">\n            <tr ng-repeat="ticket in $data">\n                <!--<td title="\'Date\'" sortable="\'fullDate\'" class="dateCell mini">-->\n                <td title="\'Date\'" sortable="\'fullDate\'" class="dateCell">\n                    <div class="dateDayFocus inEventsList">\n                        <div class="dateDayFocusDay">\n                            <p>{{ticket.day}}</p>\n                        </div>\n                        <div class="dateDayFocusRest">\n                            <p>{{ticket.month}} {{ticket.year}}</p>\n                            <p class="day">{{ticket.dayName}}, {{ticket.time}}</p>\n                        </div>\n                    </div>\n                </td>\n                <td title="\'Amount\'" sortable="\'Refunded\'" class="priceCell">\n                    <h1 class="price">LE {{ticket.Refunded}}</h1>\n                    <h1 ng-if="$root.clientWidth<=690">\n                        {{ticket.bought}}\n                        <span ng-if="!ticket.eTicket">Tickets</span>\n                        <span ng-if="ticket.eTicket">e-Tickets</span>\n                    </h1>\n                    <p ng-if="$root.clientWidth<=690 && ticket.row!=null && ticket.section==null" class="eventName">Row {{ticket.row}}</p>\n                    <p ng-if="$root.clientWidth<=690 && ticket.row!=null && ticket.section!=null" class="eventName">Section {{ticket.section}}, Row {{ticket.row}}</p>\n                    <p ng-if="$root.clientWidth<=690 && ticket.row==null" class="eventName">{{ticket.section}}</p>\n                </td>\n                <td ng-if="$root.clientWidth>690" title="\'Details\'" sortable="\'FullOrderDate\'" class="boughtCell">\n                    <h1>\n                        {{ticket.bought}}\n                        <span ng-if="!ticket.eTicket">Tickets</span>\n                        <span ng-if="ticket.eTicket">e-Tickets</span>\n                    </h1>\n                    <p class="eventName" ng-if="ticket.row!=null &&  ticket.section!=null">Section {{ticket.section}}, Row {{ticket.row}}</p>\n                    <p class="eventName" ng-if="ticket.row!=null && ticket.section==null">Row {{ticket.row}}</p>\n                    <p class="eventName" ng-if="ticket.row==null">{{ticket.section}}</p>\n                    <h1 class="eventName">\n                        <span>Created on</span>\n                    </h1>\n                    <p class="eventName">{{ticket.CreatedOn}}</p>\n                </td>\n                <td title="\'Event\'" sortable="\'eventName\'" class="eventsListEventCell">\n                    <h1><a href="#/performance/{{ticket.PerformanceId}}">{{ticket.performence}} </a></h1>\n                    <p class="eventName"><a ng-if="ticket.Num_Performances_InEvent>1" href="#/event/{{ticket.EventId}}">{{ticket.eventName}}</a></p>\n                    <h1 ng-if="$root.clientWidth<=690" class="eventName">\n                        <span>Created on</span>\n                    </h1>\n                    <p ng-if="$root.clientWidth<=690" class="eventName">{{ticket.CreatedOn}}</p>\n                </td>\n            </tr>\n        </table>\n        <div class="globalButtonsBar midTopSpace extraWidth">\n            <a ng-click="vm.loadMoreRefunded()" ng-if="vm.disableRefunded == false && vm.dataLength_Refund > vm.CountPerPage_Refunded" class="globalButton borderedButton" color="lightGrey">Load More</a>\n        </div>\n    </div>\n</div>\n<!-- AI:Open Reset makes a new request from server -->\n<div eturn-popup title="Receipt #{{vm.Receipt.Reference}}" printable=true closable=true ng-if="vm.showPoper" show-poper="vm.showPoper">\n    <div class="tableLike">\n        <div class="rowLike rowLikeHead">\n            <div class="cellLike">\n                <p>Item</p>\n            </div>\n            <div class="cellLike center">\n                <p>QTY</p>\n            </div>\n            <div class="cellLike otherSide">\n                <p>Price</p>\n            </div>\n            <div class="cellLike otherSide">\n                <p>Total</p>\n            </div>\n        </div>\n        <div class="rowLike">\n            <div class="cellLike">\n                <p>{{vm.Receipt.Perfomance}} Ticket</p>\n            </div>\n            <div class="cellLike center">\n                <p>{{vm.Receipt.boughtTikets}}</p>\n            </div>\n            <div class="cellLike otherSide">\n                <p>LE  {{vm.Receipt.PricePerTicket}}</p>\n            </div>\n            <div class="cellLike otherSide">\n                <p>LE  {{vm.Receipt.Total}}</p>\n            </div>\n        </div>\n\n        <div ng-repeat="fees in vm.Receipt.Fees" class="rowLike">\n            <div class="cellLike">\n                <p>{{fees.Name}}</p>\n            </div>\n            <div class="cellLike center">\n                <p></p>\n            </div>\n            <div class="cellLike otherSide">\n                <p></p>\n            </div>\n            <div class="cellLike otherSide">\n                <!-- <p>LE  {{vm.order.OrderFees}}</p> -->\n                LE  {{fees.Cost}}\n            </div>\n        </div>\n    </div>\n    <div class="resetTotal">\n        <p>Total <span>LE {{vm.Receipt.GrandTotal}}</span></p>\n    </div>\n</div>\n');
$templateCache.put('app/components/users/continueVerification.html','<div class="centerDiv" ng-controller="UsersController">\n    <div class="row">\n        <h2>\n            Verify your account\n        </h2>\n        <p>\n            Please enter below the verification code sent to the mobile number {{mobileNumber}}.\n        </p>\n    </div>\n    <div class="row">\n        <form novalidate id="skippiedConfForm" name="confForm" ng-submit="vm.ConfirmCode(VerificationCode)">\n            <div class="row">\n                <input type="text" name="verificationcode" id="verificationcode" ng-model="VerificationCode" placeholder="Enter code here" />\n                <span>{{vm.errors.InvalidVerificationCode}}</span>\n            </div>\n            <div class="row">\n                <input type="submit" class="" value="{{vm.verificationText}}" />\n            </div>\n            <div class="row">\n                <a href="javascript:;" ng-click="vm.ResendCode()">\n                    {{vm.resendText}}\n                </a>\n            </div>\n            <!--<div class="row">\n                <a href="javascript:;" ng-click="vm.skipVerification()">\n                    {{vm.skipText}}\n                </a>\n            </div>-->\n        </form>\n    </div>\n    <!--<div style="margin-top:50px;font-size:8px">\n        UserIdee: {{idee}}\n    </div>-->\n</div>\n\n');
$templateCache.put('app/components/users/profile.html','<style>\n    .italic {\n        font-style: italic;\n    }\n</style>\n<div class="contents">\n    <div class="eventsListFilter breadCrumb">\n        <p>\n            <a href="#/home">Home</a>\n            <span>\n                <svg><use xlink:href="#breadCrumbArrow" /></svg>\n            </span>\n            <span>Your Profile</span>\n        </p>\n    </div>\n    <div class="contentsTitle withSide withSideButton">\n        <h1>Profile Info</h1>\n        <a href="javascript:void(0);" ng-click="vm.toggler(\'profileInfo\'); vm.resetProfileFields()">\n            <svg ng-if="!vm.profileInfo"><use xlink:href="#editIcon" /></svg>\n            <svg ng-if="vm.profileInfo"><use xlink:href="#closeIcon" /></svg>\n        </a>\n    </div>\n    <div class="contentsCore">\n        <div class="profileSwitchView" ng-form="profileForm" ng-class="{active:vm.profileInfo}">\n            <div class="accountRow borderedBottom">\n                <div class="accountRowLabel">\n                    <p>Full Name</p>\n                </div>\n                <div class="accountRowValue">\n                    <div class="accountRowValueData">\n                        <p>{{vm.profileInfoDetails.NameCopy || \'Not set\'}}</p>\n                    </div>\n                    <div class="globalForm">\n                        <div class="globalFormUnit balanced sidedButton">\n                            <input type="text" id="name" name="name" ng-model="vm.profileInfoDetails.Name"\n                                full-name\n                                required />\n                        </div>\n                    </div>\n                </div>\n                <p class="accountError" ng-show="profileForm.name.$error.required && !profileForm.name.$pristine && vm.profileInfo">\n                    Full name is required\n                </p>\n                <p class="accountError" ng-show="profileForm.name.$error.pattern && !profileForm.name.$pristine && vm.profileInfo">\n                    At least two words\n                </p>\n            </div>\n            <div class="accountRow borderedBottom">\n                <div class="accountRowLabel">\n                    <p>Gender</p>\n                </div>\n                <div class="accountRowValue">\n                    <div class="accountRowValueData">\n                        <p>{{vm.GenderLiteral || \'Not set\'}}</p>\n                    </div>\n                    <div class="globalForm">\n                        <div class="globalFormUnit balanced sidedButton">\n                            <select ng-model="vm.profileInfoDetails.Gender" ng-options="gender[0] as gender[1] for gender in vm.genders">\n                            </select>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class="accountRow borderedBottom">\n                <div class="accountRowLabel">\n                    <p>Birthdate</p>\n                </div>\n                <div class="accountRowValue">\n                    <div class="accountRowValueData">\n                        <p>{{vm.profileInfoDetails.Birthdate || \'Not set\'}}</p>\n                    </div>\n                    <div class="globalForm">\n                        <div class="globalFormUnit balanced sidedButton dateDropDowns">\n                            <select name="day" id="day" ng-model="vm.profileInfoDetails.Day"\n                                    ng-options="day for day in vm.days"\n                                    ng-change="vm.checkFullBirthdate(profileForm)"\n                                    class="dayDropDown"></select>\n                            <select name="month" id="month" ng-model="vm.profileInfoDetails.Month"\n                                    ng-options="month[1] as month[0] for month in vm.months"\n                                    ng-change="vm.updateDays(vm.profileInfoDetails.Month); vm.checkFullBirthdate(profileForm)"\n                                    class="monthDropDown"></select>\n                            <select name="year" id="year" ng-model="vm.profileInfoDetails.Year"\n                                    ng-options="year for year in vm.years"\n                                    ng-change="vm.checkFullBirthdate(profileForm)"\n                                    class="yearDropDown"></select>\n                        </div>\n                    </div>\n                </div>\n                <p class="accountError"\n                   ng-show="profileForm.$error.notFull && vm.profileInfo && vm.profileSubmitted">\n                    Full birthdate is required\n                </p>\n            </div>\n            <div class="globalButtonsBar edged otherSide midTopSpace">\n                <input type="submit" value="{{vm.submitProfileText}}" class="globalButton inputSidedButton" color="blue"\n                       ng-disabled="vm.profileSent" ng-click="vm.saveProfileInfo(profileForm.$valid)" />\n            </div>\n        </div>\n    </div>\n</div>\n<div class="contents">\n    <div class="contentsTitle withSide withSideButton">\n        <h1>Shipping Info</h1>\n        <a href="javascript:void(0);" ng-click="vm.toggler(\'locationInfo\'); vm.resetHomeLocationFields()">\n            <svg ng-if="!vm.locationInfo"><use xlink:href="#editIcon" /></svg>\n            <svg ng-if="vm.locationInfo"><use xlink:href="#closeIcon" /></svg>\n        </a>\n    </div>\n    <div class="contentsCore">\n        <div class="profileSwitchView" ng-form="locationForm" ng-class="{active:vm.locationInfo}">\n            <div class="accountRow borderedBottom">\n                <div class="accountRowLabel">\n                    <p>Country</p>\n                </div>\n                <div class="accountRowValue">\n                    <div class="accountRowValueData">\n                        <p ng-class="{italic:vm.homeCountriesLoading}">{{vm.homeLocationCountryLiteral || \'Not set\'}}</p>\n                    </div>\n                    <div class="globalForm">\n                        <div class="globalFormUnit balanced sidedButton">\n                            <select name="homeCountry" id="homeCountry" ng-model="vm.homeLocationInfoDetails.CountryId"\n                                    ng-init="vm.homeLocationInfoDetails.CountryId = 0"\n                                    ng-options="country.CountryId as country.CountryName for country in vm.homeCountries"\n                                    ng-disabled="vm.homeCountriesloading"\n                                    ng-change="vm.getHomeCountryCities(true)" class="form-control"></select>\n                            <!--<input type="text" name="homeCountry" id="homeCountry" ng-model="vm.locationInfoDetails.CountryName" />-->\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class="accountRow borderedBottom">\n                <div class="accountRowLabel">\n                    <p>City</p>\n                </div>\n                <div class="accountRowValue">\n                    <div class="accountRowValueData">\n                        <p ng-class="{italic:vm.homeCityLoading || vm.homeCountriesLoading}">{{vm.homeLocationCityLiteral || \'Not set\'}}</p>\n                    </div>\n                    <div class="globalForm">\n                        <div class="globalFormUnit balanced sidedButton">\n                            <select name="homeCity" id="homeCity" ng-model="vm.homeLocationInfoDetails.CityId"\n                                    ng-init="vm.homeLocationInfoDetails.CityId = 0"\n                                    ng-options="city.CityId as city.CityName for city in vm.homeCities | orderBy"\n                                    ng-disabled="vm.homeLocationInfoDetails.CountryId < 1 || vm.homeCitiesLoading || vm.homeCountriesLoading"\n                                    class="form-control">\n                            </select>\n                            <!--<input type="text" name="homeCity" id="homeCity" ng-model="vm.locationInfoDetails.CityName" />-->\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class="accountRow borderedBottom">\n                <div class="accountRowLabel">\n                    <p>Address</p>\n                </div>\n                <div class="accountRowValue">\n                    <div class="accountRowValueData">\n                        <p>{{vm.homeLocationInfoDetails.AddressCopy || \'Not set\'}}</p>\n                    </div>\n                    <div class="globalForm">\n                        <div class="globalFormUnit balanced sidedButton">\n                            <input type="text" id="address" name="address"\n                                   ng-model="vm.homeLocationInfoDetails.Address"\n                                   ng-required="vm.homeLocationInfoDetails.CountryId > 0"\n                                   ng-disabled="vm.homeLocationInfoDetails.CountryId < 1"\n                                   ng-pattern="" />\n                        </div>\n                    </div>\n                </div>\n                <p class="accountError" ng-show="locationForm.address.$error.required && vm.locationInfo && vm.locationSubmitted">\n                    Address is required\n                </p>\n            </div>\n            <div class="accountRow borderedBottom">\n                <div class="accountRowLabel">\n                    <p>Postal Code</p>\n                </div>\n                <div class="accountRowValue">\n                    <div class="accountRowValueData">\n                        <p>{{vm.homeLocationInfoDetails.PostalCodeCopy || \'Not set\'}}</p>\n                    </div>\n                    <div class="globalForm">\n                        <div class="globalFormUnit balanced sidedButton">\n                            <input type="text" id="postalCode" name="postalCode"\n                                   ng-model="vm.homeLocationInfoDetails.PostalCode"\n                                   ng-disabled="vm.homeLocationInfoDetails.CountryId < 1"\n                                   ng-pattern="/^[1-9]\\d*$/" />\n                        </div>\n                    </div>\n                </div>\n                <p class="accountError" ng-show="locationForm.postalCode.$error.pattern">\n                    Invalid postal code\n                </p>\n            </div>\n            <div class="globalButtonsBar edged otherSide midTopSpace">\n                <input type="submit" value="{{vm.submitLocationText}}" class="globalButton inputSidedButton globalButton.disabled"\n                       ng-disabled="vm.locationSent \n                       || vm.homeCountriesLoading \n                       || vm.homeCitiesLoading" color="blue" ng-click="vm.saveHomeLocation(locationForm.$valid)" />\n            </div>\n        </div>\n    </div>\n</div>\n<div class="contents">\n    <div class="contentsTitle withSide withSideButton">\n        <h1>Company Info</h1>\n        <a href="javascript:void(0);" ng-click="vm.toggler(\'companyInfo\'); vm.resetCompanyFields()">\n            <svg ng-if="!vm.companyInfo"><use xlink:href="#editIcon" /></svg>\n            <svg ng-if="vm.companyInfo"><use xlink:href="#closeIcon" /></svg>\n        </a>\n    </div>\n    <div class="contentsCore">\n        <div class="profileSwitchView" ng-form="companyForm" ng-class="{active:vm.companyInfo}">\n            <div class="accountRow borderedBottom">\n                <div class="accountRowLabel">\n                    <p>Company Name</p>\n                </div>\n                <div class="accountRowValue">\n                    <div class="accountRowValueData">\n                        <p>{{vm.companyInfoDetails.CompanyNameCopy || \'Not set\'}}</p>\n                    </div>\n                    <div class="globalForm">\n                        <div class="globalFormUnit balanced sidedButton">\n                            <input type="text" ng-model="vm.companyInfoDetails.CompanyName" />\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class="accountRow borderedBottom">\n                <div class="accountRowLabel">\n                    <p>Company Phone</p>\n                </div>\n                <div class="accountRowValue">\n                    <div class="accountRowValueData">\n                        <p>{{vm.companyInfoDetails.CompanyPhoneCopy || \'Not set\'}}</p>\n                    </div>\n                    <div class="globalForm">\n                        <div class="globalFormUnit balanced sidedButton">\n                            <input type="text" \n                                   id="companyPhone" \n                                   name="companyPhone" \n                                   ng-model="vm.companyInfoDetails.CompanyPhone"\n                                   ng-pattern="vm.regex.mobile" \n                                   ng-disabled="vm.companyInfoDetails.CompanyName == undefined\n                                      || vm.companyInfoDetails.CompanyName == \'\' || vm.companyInfoDetails.CompanyName == null"\n                                   ng-pattern="vm.regex.mobile"\n                                   mobile-phone style="padding-left:52px" />\n                        </div>\n                    </div>\n                </div>\n                <p class="accountError" ng-show="companyForm.companyPhone.$invalid && vm.companySubmitted && vm.companyInfo">\n                    Invalid company phone\n                </p>\n            </div>\n            <div class="accountRow borderedBottom">\n                <div class="accountRowLabel">\n                    <p>Country</p>\n                </div>\n                <div class="accountRowValue">\n                    <div class="accountRowValueData">\n                        <p ng-class="{italic:vm.companyCountriesLoading}">{{vm.companyLocationCountryLiteral || \'Not set\'}}</p>\n                    </div>\n                    <div class="globalForm">\n                        <div class="globalFormUnit balanced sidedButton">\n                            <select name="companyCountry" id="companyCountry" ng-model="vm.companyLocationInfoDetails.CountryId"\n                                    ng-init="vm.companyLocationInfoDetails.CountryId = 0"\n                                    ng-options="country.CountryId as country.CountryName for country in vm.companyCountries"\n                                    ng-disabled="vm.companyCountriesloading || vm.companyInfoDetails.CompanyName == undefined\n                                    || vm.companyInfoDetails.CompanyName == \'\' || vm.companyInfoDetails.CompanyName == null"\n                                    ng-change="vm.getCompanyCountryCities(true)" class="form-control">\n                            </select>\n                            <!--<input type="text" value="" />-->\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class="accountRow borderedBottom">\n                <div class="accountRowLabel">\n                    <p>City</p>\n                </div>\n                <div class="accountRowValue">\n                    <div class="accountRowValueData">\n                        <p ng-class="{italic:vm.companyCityLoading || vm.companyCountriesLoading}">{{vm.companyLocationCityLiteral || \'Not set\'}}</p>\n                    </div>\n                    <div class="globalForm">\n                        <div class="globalFormUnit balanced sidedButton">\n                            <select name="companyCity" id="companyCity" ng-model="vm.companyLocationInfoDetails.CityId"\n                                    ng-init="vm.companyLocationInfoDetails.CityId = 0"\n                                    ng-options="city.CityId as city.CityName for city in vm.companyCities"\n                                    ng-disabled="vm.companyLocationInfoDetails.CountryId < 1 || vm.compnayCitiesLoading || vm.companyCountriesLoading\n                                    || vm.companyInfoDetails.CompanyName == undefined\n                                    || vm.companyInfoDetails.CompanyName == \'\' || vm.companyInfoDetails.CompanyName == null"\n                                    class="form-control"></select>\n                            <!--<input type="text" value="" />-->\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class="accountRow borderedBottom">\n                <div class="accountRowLabel">\n                    <p>Address</p>\n                </div>\n                <div class="accountRowValue">\n                    <div class="accountRowValueData">\n                        <p>{{vm.companyLocationInfoDetails.AddressCopy || \'Not set\'}}</p>\n                    </div>\n                    <div class="globalForm">\n                        <div class="globalFormUnit balanced sidedButton">\n                            <input type="text" id="caddress" name="caddress"\n                                   ng-model="vm.companyLocationInfoDetails.Address"\n                                   ng-required="vm.companyLocationInfoDetails.CountryId > 0"\n                                   ng-disabled="vm.companyLocationInfoDetails.CountryId < 1 || vm.companyInfoDetails.CompanyName == undefined\n                                    || vm.companyInfoDetails.CompanyName == \'\' || vm.companyInfoDetails.CompanyName == null"\n                                   ng-pattern="" />\n                        </div>\n                    </div>\n                </div>\n                <p class="accountError" ng-show="companyForm.caddress.$error.required && vm.companyInfo && vm.companySubmitted">\n                    Company address is required\n                </p>\n            </div>\n            <div class="accountRow borderedBottom">\n                <div class="accountRowLabel">\n                    <p>Postal Code</p>\n                </div>\n                <div class="accountRowValue">\n                    <div class="accountRowValueData">\n                        <p>{{vm.companyLocationInfoDetails.PostalCodeCopy || \'Not set\'}}</p>\n                    </div>\n                    <div class="globalForm">\n                        <div class="globalFormUnit balanced sidedButton">\n                            <input type="text" id="cpostalCode" name="cpostalCode"\n                                   ng-model="vm.companyLocationInfoDetails.PostalCode"\n                                   ng-disabled="vm.companyLocationInfoDetails.CountryId < 1 || vm.companyInfoDetails.CompanyName == undefined\n                                    || vm.companyInfoDetails.CompanyName == \'\' || vm.companyInfoDetails.CompanyName == null"\n                                    ng-pattern="/^[1-9]\\d*$/" />\n                        </div>\n                    </div>\n                </div>\n                <p class="accountError" ng-show="companyForm.cpostalCode.$error.pattern">\n                    invalid postal code\n                </p>\n            </div>\n            <div class="globalButtonsBar edged otherSide midTopSpace">\n                <input type="submit" value="{{vm.submitCompanyText}}" class="globalButton inputSidedButton"\n                       ng-disabled="vm.companySent \n                       || vm.companyCountriesLoading \n                       || vm.compnayCitiesLoading" color="blue" ng-click="vm.saveCompanyInfo(companyForm.$valid)" />\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/components/users/soldTickets.html','<div class="contents">\n    <div class="eventsListFilter breadCrumb">\n        <p>\n            <a href="#/home">Home</a>\n            <span>\n                <svg><use xlink:href="#breadCrumbArrow" /></svg>\n            </span>\n            <span>My Tickets</span>\n        </p>\n    </div>\n    <div class="layoutHolder soldTicketsFinancials">\n        <div class="layoutUnit layoutThird soldTicketsFinancialsUnitHolder contentsBorderedRight editWidthFourUnit">\n            <div class="contentsCore soldTicketsFinancialsUnit">\n                <svg viewBox="0 0 25 25">\n                    <path d="M5.5,0H18.5A5.5,5.5 0 0,1 24,5.5V18.5A5.5,5.5 0 0,1 18.5,24H5.5A5.5,5.5 0 0,1 0,18.5V5.5A5.5,5.5 0 0,1 5.5,0M15.39,15.18C15.39,16.76 14.5,17.81 12.85,17.95V12.61C14.55,13.13 15.39,13.66 15.39,15.18M11.65,6V10.88C10.34,10.5 9.03,9.93 9.03,8.43C9.03,6.94 10.18,6.12 11.65,6M15.5,7.6L16.5,6.8C15.62,5.66 14.4,4.92 12.85,4.77V3.8H11.65V3.8L11.65,4.75C9.5,4.89 7.68,6.17 7.68,8.5C7.68,11 9.74,11.78 11.65,12.29V17.96C10.54,17.84 9.29,17.31 8.43,16.03L7.3,16.78C8.2,18.12 9.76,19 11.65,19.14V20.2H12.07L12.85,20.2V19.16C15.35,19 16.7,17.34 16.7,15.14C16.7,12.58 14.81,11.76 12.85,11.19V6.05C14,6.22 14.85,6.76 15.5,7.6Z" />\n                </svg>\n                <div class="soldTicketsFinancialsValue">\n                    <h1 class="price">LE {{vm.AmountDollars}}<span>.{{vm.AmountCents}}</span></h1>\n                    <p>Amount</p>\n                </div>\n            </div>\n        </div>\n        <div class="layoutUnit layoutThird soldTicketsFinancialsUnitHolder contentsBorderedRight editWidthFourUnit ClearContentsBorderedRight">\n            <div class="contentsCore soldTicketsFinancialsUnit">\n                <svg viewBox="0 0 25 25">\n                    <path d="M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M11,16.5L18,9.5L16.59,8.09L11,13.67L7.91,10.59L6.5,12L11,16.5Z" />\n                </svg>\n                <div class="soldTicketsFinancialsValue">\n                    <h1 class="price">LE {{vm.PaidDollars}}<span>.{{vm.PaidCents}}</span></h1>\n                    <p>Paid</p>\n                </div>\n            </div>\n        </div>\n        <div class="layoutUnit layoutThird soldTicketsFinancialsUnitHolder contentsBorderedRight editWidthFourUnit">\n            <div class="contentsCore soldTicketsFinancialsUnit">\n                <svg viewBox="0 0 25 25">\n                    <path d="M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L6.04,7.5L12,10.85L17.96,7.5L12,4.15Z" />\n                </svg>\n                <div class="soldTicketsFinancialsValue">\n                    <h1 class="price">LE {{vm.RemainingDollars}}<span>.{{vm.RemainingCents}}</span></h1>\n                    <p>Remaining</p>\n                </div>\n            </div>\n        </div>\n        <div class="layoutUnit layoutThird soldTicketsFinancialsUnitHolder editWidthFourUnit">\n            <div class="contentsCore soldTicketsFinancialsUnit">\n                <img src="assets/images/refund.png">\n                <div class="soldTicketsFinancialsValue">\n                    <h1 class="price">LE {{vm.RefundDollars}}<span>.{{vm.RefundCents}}</span></h1>\n                    <p>Refund</p>\n                </div>\n            </div>\n        </div>\n    </div>\n    <spinner ng-if="vm.soldTicketsLoading" give="contentsCore" push="center"></spinner>\n    <div class="contentsCore" ng-if="vm.PendingTickets.length>0">\n        <div class="contentsTitle borderedBottom">\n            <h1>Pending Approval</h1>\n        </div>\n        <div class="contentsCore">\n            <table ng-table="vm.customConfigParamsPending" class="eventsList" show-filter="true">\n                <tr ng-repeat="ticket in $data track by $index">\n                    <!--<td title="\'Date\'" sortable="\'FullDate\'" class="dateCell mini">-->\n                    <td title="\'Date\'" sortable="\'FullDate\'" class="dateCell">\n                        <div class="dateDayFocus inEventsList">\n                            <div class="dateDayFocusDay">\n                                <p>{{ticket.Day}}</p>\n                            </div>\n                            <div class="dateDayFocusRest">\n                                <p>{{ticket.Month}} {{ticket.Year}}</p>\n                                <p class="day">{{ticket.DayName}}, {{ticket.Time}}</p>\n                            </div>\n                        </div>\n                    </td>\n                    <td title="\'Price\'" sortable="\'Price\'" class="priceCell">\n                        <h1 class="price">LE {{ticket.Price}}<span>.00</span></h1>\n                        <h1 class="editFontSize" ng-if="$root.clientWidth<650">\n                            {{ticket.NumberOfTickets}}\n                            <span ng-if="!ticket.eTicket">Tickets</span>\n                            <span ng-if="ticket.eTicket">e-Tickets</span>\n                        </h1>\n                        <p ng-if="$root.clientWidth<=650 && ticket.Row != null && ticket.NumberOfTickets>1" class="eventName">Row {{ticket.Row}} / Seats From {{ticket.StartSeat}} To {{ticket.EndSeat}}</p>\n                        <p ng-if="$root.clientWidth<=650 && ticket.Row != null && ticket.NumberOfTickets==1" class="eventName">Row {{ticket.Row}} / Seat {{ticket.StartSeat}}</p>\n                        <p ng-if="$root.clientWidth<=650 && ticket.Row == null" class="eventName">{{ticket.Section || \'Standing\'}}</p>\n                    </td>\n                    <td ng-if="$root.clientWidth>650" title="\'QTY\'" sortable="\'NumberOfTickets\'" class="boughtCell">\n                        <h1>\n                            {{ticket.NumberOfTickets}}\n                            <span ng-if="!ticket.eTicket">Tickets</span>\n                            <span ng-if="ticket.eTicket">e-Tickets</span>\n                        </h1>\n                        <p ng-if="ticket.Row != null && ticket.NumberOfTickets>1" class="eventName">Row {{ticket.Row}} / Seats From {{ticket.StartSeat}} To {{ticket.EndSeat}}</p>\n                        <p ng-if="ticket.Row != null && ticket.NumberOfTickets==1" class="eventName">Row {{ticket.Row}} / Seat {{ticket.StartSeat}}</p>\n                        <p ng-if="ticket.Row == null" class="eventName">{{ticket.Section || \'Standing\'}}</p>\n                    </td>\n                    <td title="\'Event\'" sortable="\'EventName\'" class="eventsListEventCell">\n                        <h1><a href="#/performance/{{ticket.PerformanceId}}">{{ticket.PerformanceName}}</a></h1>\n                        <p class="eventName"><a href="#/event/{{ticket.EventId}}">{{ticket.EventName}}</a></p>\n                    </td>\n                    <td ng-if="$root.clientWidth<750" class="eventsListEventCell">\n                        <a href="" class="globalButton borderedButton editWidthResponsive" color="grey" tooltip="Remove remaining tickets from sale"\n                           ng-click="vm.CancelSellRequest(ticket.RequestId)">\n                            Cancel\n                        </a>\n                    </td>\n                    <td ng-if="$root.clientWidth>=750">\n                        <div class="globalButtonsBar edged otherSide">\n                            <a href="" class="globalButton borderedButton" color="grey" tooltip="Remove remaining tickets from sale"\n                               ng-click="vm.CancelSellRequest(ticket.RequestId)">\n                               Cancel\n                            </a>\n                        </div>\n                    </td>\n                </tr>\n            </table>\n            <div class="globalButtonsBar midTopSpace extraWidth">\n                <a ng-click="vm.loadMorePendingTickets()" ng-if="vm.disablePendingTickets == false && vm.PendingTickets.length > vm.CountPerPage_PendingTickets" class="globalButton borderedButton" color="lightGrey">Load More</a>\n            </div>\n        </div>\n    </div>\n    <div class="contentsCore" ng-if="vm.ActiveTickets.length>0">\n        <div class="contentsTitle borderedBottom">\n            <h1>My Tickets For Sale</h1>\n        </div>\n        <div class="contentsCore">\n            <table ng-table="vm.customConfigParamsActive" class="eventsList" show-filter="true">\n                <tr ng-repeat="ticket in $data">\n                    <td title="\'Date\'" sortable="\'FullDate\'" class="dateCell">\n                        <div class="dateDayFocus inEventsList">\n                            <div class="dateDayFocusDay">\n                                <p>{{ticket.Day}}</p>\n                            </div>\n                            <div class="dateDayFocusRest">\n                                <p>{{ticket.Month}} {{ticket.Year}}</p>\n                                <p class="day">{{ticket.DayName}}, {{ticket.Time}}</p>\n                            </div>\n                        </div>\n                    </td>\n                    <td title="\'Price\'" sortable="\'Price\'" class="priceCell">\n                        <h1 class="price">LE {{ticket.Price}}<span>.00</span></h1>\n                        <h1 class="editFontSize" ng-if="$root.clientWidth<=750">\n                            {{ticket.RemainingTickets}}\n                            <span ng-if="!ticket.eTicket">Tickets</span>\n                            <span ng-if="ticket.eTicket">e-Tickets</span>\n                        </h1>\n\n                        <p ng-if="$root.clientWidth<=750 && ticket.Row != null && ticket.RemainingTickets>1" class="eventName">Row {{ticket.Row}} / Seats From {{ticket.StartSeat}} To {{ticket.EndSeat}}</p>\n                        <p ng-if="$root.clientWidth<=750 && ticket.Row != null && ticket.RemainingTickets==1" class="eventName">Row {{ticket.Row}} / Seat {{ticket.StartSeat}}</p>\n                        <p ng-if="$root.clientWidth<=750 && ticket.Row == null" class="eventName">{{ticket.Section || \'Standing\'}}</p>\n\n                    </td>\n                    <td ng-if="$root.clientWidth>750" title="\'QTY\'" sortable="\'RemainingTickets\'" class="boughtCell">\n                        <h1>\n                            {{ticket.RemainingTickets}}\n                            <span ng-if="!ticket.eTicket">Tickets</span>\n                            <span ng-if="ticket.eTicket">e-Tickets</span>\n                        </h1>\n                        <p ng-if="ticket.Row != null && ticket.RemainingTickets>1" class="eventName">Row {{ticket.Row}} / Seats From {{ticket.StartSeat}} To {{ticket.EndSeat}}</p>\n                        <p ng-if="ticket.Row != null && ticket.RemainingTickets==1" class="eventName">Row {{ticket.Row}} / Seat {{ticket.StartSeat}}</p>\n                        <p ng-if="ticket.Row == null" class="eventName">{{ticket.Section || \'Standing\'}}</p>\n                    </td>\n                    <td title="\'Event\'" sortable="\'EventName\'" class="eventsListEventCell">\n                        <h1><a href="#/performance/{{ticket.PerformanceId}}">{{ticket.PerformanceName}}</a></h1>\n                        <p class="eventName"><a href="#/event/{{ticket.EventId}}">{{ticket.EventName}}</a></p>\n                    </td>\n                    <td ng-if="$root.clientWidth<750" class="eventsListEventCell">\n                        <a href="" class="globalButton borderedButton editWidthResponsive" color="grey" tooltip="Remove remaining tickets from sale"\n                           ng-click="vm.CancelTicketGroup(ticket.TicketGroupId)">\n                            Cancel\n                        </a>\n                    </td>\n                    <td ng-if="$root.clientWidth>=750">\n                        <div class="globalButtonsBar edged otherSide">\n                            <a href="" class="globalButton borderedButton" color="grey" tooltip="Remove remaining tickets from sale"\n                               ng-click="vm.CancelTicketGroup(ticket.TicketGroupId)">\n                               Cancel\n                            </a>\n                        </div>\n                    </td>\n                </tr>\n            </table>\n            <div class="globalButtonsBar midTopSpace extraWidth">\n                <a ng-click="vm.loadMoreActiveTickets()" ng-if="vm.disableActiveTickets == false && vm.ActiveTickets.length > vm.CountPerPage_ActiveTickets" class="globalButton borderedButton" color="lightGrey">Load More</a>\n            </div>\n        </div>\n    </div>\n    <div class="contentsCore" ng-if="vm.SoldTickets.length>0">\n        <div class="contentsTitle borderedBottom">\n            <h1>Sold Tickets</h1>\n        </div>\n        <div class="contentsCore">\n            <table ng-table="vm.customConfigParamsSold" class="eventsList" show-filter="true">\n                <tr ng-repeat="ticket in $data">\n                    <!--<td title="\'Date\'" sortable="\'FullDate\'" class="dateCell mini">-->\n                    <td title="\'Date\'" sortable="\'FullDate\'" class="dateCell">\n                        <div class="dateDayFocus inEventsList">\n                            <div class="dateDayFocusDay">\n                                <p>{{ticket.Day}}</p>\n                            </div>\n                            <div class="dateDayFocusRest">\n                                <p>{{ticket.Month}} {{ticket.Year}}</p>\n                                <p class="day">{{ticket.DayName}}, {{ticket.Time}}</p>\n                            </div>\n                        </div>\n                    </td>\n                    <td title="\'Price\'" sortable="\'Price\'" class="priceCell">\n                        <h1 class="price">LE {{ticket.Price}}<span>.00</span></h1>\n                        <h1 ng-if="$root.clientWidth<=768" class="editFontSize">\n                            {{ticket.NumberOfTickets-ticket.RemainingTickets}}\n                            <span ng-if="!ticket.eTicket">Tickets</span>\n                            <span ng-if="ticket.eTicket">e-Tickets</span>\n                        </h1>\n                        <p ng-if="$root.clientWidth<=768 && ticket.Row != null && (ticket.NumberOfTickets-ticket.RemainingTickets)>1" class="eventName">Row {{ticket.Row}} / Seats From {{ticket.StartSeat}} To {{ticket.EndSeatUpdated}}</p>\n                        <p ng-if="$root.clientWidth<=768 && ticket.Row != null && (ticket.NumberOfTickets-ticket.RemainingTickets)==1" class="eventName">Row {{ticket.Row}} / Seat {{ticket.StartSeat}}</p>\n                        <p ng-if="$root.clientWidth<=768 && ticket.Row == null" class="eventName">{{ticket.Section || \'Standing\'}}</p>\n                    </td>\n                    <td ng-if="$root.clientWidth>768" title="\'QTY\'" sortable="\'ticket.RemainingTickets\'" class="boughtCell">\n                        <h1>\n                            {{ticket.NumberOfTickets-ticket.RemainingTickets}}\n                            <span ng-if="!ticket.eTicket">Tickets</span>\n                            <span ng-if="ticket.eTicket">e-Tickets</span>\n                        </h1>\n                        <p ng-if="ticket.Row != null && (ticket.NumberOfTickets-ticket.RemainingTickets)>1" class="eventName">Row {{ticket.Row}} / Seats From {{ticket.StartSeat}} To {{ticket.EndSeatUpdated}}</p>\n                        <p ng-if="ticket.Row != null && (ticket.NumberOfTickets-ticket.RemainingTickets)==1" class="eventName">Row {{ticket.Row}} / Seat {{ticket.StartSeat}}</p>\n                        <p ng-if="ticket.Row == null" class="eventName">{{ticket.Section || \'Standing\'}}</p>\n                    </td>\n                    <td title="\'Event\'" sortable="\'EventName\'" class="eventsListEventCell">\n                        <h1><a href="#/performance/{{ticket.PerformanceId}}">{{ticket.PerformanceName}}</a></h1>\n                        <p class="eventName"><a href="#/event/{{ticket.EventId}}">{{ticket.EventName}}</a></p>\n                    </td>\n                </tr>\n            </table>\n            <div class="globalButtonsBar midTopSpace extraWidth">\n                <a ng-click="vm.loadMoreSoldTickets()" ng-if="vm.disableSoldTickets == false && vm.SoldTickets.length > vm.CountPerPage_SoldTickets" class="globalButton borderedButton" color="lightGrey">Load More</a>\n            </div>\n        </div>\n    </div>\n    <div class="contentsCore" ng-if="vm.RejectedTickets.length>0">\n        <div class="contentsTitle borderedBottom">\n            <h1>Rejected Tickets</h1>\n        </div>\n        <div class="contentsCore">\n            <table ng-table="vm.customConfigParamsRejected" class="eventsList" show-filter="true">\n                <tr ng-repeat="ticket in $data">\n                    <!--<td title="\'Date\'" sortable="\'FullDate\'" class="dateCell mini">-->\n                    <td title="\'Date\'" sortable="\'FullDate\'" class="dateCell">\n                        <div class="dateDayFocus inEventsList">\n                            <div class="dateDayFocusDay">\n                                <p>{{ticket.Day}}</p>\n                            </div>\n                            <div class="dateDayFocusRest">\n                                <p>{{ticket.Month}} {{ticket.Year}}</p>\n                                <p class="day">{{ticket.DayName}}, {{ticket.Time}}</p>\n                            </div>\n                        </div>\n                    </td>\n                    <td title="\'Price\'" sortable="\'Price\'" class="priceCell">\n                        <h1 class="price">LE {{ticket.Price}}<span>.00</span></h1>\n                        <h1 class="editFontSize" ng-if="$root.clientWidth<=750">\n                            {{ticket.NumberOfTickets}}\n                            <span ng-if="!ticket.eTicket">Tickets</span>\n                            <span ng-if="ticket.eTicket">e-Tickets</span>\n                        </h1>\n                        <p ng-if="$root.clientWidth<=750 && ticket.Row != null && ticket.NumberOfTickets>1 " class="eventName">Row {{ticket.Row}} / Seats From {{ticket.StartSeat}} To {{ticket.EndSeat}}</p>\n                        <p ng-if="$root.clientWidth<=750 && ticket.Row != null && ticket.NumberOfTickets==1 " class="eventName">Row {{ticket.Row}} / Seat {{ticket.StartSeat}}</p>\n                        <p ng-if="$root.clientWidth<=750 && ticket.Row == null" class="eventName">{{ticket.Section || \'Standing\'}}</p>\n                    </td>\n                    <td ng-if="$root.clientWidth>750" title="\'QTY\'" sortable="\'NumberOfTickets\'" class="boughtCell">\n                        <h1>\n                            {{ticket.NumberOfTickets}}\n                            <span ng-if="!ticket.eTicket">Tickets</span>\n                            <span ng-if="ticket.eTicket">e-Tickets</span>\n                        </h1>\n                        <p ng-if="ticket.Row != null && ticket.NumberOfTickets>1" class="eventName">Row {{ticket.Row}} / Seats From {{ticket.StartSeat}} To {{ticket.EndSeat}}</p>\n                        <p ng-if="ticket.Row != null && ticket.NumberOfTickets==1" class="eventName">Row {{ticket.Row}} / Seat {{ticket.StartSeat}}</p>\n                        <p ng-if="ticket.Row == null" class="eventName">{{ticket.Section || \'Standing\'}}</p>\n                    </td>\n                    <td title="\'Event\'" sortable="\'EventName\'" class="eventsListEventCell">\n                        <h1><a href="#/performance/{{ticket.PerformanceId}}">{{ticket.PerformanceName}}</a></h1>\n                        <p class="eventName"><a href="#/event/{{ticket.EventId}}">{{ticket.EventName}}</a></p>\n                    </td>\n                </tr>\n            </table>\n            <div class="globalButtonsBar midTopSpace extraWidth">\n                <a ng-click="vm.loadMoreRejectedTickets()" ng-if="vm.disableRejectedTickets == false && vm.RejectedTickets.length > vm.CountPerPage_RejectedTickets" class="globalButton borderedButton" color="lightGrey">Load More</a>\n            </div>\n        </div>\n    </div>\n\n    <div class="contentsCore" ng-if="vm.CancelledTickets.length>0">\n        <div class="contentsTitle borderedBottom">\n            <h1>Cancelled Tickets</h1>\n        </div>\n        <div class="contentsCore">\n            <table ng-table="vm.customConfigParamsCancelled" class="eventsList" show-filter="true">\n                <tr ng-repeat="ticket in $data">\n                    <!--<td title="\'Date\'" sortable="\'FullDate\'" class="dateCell mini">-->\n                    <td title="\'Date\'" sortable="\'FullDate\'" class="dateCell">\n                        <div class="dateDayFocus inEventsList">\n                            <div class="dateDayFocusDay">\n                                <p>{{ticket.Day}}</p>\n                            </div>\n                            <div class="dateDayFocusRest">\n                                <p>{{ticket.Month}} {{ticket.Year}}</p>\n                                <p class="day">{{ticket.DayName}}, {{ticket.Time}}</p>\n                            </div>\n                        </div>\n                    </td>\n                    <td title="\'Price\'" sortable="\'Price\'" class="priceCell">\n                        <h1 class="price">LE {{ticket.Price}}<span>.00</span></h1>\n                        <h1 class="editFontSize" ng-if="$root.clientWidth<=750">\n                            {{ticket.NumberOfTickets}}\n                            <span ng-if="!ticket.eTicket">Tickets</span>\n                            <span ng-if="ticket.eTicket">e-Tickets</span>\n                        </h1>\n                        <p ng-if="$root.clientWidth<=750 && ticket.Row != null && ticket.NumberOfTickets>1 " class="eventName">Row {{ticket.Row}} / Seats From {{ticket.StartSeat}} To {{ticket.EndSeat}}</p>\n                        <p ng-if="$root.clientWidth<=750 && ticket.Row != null && ticket.NumberOfTickets==1 " class="eventName">Row {{ticket.Row}} / Seat {{ticket.StartSeat}}</p>\n                        <p ng-if="$root.clientWidth<=750 && ticket.Row == null" class="eventName">{{ticket.Section || \'Standing\'}}</p>\n                    </td>\n                    <td ng-if="$root.clientWidth>750" title="\'QTY\'" sortable="\'NumberOfTickets\'" class="boughtCell">\n                        <h1>\n                            {{ticket.NumberOfTickets}}\n                            <span ng-if="!ticket.eTicket">Tickets</span>\n                            <span ng-if="ticket.eTicket">e-Tickets</span>\n                        </h1>\n                        <p ng-if="ticket.Row != null && ticket.NumberOfTickets>1" class="eventName">Row {{ticket.Row}} / Seats From {{ticket.StartSeat}} To {{ticket.EndSeat}}</p>\n                        <p ng-if="ticket.Row != null && ticket.NumberOfTickets==1" class="eventName">Row {{ticket.Row}} / Seat {{ticket.StartSeat}}</p>\n                        <p ng-if="ticket.Row == null" class="eventName">{{ticket.Section || \'Standing\'}}</p>\n                    </td>\n                    <td title="\'Event\'" sortable="\'EventName\'" class="eventsListEventCell">\n                        <h1><a href="#/performance/{{ticket.PerformanceId}}">{{ticket.PerformanceName}}</a></h1>\n                        <p class="eventName"><a href="#/event/{{ticket.EventId}}">{{ticket.EventName}}</a></p>\n                    </td>\n                </tr>\n            </table>\n            <div class="globalButtonsBar midTopSpace extraWidth">\n                <a ng-click="vm.loadMoreCancelledTickets()" ng-if="vm.disableCancelledTickets == false && vm.CancelledTickets.length > vm.CountPerPage_CancelledTickets" class="globalButton borderedButton" color="lightGrey">Load More</a>\n            </div>\n        </div>\n    </div>\n</div>\n<!-- AI:Open Reset makes a new request from server -->\n<div eturn-popup title="Receipt #{{vm.order.Reference}}" closable=true printable=true ng-if="vm.showPoper" show-poper="vm.showPoper">\n    <div class="tableLike">\n        <div class="rowLike rowLikeHead">\n            <div class="cellLike addMoreSpace">\n                <p>Item</p>\n            </div>\n            <div class="cellLike center">\n                <p>QTY</p>\n            </div>\n            <div class="cellLike otherSide">\n                <p>Price Per Ticket</p>\n            </div>\n            <div class="cellLike otherSide">\n                <p>Total</p>\n            </div>\n        </div>\n        <div class="rowLike">\n            <div class="cellLike">\n                <p>{{vm.order.PerformanceName}} Ticket</p>\n            </div>\n            <div class="cellLike center">\n                <p>{{vm.ReceiptNumberOfTickets}}</p>\n            </div>\n            <div class="cellLike otherSide">\n                <p>LE  {{vm.order.TicketPrice}}</p>\n            </div>\n            <div class="cellLike otherSide">\n                <p>LE  {{vm.order.TicketsTotalPrice}}</p>\n            </div>\n        </div>\n        <div ng-repeat="fees in vm.order.OrderFees" class="rowLike">\n            <div class="cellLike">\n                <p>{{fees.FeeName}}</p>\n            </div>\n            <div class="cellLike center">\n                <p></p>\n            </div>\n            <div class="cellLike otherSide">\n                <p></p>\n            </div>\n            <div class="cellLike otherSide">\n                <!-- <p>LE  {{vm.order.OrderFees}}</p> -->\n                LE  {{fees.FeeValue}}\n            </div>\n        </div>\n        <div class="rowLike">\n            <div class="cellLike">\n                <p>Sub Total</p>\n            </div>\n            <div class="cellLike center">\n                <p></p>\n            </div>\n            <div class="cellLike otherSide">\n                <p></p>\n            </div>\n            <div class="cellLike otherSide">\n                <!-- <p>LE  {{vm.order.OrderFees}}</p> -->\n                LE  {{vm.order.OrderSubTotal}}\n            </div>\n        </div>\n        <div class="cellLike">\n            <p>Tax</p>\n        </div>\n        <div class="cellLike center">\n            <p></p>\n        </div>\n        <div class="cellLike otherSide">\n            <p></p>\n        </div>\n        <div class="cellLike otherSide">\n            LE  {{vm.order.OrderTaxTotal}}\n        </div>\n    </div>\n    <div class="resetTotal">\n        <p>Total <span>LE  {{vm.order.OrderGrandTotal}}</span></p>\n    </div>\n</div>\n\n<div eturn-popup title="Cancel Tickets From Sale" ng-show="vm.showCancel" show-poper="vm.showCancel">\n    <div class="tableLike">\n        <p>Are you sure you want to cancel the remaining tickets from sale?</p>\n    </div>\n    <div class="globalButtonsBar topSpace">\n        <a ng-click="vm.CancelTicketGroupVerified()" class="globalButton callToAction green ">Yes</a>\n        <a ng-click="vm.CancelTicketGroupDismiss()" class="globalButton callToAction red ">No</a>\n    </div>\n</div>\n\n<div eturn-popup title="Cannot Be Cancelled" ng-show="vm.showCannotCancel" show-poper="vm.showCannotCancel">\n    <div class="tableLike">\n        <p>There are pending orders on some of the tickets.</p>\n    </div>\n    <div class="globalButtonsBar topSpace">\n        <a ng-click="vm.CannotCancelTicketGroupDismiss()" class="globalButton callToAction blue">OK</a>\n    </div>\n</div>');
$templateCache.put('app/components/users/thanks.html','<div class="contents">\n  <h1 id="result" class="text-transform-none"></h1>\n  <div class="centerDiv" ng-show="vm.showButton">\n    <h1 class="text-center text-transform-none">\n      Please check your email to verify your account.\n    </h1>\n  </div>\n</div>\n');
$templateCache.put('app/components/users/verifyRegistration.html','<div eturn-popup title="{{$root.PopUpTitle}}" closable=true ng-if="$root.PopError == true" show-poper="$root.PopError">\n    <p>{{$root.PopUpDescription}}</p>\n</div>\n<!--<div eturn-popup title="Email Verification" closable=true ng-if="vm.showEmailPopUp==true" show-poper="vm.showEmailPopUp">\n    <p>A VERIFICATION EMAIL HAS BEEN SENT TO YOU. PLEASE CHECK YOUR EMAIL TO VERIFY YOUR ACCOUNT</p>\n</div>-->\n<div ng-if="vm.verificationCheck">\n    <div class="contents" ng-if="!vm.mobileRejectionToggle">\n        <div class="contentsHalf contentsHalfResponsive">\n            <h1>verify your account</h1>\n            <div class="contentsCore">\n                <div ng-if="!vm.mobileRejectionToggle">\n                    <p ng-show="vm.showEmailPopUp">\n                        A verification mail has been sent, please check your email to verify your account.\n                    </p>\n                    <p ng-show="vm.firstSent">\n                        A verification code has been sent to the mobile number:\n                    </p>\n                    <p ng-show="vm.secondSent">\n                        Click on send to send verification code:\n                    </p>\n                    <h2>\n                        {{vm.mobileNumber}}\n                        <a href="javascript:;" class="miniLink" ng-click="vm.rejectMobileNumber()">That\'s not my\n                            number!</a>\n                    </h2>\n                </div>\n                <form novalidate id="verificationForm" name="verificationForm"\n                    ng-submit="vm.verify(verificationForm.$valid)" ng-if="!vm.mobileRejectionToggle">\n                    <div class="globalForm">\n                        <div class="globalFormUnit sidedButton extraInput"\n                            ng-class="{error:vm.message.length > 0 && vm.verificationCodeSubmitted}">\n                            <p ng-show="vm.verificationCodeResent">\n                                Code has been resent\n                            </p>\n                            <p>\n                                Enter Code Here\n                                <span class="errorVerifyPage">\n                                    {{vm.message}}\n                                </span>\n                            </p>\n                            <input type="text" name="verificationCode" id="verificationCode"\n                                ng-model="vm.verificationCode"\n                                ng-change="vm.message = \'\'; vm.verificationCodeResent = false" required />\n                            <input type="submit" class="globalButton callToAction green" color="grey"\n                                value="{{vm.verifyText}}" />\n                        </div>\n                        <div class="globalButtonsBar edged extraWidth">\n                            <a href="javascript:;" ng-click="vm.resendVerificationCode()" ng-disabled="vm.disableButton"\n                                class="globalButton borderedButton blue" color="lightGrey">\n                                {{vm.resendVerificationCodeText}}\n                            </a>\n                            <a href="javascript:;" ng-click="vm.skipVerification()" class="globalButton borderedButton"\n                                color="lightGrey">\n                                {{vm.skipVerificationText}}\n                            </a>\n                        </div>\n                    </div>\n                </form>\n            </div>\n        </div>\n        <div class="contentsHalf centeredContents contentsHalfResponsiveRightSide">\n            <img src="assets/images/art/verification.png" />\n        </div>\n    </div>\n    <div class="contents" ng-if="vm.mobileRejectionToggle">\n        <div class="contentsHalf contentsHalfChangeYourNum">\n            <h1>Change your number</h1>\n            <div class="contentsCore">\n                <form novalidate id="changingForm" name="changingForm" class="globalformunit sidedbutton"\n                    ng-submit="vm.change(changingForm.$valid)">\n                    <div class="globalForm">\n                        <div class="globalFormUnit sidedButton extraInput extraWidth"\n                            ng-class="{error:changingForm.$invalid && vm.newNumberSubmitted}">\n                            <p>\n                                Enter new number here\n                                <span style="float:right"\n                                    ng-show="changingForm.newMobileNumber.$error.required && vm.newNumberSubmitted">\n                                    New number is required\n                                </span>\n                                <span class="errorChangeNumVerifyPage" style="float:right"\n                                    ng-show="changingForm.newMobileNumber.$invalid && !changingForm.newMobileNumber.$error.required && vm.newNumberSubmitted">\n                                    Invalid new number\n                                </span>\n                                <span style="float:right; margin-left: 15px;"\n                                    ng-show="vm.mobileUsed && vm.newNumberSubmitted">\n                                    New number is already used\n                                </span>\n                            </p>\n                            <input type="text" name="newMobileNumber" id="newMobileNumber" ng-model="vm.mobileNumber"\n                                ng-change="vm.newNumberSubmitted = false" ng-pattern="vm.regex.mobile" mobile-phone\n                                required />\n                            <input type="submit" class="globalButton callToAction green ChangeYourNum" color="grey"\n                                value="{{vm.changeMobileNumberText}}" />\n                        </div>\n                        <div class="globalButtonsBar edged extraWidth">\n                            <a href="javascript:;" ng-click="vm.cancelRejection()" class="globalButton borderedButton"\n                                color="lightGrey">\n                                Cancel\n                            </a>\n                        </div>\n                    </div>\n                </form>\n            </div>\n        </div>\n        <div class="contentsHalf centeredContents contentsHalfResponsiveRightSide">\n            <img src="assets/images/art/changeNumber.png" />\n        </div>\n    </div>\n</div>');
$templateCache.put('app/components/utils/popup.html','<div class="globalPopup" size="medium" ng-class="{active:poper.showPopup,spread:poper.spread}">\n  <div class="overlay">\n    <div id="printableArea" class="globalPopupCore">\n      <div class="contentsTitle withSide borderedBottom">\n        <h1>{{poper.title}}</h1>\n        <div class="globalPopupControls">\n            <a href="javascript:void(0);" tooltip="Print" ng-click="poper.print()" class="print" ng-if="poper.printable">\n                <svg><use xlink:href="#printIcon" /></svg>\n            </a>\n          <a href="javascript:void(0);" tooltip="Close" ng-click="poper.closePoper()" ng-if="poper.closable">\n            <svg><use xlink:href="#closeIcon" /></svg>\n          </a>\n        </div>\n      </div>\n      <div class="contentsCore"  ng-transclude>\n\n      </div>\n    </div>\n  </div>\n\n</div>\n');
$templateCache.put('app/components/utils/upload.html','<div ng-if="uploader.showDialog">\n  <div class="globalDialogCore">\n    <div class="globalDialogCoreTitle">\n      <h1>Upload Images Of Your Item</h1>\n      <span class="globalDialogClose" ng-click="uploader.close()" ng-if="uploader.showFiles">\n        <svg viewbox="0 0 24 24">\n          <path d="M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,19H5V5H19V19M17,8.4L13.4,12L17,15.6L15.6,17L12,13.4L8.4,17L7,15.6L10.6,12L7,8.4L8.4,7L12,10.6L15.6,7L17,8.4Z"/>\n        </svg>\n      </span>\n    </div>\n    <div class="globalDIalogCoreBody">\n      <div class="uploadProgressHolder" ng-if="uploader.showProgress">\n        <div class="uploadProgressUnit"\n             ng-repeat="p in uploader.uploadProgress track by $index"\n             ng-class="{\'uploadProgressUnitFinished\': p === 100, \'uploadProgressUnitActive\': p < 100}">\n          <p>{{uploader.files[$index].name}}<span>{{uploader.fileSizeLabel(uploader.filesSizes[$index])}}</span></p>\n          <div class="uploadProgressUnitCore">\n            <div class="uploadProgressUnitFill" style="width: {{p}}%;"><span>{{p}}%</span></div>\n          </div>\n        </div>\n      </div>\n      <div class="globalDialogMiniGallery" ng-if="uploader.showFiles">\n        <div class="globalDialogMiniGalleryUnit"\n              ng-repeat="data in uploader.filesAsData track by $index">\n          <div class="globalDialogMiniGalleryUnitCore">\n            <img data-ng-src="{{data}}"/>\n          </div>\n          <span ng-click="uploader.deleteImage($index)">\n            <span>Delete</span>\n              <svg viewbox="0 0 24 24">\n                <path d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z"/>\n              </svg>\n          </span>\n        </div>\n        <div class="formControls">\n          <md-button class="md-raised formButton green leftIcon hide500" ng-hide="uploader.remainingFiles <= 0" ng-click="doTheBack();">\n            <svg viewbox="0 0 24 24">\n              <path d="M9,16V10H5L12,3L19,10H15V16H9M5,20V18H19V20H5Z"/>\n            </svg>\n            Add More\n            <input type="file" name="files[]" file multiple trigger="uploader.updateChoosenFiles(files)"/>\n          </md-button>\n          <md-button class="md-raised formButton red"\n                     ng-click="uploader.close()">\n            Done, Continue\n            <svg viewbox="0 0 24 24">\n              <path d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z"/>\n            </svg>\n          </md-button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n');
$templateCache.put('app/components/venues/venue.html','<spinner ng-if="vm.venueLoading" give="contents" push ="center"></spinner>\n<div ng-if="!vm.venueLoading" class="banner withMap">\n    <img src="{{vm.VenueDetails.Image2}}" />\n    <div class="bannerMap">\n        <ng-map style="height:100%;" center="[{{vm.VenueDetails.Latt}},{{vm.VenueDetails.Long}}]" zoom="15"></ng-map>\n    </div>\n</div>\n<div ng-if="!vm.venueLoading" class="contents borderedBottom">\n    <div class="contentsTitle">\n        <h1>{{vm.VenueDetails.name}}</h1>\n    </div>\n    <div class="contactBar eventsListFilter">\n        <h2>\n            <span>\n                <svg viewBox="0 0 24 24">\n                    <path d="M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z" />\n                </svg>\n                {{vm.VenueDetails.Address}}\n            </span>\n            <span ng-if="vm.VenueDetails.Phone">\n                <svg viewBox="0 0 24 24">\n                    <path d="M6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5A1,1 0 0,1 21,16.5V20A1,1 0 0,1 20,21A17,17 0 0,1 3,4A1,1 0 0,1 4,3H7.5A1,1 0 0,1 8.5,4C8.5,5.25 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.59L6.62,10.79Z" />\n                </svg>\n                {{vm.VenueDetails.Phone}}\n            </span>\n        </h2>\n    </div>\n    <div class="contentsCore textData" ng-class="{rtlContents:$root.isArabic(vm.VenueDetails.Description)}">\n        <p>\n            {{vm.VenueDetails.Description}}\n        </p>\n    </div>\n</div>\n<div class="contents" ng-if="vm.hasPerformances && !vm.venueLoading">\n    <div class="contentsTitle">\n        <h1>{{vm.VenueDetails.name}} Events</h1>\n    </div>\n    <div class="contentsCore">\n        <div class="eventsListFilter eventsListFilterIdentifier">\n            <div class="eventsListFilterUnit">\n                <p>Category</p>\n                <select ng-model="vm.filters.CategoryId"\n                        ng-init="vm.filters.CategoryId = -1"\n                        ng-options="category.CategoryId as category.CategoryName for category in vm.allCategories"\n                        ng-change="vm.getPerformances(false)"></select>\n            </div>\n            <div class="eventsListFilterUnit">\n                <p>Event</p>\n                <select ng-model="vm.filters.EventId"\n                        ng-init="vm.filters.EventId = -1"\n                        ng-options="event.EventId as event.EventName for event in vm.allEvents"\n                        ng-change="vm.getPerformances(false)"></select>\n            </div>\n            <div class="eventsListFilterUnit">\n                <p>Venue</p>\n                <select disabled>\n                    <option>{{vm.VenueDetails.name}} </option>\n                </select>\n            </div>\n            <div class="eventsListFilterUnit">\n                <p>Performer</p>\n                <select ng-model="vm.filters.PerformerId"\n                        ng-init="vm.filters.PerformerId = -1"\n                        ng-options="performer.PerformerId as performer.PerformerName for performer in vm.allPerformers"\n                        ng-change="vm.getPerformances(false)"></select>\n            </div>\n        </div>\n    </div>\n    <spinner ng-if="vm.allEventsLoading" give="contents" push="center"></spinner>\n    <div class="contentsCore" ng-show="!vm.hasPerformancesFiltered && !vm.allEventsLoading">\n        <p>No Events Found.</p>\n    </div>\n    <!-- AI:NO VENUE CELL IN VENUE EVENT LIST -->\n    <table ng-table="vm.customConfigParams" class="eventsList eventsListIdentifier" show-filter="true"\n           ng-show="vm.hasPerformancesFiltered && !vm.allEventsLoading">\n        <tr ng-repeat="event in $data">\n            <td title="\'Date\'" sortable="\'startDate\'" class="dateCell">\n                <div class="dateDayFocus inEventsList">\n                    <div class="dateDayFocusDay">\n                        <p>{{event.day}}</p>\n                    </div>\n                    <div class="dateDayFocusRest">\n                        <p>{{event.month}} {{event.year}}</p>\n                        <p class="day">{{event.dayName}}, {{event.time}}</p>\n                    </div>\n                </div>\n            </td>\n            <td title="\'Event\'" sortable="\'Performence\'" class="eventsListEventCell">\n                <h1><a href="#/performance/{{event.PerformenceId}}">{{event.Performence}}</a></h1>\n                <!-- AI:MUST BE HIDDEN IF SINGLE PERFORMENCE PER EVENT -->\n                <p class="eventName"><a ng-if="event.Num_Performances_InEvent > 1" href="#/event/{{event.EventId}}">{{event.EventName}}</a></p>\n                <p class="avTickets" ng-if="$root.clientWidth<=600">{{event.avTickets}} Tickets Available</p>\n                <div class="globalButtonsBar edged" ng-if="$root.clientWidth<=420">\n                    <a ng-if="event.avTickets !=0 &&event.IsBuyBlocked!=true" href="#/performance/{{event.PerformenceId}}" class="globalButton borderedButton" color="nevy">buy tickets</a>\n                    <a ng-if="event.IsSellBlocked!=true" href="javascript:;" class="globalButton borderedButton" color="red" ng-click="vm.trySell(event.PerformenceId)">Sell tickets</a>\n                </div>\n            </td>\n            <td ng-if="$root.clientWidth>600">\n                <p class="avTickets">{{event.avTickets}} Tickets Available</p>\n            </td>\n            <td ng-if="$root.clientWidth>420">\n                <div class="globalButtonsBar otherSide" ng-class="{edged:$root.clientWidth>860,vertical:$root.clientWidth<=860}">\n                    <a ng-if="event.avTickets !=0 &&event.IsBuyBlocked!=true" href="#/performance/{{event.PerformenceId}}" class="globalButton borderedButton" color="nevy">buy tickets</a>\n                    <a ng-if="event.IsSellBlocked!=true" href="javascript:;" class="globalButton borderedButton" color="red" ng-click="vm.trySell(event.PerformenceId)">Sell tickets</a>\n                </div>\n            </td>\n        </tr>\n        <!-- TEMP STYLE-->\n        <style>\n            .ng-table-pager {\n                display: none;\n            }\n        </style>\n    </table>\n    <div class="globalButtonsBar midTopSpace extraWidth" ng-if="!vm.allEventsLoading">\n        <a href="javascript:void(0);" class="globalButton borderedButton" color="lightGrey"\n           ng-click="vm.loadMore()"\n           ng-hide="vm.lastCall">\n            {{vm.loadMoreText}}\n        </a>\n    </div>\n</div>\n\n\n<!-- Root element of PhotoSwipe. Must have class pswp. -->\n<div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">\n    <div class="pswp__bg"></div>\n    <div class="pswp__scroll-wrap">\n        <div class="pswp__container">\n            <div class="pswp__item"></div>\n            <div class="pswp__item"></div>\n            <div class="pswp__item"></div>\n        </div>\n        <div class="pswp__ui pswp__ui--hidden">\n            <div class="pswp__top-bar">\n                <div class="pswp__counter"></div>\n                <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>\n                <!-- <button class="pswp__button pswp__button--share" title="Share"></button> -->\n                <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>\n                <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>\n                <div class="pswp__preloader">\n                    <div class="pswp__preloader__icn">\n                        <div class="pswp__preloader__cut">\n                            <div class="pswp__preloader__donut"></div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">\n                <div class="pswp__share-tooltip"></div>\n            </div>\n            <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)"></button>\n            <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)"></button>\n            <div class="pswp__caption">\n                <div class="pswp__caption__center"></div>\n            </div>\n        </div>\n    </div>\n</div>\n<div eturn-popup title="{{$root.PopUpTitle}}" closable=true ng-if="$root.showPopup == true" show-poper="$root.showPopup">\n     {{$root.PopUpDescription}}\n</div>\n');
$templateCache.put('app/layouts/footer/footer.html','<div class="footerLinksGroups">\n\t<div class="footerLinksGroup">\n\t\t<h1>company</h1>\n\t\t<div class="footerLinks">\n\t\t\t<div class="footerLinksCore">\n\t\t\t\t<a href="#/about">About us</a>\n\t\t\t\t<a href="#/requests/Contact_Us">Contact Us</a>\n\t\t\t\t<!-- <a href="">How It Works</a> -->\n\t\t\t\t<!-- <a href="">Our Guarantee</a> -->\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\t<div class="footerLinksGroup">\n\t\t<h1>Quick Link</h1>\n\t\t<div class="footerLinks">\n\t\t\t<div class="footerLinksCore">\n\t\t\t\t<a href="#/requests/Add_Event">Add Event</a>\n\t\t\t\t<a href="#/requests/Add_Venue">Add Venue</a>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\t<div class="footerLinksGroup" ng-if="$root.clientWidth<=768">\n\t\t<h1>Legal</h1>\n\t\t<div class="footerLinks">\n\t\t\t<div class="footerLinksCore">\n\t\t\t\t<a href="#/buyer-agreement">Buyer Agreement</a>\n\t\t\t\t<a href="#/seller-agreement">Seller Agreement</a>\n\t\t\t</div>\n\t\t\t<div class="footerLinksCore">\n\t\t\t\t<a href="#/privacy">Privacy Policy</a>\n\t\t\t\t<a href="#/cookies">Cookies Policy</a>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\t<div class="footerLinksGroup" ng-if="$root.clientWidth>768">\n\t\t<h1>Legal</h1>\n\t\t<div class="footerLinks">\n\t\t\t<div class="footerLinksCore">\n\t\t\t\t<a href="#/buyer-agreement">Buyer Agreement</a>\n\t\t\t\t<a href="#/seller-agreement">Seller Agreement</a>\n\t\t\t</div>\n\t\t\t<div class="footerLinksCore">\n\t\t\t\t<a href="#/privacy">Privacy Policy</a>\n\t\t\t\t<a href="#/cookies">Cookies Policy</a>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n<div class="footerLinksGroups rights">\n\t<div class="rightsGroupsHolder">\n\t\t<!-- <div class="footerLinksGroup">\n      <h1>secure buy</h1>\n      <div class="footerLinks">\n        <div class="footerLinksCore">\n          <img src="assets/images/visa.png" />\n        </div>\n      </div>\n    </div> -->\n\t\t<div class="footerLinksGroup">\n\t\t\t<h1>follow us</h1>\n\t\t\t<div class="footerLinks">\n\t\t\t\t<div class="footerLinksCore social">\n\t\t\t\t\t<a href="http://bit.ly/TixawyFacebook" target="_blank">\n\t\t\t\t\t\t<svg>\n\t\t\t\t\t\t\t<use xlink:href="#facebookIcon" /></svg>\n\t\t\t\t\t</a>\n\t\t\t\t\t<a href="http://bit.ly/TixawyOnlineT" target="_blank">\n\t\t\t\t\t\t<svg>\n\t\t\t\t\t\t\t<use xlink:href="#twitterIcon" /></svg>\n\t\t\t\t\t</a>\n\t\t\t\t\t<a href="">\n\t\t\t\t\t\t<svg viewBox="0 0 24 24">\n\t\t\t\t\t\t\t<path d="M10,16.5V7.5L16,12M20,4.4C19.4,4.2 15.7,4 12,4C8.3,4 4.6,4.19 4,4.38C2.44,4.9 2,8.4 2,12C2,15.59 2.44,19.1 4,19.61C4.6,19.81 8.3,20 12,20C15.7,20 19.4,19.81 20,19.61C21.56,19.1 22,15.59 22,12C22,8.4 21.56,4.91 20,4.4Z" />\n\t\t\t\t\t\t</svg>\n\t\t\t\t\t</a>\n\t\t\t\t\t<a href="http://bit.ly/tixawyonlineI" target="_blank">\n\t\t\t\t\t\t<svg viewBox="0 0 24 24">\n\t\t\t\t\t\t\t<path d="M7.8,2H16.2C19.4,2 22,4.6 22,7.8V16.2A5.8,5.8 0 0,1 16.2,22H7.8C4.6,22 2,19.4 2,16.2V7.8A5.8,5.8 0 0,1 7.8,2M7.6,4A3.6,3.6 0 0,0 4,7.6V16.4C4,18.39 5.61,20 7.6,20H16.4A3.6,3.6 0 0,0 20,16.4V7.6C20,5.61 18.39,4 16.4,4H7.6M17.25,5.5A1.25,1.25 0 0,1 18.5,6.75A1.25,1.25 0 0,1 17.25,8A1.25,1.25 0 0,1 16,6.75A1.25,1.25 0 0,1 17.25,5.5M12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9Z" />\n\t\t\t\t\t\t</svg>\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\t<div class="copy">\n\t\t<p>Copyright \xA9 {{footerC.date | date:\'yyyy\'}}. All Rights reserved.</p>\n\t\t<!-- <p>Developed With Love By <a href="http://appenza-studio.com/" target="_blank"><img src="assets/images/eTurn.png" /></a></p> -->\n\t</div>\n</div>');
$templateCache.put('app/layouts/topBar/topBar.html','<header>\n    <a href="#/home" class="logo"><img src="assets/images/logo.png" /></a>\n    <div class="headerSearch">\n        <div class="ticketCutEdgeVertical"></div>\n\n        <div class="headerSearchField" my-enter="vm.searchResult()" angucomplete-alt id="headerSearchField"\n            placeholder="Search For Events, Performers or Venues at least 3 character" pause="400"\n            selected-object="vm.itemSelected" remote-url="{{vm.searchEndpoint}}" title-field="title"\n            description-field="type">\n        </div>\n        <div class="ticketCutEdgeVertical flipped"></div>\n        <div class="ticketCutEdgeVertical"></div>\n        <button ng-click="vm.searchResult()">\n            <svg viewBox="0 0 25 25">\n                <path\n                    d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z" />\n            </svg>\n        </button>\n        <div class="ticketCutEdgeVertical flipped"></div>\n    </div>\n    <div class="headerUtlsLinks">\n        <a href="javascript:void(0);" class="loginHandler" ng-click="vm.toggleLoginPanel()" ng-if="!vm.isLoggedIn">\n            <svg viewBox="0 0 24 24">\n                <path\n                    d="M11,10V12H10V14H8V12H5.83C5.42,13.17 4.31,14 3,14A3,3 0 0,1 0,11A3,3 0 0,1 3,8C4.31,8 5.42,8.83 5.83,10H11M3,10A1,1 0 0,0 2,11A1,1 0 0,0 3,12A1,1 0 0,0 4,11A1,1 0 0,0 3,10M16,14C18.67,14 24,15.34 24,18V20H8V18C8,15.34 13.33,14 16,14M16,12A4,4 0 0,1 12,8A4,4 0 0,1 16,4A4,4 0 0,1 20,8A4,4 0 0,1 16,12Z" />\n            </svg>\n            <span>Login</span>\n            <svg class="arrow">\n                <use xlink:href="#arrowIcon" />\n            </svg>\n        </a>\n        <!-- AI:Logged In Case -->\n        <!-- IMPORTANT:When user logged in login HTML must be removed from DOM -->\n        <div class="loggedInMenu" ng-class="{active:$root.userMenu}" ng-click="vm.toggleUserMenu()"\n            ng-if="vm.isLoggedIn" dismiss-menu>\n            <a href="javascript:void(0);">\n                <svg viewBox="0 0 24 24">\n                    <path\n                        d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z" />\n                </svg>\n                <span>{{$root.User.Name}}</span>\n                <svg class="arrow">\n                    <use xlink:href="#arrowIcon" />\n                </svg>\n            </a>\n            <div class="loggedInMenuDrop">\n                <a href="#/users/profile">\n                    <svg viewBox="0 0 24 24">\n                        <path\n                            d="M12,13C9.33,13 4,14.33 4,17V20H20V17C20,14.33 14.67,13 12,13M12,4A4,4 0 0,0 8,8A4,4 0 0,0 12,12A4,4 0 0,0 16,8A4,4 0 0,0 12,4M12,14.9C14.97,14.9 18.1,16.36 18.1,17V18.1H5.9V17C5.9,16.36 9,14.9 12,14.9M12,5.9A2.1,2.1 0 0,1 14.1,8A2.1,2.1 0 0,1 12,10.1A2.1,2.1 0 0,1 9.9,8A2.1,2.1 0 0,1 12,5.9Z" />\n                    </svg>\n                    <span>View Profile</span>\n                </a>\n                <a href="#/users/account">\n                    <svg viewBox="0 0 24 24">\n                        <path\n                            d="M9,4A4,4 0 0,0 5,8A4,4 0 0,0 9,12A4,4 0 0,0 13,8A4,4 0 0,0 9,4M9,14C6.33,14 1,15.33 1,18V20H12.08C12.03,19.67 12,19.34 12,19C12,17.5 12.5,16 13.41,14.8C11.88,14.28 10.18,14 9,14M18,14C17.87,14 17.76,14.09 17.74,14.21L17.55,15.53C17.25,15.66 16.96,15.82 16.7,16L15.46,15.5C15.35,15.5 15.22,15.5 15.15,15.63L14.15,17.36C14.09,17.47 14.11,17.6 14.21,17.68L15.27,18.5C15.25,18.67 15.24,18.83 15.24,19C15.24,19.17 15.25,19.33 15.27,19.5L14.21,20.32C14.12,20.4 14.09,20.53 14.15,20.64L15.15,22.37C15.21,22.5 15.34,22.5 15.46,22.5L16.7,22C16.96,22.18 17.24,22.35 17.55,22.47L17.74,23.79C17.76,23.91 17.86,24 18,24H20C20.11,24 20.22,23.91 20.24,23.79L20.43,22.47C20.73,22.34 21,22.18 21.27,22L22.5,22.5C22.63,22.5 22.76,22.5 22.83,22.37L23.83,20.64C23.89,20.53 23.86,20.4 23.77,20.32L22.7,19.5C22.72,19.33 22.74,19.17 22.74,19C22.74,18.83 22.73,18.67 22.7,18.5L23.76,17.68C23.85,17.6 23.88,17.47 23.82,17.36L22.82,15.63C22.76,15.5 22.63,15.5 22.5,15.5L21.27,16C21,15.82 20.73,15.65 20.42,15.53L20.23,14.21C20.22,14.09 20.11,14 20,14M19,17.5A1.5,1.5 0 0,1 20.5,19A1.5,1.5 0 0,1 19,20.5C18.16,20.5 17.5,19.83 17.5,19A1.5,1.5 0 0,1 19,17.5Z" />\n                    </svg>\n                    <span>Account Settings</span>\n                </a>\n                <!--<a href="#/users/balanceSheet" ng-if="$root.User.HaveOrders">\n                    <svg viewBox="0 0 24 24">\n                        <path d="M19,17.59L17.59,19L7,8.41V15H5V5H15V7H8.41L19,17.59Z" />\n                    </svg>\n                    <span>Balance Sheet</span>\n                </a>-->\n                <a href="#/users/tickets_for_sale">\n                    <svg viewBox="0 0 17 17">\n                        <path\n                            d="M14.371,3.547c-0.044,0.085-0.098,0.165-0.167,0.234c-0.478,0.478-1.393,0.338-2.043-0.312   c-0.65-0.65-0.79-1.565-0.312-2.043c0.069-0.069,0.148-0.124,0.233-0.167L10.822,0L8.964,1.859l0.465,0.465L9.14,2.613L8.675,2.148   l-8.674,8.675l1.226,1.227c0.479-0.479,1.393-0.34,2.043,0.311s0.79,1.564,0.312,2.043l1.226,1.227L15.63,4.807L14.371,3.547z    M10.567,4.038L9.854,3.325l0.288-0.289l0.713,0.713L10.567,4.038z M11.993,5.464L11.28,4.751l0.288-0.288l0.714,0.713   L11.993,5.464z M13.42,6.891l-0.714-0.713l0.289-0.288l0.713,0.713L13.42,6.891z" />\n                    </svg>\n                    <span>My Tickets</span>\n                </a>\n                <a href="#/users/orders" ng-if="$root.User.HaveOrders">\n                    <svg viewBox="0 0 24 24">\n                        <path d="M5,6.41L6.41,5L17,15.59V9H19V19H9V17H15.59L5,6.41Z" />\n                    </svg>\n                    <span>Orders</span>\n                </a>\n                <a href="#/users/account"\n                    ng-if="(!$root.User.IsPhoneVerified || !$root.User.IsEmailVerified) && vm.showVerify==true ">\n                    <svg viewBox="0 0 24 24">\n                        <path d="M5,6.41L6.41,5L17,15.59V9H19V19H9V17H15.59L5,6.41Z" />\n                    </svg>\n                    <span>Verify Now</span>\n                </a>\n                <a href="" data-facebook="{{vm.fbAppId}}" ng-click="vm.logout()">\n                    <svg viewBox="0 0 24 24">\n                        <path\n                            d="M6.5,3C8.46,3 10.13,4.25 10.74,6H22V9H18V12H15V9H10.74C10.13,10.75 8.46,12 6.5,12C4,12 2,10 2,7.5C2,5 4,3 6.5,3M6.5,6A1.5,1.5 0 0,0 5,7.5A1.5,1.5 0 0,0 6.5,9A1.5,1.5 0 0,0 8,7.5A1.5,1.5 0 0,0 6.5,6M14.59,14L16,15.41L13.41,18L16,20.59L14.59,22L12,19.41L9.41,22L8,20.59L10.59,18L8,15.41L9.41,14L12,16.59L14.59,14Z" />\n                    </svg>\n                    <span>Logout</span>\n                </a>\n            </div>\n        </div>\n    </div>\n    <div class="loginView" ng-if="!vm.isLoggedIn">\n        <div class="overlay">\n        </div>\n        <div class="loginPanelHolder">\n            <div class="loginPanel">\n                <div class="globalForm">\n                    <form novalidate class="loginPanelHalf"\n                        ng-if="$root.clientWidth>768 || !$root.signUpView && $root.clientWidth<=768">\n                        <div class="loginPanelLoginCore" ng-if="!vm.forgotPassword">\n                            <h1>Login With Tixawy account</h1>\n                            <div class="globalFormUnit" ng-class="{error:$root.userLoginError}">\n                                <p>\n                                    Email Address / Mobile Number\n                                    <span ng-if="$root.userLoginError">\n                                        Wrong Credentials\n                                    </span>\n                                </p>\n                                <input type="text" id="userLoginEmail" maxlength="200" />\n                            </div>\n                            <div class="globalFormUnit condensed" ng-class="{error:$root.userLoginError}">\n                                <p>\n                                    Password\n                                </p>\n                                <input type="password" id="userLoginPassword" maxlength="200" />\n                            </div>\n                            <div class="globalFormUnit">\n                                <div class="globalFormUnitCheck">\n                                    <input type="checkbox" id="userLoginRemember" />\n                                    <div class="globalFormUnitCheckCore">\n                                        <svg viewBox="0 0 24 24">\n                                            <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />\n                                        </svg>\n                                    </div>\n                                    <p>\n                                        Remember Me\n                                    </p>\n                                </div>\n                                <a href="javascript:void(0);" class="restorePasswordHandler"\n                                    ng-click="vm.forgotPasswordToggler()">I can\u2019t remember<span> my password</span></a>\n                            </div>\n                            <div class="globalButtonsBar">\n                                <input type="submit" value="Login" class="globalButton callToAction blue fullWidth"\n                                    ng-click="vm.doUserLogin()" />\n                            </div>\n                            <div class="loginOr">\n                                <h1>\n                                    OR\n                                </h1>\n                                <span class="horzLine"></span>\n                            </div>\n                            <div class="globalButtonsBar">\n                                <a href="javascript:void(0);"\n                                    class="globalButton callToAction facebookBlue fullWidth normalChars regularFont"\n                                    data-facebook="{{vm.fbAppId}}" ng-click="fetch()">\n                                    <svg viewBox="0 0 23 23">\n                                        <path\n                                            d="M19,4V7H17A1,1 0 0,0 16,8V10H19V13H16V20H13V13H11V10H13V7.5C13,5.56 14.57,4 16.5,4M20,2H4A2,2 0 0,0 2,4V20A2,2 0 0,0 4,22H20A2,2 0 0,0 22,20V4C22,2.89 21.1,2 20,2Z" />\n                                    </svg>\n                                    Login With Facebook\n                                </a>\n                            </div>\n                            <div class="globalButtonsBar topSpace" ng-if="$root.clientWidth<=768">\n                                <a href="javascript:void(0);" class="globalButton callToAction green fullWidth"\n                                    ng-click="vm.toggleLoginView($event)">New Account</a>\n                            </div>\n                        </div>\n                        <div class="loginPanelLoginCore" ng-if="vm.forgotPassword" ng-form="resetPasswordForm">\n                            <h1>Reset Password</h1>\n                            <div class="globalFormUnit"\n                                ng-class="{error:(vm.resetPasswordEmailNotExist\n                                 || vm.resetPasswordEmailNotVerified\n                                 || resetPasswordForm.resetpasswordemail.$error.required) && vm.resetPasswordEmailSubmitted}">\n                                <p>\n                                    Your E-Mail\n                                    <span\n                                        ng-if="vm.resetPasswordEmailNotExist && !resetPasswordForm.resetpasswordemail.$error.required && vm.resetPasswordEmailSubmitted">\n                                        No user account is associated with this email\n                                    </span>\n                                    <span\n                                        ng-if="resetPasswordForm.resetpasswordemail.$error.required && vm.resetPasswordEmailSubmitted">\n                                        Email is required\n                                    </span>\n                                </p>\n                                <input type="text" id="resetpasswordemail" name="resetpasswordemail"\n                                    ng-model="vm.resetpasswordemail" required />\n                            </div>\n                            <div class="globalButtonsBar">\n                                <input type="submit" value="{{vm.ResetPassowrdButtonText}}"\n                                    class="globalButton callToAction green"\n                                    ng-click="vm.resetpassword(resetPasswordForm)"\n                                    ng-disabled="vm.resetPasswordEmailSent" />\n                                <a href="javascript:void(0);" class="globalButton callToAction red"\n                                    ng-click="vm.forgotPasswordToggler()">Cancel</a>\n                            </div>\n                            <div class="globalFormUnit">\n                                <p style="color: green; padding-top: 30px;font-size: medium"\n                                    ng-if="vm.mailSendSuccessfully">\n                                    Mail was sent successfully. Please check your mail now.<br />\n                                    Redirecting to login view ({{vm.countDownCounter}})\n                                </p>\n                            </div>\n                        </div>\n                    </form>\n                    <div class="loginPanelHalf bordered" ng-show="$root.signUpView">\n                        <form novalidate name="vm.registerForm" id="registerForm"\n                            ng-submit="vm.SaveData(vm.registerForm)">\n                            <h1>Sign up a new account</h1>\n                            <div class="globalFormUnit" ng-class="{error:(vm.registerForm.ufullname.$error.pattern\n                                    || vm.registerForm.ufullname.$error.required)\n                                    && vm.registrationSubmitted}">\n                                <p>\n                                    Full Name\n                                    <span\n                                        ng-show="vm.registerForm.ufullname.$error.pattern && vm.registrationSubmitted">\n                                        At least two names in English\n                                    </span>\n                                    <span\n                                        ng-show="vm.registerForm.ufullname.$error.required && vm.registrationSubmitted">\n                                        Full name is required\n                                    </span>\n                                </p>\n                                <input type="text" name="ufullname" id="ufullname" ng-model="vm.User.Name"\n                                    maxlength="200" placeholder="Enter your full name" required />\n                            </div>\n                            <div class="globalFormUnit" ng-class="{error:(vm.registerForm.uphone.$invalid\n                                    || vm.existPhone\n                                    || vm.registerForm.uphone.$error.required)\n                                    && vm.registrationSubmitted}">\n                                <p>\n                                    Mobile Number\n                                    <span ng-show="vm.registerForm.uphone.$invalid\n                                          && !vm.registerForm.uphone.$error.required\n                                          && !vm.existPhone\n                                          && vm.registrationSubmitted">\n                                        Invalid mobile number\n                                    </span>\n                                    <span ng-show="vm.existPhone\n                                          && !vm.registerForm.uphone.$invalid\n                                          && !vm.registerForm.uphone.$error.required\n                                          && vm.registrationSubmitted">\n                                        Mobile number is already registered\n                                    </span>\n                                    <span ng-show="vm.registerForm.uphone.$error.required\n                                          && !vm.existPhone\n                                          && vm.registrationSubmitted">\n                                        Mobile number is required\n                                    </span>\n                                </p>\n                                <input type="tel" name="uphone" id="uphone" ng-model="vm.User.MobileNumber" \n                                    placeholder="Enter your mobile number"\n                                    ng-intl-tel-input data-initial-country="gb" mobile-phone\n                                    number="vm.User.MobileNumber" required>\n                            </div>\n                            <div class="globalFormUnit" ng-class="{error:(vm.registerForm.uemail.$error.pattern\n                                 || vm.existEmail\n                                 || vm.registerForm.uemail.$error.required)\n                                 && vm.registrationSubmitted}">\n                                <p>\n                                    Email Address\n                                    <span ng-show="vm.registerForm.uemail.$error.pattern\n                                          && !vm.existEmail\n                                          && !vm.registerForm.uemail.$error.required\n                                          && vm.registrationSubmitted">\n                                        Invalid email address\n                                    </span>\n                                    <span ng-show="vm.existEmail\n                                          && !vm.registerForm.uemail.$error.pattern\n                                          && !vm.registerForm.uemail.$error.required\n                                          && vm.registrationSubmitted">\n                                        Email address is already registered\n                                    </span>\n                                    <span ng-show="vm.registerForm.uemail.$error.required\n                                          && !vm.existEmail\n                                          && !vm.registerForm.uemail.$error.pattern\n                                          && vm.registrationSubmitted">\n                                        Email address is required\n                                    </span>\n                                </p>\n                                <input type="email" name="uemail" id="uemail" ng-model="vm.User.Email" maxlength="200"\n                                    placeholder="example@example.com" ng-change="vm.existEmail = false"\n                                    ng-pattern=\'/^(([^<>()\\[\\]\\.,;:\\s@\\"]+(\\.[^<>()\\[\\]\\.,;:\\s@\\"]+)*)|(\\".+\\"))@(([^<>()[\\]\\.,;:\\s@\\"]+\\.)+[^<>()[\\]\\.,;:\\s@\\"]{2,})$/i\'\n                                    required />\n                            </div>\n                            <div class="globalFormTwoUnits">\n                                <div class="globalFormUnit" ng-class="{error:(vm.registerForm.upass.$error.pattern\n                                     || vm.registerForm.upass.$error.required)\n                                     && vm.registrationSubmitted}">\n                                    <p>\n                                        Password\n                                        <span ng-show="vm.registerForm.upass.$error.pattern\n                                              && !vm.registerForm.upass.$error.required\n                                              && vm.registrationSubmitted">\n                                            Wrong criteria\n                                        </span>\n                                        <span ng-show="vm.registerForm.upass.$error.required\n                                              && !vm.registerForm.upass.$error.pattern\n                                              && vm.registrationSubmitted">\n                                            Required\n                                        </span>\n                                    </p>\n                                    <input type="password" name="upass" id="upass" ng-model="vm.User.Password"\n                                        maxlength="200" placeholder="Enter password"\n                                        ng-pattern="/^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z~@#$%^&*+=`|{}:;!.?\\()\\[\\]-]{8,}$/"\n                                        required />\n                                </div>\n                                <div class="globalFormUnit" ng-class="{error:(vm.confirmedPasswordError\n                                     || vm.registerForm.confirmpass.$error.required)\n                                     && vm.registrationSubmitted}">\n                                    <p>\n                                        Confirm Password\n                                        <span ng-show="vm.confirmedPasswordError\n                                              && !vm.registerForm.confirmpass.$error.required\n                                              && vm.registrationSubmitted">\n                                            No match\n                                        </span>\n                                        <span ng-show="vm.registerForm.confirmpass.$error.required\n                                              && vm.registrationSubmitted">\n                                            Required\n                                        </span>\n                                    </p>\n                                    <input type="password" name="confirmpass" id="confirmpass"\n                                        ng-model="vm.User.ConfirmPassword" placeholder="Enter password again"\n                                        ng-change="vm.confirmedPasswordFunc()" required maxlength="200" required />\n                                </div>\n                            </div>\n                            <div class="globalFormUnit"\n                                ng-show="vm.registerForm.upass.$error.pattern && vm.registrationSubmitted">\n                                <p>\n                                    <!--Password Criteria : At Least One Uppercase And One Lowercase and One Number and Minimum Password Length is Eight-->\n                                    Password criteria: At least 8 characters, containing uppercase letters, lowercase\n                                    letters and digits.\n                                </p>\n                            </div>\n                            <div class="globalFormUnit">\n                                <div class="globalFormUnitCheck">\n                                    <input type="checkbox" name="userAgeCliam" id="userAgeCliam"\n                                        ng-model="vm.userClaimChecked" />\n                                    <div class="globalFormUnitCheckCore">\n                                        <svg viewBox="0 0 24 24">\n                                            <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />\n                                        </svg>\n                                    </div>\n                                    <p>\n                                        I claim that I am over 13 years old\n                                        <span style="color: red"\n                                            ng-show="!vm.userClaimChecked && vm.registrationSubmitted">\n                                            <br /> Required\n                                        </span>\n                                    </p>\n                                </div>\n                            </div>\n\n                            <div class="globalButtonsBar">\n                                <input type="submit" class="globalButton callToAction green fullWidth"\n                                    value="{{vm.submitText}}" />\n                            </div>\n                            <div class="globalButtonsBar topSpace" ng-if="$root.clientWidth<=768">\n                                <a href="javascript:void(0);" class="globalButton callToAction red fullWidth"\n                                    ng-click="vm.toggleLoginView($event)">Back To Login</a>\n                            </div>\n                        </form>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <a href="javascript:void(0);" class="mobileMenuHandler" ng-if="$root.clientWidth<=768"\n        ng-click="vm.openMobileMenu()" ng-show="!$root.loginPanelActive">\n        <span></span>\n        <span></span>\n        <span></span>\n    </a>\n    <a href="#/categories" class="globalButton sellTicketsMini" ng-if="$root.clientWidth<=600" ng-show="!$root.loginPanelActive">Sell</br>Tickets</a>\n</header>\n<nav ng-class="{activated:$root.mobileMenuOpen}" ng-swipe-left="vm.closeMobileMenu()">\n    <a href="javascript:void(0);" class="closeMenu" ng-if="$root.clientWidth<=768" ng-click="vm.closeMobileMenu()">\n        <svg class="arrow">\n            <use xlink:href="#closeIcon" />\n        </svg>\n    </a>\n    <ul ng-click="vm.closeMobileMenu()">\n        <li ng-repeat="category in vm.CategoriesList " category={{category.Theme}}>\n            <a href="#/category/{{category.categoryId}}">{{category.Name}}</a>\n            <div class="navSubCategories">\n                <div class="navSubCategoriesGroup"\n                    ng-repeat="i in vm.getNumber(vm.number[category.categoryId -1]) track by $index">\n                    <a ng-repeat="subcategory in category.ChildCategories.slice($index*6, $index*6+6)"\n                        href="#/category/{{subcategory.Id}}">{{subcategory.ChildCategoryName}}</a>\n                </div>\n            </div>\n        </li>\n    </ul>\n    <a href="#/categories" class="sellTickets" ng-if="$root.clientWidth>600">\n        <span>Sell tickets</span>\n        <span class="sellTicketsHover">Sell tickets</span>\n    </a>\n</nav>\n<div class="contentWhiteOverlay"></div>\n\n<div eturn-popup title="{{$root.PopUpTitle}}" closable=true ng-if="$root.PopError == true" show-poper="$root.PopError">\n    <p>{{$root.PopUpDescription}}</p>\n</div>\n\n<!-- AI:Shadow DOM For multible use without effect on size -->\n<svg style="display:none">\n    <symbol id="breadCrumbArrow" viewBox="0 0 24 24">\n        <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />\n    </symbol>\n    <symbol id="noVideoRecording" viewBox="0 0 24 24">\n        <path\n            d="M3.27,2L2,3.27L4.73,6H4A1,1 0 0,0 3,7V17A1,1 0 0,0 4,18H16C16.2,18 16.39,17.92 16.54,17.82L19.73,21L21,19.73M21,6.5L17,10.5V7A1,1 0 0,0 16,6H9.82L21,17.18V6.5Z" />\n    </symbol>\n    <symbol id="noCameras" viewBox="0 0 24 24">\n        <path\n            d="M1.2,4.47L2.5,3.2L20,20.72L18.73,22L16.73,20H4A2,2 0 0,1 2,18V6C2,5.78 2.04,5.57 2.1,5.37L1.2,4.47M7,4L9,2H15L17,4H20A2,2 0 0,1 22,6V18C22,18.6 21.74,19.13 21.32,19.5L16.33,14.5C16.76,13.77 17,12.91 17,12A5,5 0 0,0 12,7C11.09,7 10.23,7.24 9.5,7.67L5.82,4H7M7,12A5,5 0 0,0 12,17C12.5,17 13.03,16.92 13.5,16.77L11.72,15C10.29,14.85 9.15,13.71 9,12.28L7.23,10.5C7.08,10.97 7,11.5 7,12M12,9A3,3 0 0,1 15,12C15,12.35 14.94,12.69 14.83,13L11,9.17C11.31,9.06 11.65,9 12,9Z" />\n    </symbol>\n    <symbol id="noDrinks" viewBox="0 0 24 24">\n        <path\n            d="M1,4.27L2.28,3L21,21.72L19.73,23L18.27,21.54C17.93,21.83 17.5,22 17,22H7C5.97,22 5.13,21.23 5,20.23L3.53,6.8L1,4.27M18.32,8L18.77,4H5.82L3.82,2H21L19.29,17.47L9.82,8H18.32Z" />\n    </symbol>\n    <symbol id="noFood" viewBox="0 0 24 24">\n        <path\n            d="M2,5.27L3.28,4L21,21.72L19.73,23L17.73,21H15.5L15.21,18.5L12.97,16.24C12.86,16.68 12.47,17 12,17H3A1,1 0 0,1 2,16A1,1 0 0,1 3,15H8L9.5,16.5L11,15H11.73L10.73,14H2A3,3 0 0,1 5,11H7.73L2,5.27M14,8H16.23L15.1,3.46L16.84,3L18.09,8H22L20.74,18.92L14.54,12.72L14,8M13,18A3,3 0 0,1 10,21H5A3,3 0 0,1 2,18H13Z" />\n    </symbol>\n    <symbol id="noSmoking" viewBox="0 0 24 24">\n        <path\n            d="M15.82,14L19.82,18H22V14M2,18H5V14H2M3.28,4L2,5.27L4.44,7.71C2.93,8.61 2,10.24 2,12H4C4,10.76 4.77,9.64 5.93,9.2L10.73,14H7V18H14.73L18.73,22L20,20.72M10,3V4C10,5.09 9.4,6.1 8.45,6.62L9.89,8.07C11.21,7.13 12,5.62 12,4V3H10Z" />\n    </symbol>\n    <symbol id="noChildren" viewBox="0 0 24 24">\n        <path\n            d="M9,11.75A1.25,1.25 0 0,0 7.75,13A1.25,1.25 0 0,0 9,14.25A1.25,1.25 0 0,0 10.25,13A1.25,1.25 0 0,0 9,11.75M15,11.75A1.25,1.25 0 0,0 13.75,13A1.25,1.25 0 0,0 15,14.25A1.25,1.25 0 0,0 16.25,13A1.25,1.25 0 0,0 15,11.75M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20C7.59,20 4,16.41 4,12C4,11.71 4,11.42 4.05,11.14C6.41,10.09 8.28,8.16 9.26,5.77C11.07,8.33 14.05,10 17.42,10C18.2,10 18.95,9.91 19.67,9.74C19.88,10.45 20,11.21 20,12C20,16.41 16.41,20 12,20Z" />\n    </symbol>\n    <symbol id="facebookIcon" viewBox="0 0 24 24">\n        <path d="M17,2V2H17V6H15C14.31,6 14,6.81 14,7.5V10H14L17,10V14H14V22H10V14H7V10H10V6A4,4 0 0,1 14,2H17Z" />\n    </symbol>\n    <symbol id="twitterIcon" viewBox="0 0 24 24">\n        <path\n            d="M22.46,6C21.69,6.35 20.86,6.58 20,6.69C20.88,6.16 21.56,5.32 21.88,4.31C21.05,4.81 20.13,5.16 19.16,5.36C18.37,4.5 17.26,4 16,4C13.65,4 11.73,5.92 11.73,8.29C11.73,8.63 11.77,8.96 11.84,9.27C8.28,9.09 5.11,7.38 3,4.79C2.63,5.42 2.42,6.16 2.42,6.94C2.42,8.43 3.17,9.75 4.33,10.5C3.62,10.5 2.96,10.3 2.38,10C2.38,10 2.38,10 2.38,10.03C2.38,12.11 3.86,13.85 5.82,14.24C5.46,14.34 5.08,14.39 4.69,14.39C4.42,14.39 4.15,14.36 3.89,14.31C4.43,16 6,17.26 7.89,17.29C6.43,18.45 4.58,19.13 2.56,19.13C2.22,19.13 1.88,19.11 1.54,19.07C3.44,20.29 5.7,21 8.12,21C16,21 20.33,14.46 20.33,8.79C20.33,8.6 20.33,8.42 20.32,8.23C21.16,7.63 21.88,6.87 22.46,6Z" />\n    </symbol>\n    <symbol id="googleIcon" viewBox="0 0 24 24">\n        <path\n            d="M23,11H21V9H19V11H17V13H19V15H21V13H23M8,11V13.4H12C11.8,14.4 10.8,16.4 8,16.4C5.6,16.4 3.7,14.4 3.7,12C3.7,9.6 5.6,7.6 8,7.6C9.4,7.6 10.3,8.2 10.8,8.7L12.7,6.9C11.5,5.7 9.9,5 8,5C4.1,5 1,8.1 1,12C1,15.9 4.1,19 8,19C12,19 14.7,16.2 14.7,12.2C14.7,11.7 14.7,11.4 14.6,11H8Z" />\n    </symbol>\n    <symbol id="venueIcon" viewBox="0 0 24 24">\n        <path\n            d="M5,4A2,2 0 0,0 3,6V16.29L11.18,8.11C11.06,7.59 11,7.07 11,6.53C11,5.62 11.2,4.76 11.59,4H5M18,21A2,2 0 0,0 20,19V11.86C19.24,13 18.31,14.21 17.29,15.5L16.5,16.5L15.72,15.5C14.39,13.85 13.22,12.32 12.39,10.91C12.05,10.33 11.76,9.76 11.53,9.18L7.46,13.25L15.21,21H18M3,19A2,2 0 0,0 5,21H13.79L6.75,13.96L3,17.71V19M16.5,15C19.11,11.63 21,9.1 21,6.57C21,4.05 19,2 16.5,2C14,2 12,4.05 12,6.57C12,9.1 13.87,11.63 16.5,15M18.5,6.5A2,2 0 0,1 16.5,8.5A2,2 0 0,1 14.5,6.5A2,2 0 0,1 16.5,4.5A2,2 0 0,1 18.5,6.5Z" />\n    </symbol>\n    <symbol id="arrowIcon" viewBox="0 0 24 24">\n        <path d="M7,10L12,15L17,10H7Z" />\n    </symbol>\n    <symbol id="editIcon" viewBox="0 0 24 24">\n        <path\n            d="M19,19V5H5V19H19M19,3A2,2 0 0,1 21,5V19C21,20.11 20.1,21 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H19M16.7,9.35L15.7,10.35L13.65,8.3L14.65,7.3C14.86,7.08 15.21,7.08 15.42,7.3L16.7,8.58C16.92,8.79 16.92,9.14 16.7,9.35M7,14.94L13.06,8.88L15.12,10.94L9.06,17H7V14.94Z" />\n    </symbol>\n    <symbol id="closeIcon" viewBox="0 0 24 24">\n        <path\n            d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />\n    </symbol>\n    <symbol id="printIcon" viewBox="0 0 24 24">\n        <path\n            d="M18,3H6V7H18M19,12A1,1 0 0,1 18,11A1,1 0 0,1 19,10A1,1 0 0,1 20,11A1,1 0 0,1 19,12M16,19H8V14H16M19,8H5A3,3 0 0,0 2,11V17H6V21H18V17H22V11A3,3 0 0,0 19,8Z" />\n    </symbol>\n</svg>');
$templateCache.put('app/social/layouts/footer/footer.html','<div class="footerLinksGroups">\n  <div class="footerLinksGroup">\n    <h1>company</h1>\n    <div class="footerLinks">\n      <div class="footerLinksCore">\n        <a href="">About us</a>\n        <a href="">How It Works</a>\n        <a href="">Our Guarantee</a>\n        <a href="">Contact Us</a>\n      </div>\n    </div>\n  </div>\n  <div class="footerLinksGroup">\n    <h1>Quick Links</h1>\n    <div class="footerLinks">\n      <div class="footerLinksCore">\n        <a href="">My Account</a>\n        <a href="">How To Buy</a>\n        <a href="">How To Sell</a>\n        <a href="">FAQs</a>\n      </div>\n      <div class="footerLinksCore">\n        <a href="">Request Adding Event</a>\n        <a href="">Sell Tickets</a>\n        <a href="">Venues</a>\n        <a href="">Performers</a>\n      </div>\n    </div>\n  </div>\n  <div class="footerLinksGroup">\n    <h1>legal</h1>\n    <div class="footerLinks">\n      <div class="footerLinksCore">\n        <a href="">Buyer Agreement</a>\n        <a href="">Seller Agreement</a>\n        <a href="">Privacy Policy</a>\n        <a href="">Cookies Ploicy</a>\n      </div>\n    </div>\n  </div>\n</div>\n<div class="footerLinksGroups rights">\n  <div class="rightsGroupsHolder">\n    <div class="footerLinksGroup">\n      <h1>secure buy</h1>\n      <div class="footerLinks">\n        <div class="footerLinksCore">\n          <img src="assets/images/visa.png" />\n        </div>\n      </div>\n    </div>\n    <div class="footerLinksGroup">\n      <h1>follow us </h1>\n      <div class="footerLinks">\n        <div class="footerLinksCore social">\n          <a href="">\n            <svg viewBox="0 0 24 24">\n                <path d="M17,2V2H17V6H15C14.31,6 14,6.81 14,7.5V10H14L17,10V14H14V22H10V14H7V10H10V6A4,4 0 0,1 14,2H17Z" />\n            </svg>\n          </a>\n          <a href="">\n            <svg viewBox="0 0 24 24">\n                <path d="M22.46,6C21.69,6.35 20.86,6.58 20,6.69C20.88,6.16 21.56,5.32 21.88,4.31C21.05,4.81 20.13,5.16 19.16,5.36C18.37,4.5 17.26,4 16,4C13.65,4 11.73,5.92 11.73,8.29C11.73,8.63 11.77,8.96 11.84,9.27C8.28,9.09 5.11,7.38 3,4.79C2.63,5.42 2.42,6.16 2.42,6.94C2.42,8.43 3.17,9.75 4.33,10.5C3.62,10.5 2.96,10.3 2.38,10C2.38,10 2.38,10 2.38,10.03C2.38,12.11 3.86,13.85 5.82,14.24C5.46,14.34 5.08,14.39 4.69,14.39C4.42,14.39 4.15,14.36 3.89,14.31C4.43,16 6,17.26 7.89,17.29C6.43,18.45 4.58,19.13 2.56,19.13C2.22,19.13 1.88,19.11 1.54,19.07C3.44,20.29 5.7,21 8.12,21C16,21 20.33,14.46 20.33,8.79C20.33,8.6 20.33,8.42 20.32,8.23C21.16,7.63 21.88,6.87 22.46,6Z" />\n            </svg>\n          </a>\n          <a href="">\n            <svg viewBox="0 0 24 24">\n                <path d="M10,16.5V7.5L16,12M20,4.4C19.4,4.2 15.7,4 12,4C8.3,4 4.6,4.19 4,4.38C2.44,4.9 2,8.4 2,12C2,15.59 2.44,19.1 4,19.61C4.6,19.81 8.3,20 12,20C15.7,20 19.4,19.81 20,19.61C21.56,19.1 22,15.59 22,12C22,8.4 21.56,4.91 20,4.4Z" />\n            </svg>\n          </a>\n          <a href="">\n            <svg viewBox="0 0 24 24">\n                <path d="M7.8,2H16.2C19.4,2 22,4.6 22,7.8V16.2A5.8,5.8 0 0,1 16.2,22H7.8C4.6,22 2,19.4 2,16.2V7.8A5.8,5.8 0 0,1 7.8,2M7.6,4A3.6,3.6 0 0,0 4,7.6V16.4C4,18.39 5.61,20 7.6,20H16.4A3.6,3.6 0 0,0 20,16.4V7.6C20,5.61 18.39,4 16.4,4H7.6M17.25,5.5A1.25,1.25 0 0,1 18.5,6.75A1.25,1.25 0 0,1 17.25,8A1.25,1.25 0 0,1 16,6.75A1.25,1.25 0 0,1 17.25,5.5M12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9Z" />\n            </svg>\n          </a>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class="copy">\n    <p>Copyright \xA9 Copyright \xA9 {{footerC.date | date:\'yyyy\'}}. All Rights reserved.</p>\n    <p>Developed With Love By <a href="http://www.e-turn.co.uk" target="_blank"><img src="assets/images/eTurn.png" /></a></p>\n  </div>\n</div>\n');
$templateCache.put('app/social/layouts/topBar/topBar.html','<header>\n  <a href="#/home" class="logo"><img src="assets/images/logo.png" /></a>\n  <div class="headerSearch">\n    <div class="ticketCutEdgeVertical"></div>\n    <div class="headerSearchField">\n      <input type="text" placeholder="Search For Events, Performers or Venues" />\n    </div>\n    <div class="ticketCutEdgeVertical flipped"></div>\n    <div class="ticketCutEdgeVertical"></div>\n    <button>\n      <svg viewBox="0 0 25 25">\n          <path d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z" />\n      </svg>\n    </button>\n    <div class="ticketCutEdgeVertical flipped"></div>\n  </div>\n  <div class="headerUtlsLinks">\n    <!-- Need help with this -->\n    <a href="javascript:void(0);" class="loginHandler" ng-click="vm.toggleLoginPanel()">\n      <svg viewBox="0 0 24 24">\n          <path d="M11,10V12H10V14H8V12H5.83C5.42,13.17 4.31,14 3,14A3,3 0 0,1 0,11A3,3 0 0,1 3,8C4.31,8 5.42,8.83 5.83,10H11M3,10A1,1 0 0,0 2,11A1,1 0 0,0 3,12A1,1 0 0,0 4,11A1,1 0 0,0 3,10M16,14C18.67,14 24,15.34 24,18V20H8V18C8,15.34 13.33,14 16,14M16,12A4,4 0 0,1 12,8A4,4 0 0,1 16,4A4,4 0 0,1 20,8A4,4 0 0,1 16,12Z" />\n      </svg>\n      <span>Login</span>\n      <svg viewBox="0 0 24 24" class="arrow">\n        <path d="M7,10L12,15L17,10H7Z" />\n      </svg>\n    </a>\n    <a href="javascript:void(0);" class="help">\n      <svg viewBox="0 0 30 30">\n        <path d="M10,19H13V22H10V19M12,2C17.35,2.22 19.68,7.62 16.5,11.67C15.67,12.67 14.33,13.33 13.67,14.17C13,15 13,16 13,17H10C10,15.33 10,13.92 10.67,12.92C11.33,11.92 12.67,11.33 13.5,10.67C15.92,8.43 15.32,5.26 12,5A3,3 0 0,0 9,8H6A6,6 0 0,1 12,2Z" />\n      </svg>\n      <span>Help</span>\n    </a>\n  </div>\n  <!--\n    UI NOTES\n    Asign class .error to .globalFormUnit if you want to show error\n    Example:\n    <div class="globalFormUnit error">\n      <p>\n        Mobile Number <span>Invalid Mobile Number</span>\n      </p>\n      <input type="tel" />\n    </div>\n  -->\n    <div class="loginView">\n        <div class="overlay">\n        </div>\n        <div class="loginPanelHolder">\n            <div class="loginPanel">\n                <div class="globalForm">\n                    <div class="loginPanelHalf">\n                        <h1>Login With Tixawy account</h1>\n                        <div class="globalFormUnit">\n                            <p>\n                                Email Address / Mobile Number\n                            </p>\n                            <input type="text" />\n                        </div>\n                        <div class="globalFormUnit condensed">\n                            <p>\n                                Password\n                            </p>\n                            <input type="password" />\n                        </div>\n                        <div class="globalFormUnit">\n                            <div class="globalFormUnitCheck">\n                                <input type="checkbox" />\n                                <div class="globalFormUnitCheckCore">\n                                    <svg viewBox="0 0 24 24">\n                                        <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />\n                                    </svg>\n                                </div>\n                                <p>\n                                    Remember Me\n                                </p>\n                            </div>\n                            <a href="javascript:void(0);" class="restorePasswordHandler">I can\u2019t remember my password</a>\n                        </div>\n                        <div class="globalButtonsBar">\n                            <input type="submit" value="Login" class="globalButton callToAction blue fullWidth" />\n                        </div>\n                        <div class="loginOr">\n                            <h1>\n                                OR\n                            </h1>\n                            <span class="horzLine"></span>\n                        </div>\n                        <div class="globalButtonsBar">\n                            <a href="javascript:void(0);" class="globalButton callToAction facebookBlue fullWidth normalChars regularFont">\n                                <svg viewBox="0 0 23 23">\n                                    <path d="M19,4V7H17A1,1 0 0,0 16,8V10H19V13H16V20H13V13H11V10H13V7.5C13,5.56 14.57,4 16.5,4M20,2H4A2,2 0 0,0 2,4V20A2,2 0 0,0 4,22H20A2,2 0 0,0 22,20V4C22,2.89 21.1,2 20,2Z" />\n                                </svg>\n                                Login With Facebook\n                            </a>\n                        </div>\n                    </div>\n                    <form class="loginPanelHalf bordered" ng-submit="vm.validate()" novalidate>\n                        <h1>Sign Up a new account</h1>\n                        <div class="globalFormUnit">\n                            <p>\n                                Full Name <span>{{vm.errors.FullName}}</span>\n                            </p>\n                            <input type="text" name="ufullname" id="ufullname" ng-model="vm.User.Name" />\n                        </div>\n                        <div class="globalFormUnit">\n                            <p>\n                                Mobile Number <span>{{vm.errors.MobileNumber}}</span>\n                            </p>\n                            <input type="text" name="uphone" id="uphone" ng-model="vm.User.MobileNumber" />\n                        </div>\n                        <div class="globalFormUnit">\n                            <p>\n                                Email Address <span>{{vm.errors.Email}}</span>\n                            </p>\n                            <input type="email" name="uemail" id="uemail" ng-model="vm.User.Email" />\n                        </div>\n                        <div class="globalFormTwoUnits">\n                            <div class="globalFormUnit">\n                                <p>\n                                    Password <span>{{vm.errors.Password}}</span>\n                                </p>\n                                <input type="password" name="upass" id="upass" ng-model="vm.User.Password" />\n                            </div>\n                            <div class="globalFormUnit">\n                                <p>\n                                    Confirm Password <span>{{vm.errors.ConfirmPassword}}</span>\n                                </p>\n                                <input type="password" name="confirmpass" id="confirmpass" ng-model="vm.User.ConfirmPassword" />\n                            </div>\n                        </div>\n                        <div class="globalButtonsBar">\n                            <input type="submit" class="globalButton callToAction green fullWidth" value="{{vm.submitText}}" />\n                        </div>\n                    </form>\n                </div>\n            </div>\n        </div>\n    </div>\n</header>\n<nav>\n  <ul>\n    <!-- AI:ng-click IS TEMP FOR SIMULATION AND MUST BE DELETED -->\n    <li category="music" ng-click="vm.tempChangeTheme(\'music\')">\n      <a href="#/category">Music</a>\n      <div class="navSubCategories">\n        <!-- This will be refined after ng-repeat with the real data -->\n        <div class="navSubCategoriesGroup">\n          <a href="">Rock and Pop</a>\n          <a href="">Jazz and Blues</a>\n          <a href="">Opera and Classical</a>\n          <a href="">Word Music</a>\n          <a href="">Rap and Hip Hop</a>\n          <a href="">Dance and Electronic</a>\n        </div>\n        <div class="navSubCategoriesGroup">\n          <a href="">Word Music</a>\n          <a href="">Rap and Hip Hop</a>\n          <a href="">Dance and Electronic</a>\n          <a href="">Country and Folk</a>\n          <a href="">Alternative</a>\n          <a href="">Poetry</a>\n        </div>\n      </div>\n    </li>\n    <li category="festivals" ng-click="vm.tempChangeTheme(\'festivals\')">\n      <a href="#/category">Festivals</a>\n      <div class="navSubCategories">\n        <!-- This will be refined after ng-repeat with the real data -->\n        <div class="navSubCategoriesGroup">\n          <a href="">Reading Festivals</a>\n          <a href="">Folk Festivals</a>\n          <a href="">Social Festivals</a>\n          <a href="">Summer Festivals</a>\n          <a href="">National Festivals</a>\n        </div>\n      </div>\n    </li>\n    <li category="sports" ng-click="vm.tempChangeTheme(\'sports\')">\n      <a href="#/category">Sports</a>\n      <div class="navSubCategories">\n        <!-- This will be refined after ng-repeat with the real data -->\n        <div class="navSubCategoriesGroup">\n          <a href="#/subcategory">Football</a>\n          <a href="">Basketball</a>\n          <a href="">Squash</a>\n          <a href="">Handball</a>\n          <a href="">Boxing</a>\n          <a href="">Tinnes</a>\n        </div>\n        <div class="navSubCategoriesGroup">\n          <a href="">Horse Racing</a>\n          <a href="">Handball</a>\n          <a href="">Tinnes</a>\n          <a href="">Egyptian Cup</a>\n          <a href="">Golf</a>\n          <a href="">Swimming</a>\n        </div>\n      </div>\n    </li>\n    <li category="theater" ng-click="vm.tempChangeTheme(\'theater\')">\n      <a href="#/category">Arts And Theater</a>\n      <div class="navSubCategories">\n        <!-- This will be refined after ng-repeat with the real data -->\n        <div class="navSubCategoriesGroup">\n          <a href="">Theater Plays</a>\n          <a href="">Galleries</a>\n          <a href="">Musical Plays</a>\n          <a href="">Ballet and Dance</a>\n          <a href="">Opera Shows</a>\n        </div>\n      </div>\n    </li>\n    <li category="comedy" ng-click="vm.tempChangeTheme(\'comedy\')">\n      <a href="#/category">Comedy</a>\n      <div class="navSubCategories">\n        <!-- This will be refined after ng-repeat with the real data -->\n        <div class="navSubCategoriesGroup">\n          <a href="">Comedy Shows</a>\n          <a href="">Stand Up Comedy Shows</a>\n          <a href="">Comedy TV Shows</a>\n        </div>\n      </div>\n    </li>\n  </ul>\n  <a href="#/categories" class="sellTickets">\n    <span>Sell tickets</span>\n    <span class="sellTicketsHover">Sell tickets</span>\n  </a>\n</nav>\n<div class="contentWhiteOverlay"></div>\n');}]);})();